var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601, _path2602, _path2603, _path2604, _path2605, _path2606, _path2607, _path2608, _path2609, _path2610, _path2611, _path2612, _path2613, _path2614, _path2615, _path2616, _path2617, _path2618, _path2619, _path2620, _path2621, _path2622, _path2623, _path2624, _path2625, _path2626, _path2627, _path2628, _path2629, _path2630, _path2631, _path2632, _path2633, _path2634, _path2635, _path2636, _path2637, _path2638, _path2639, _path2640, _path2641, _path2642, _path2643, _path2644, _path2645, _path2646, _path2647, _path2648, _path2649, _path2650, _path2651, _path2652, _path2653, _path2654, _path2655, _path2656, _path2657, _path2658, _path2659, _path2660, _path2661, _path2662, _path2663, _path2664, _path2665, _path2666, _path2667, _path2668, _path2669, _path2670, _path2671, _path2672, _path2673, _path2674, _path2675, _path2676, _path2677, _path2678, _path2679, _path2680, _path2681, _path2682, _path2683, _path2684, _path2685, _path2686, _path2687, _path2688, _path2689, _path2690, _path2691, _path2692, _path2693, _path2694, _path2695, _path2696, _path2697, _path2698, _path2699, _path2700, _path2701, _path2702, _path2703, _path2704, _path2705, _path2706, _path2707, _path2708, _path2709, _path2710, _path2711, _path2712, _path2713, _path2714, _path2715, _path2716, _path2717, _path2718, _path2719, _path2720, _path2721, _path2722, _path2723, _path2724, _path2725, _path2726, _path2727, _path2728, _path2729, _path2730, _path2731, _path2732, _path2733, _path2734, _path2735, _path2736, _path2737, _path2738, _path2739, _path2740, _path2741, _path2742, _path2743, _path2744, _path2745, _path2746, _path2747, _path2748, _path2749, _path2750, _path2751, _path2752, _path2753, _path2754, _path2755, _path2756, _path2757, _path2758, _path2759, _path2760, _path2761, _path2762, _path2763, _path2764, _path2765, _path2766, _path2767, _path2768, _path2769, _path2770, _path2771, _path2772, _path2773, _path2774, _path2775, _path2776, _path2777, _path2778, _path2779, _path2780, _path2781, _path2782, _path2783, _path2784, _path2785, _path2786, _path2787, _path2788, _path2789, _path2790, _path2791, _path2792, _path2793, _path2794, _path2795, _path2796, _path2797, _path2798, _path2799, _path2800, _path2801, _path2802, _path2803, _path2804, _path2805, _path2806, _path2807, _path2808, _path2809, _path2810, _path2811, _path2812, _path2813, _path2814, _path2815, _path2816, _path2817, _path2818, _path2819, _path2820, _path2821, _path2822, _path2823, _path2824, _path2825, _path2826, _path2827, _path2828, _path2829, _path2830, _path2831, _path2832, _path2833, _path2834, _path2835, _path2836, _path2837, _path2838, _path2839, _path2840, _path2841, _path2842, _path2843, _path2844, _path2845, _path2846, _path2847, _path2848, _path2849, _path2850, _path2851, _path2852, _path2853, _path2854, _path2855, _path2856, _path2857, _path2858, _path2859, _path2860, _path2861, _path2862, _path2863, _path2864, _path2865, _path2866, _path2867, _path2868, _path2869, _path2870, _path2871, _path2872, _path2873, _path2874, _path2875, _path2876, _path2877, _path2878, _path2879, _path2880, _path2881, _path2882, _path2883, _path2884, _path2885, _path2886, _path2887, _path2888, _path2889, _path2890, _path2891, _path2892, _path2893, _path2894, _path2895, _path2896, _path2897, _path2898, _path2899, _path2900, _path2901, _path2902, _path2903, _path2904, _path2905, _path2906, _path2907, _path2908, _path2909, _path2910, _path2911, _path2912, _path2913, _path2914, _path2915, _path2916, _path2917, _path2918, _path2919, _path2920, _path2921, _path2922, _path2923, _path2924, _path2925, _path2926, _path2927, _path2928, _path2929, _path2930, _path2931, _path2932, _path2933, _path2934, _path2935, _path2936, _path2937, _path2938, _path2939, _path2940, _path2941, _path2942, _path2943, _path2944, _path2945, _path2946, _path2947, _path2948, _path2949, _path2950, _path2951, _path2952, _path2953, _path2954, _path2955, _path2956, _path2957, _path2958, _path2959, _path2960, _path2961, _path2962, _path2963, _path2964, _path2965, _path2966, _path2967, _path2968, _path2969, _path2970, _path2971, _path2972, _path2973, _path2974, _path2975, _path2976, _path2977, _path2978, _path2979, _path2980, _path2981, _path2982, _path2983, _path2984, _path2985, _path2986, _path2987, _path2988, _path2989, _path2990, _path2991, _path2992, _path2993, _path2994, _path2995, _path2996, _path2997, _path2998, _path2999, _path3000, _path3001, _path3002, _path3003, _path3004, _path3005, _path3006, _path3007, _path3008, _path3009, _path3010, _path3011, _path3012, _path3013, _path3014, _path3015, _path3016, _path3017, _path3018, _path3019, _path3020, _path3021, _path3022, _path3023, _path3024, _path3025, _path3026, _path3027, _path3028, _path3029, _path3030, _path3031, _path3032, _path3033, _path3034, _path3035, _path3036, _path3037, _path3038, _path3039, _path3040, _path3041, _path3042, _path3043, _path3044, _path3045, _path3046, _path3047, _path3048, _path3049, _path3050, _path3051, _path3052, _path3053, _path3054, _path3055, _path3056, _path3057, _path3058, _path3059, _path3060, _path3061, _path3062, _path3063, _path3064, _path3065, _path3066, _path3067, _path3068, _path3069, _path3070, _path3071, _path3072, _path3073, _path3074, _path3075, _path3076, _path3077, _path3078, _path3079, _path3080, _path3081, _path3082, _path3083, _path3084, _path3085, _path3086, _path3087, _path3088, _path3089, _path3090, _path3091, _path3092, _path3093, _path3094, _path3095, _path3096, _path3097, _path3098, _path3099, _path3100, _path3101, _path3102, _path3103, _path3104, _path3105, _path3106, _path3107, _path3108, _path3109, _path3110, _path3111, _path3112, _path3113, _path3114, _path3115, _path3116, _path3117, _path3118, _path3119, _path3120, _path3121, _path3122, _path3123, _path3124, _path3125, _path3126, _path3127, _path3128, _path3129, _path3130, _path3131, _path3132, _path3133, _path3134, _path3135, _path3136, _path3137, _path3138, _path3139, _path3140, _path3141, _path3142, _path3143, _path3144, _path3145, _path3146, _path3147, _path3148, _path3149, _path3150, _path3151, _path3152, _path3153, _path3154, _path3155, _path3156, _path3157, _path3158, _path3159, _path3160, _path3161, _path3162, _path3163, _path3164, _path3165, _path3166, _path3167, _path3168, _path3169, _path3170, _path3171, _path3172, _path3173, _path3174, _path3175, _path3176, _path3177, _path3178, _path3179, _path3180, _path3181, _path3182, _path3183, _path3184, _path3185, _path3186, _path3187, _path3188, _path3189, _path3190, _path3191, _path3192, _path3193, _path3194, _path3195, _path3196, _path3197, _path3198, _path3199, _path3200, _path3201, _path3202, _path3203, _path3204, _path3205, _path3206, _path3207, _path3208, _path3209, _path3210, _path3211, _path3212, _path3213, _path3214, _path3215, _path3216, _path3217, _path3218, _path3219, _path3220, _path3221, _path3222, _path3223, _path3224, _path3225, _path3226, _path3227, _path3228, _path3229, _path3230, _path3231, _path3232, _path3233, _path3234, _path3235, _path3236, _path3237, _path3238, _path3239, _path3240, _path3241, _path3242, _path3243, _path3244, _path3245, _path3246, _path3247, _path3248, _path3249, _path3250, _path3251, _path3252, _path3253, _path3254, _path3255, _path3256, _path3257, _path3258, _path3259, _path3260, _path3261, _path3262, _path3263, _path3264, _path3265, _path3266, _path3267, _path3268, _path3269, _path3270, _path3271, _path3272, _path3273, _path3274, _path3275, _path3276, _path3277, _path3278, _path3279, _path3280, _path3281, _path3282, _path3283, _path3284, _path3285, _path3286, _path3287, _path3288, _path3289, _path3290, _path3291, _path3292, _path3293, _path3294, _path3295, _path3296, _path3297, _path3298, _path3299, _path3300, _path3301, _path3302, _path3303, _path3304, _path3305, _path3306, _path3307, _path3308, _path3309, _path3310, _path3311, _path3312, _path3313, _path3314, _path3315, _path3316, _path3317, _path3318, _path3319, _path3320, _path3321, _path3322, _path3323, _path3324, _path3325, _path3326, _path3327, _path3328, _path3329, _path3330, _path3331, _path3332, _path3333, _path3334, _path3335, _path3336, _path3337, _path3338, _path3339, _path3340, _path3341, _path3342, _path3343, _path3344, _path3345, _path3346, _path3347, _path3348, _path3349, _path3350, _path3351, _path3352, _path3353, _path3354, _path3355, _path3356, _path3357, _path3358, _path3359, _path3360, _path3361, _path3362, _path3363, _path3364, _path3365, _path3366, _path3367, _path3368, _path3369, _path3370, _path3371, _path3372, _path3373, _path3374, _path3375, _path3376, _path3377, _path3378, _path3379, _path3380, _path3381, _path3382, _path3383, _path3384, _path3385, _path3386, _path3387, _path3388, _path3389, _path3390, _path3391, _path3392, _path3393, _path3394, _path3395, _path3396, _path3397, _path3398, _path3399, _path3400, _path3401, _path3402, _path3403, _path3404, _path3405, _path3406, _path3407, _path3408, _path3409, _path3410, _path3411, _path3412, _path3413, _path3414, _path3415, _path3416, _path3417, _path3418, _path3419, _path3420, _path3421, _path3422, _path3423, _path3424, _path3425, _path3426, _path3427, _path3428, _path3429, _path3430, _path3431, _path3432, _path3433, _path3434, _path3435, _path3436, _path3437, _path3438, _path3439, _path3440, _path3441, _path3442, _path3443, _path3444, _path3445, _path3446, _path3447, _path3448, _path3449, _path3450, _path3451, _path3452, _path3453, _path3454, _path3455, _path3456, _path3457, _path3458, _path3459, _path3460, _path3461, _path3462, _path3463, _path3464, _path3465, _path3466, _path3467, _path3468, _path3469, _path3470, _path3471, _path3472, _path3473, _path3474, _path3475, _path3476, _path3477, _path3478, _path3479, _path3480, _path3481, _path3482, _path3483, _path3484, _path3485, _path3486, _path3487, _path3488, _path3489, _path3490, _path3491, _path3492, _path3493, _path3494, _path3495, _path3496, _path3497, _path3498, _path3499, _path3500, _path3501, _path3502, _path3503, _path3504, _path3505, _path3506, _path3507, _path3508, _path3509, _path3510, _path3511, _path3512, _path3513, _path3514, _path3515, _path3516, _path3517, _path3518, _path3519, _path3520, _path3521, _path3522, _path3523, _path3524, _path3525, _path3526, _path3527, _path3528, _path3529, _path3530, _path3531, _path3532, _path3533, _path3534, _path3535, _path3536, _path3537, _path3538, _path3539, _path3540, _path3541, _path3542, _path3543, _path3544, _path3545, _path3546, _path3547, _path3548, _path3549, _path3550, _path3551, _path3552, _path3553, _path3554, _path3555, _path3556, _path3557, _path3558, _path3559, _path3560, _path3561, _path3562, _path3563, _path3564, _path3565, _path3566, _path3567, _path3568, _path3569, _path3570, _path3571, _path3572, _path3573, _path3574, _path3575, _path3576, _path3577, _path3578, _path3579, _path3580, _path3581, _path3582, _path3583, _path3584, _path3585, _path3586, _path3587, _path3588, _path3589, _path3590, _path3591, _path3592, _path3593, _path3594, _path3595, _path3596, _path3597, _path3598, _path3599, _path3600, _path3601, _path3602, _path3603, _path3604, _path3605, _path3606, _path3607, _path3608, _path3609, _path3610, _path3611, _path3612, _path3613, _path3614, _path3615, _path3616, _path3617, _path3618, _path3619, _path3620, _path3621, _path3622, _path3623, _path3624, _path3625, _path3626, _path3627, _path3628, _path3629, _path3630, _path3631, _path3632, _path3633, _path3634, _path3635, _path3636, _path3637, _path3638, _path3639, _path3640, _path3641, _path3642, _path3643, _path3644, _path3645, _path3646, _path3647, _path3648, _path3649, _path3650, _path3651, _path3652, _path3653, _path3654, _path3655, _path3656, _path3657, _path3658, _path3659, _path3660, _path3661, _path3662, _path3663, _path3664, _path3665, _path3666, _path3667, _path3668, _path3669, _path3670, _path3671, _path3672, _path3673, _path3674, _path3675, _path3676, _path3677, _path3678, _path3679, _path3680, _path3681, _path3682, _path3683, _path3684, _path3685, _path3686, _path3687, _path3688, _path3689, _path3690, _path3691, _path3692, _path3693, _path3694, _path3695, _path3696, _path3697, _path3698, _path3699, _path3700, _path3701, _path3702, _path3703, _path3704, _path3705, _path3706, _path3707, _path3708, _path3709, _path3710, _path3711, _path3712, _path3713, _path3714, _path3715, _path3716, _path3717, _path3718, _path3719, _path3720, _path3721, _path3722, _path3723, _path3724, _path3725, _path3726, _path3727, _path3728, _path3729, _path3730, _path3731, _path3732, _path3733, _path3734, _path3735, _path3736, _path3737, _path3738, _path3739, _path3740, _path3741, _path3742, _path3743, _path3744, _path3745, _path3746, _path3747, _path3748, _path3749, _path3750, _path3751, _path3752, _path3753, _path3754, _path3755, _path3756, _path3757, _path3758, _path3759, _path3760, _path3761, _path3762, _path3763, _path3764, _path3765, _path3766, _path3767, _path3768, _path3769, _path3770, _path3771, _path3772, _path3773, _path3774, _path3775, _path3776, _path3777, _path3778, _path3779, _path3780, _path3781, _path3782, _path3783, _path3784, _path3785, _path3786, _path3787, _path3788, _path3789, _path3790, _path3791, _path3792, _path3793, _path3794, _path3795, _path3796, _path3797, _path3798, _path3799, _path3800, _path3801, _path3802, _path3803, _path3804, _path3805, _path3806, _path3807, _path3808, _path3809, _path3810, _path3811, _path3812, _path3813, _path3814, _path3815, _path3816, _path3817, _path3818, _path3819, _path3820, _path3821, _path3822, _path3823, _path3824, _path3825, _path3826, _path3827, _path3828, _path3829, _path3830, _path3831, _path3832, _path3833, _path3834, _path3835, _path3836, _path3837, _path3838, _path3839, _path3840, _path3841, _path3842, _path3843, _path3844, _path3845, _path3846, _path3847, _path3848, _path3849, _path3850, _path3851, _path3852, _path3853, _path3854, _path3855, _path3856, _path3857, _path3858, _path3859, _path3860, _path3861, _path3862, _path3863, _path3864, _path3865, _path3866, _path3867, _path3868, _path3869, _path3870, _path3871, _path3872, _path3873, _path3874, _path3875, _path3876, _path3877, _path3878, _path3879, _path3880, _path3881, _path3882, _path3883, _path3884, _path3885, _path3886, _path3887, _path3888, _path3889, _path3890, _path3891, _path3892, _path3893, _path3894, _path3895, _path3896, _path3897, _path3898, _path3899, _path3900, _path3901, _path3902, _path3903, _path3904, _path3905, _path3906, _path3907, _path3908, _path3909, _path3910, _path3911, _path3912, _path3913, _path3914, _path3915, _path3916, _path3917, _path3918, _path3919, _path3920, _path3921, _path3922, _path3923, _path3924, _path3925, _path3926, _path3927, _path3928, _path3929, _path3930, _path3931, _path3932, _path3933, _path3934, _path3935, _path3936, _path3937, _path3938, _path3939, _path3940, _path3941, _path3942, _path3943, _path3944, _path3945, _path3946, _path3947, _path3948, _path3949, _path3950, _path3951, _path3952, _path3953, _path3954, _path3955, _path3956, _path3957, _path3958, _path3959, _path3960, _path3961, _path3962, _path3963, _path3964, _path3965, _path3966, _path3967, _path3968, _path3969, _path3970, _path3971, _path3972, _path3973, _path3974, _path3975, _path3976, _path3977, _path3978, _path3979, _path3980, _path3981, _path3982, _path3983, _path3984, _path3985, _path3986, _path3987, _path3988, _path3989, _path3990, _path3991, _path3992, _path3993, _path3994, _path3995, _path3996, _path3997, _path3998, _path3999, _path4000, _path4001, _path4002, _path4003, _path4004, _path4005, _path4006, _path4007, _path4008, _path4009, _path4010, _path4011, _path4012, _path4013, _path4014, _path4015, _path4016, _path4017, _path4018, _path4019, _path4020, _path4021, _path4022, _path4023, _path4024, _path4025, _path4026, _path4027, _path4028, _path4029, _path4030, _path4031, _path4032, _path4033, _path4034, _path4035, _path4036, _path4037, _path4038, _path4039, _path4040, _path4041, _path4042, _path4043, _path4044, _path4045, _path4046, _path4047, _path4048, _path4049, _path4050, _path4051, _path4052, _path4053, _path4054, _path4055, _path4056, _path4057, _path4058, _path4059, _path4060, _path4061, _path4062, _path4063, _path4064, _path4065, _path4066, _path4067, _path4068, _path4069, _path4070, _path4071, _path4072, _path4073, _path4074, _path4075, _path4076, _path4077, _path4078, _path4079, _path4080, _path4081, _path4082, _path4083, _path4084, _path4085, _path4086, _path4087, _path4088, _path4089, _path4090, _path4091, _path4092, _path4093, _path4094, _path4095, _path4096, _path4097, _path4098, _path4099, _path4100, _path4101, _path4102, _path4103, _path4104, _path4105, _path4106, _path4107, _path4108, _path4109, _path4110, _path4111, _path4112, _path4113, _path4114, _path4115, _path4116, _path4117, _path4118, _path4119, _path4120, _path4121, _path4122, _path4123, _path4124, _path4125, _path4126, _path4127, _path4128, _path4129, _path4130, _path4131, _path4132, _path4133, _path4134, _path4135, _path4136, _path4137, _path4138, _path4139, _path4140, _path4141, _path4142, _path4143, _path4144, _path4145, _path4146, _path4147, _path4148, _path4149, _path4150, _path4151, _path4152, _path4153, _path4154, _path4155, _path4156, _path4157, _path4158, _path4159, _path4160, _path4161, _path4162, _path4163, _path4164, _path4165, _path4166, _path4167, _path4168, _path4169, _path4170, _path4171, _path4172, _path4173, _path4174, _path4175, _path4176, _path4177, _path4178, _path4179, _path4180, _path4181, _path4182, _path4183, _path4184, _path4185, _path4186, _path4187, _path4188, _path4189, _path4190, _path4191, _path4192, _path4193, _path4194, _path4195, _path4196, _path4197, _path4198, _path4199, _path4200, _path4201, _path4202, _path4203, _path4204, _path4205, _path4206, _path4207, _path4208, _path4209, _path4210, _path4211, _path4212, _path4213, _path4214, _path4215, _path4216, _path4217, _path4218, _path4219, _path4220, _path4221, _path4222, _path4223, _path4224, _path4225, _path4226, _path4227, _path4228, _path4229, _path4230, _path4231, _path4232, _path4233, _path4234, _path4235, _path4236, _path4237, _path4238, _path4239, _path4240, _path4241, _path4242, _path4243, _path4244, _path4245, _path4246, _path4247, _path4248, _path4249, _path4250, _path4251, _path4252, _path4253, _path4254, _path4255, _path4256, _path4257, _path4258, _path4259, _path4260, _path4261, _path4262, _path4263, _path4264, _path4265, _path4266, _path4267, _path4268, _path4269, _path4270, _path4271, _path4272, _path4273, _path4274, _path4275, _path4276, _path4277, _path4278, _path4279, _path4280, _path4281, _path4282, _path4283, _path4284, _path4285, _path4286, _path4287, _path4288, _path4289, _path4290, _path4291, _path4292, _path4293, _path4294, _path4295, _path4296, _path4297, _path4298, _path4299, _path4300, _path4301, _path4302, _path4303, _path4304, _path4305, _path4306, _path4307, _path4308, _path4309, _path4310, _path4311, _path4312, _path4313, _path4314, _path4315, _path4316, _path4317, _path4318, _path4319, _path4320, _path4321, _path4322, _path4323, _path4324, _path4325, _path4326, _path4327, _path4328, _path4329, _path4330, _path4331, _path4332, _path4333, _path4334, _path4335, _path4336, _path4337, _path4338, _path4339, _path4340, _path4341, _path4342, _path4343, _path4344, _path4345, _path4346, _path4347, _path4348, _path4349, _path4350, _path4351, _path4352, _path4353, _path4354, _path4355, _path4356, _path4357, _path4358, _path4359, _path4360, _path4361, _path4362, _path4363, _path4364, _path4365, _path4366, _path4367, _path4368, _path4369, _path4370, _path4371, _path4372, _path4373, _path4374, _path4375, _path4376, _path4377, _path4378, _path4379, _path4380, _path4381, _path4382, _path4383, _path4384, _path4385, _path4386, _path4387, _path4388, _path4389, _path4390, _path4391, _path4392, _path4393, _path4394, _path4395, _path4396, _path4397, _path4398, _path4399, _path4400, _path4401, _path4402, _path4403, _path4404, _path4405, _path4406, _path4407, _path4408, _path4409, _path4410, _path4411, _path4412, _path4413, _path4414, _path4415, _path4416, _path4417, _path4418, _path4419, _path4420, _path4421, _path4422, _path4423, _path4424, _path4425, _path4426, _path4427, _path4428, _path4429, _path4430, _path4431, _path4432, _path4433, _path4434, _path4435, _path4436, _path4437, _path4438, _path4439, _path4440, _path4441, _path4442, _path4443, _path4444, _path4445, _path4446, _path4447, _path4448, _path4449, _path4450, _path4451, _path4452, _path4453, _path4454, _path4455, _path4456, _path4457, _path4458, _path4459, _path4460, _path4461, _path4462, _path4463, _path4464, _path4465, _path4466, _path4467, _path4468, _path4469, _path4470, _path4471, _path4472, _path4473, _path4474, _path4475, _path4476, _path4477, _path4478, _path4479, _path4480, _path4481, _path4482, _path4483, _path4484, _path4485, _path4486, _path4487, _path4488, _path4489, _path4490, _path4491, _path4492, _path4493, _path4494, _path4495, _path4496, _path4497, _path4498, _path4499, _path4500, _path4501, _path4502, _path4503, _path4504, _path4505, _path4506, _path4507, _path4508, _path4509, _path4510, _path4511, _path4512, _path4513, _path4514, _path4515, _path4516, _path4517, _path4518, _path4519, _path4520, _path4521, _path4522, _path4523, _path4524, _path4525, _path4526, _path4527, _path4528, _path4529, _path4530, _path4531, _path4532, _path4533, _path4534, _path4535, _path4536, _path4537, _path4538, _path4539, _path4540, _path4541, _path4542, _path4543, _path4544, _path4545, _path4546, _path4547, _path4548, _path4549, _path4550, _path4551, _path4552, _path4553, _path4554, _path4555, _path4556, _path4557, _path4558, _path4559, _path4560, _path4561, _path4562, _path4563, _path4564, _path4565, _path4566, _path4567, _path4568, _path4569, _path4570, _path4571, _path4572, _path4573, _path4574, _path4575, _path4576, _path4577, _path4578, _path4579, _path4580, _path4581, _path4582, _path4583, _path4584, _path4585, _path4586, _path4587, _path4588, _path4589, _path4590, _path4591, _path4592, _path4593, _path4594, _path4595, _path4596, _path4597, _path4598, _path4599, _path4600, _path4601, _path4602, _path4603, _path4604, _path4605, _path4606, _path4607, _path4608, _path4609, _path4610, _path4611, _path4612, _path4613, _path4614, _path4615, _path4616, _path4617, _path4618, _path4619, _path4620, _path4621, _path4622, _path4623, _path4624, _path4625, _path4626, _path4627, _path4628, _path4629, _path4630, _path4631, _path4632, _path4633, _path4634, _path4635, _path4636, _path4637, _path4638, _path4639, _path4640, _path4641, _path4642, _path4643, _path4644, _path4645, _path4646, _path4647, _path4648, _path4649, _path4650, _path4651, _path4652, _path4653, _path4654, _path4655, _path4656, _path4657, _path4658, _path4659, _path4660, _path4661, _path4662, _path4663, _path4664, _path4665, _path4666, _path4667, _path4668, _path4669, _path4670, _path4671, _path4672, _path4673, _path4674, _path4675, _path4676, _path4677, _path4678, _path4679, _path4680, _path4681, _path4682, _path4683, _path4684, _path4685, _path4686, _path4687, _path4688, _path4689, _path4690, _path4691, _path4692, _path4693, _path4694, _path4695, _path4696, _path4697, _path4698, _path4699, _path4700, _path4701, _path4702, _path4703, _path4704, _path4705, _path4706, _path4707, _path4708, _path4709, _path4710, _path4711, _path4712, _path4713, _path4714, _path4715, _path4716, _path4717, _path4718, _path4719, _path4720, _path4721, _path4722, _path4723, _path4724, _path4725, _path4726, _path4727, _path4728, _path4729, _path4730, _path4731, _path4732, _path4733, _path4734, _path4735, _path4736, _path4737, _path4738, _path4739, _path4740, _path4741, _path4742, _path4743, _path4744, _path4745, _path4746, _path4747, _path4748, _path4749, _path4750, _path4751, _path4752, _path4753, _path4754, _path4755, _path4756, _path4757, _path4758, _path4759, _path4760, _path4761, _path4762, _path4763, _path4764, _path4765, _path4766, _path4767, _path4768, _path4769, _path4770, _path4771, _path4772, _path4773, _path4774, _path4775, _path4776, _path4777, _path4778, _path4779, _path4780, _path4781, _path4782, _path4783, _path4784, _path4785, _path4786, _path4787, _path4788, _path4789, _path4790, _path4791, _path4792, _path4793, _path4794, _path4795, _path4796, _path4797, _path4798, _path4799, _path4800, _path4801, _path4802, _path4803, _path4804, _path4805, _path4806, _path4807, _path4808, _path4809, _path4810, _path4811, _path4812, _path4813, _path4814, _path4815, _path4816, _path4817, _path4818, _path4819, _path4820, _path4821, _path4822, _path4823, _path4824, _path4825, _path4826, _path4827, _path4828, _path4829, _path4830, _path4831, _path4832, _path4833, _path4834, _path4835, _path4836, _path4837, _path4838, _path4839, _path4840, _path4841, _path4842, _path4843, _path4844, _path4845, _path4846, _path4847, _path4848, _path4849, _path4850, _path4851, _path4852, _path4853, _path4854, _path4855, _path4856, _path4857, _path4858, _path4859, _path4860, _path4861, _path4862, _path4863, _path4864, _path4865, _path4866, _path4867, _path4868, _path4869, _path4870, _path4871, _path4872, _path4873, _path4874, _path4875, _path4876, _path4877, _path4878, _path4879, _path4880, _path4881, _path4882, _path4883, _path4884, _path4885, _path4886, _path4887, _path4888, _path4889, _path4890, _path4891, _path4892, _path4893, _path4894, _path4895, _path4896, _path4897, _path4898, _path4899, _path4900, _path4901, _path4902, _path4903, _path4904, _path4905, _path4906, _path4907, _path4908, _path4909, _path4910, _path4911, _path4912, _path4913, _path4914, _path4915, _path4916, _path4917, _path4918, _path4919, _path4920, _path4921, _path4922, _path4923, _path4924, _path4925, _path4926, _path4927, _path4928, _path4929, _path4930, _path4931, _path4932, _path4933, _path4934, _path4935, _path4936, _path4937, _path4938, _path4939, _path4940, _path4941, _path4942, _path4943, _path4944, _path4945, _path4946, _path4947, _path4948, _path4949, _path4950, _path4951, _path4952, _path4953, _path4954, _path4955, _path4956, _path4957, _path4958, _path4959, _path4960, _path4961, _path4962, _path4963, _path4964, _path4965, _path4966, _path4967, _path4968, _path4969, _path4970, _path4971, _path4972, _path4973, _path4974, _path4975, _path4976, _path4977, _path4978, _path4979, _path4980, _path4981, _path4982, _path4983, _path4984, _path4985, _path4986, _path4987, _path4988, _path4989, _path4990, _path4991, _path4992, _path4993, _path4994, _path4995, _path4996, _path4997, _path4998, _path4999, _path5000, _path5001, _path5002, _path5003, _path5004, _path5005, _path5006, _path5007, _path5008, _path5009, _path5010, _path5011, _path5012, _path5013, _path5014, _path5015, _path5016, _path5017, _path5018, _path5019, _path5020, _path5021, _path5022, _path5023, _path5024, _path5025, _path5026, _path5027, _path5028, _path5029, _path5030, _path5031, _path5032, _path5033, _path5034, _path5035, _path5036, _path5037, _path5038, _path5039, _path5040, _path5041, _path5042, _path5043, _path5044, _path5045, _path5046, _path5047, _path5048, _path5049, _path5050, _path5051, _path5052, _path5053, _path5054, _path5055, _path5056, _path5057, _path5058, _path5059, _path5060, _path5061, _path5062, _path5063, _path5064, _path5065, _path5066, _path5067, _path5068, _path5069, _path5070, _path5071, _path5072, _path5073, _path5074, _path5075, _path5076, _path5077, _path5078, _path5079, _path5080, _path5081, _path5082, _path5083, _path5084, _path5085, _path5086, _path5087, _path5088, _path5089, _path5090, _path5091, _path5092, _path5093, _path5094, _path5095, _path5096, _path5097, _path5098, _path5099, _path5100, _path5101, _path5102, _path5103, _path5104, _path5105, _path5106, _path5107, _path5108, _path5109, _path5110, _path5111, _path5112, _path5113, _path5114, _path5115, _path5116, _path5117, _path5118, _path5119, _path5120, _path5121, _path5122, _path5123, _path5124, _path5125, _path5126, _path5127, _path5128, _path5129, _path5130, _path5131, _path5132, _path5133, _path5134, _path5135, _path5136, _path5137, _path5138, _path5139, _path5140, _path5141, _path5142, _path5143, _path5144, _path5145, _path5146, _path5147, _path5148, _path5149, _path5150, _path5151, _path5152, _path5153, _path5154, _path5155, _path5156, _path5157, _path5158, _path5159, _path5160, _path5161, _path5162, _path5163, _path5164, _path5165, _path5166, _path5167, _path5168, _path5169, _path5170, _path5171, _path5172, _path5173, _path5174, _path5175, _path5176, _path5177, _path5178, _path5179, _path5180, _path5181, _path5182, _path5183, _path5184, _path5185, _path5186, _path5187, _path5188, _path5189, _path5190, _path5191, _path5192, _path5193, _path5194, _path5195, _path5196, _path5197, _path5198, _path5199, _path5200, _path5201, _path5202, _path5203, _path5204, _path5205, _path5206, _path5207, _path5208, _path5209, _path5210, _path5211, _path5212, _path5213, _path5214, _path5215, _path5216, _path5217, _path5218, _path5219, _path5220, _path5221, _path5222, _path5223, _path5224, _path5225, _path5226, _path5227, _path5228, _path5229, _path5230, _path5231, _path5232, _path5233, _path5234, _path5235, _path5236, _path5237, _path5238, _path5239, _path5240, _path5241, _path5242, _path5243, _path5244, _path5245, _path5246, _path5247, _path5248, _path5249, _path5250, _path5251, _path5252, _path5253, _path5254, _path5255, _path5256, _path5257, _path5258, _path5259, _path5260, _path5261, _path5262, _path5263, _path5264, _path5265, _path5266, _path5267, _path5268, _path5269, _path5270, _path5271, _path5272, _path5273, _path5274, _path5275, _path5276, _path5277, _path5278, _path5279, _path5280, _path5281, _path5282, _path5283, _path5284, _path5285, _path5286, _path5287, _path5288, _path5289, _path5290, _path5291, _path5292, _path5293, _path5294, _path5295, _path5296, _path5297, _path5298, _path5299, _path5300, _path5301, _path5302, _path5303, _path5304, _path5305, _path5306, _path5307, _path5308, _path5309, _path5310, _path5311, _path5312, _path5313, _path5314, _path5315, _path5316, _path5317, _path5318, _path5319, _path5320, _path5321, _path5322, _path5323, _path5324, _path5325, _path5326, _path5327, _path5328, _path5329, _path5330, _path5331, _path5332, _path5333, _path5334, _path5335, _path5336, _path5337, _path5338, _path5339, _path5340, _path5341, _path5342, _path5343, _path5344, _path5345, _path5346, _path5347, _path5348, _path5349, _path5350, _path5351, _path5352, _path5353, _path5354, _path5355, _path5356, _path5357, _path5358, _path5359, _path5360, _path5361, _path5362, _path5363, _path5364, _path5365, _path5366, _path5367, _path5368, _path5369, _path5370, _path5371, _path5372, _path5373, _path5374, _path5375, _path5376, _path5377, _path5378, _path5379, _path5380, _path5381, _path5382, _path5383, _path5384, _path5385, _path5386, _path5387, _path5388, _path5389, _path5390, _path5391, _path5392, _path5393, _path5394, _path5395, _path5396, _path5397, _path5398, _path5399, _path5400, _path5401, _path5402, _path5403, _path5404, _path5405, _path5406, _path5407, _path5408, _path5409, _path5410, _path5411, _path5412, _path5413, _path5414, _path5415, _path5416, _path5417, _path5418, _path5419, _path5420, _path5421, _path5422, _path5423, _path5424, _path5425, _path5426, _path5427, _path5428, _path5429, _path5430, _path5431, _path5432, _path5433, _path5434, _path5435, _path5436, _path5437, _path5438, _path5439, _path5440, _path5441, _path5442, _path5443, _path5444, _path5445, _path5446, _path5447, _path5448, _path5449, _path5450, _path5451, _path5452, _path5453, _path5454, _path5455, _path5456, _path5457, _path5458, _path5459, _path5460, _path5461, _path5462, _path5463, _path5464, _path5465, _path5466, _path5467, _path5468, _path5469, _path5470, _path5471, _path5472, _path5473, _path5474, _path5475, _path5476, _path5477, _path5478, _path5479, _path5480, _path5481, _path5482, _path5483, _path5484, _path5485, _path5486, _path5487, _path5488, _path5489, _path5490, _path5491, _path5492, _path5493, _path5494, _path5495, _path5496, _path5497, _path5498, _path5499, _path5500, _path5501, _path5502, _path5503, _path5504, _path5505, _path5506, _path5507, _path5508, _path5509, _path5510, _path5511, _path5512, _path5513, _path5514, _path5515, _path5516, _path5517, _path5518, _path5519, _path5520, _path5521, _path5522, _path5523, _path5524, _path5525, _path5526, _path5527, _path5528, _path5529, _path5530, _path5531, _path5532, _path5533, _path5534, _path5535, _path5536, _path5537, _path5538, _path5539, _path5540, _path5541, _path5542, _path5543, _path5544, _path5545, _path5546, _path5547, _path5548, _path5549, _path5550, _path5551, _path5552, _path5553, _path5554, _path5555, _path5556, _path5557, _path5558, _path5559, _path5560, _path5561, _path5562, _path5563, _path5564, _path5565, _path5566, _path5567, _path5568, _path5569, _path5570, _path5571, _path5572, _path5573, _path5574, _path5575, _path5576, _path5577, _path5578, _path5579, _path5580, _path5581, _path5582, _path5583, _path5584, _path5585, _path5586, _path5587, _path5588, _path5589, _path5590, _path5591, _path5592, _path5593, _path5594, _path5595, _path5596, _path5597, _path5598, _path5599, _path5600, _path5601, _path5602, _path5603, _path5604, _path5605, _path5606, _path5607, _path5608, _path5609, _path5610, _path5611, _path5612, _path5613, _path5614, _path5615, _path5616, _path5617, _path5618, _path5619, _path5620, _path5621, _path5622, _path5623, _path5624, _path5625, _path5626, _path5627, _path5628, _path5629, _path5630, _path5631, _path5632, _path5633, _path5634, _path5635, _path5636, _path5637, _path5638, _path5639, _path5640, _path5641, _path5642, _path5643, _path5644, _path5645, _path5646, _path5647, _path5648, _path5649, _path5650, _path5651, _path5652, _path5653, _path5654, _path5655, _path5656, _path5657, _path5658, _path5659, _path5660, _path5661, _path5662, _path5663, _path5664, _path5665, _path5666, _path5667, _path5668, _path5669, _path5670, _path5671, _path5672, _path5673, _path5674, _path5675, _path5676, _path5677, _path5678, _path5679, _path5680, _path5681, _path5682, _path5683, _path5684, _path5685, _path5686, _path5687, _path5688, _path5689, _path5690, _path5691, _path5692, _path5693, _path5694, _path5695, _path5696, _path5697, _path5698, _path5699, _path5700, _path5701, _path5702, _path5703, _path5704, _path5705, _path5706, _path5707, _path5708, _path5709, _path5710, _path5711, _path5712, _path5713, _path5714, _path5715, _path5716, _path5717, _path5718, _path5719, _path5720, _path5721, _path5722, _path5723, _path5724, _path5725, _path5726, _path5727, _path5728, _path5729, _path5730, _path5731, _path5732, _path5733, _path5734, _path5735, _path5736, _path5737, _path5738, _path5739, _path5740, _path5741, _path5742, _path5743, _path5744, _path5745, _path5746, _path5747, _path5748, _path5749, _path5750, _path5751, _path5752, _path5753, _path5754, _path5755, _path5756, _path5757, _path5758, _path5759, _path5760, _path5761, _path5762, _path5763, _path5764, _path5765, _path5766, _path5767, _path5768, _path5769, _path5770, _path5771, _path5772, _path5773, _path5774, _path5775, _path5776, _path5777, _path5778, _path5779, _path5780, _path5781, _path5782, _path5783, _path5784, _path5785, _path5786, _path5787, _path5788, _path5789, _path5790, _path5791, _path5792, _path5793, _path5794, _path5795, _path5796, _path5797, _path5798, _path5799, _path5800, _path5801, _path5802, _path5803, _path5804, _path5805, _path5806, _path5807, _path5808, _path5809, _path5810, _path5811, _path5812, _path5813, _path5814, _path5815, _path5816, _path5817, _path5818, _path5819, _path5820, _path5821, _path5822, _path5823, _path5824, _path5825, _path5826, _path5827, _path5828, _path5829, _path5830, _path5831, _path5832, _path5833, _path5834, _path5835, _path5836, _path5837, _path5838, _path5839, _path5840, _path5841, _path5842, _path5843, _path5844, _path5845, _path5846, _path5847, _path5848, _path5849, _path5850, _path5851, _path5852, _path5853, _path5854, _path5855, _path5856, _path5857, _path5858, _path5859, _path5860, _path5861, _path5862, _path5863, _path5864, _path5865, _path5866, _path5867, _path5868, _path5869, _path5870, _path5871, _path5872, _path5873, _path5874, _path5875, _path5876, _path5877, _path5878, _path5879, _path5880, _path5881, _path5882, _path5883, _path5884, _path5885, _path5886, _path5887, _path5888, _path5889, _path5890, _path5891, _path5892, _path5893, _path5894, _path5895, _path5896, _path5897, _path5898, _path5899, _path5900, _path5901, _path5902, _path5903, _path5904, _path5905, _path5906, _path5907, _path5908, _path5909, _path5910, _path5911, _path5912, _path5913, _path5914, _path5915, _path5916, _path5917, _path5918, _path5919, _path5920, _path5921, _path5922, _path5923, _path5924, _path5925, _path5926, _path5927, _path5928, _path5929, _path5930, _path5931, _path5932, _path5933, _path5934, _path5935, _path5936, _path5937, _path5938, _path5939, _path5940, _path5941, _path5942, _path5943, _path5944, _path5945, _path5946, _path5947, _path5948, _path5949, _path5950, _path5951, _path5952, _path5953, _path5954, _path5955, _path5956, _path5957, _path5958, _path5959, _path5960, _path5961, _path5962, _path5963, _path5964, _path5965, _path5966, _path5967, _path5968, _path5969, _path5970, _path5971, _path5972, _path5973, _path5974, _path5975, _path5976, _path5977, _path5978, _path5979, _path5980, _path5981, _path5982, _path5983, _path5984, _path5985, _path5986, _path5987, _path5988, _path5989, _path5990, _path5991, _path5992, _path5993, _path5994, _path5995, _path5996, _path5997, _path5998, _path5999, _path6000, _path6001, _path6002, _path6003, _path6004, _path6005, _path6006, _path6007, _path6008, _path6009, _path6010, _path6011, _path6012, _path6013, _path6014, _path6015, _path6016, _path6017, _path6018, _path6019, _path6020, _path6021, _path6022, _path6023, _path6024, _path6025, _path6026, _path6027, _path6028, _path6029, _path6030, _path6031, _path6032, _path6033, _path6034, _path6035, _path6036, _path6037, _path6038, _path6039, _path6040, _path6041, _path6042, _path6043, _path6044, _path6045, _path6046, _path6047, _path6048, _path6049, _path6050, _path6051, _path6052, _path6053, _path6054, _path6055, _path6056, _path6057, _path6058, _path6059, _path6060, _path6061, _path6062, _path6063, _path6064, _path6065, _path6066, _path6067, _path6068, _path6069, _path6070, _path6071, _path6072, _path6073, _path6074, _path6075, _path6076, _path6077, _path6078, _path6079, _path6080, _path6081, _path6082, _path6083, _path6084, _path6085, _path6086, _path6087, _path6088, _path6089, _path6090, _path6091, _path6092, _path6093, _path6094, _path6095, _path6096, _path6097, _path6098, _path6099, _path6100, _path6101, _path6102, _path6103, _path6104, _path6105, _path6106, _path6107, _path6108, _path6109, _path6110, _path6111, _path6112, _path6113, _path6114, _path6115, _path6116, _path6117, _path6118, _path6119, _path6120, _path6121, _path6122, _path6123, _path6124, _path6125, _path6126, _path6127, _path6128, _path6129, _path6130, _path6131, _path6132, _path6133, _path6134, _path6135, _path6136, _path6137, _path6138, _path6139, _path6140, _path6141, _path6142, _path6143, _path6144, _path6145, _path6146, _path6147, _path6148, _path6149, _path6150, _path6151, _path6152, _path6153, _path6154, _path6155, _path6156, _path6157, _path6158, _path6159, _path6160, _path6161, _path6162, _path6163, _path6164, _path6165, _path6166, _path6167, _path6168, _path6169, _path6170, _path6171, _path6172, _path6173, _path6174, _path6175, _path6176, _path6177, _path6178, _path6179, _path6180, _path6181, _path6182, _path6183, _path6184, _path6185, _path6186, _path6187, _path6188, _path6189, _path6190, _path6191, _path6192, _path6193, _path6194, _path6195, _path6196, _path6197, _path6198, _path6199, _path6200, _path6201, _path6202, _path6203, _path6204, _path6205, _path6206, _path6207, _path6208, _path6209, _path6210, _path6211, _path6212, _path6213, _path6214, _path6215, _path6216, _path6217, _path6218, _path6219, _path6220, _path6221, _path6222, _path6223, _path6224, _path6225, _path6226, _path6227, _path6228, _path6229, _path6230, _path6231, _path6232, _path6233, _path6234, _path6235, _path6236, _path6237, _path6238, _path6239, _path6240, _path6241, _path6242, _path6243, _path6244, _path6245, _path6246, _path6247, _path6248, _path6249, _path6250, _path6251, _path6252, _path6253, _path6254, _path6255, _path6256, _path6257, _path6258, _path6259, _path6260, _path6261, _path6262, _path6263, _path6264, _path6265, _path6266, _path6267, _path6268, _path6269, _path6270, _path6271, _path6272, _path6273, _path6274, _path6275, _path6276, _path6277, _path6278, _path6279, _path6280, _path6281, _path6282, _path6283, _path6284, _path6285, _path6286, _path6287, _path6288, _path6289, _path6290, _path6291, _path6292, _path6293, _path6294, _path6295, _path6296, _path6297, _path6298, _path6299, _path6300, _path6301, _path6302, _path6303, _path6304, _path6305, _path6306, _path6307, _path6308, _path6309, _path6310, _path6311, _path6312, _path6313, _path6314, _path6315, _path6316, _path6317, _path6318, _path6319, _path6320, _path6321, _path6322, _path6323, _path6324, _path6325, _path6326, _path6327, _path6328, _path6329, _path6330, _path6331, _path6332, _path6333, _path6334, _path6335, _path6336, _path6337, _path6338, _path6339, _path6340, _path6341, _path6342, _path6343, _path6344, _path6345, _path6346, _path6347, _path6348, _path6349, _path6350, _path6351, _path6352, _path6353, _path6354, _path6355, _path6356, _path6357, _path6358, _path6359, _path6360, _path6361, _path6362, _path6363, _path6364, _path6365, _path6366, _path6367, _path6368, _path6369, _path6370, _path6371, _path6372, _path6373, _path6374, _path6375, _path6376, _path6377, _path6378, _path6379, _path6380, _path6381, _path6382, _path6383, _path6384, _path6385, _path6386, _path6387, _path6388, _path6389, _path6390, _path6391, _path6392, _path6393, _path6394, _path6395, _path6396, _path6397, _path6398, _path6399, _path6400, _path6401, _path6402, _path6403, _path6404, _path6405, _path6406, _path6407, _path6408, _path6409, _path6410, _path6411, _path6412, _path6413, _path6414, _path6415, _path6416, _path6417, _path6418, _path6419, _path6420, _path6421, _path6422, _path6423, _path6424, _path6425, _path6426, _path6427, _path6428, _path6429, _path6430, _path6431, _path6432, _path6433, _path6434, _path6435, _path6436, _path6437, _path6438, _path6439, _path6440, _path6441, _path6442, _path6443, _path6444, _path6445, _path6446, _path6447, _path6448, _path6449, _path6450, _path6451, _path6452, _path6453, _path6454, _path6455, _path6456, _path6457, _path6458, _path6459, _path6460, _path6461, _path6462, _path6463, _path6464, _path6465, _path6466, _path6467, _path6468, _path6469, _path6470, _path6471, _path6472, _path6473, _path6474, _path6475, _path6476, _path6477, _path6478, _path6479, _path6480, _path6481, _path6482, _path6483, _path6484, _path6485, _path6486, _path6487, _path6488, _path6489, _path6490, _path6491, _path6492, _path6493, _path6494, _path6495, _path6496, _path6497, _path6498, _path6499, _path6500, _path6501, _path6502, _path6503, _path6504, _path6505, _path6506, _path6507, _path6508, _path6509, _path6510;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrinksCan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 128,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 57v-3h1v-1h1v1h1v-1h1v4zm3-12h-2v-1h-1v-1h3zm1 17h-1v-1h1zm-1 7h1v1h-1zm0 2h1v1h-1z",
    fill: "#c21e25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 113h-1v-1h-4v-2h1v-1h2v2h2zm29-38v3h-1v-3zm-1-8h1v2h-1v-1zm-27 48v1h-1v-2h1zm27-63h1v1h-1zm2 22v1h-1v-1zm-37 26v-1h1v1z",
    fill: "#c21d23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84 75h1v-1h1v4h-2zm-31 34h-3v-1h-1v-1h4zm-5-5v-2h1v2zm36-75v1h-1v-1zm-35 77v-1h1v1zm6 8v-1h1v1z",
    fill: "#c31e24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87 70h-1v-6h1v1zm-1-35v1h-2v-1h1zm-4 6h1v2h-1v-1zm2-6h-1v-1h1zm1 4v1h-1v-1zm0 4h-1v-1h1zm0 19h1v1h-1zm2 9v1h-1v-1z",
    fill: "#c11f25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85 96h-1v4h-1v-1h-1v-2h1v-3h1v-2h1v2zm-1-7h2v1h-2zm0 22v1h-1v-1z",
    fill: "#c82329"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h1v5h-1zm0-12v-4h1v4zm0 1h1v4h-1v-1zm1 24h-1v-1h1z",
    fill: "#bf2428"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107h1v2h2v1h-4v-2h1zm-20 6v2h-1v-1h-3v-1zm3-23v1h-1v-2h1z",
    fill: "#c01b21"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84 90h-1v-2h2v1h-1zm-1 7h-1v-3h1zm1-3h-1v-2h1v1zm1-13v1h-1v-1zm1 7h-1v-1h1zm-14 21v-1h1v1zm13 1v1h-1v-1z",
    fill: "#c72228"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78 107v1h-1v1h-2v-2zm-28 6v-1h4v1h-1zm4 1v-1h1v2h-1zm20-7v1h-1v-1z",
    fill: "#c11c22"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33h2v3h-1v-2h-1zM39 72v-3h1v2h1v1zm4-27v-2h1v2zm2-21v-1h1v1z",
    fill: "#b2181a"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h1v8h-1v-1zm0-10h1v1h-1zm1 3v1h-1v-1z",
    fill: "#a20e0e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51 61v5h-1v-5zm3 4h-1v-3h1v1zm5-18h-1v-1h1zm-6 30h1v1h-1z",
    fill: "#af1216"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44 71v3h-1v-3zm-1 6v-2h1v1h1v1zm12-15v1h-1v-1zm1 9h-1v-1h1zm-2 6v-1h1v1zm4 1h1v1h-1z",
    fill: "#aa1012"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51 71h1v1h2v1h-3zm1-7h1v2h-1v-1zm-1 2h1v1h-1zm1 9h1v1h-1zm15 10v1h-1v-1zm10 34v-1h1v1z",
    fill: "#b31419"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43 29v-3h2v1h-1v2zm2-7h1v1h-1zm14 10h-1v-1h1zM43 43v-1h1v1zm-1 0h1v1h-1zm-3 35h1v1h-1z",
    fill: "#b2191b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48 107h-1v-2h1v1zm38-46h-1v-1h1zm-2 6h-1v-1h1zm0 12h1v1h-1zm-3 19h1v1h-1zm-32 8h1v1h-1zm19 0v1h-1v-1zm-14 4v1h-1v-1z",
    fill: "#c21e24"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81h-1v-3h1v1zm-1-7v2h-1v-2zm1-7v1h-1v-1zm10 3v1h-1v-1zm1 2v-1h1v1zm-4 3v-1h1v1z",
    fill: "#af1316"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84 87h1v1h-2v-1zm2-7v1h-1v-1zm-1 4h1v1h-1zm1 1h1v1h-1zm-1 1h1v1h-1zm-3 7v-1h1v1zm-11 16v-1h1v1zm12 6h-1v-1h1z",
    fill: "#c62127"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54v-1h1v2h-1zm8-30v1h-1v-1zm12 12h1v1h-1zM43 47h1v1h-1zm-1 2v1h-1v-1zm0 22v1h-1v-1zm-1 3v1h-1v-1z",
    fill: "#af1517"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45 36h-1v-4h1v1zm0-9v-1h1v1zm-1 3h1v1h-1zm0 8h1v1h-1zm1 2v1h-1v-1z",
    fill: "#b0171a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29v1h-1v3h-1v-4zm-1 9h-1v-2h1v1zm0 1v1h-1v-1z",
    fill: "#b1181b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46 30h1v6h-1v-4h-1v-1h1zm0 8v1h-1v-1z",
    fill: "#ac151a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73h-1v-1h2v1zm19-38h1v1h-1zm-1 2h1v1h-1zm-13 6v1h-1v-1zm-1 4h-1v-1h1zm-1 2h-1v-1h1zm-3 29v-1h1v1z",
    fill: "#b01618"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h1v3h-1v-1zm-1-17v1h-1v-1zm2 34v-1h1v1zm-38 33v-1h1v1zm6 0v1h-1v-1zm6 8h-1v-1h1z",
    fill: "#c21f25"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M84 67h1v3h-1zm-3-25h1v1h-1zm3 23h1v1h-1zm-38 38h1v1h-1zm5 1h-1v-1h1zm6 11v1h-1v-1z",
    fill: "#c21d24"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50v1h-1v-2h1zm-2 19h1v2h-1v-1zm2-21h1v1h-1zm-1 19v-1h1v1zm8 2v-1h1v1zm-9 3h1v1h-1z",
    fill: "#ae1416"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57v1h-1v-5h1zm0 5v1h-1v-2h1zm-3-14h1v1h-1z",
    fill: "#c12026"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57 62h-1v-2h1v1zm0 3h-1v-1h1zm-12 6h-1v-1h1zm-1 1h1v1h-1zm12 3h1v1h-1zm-11 3v-1h1v1zm2 3h-1v-1h1z",
    fill: "#a80e10"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M51 61h1v5h-1v-1zm2 23v-1h1v1zm14 1h1v1h-1zm8 5h1v1h-1z",
    fill: "#b4151a"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M50 115v-1h3v1zm33-53v-1h1v1zM58 89h-1v-1h1zm-10 7v-1h1v1zm29 8h1v1h-1zm-22 12h1v1h-1z",
    fill: "#c01b20"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M45 76h-1v-3h1zm9-11v-1h1v1zm3 5v1h-1v-1zm0 3v1h-1v-1zm-2 4v1h-1v-1zm-9 5v-1h1v1z",
    fill: "#a90f11"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M55 111h1v2h-1v-1zm2 3v1h-1v-2h1zm29-35v1h-1v-1zm-2 1h1v1h-1zm-39 25h-1v-1h1zm27 4h1v1h-1z",
    fill: "#c41f25"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M98 49h-1v-3h1zm-67 62h-1v-2h1v1zM91 5V4h1v1zm7 40h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h1v2h-1v-1zM76 8h-1V7h1zM45 31v1h-1v-1zm14 7v1h-1v-1zm-15 2v-1h1v1zm1 3h-1v-1h1z",
    fill: "#af1619"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47v1h-1v-2h1zm2-23h1v1h-1zm14 13h-1v-1h1zm-15 8v1h-1v-1zm-3 26h-1v-1h1zm-2 3h1v1h-1z",
    fill: "#b11719"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M43 44v1h-1v2h-1v-3zm0-19h1v1h-1zm-5 44v-1h1v1zm1 8h-1v-1h1z",
    fill: "#b31a1c"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38h-1v-3h1v1zm2-12h-1v-1h1zm1 0v1h-1v-1zm-1 1v1h-1v-1zm-1 1v1h-1v-1z",
    fill: "#a91315"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M38 71h1v4h-1v-1zm7-42h-1v-1h1zm-6 22v1h-1v-1zm1 26v1h-1v-1z",
    fill: "#b0181a"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M87 37h1v3h-1zm0 6h1v2h-1v-1zm1 10v1h-1v-1zm0 5h-1v-1h1z",
    fill: "#c12227"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M88 57h-1v-3h1zm0 18h-1v-3h1v1zm0-29v1h-1v-1z",
    fill: "#c22227"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v1h1v1h-1v1h-1v-3zm0 6v-1h1v2h-1zm-1 10v-1h1v1z",
    fill: "#a10d0d"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M88 66h1v6h-1v-1zM40 86v1h-1v-1z",
    fill: "#c02428"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M86 90v2h-2v-2zm0 15h1v1h-1zm-3 3h1v1h-1zm2 2h-1v-1h1z",
    fill: "#c92229"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M84 97v-1h1v-1h1v2h-1v3h-1zm1-3v-1h1v1z",
    fill: "#c9242a"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32v3h-1v-3zM81 7V6h1v1zm-9 0v1h-1V7zM48 30v1h-1v-1z",
    fill: "#aa1517"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M98 41v3h-1v-3zm0-3v2h-1v-2zm-5-27h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.012
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M43 32v1h-1v-2h1zm2-9h-1v-1h1zm-1 1h-1v-1h1zm-2 6v-1h1v1zm-2 50v1h-1v-1z",
    fill: "#b51b1d"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27v6h-1v-6z",
    fill: "#b71d1f"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h-1v-1h-2v-1h3zm-1-15h-1v-1h1zm1 5v1h-1v-1z",
    fill: "#c01f25"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105h-1v1h-1v-2h2zm35-70v-1h1v1zm-34 69h1v1h-1zm-2 7v-1h1v1z",
    fill: "#c21f24"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h-1v-1h1zM42 66v1h-1v-1zm8 2v-1h1v1zm0 3h1v1h-1zm-7 3v1h-1v-1zm-1 3v-1h1v1z",
    fill: "#ad1215"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h-1v-2h1v1zm-3-3h1v1h-1zm-1 3v-1h1v1zm2 6h1v1h-1zm1 33h-1v-1h1z",
    fill: "#c11e25"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M90 70v3h-1v-3zm-1-4h1v1h-1zm1 3h-1v-1h1zm0 12h1v1h-1z",
    fill: "#be2729"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M49 72h1v4h-1v-1zm29 2v-1h1v1zm-22 7h-1v-1h1z",
    fill: "#a50c0f"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M57 85v1h-1v-1zm-12 2v-1h1v1zm5-1h1v1h-1zm-2 2h-1v-1h1zm2-1v1h-1v-1zm10 3h1v1h-1z",
    fill: "#ba161d"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v-1h1v2h-2v-1zm4-2v1h-1v-1zm-2 3v-1h1v1zm-1 25v1h-1v-1z",
    fill: "#be191f"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M87 96h-1v-3h1zm0-4h-1v-2h1v1zm0 12h-1v-1h1z",
    fill: "#ca252c"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M56 123v-1h5v1h-1zm10 0h-1v-1h1z",
    fill: "#a0a19c"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M46 77h-1v-3h1zM63 7h1v1h-1zm-9 55v-1h1v1z",
    fill: "#a70e10"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M85 97h1v3h-1zm0-78v1h-1v-1zm0 87h1v1h-1z",
    fill: "#ca252b"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M44 21h1v1h-1zm-2 1v1h-1v-1zm1 1v-1h1v1zm-1 0h1v1h-1zm-3 59v-1h1v1z",
    fill: "#b61c1e"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23h-1v-1h2v1zm-1 3h-1v-1h1zm-2 19h-1v-1h1zm-3 3v1h-1v-1z",
    fill: "#af1618"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M87 69h1v3h-1zm-1-44h1v1h-1zm2 21h-1v-1h1z",
    fill: "#c12127"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M41 36v1h-1v-4h1zm0-9h-1v-1h1z",
    fill: "#b62022"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M43 29h-1v-3h1zm-1 14v1h-1v-1zm-5 32h1v1h-1z",
    fill: "#b41b1d"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M49 27h-1v-1h1zm0 1v-1h1v1zm0 7h-1v-1h1zm11 2h1v1h-1zm-13 6v1h-1v-1z",
    fill: "#a91415"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29h1v1h-1zm-5 17v-1h1v1zm-8 12h-1v-1h1zm-26 1v1h-1v-1zm34 3v1h-1v-1z",
    fill: "#c1c4be"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M87 76h1v2h-1v-1zm1-47v1h-1v-1zm-2 21v1h-1v-1zm2 30h-1v-1h1z",
    fill: "#c32027"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h-1v-3h1zm-1 2h1v1h-1zm1 4h-1v-1h1z",
    fill: "#b2191c"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M84 66h2v1h-2zm0-33h1v1h-1zm-1 1v1h-1v-1zm0 19v1h-1v-1z",
    fill: "#c31e25"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34h1v1h-1zm-6 4h-1v-1h1zM52 57h-1v-1h1zm-7 9v-1h1v1zm4 14v-1h1v1z",
    fill: "#a60e10"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v4h-1v-4zm14 5v1h-1v-1z",
    fill: "#ab1419"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M75 37h-1v-1h1zm3 12h1v1h-1zM36 59h-1v-1h1zm36 19h-1v-1h1zm-8 31v1h-1v-1z",
    fill: "#c2c4be"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M87 37v2h-1v-2zm0 23h-1v-2h1v1zm0 5h1v1h-1z",
    fill: "#c02126"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M80 39h-1v-1h1zm-9 26h1v1h-1zm-9 5h-1v-1h1zm3 19v1h-1v-1zm4 3h-1v-1h1z",
    fill: "#c2c2bd"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M85 40h1v1h-2v-1zm-1 6v-1h1v1zm-1 3v-1h1v1zm-3 56h-1v-1h1z",
    fill: "#c01f26"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h-1v-2h1v1zm27-15h-1v-1h1zm2 25v1h-1v-1zm-4 3v-1h1v1z",
    fill: "#a00c0d"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46h1v3h-1zm0 27v-1h1v2h-1z",
    fill: "#c02529"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v-2h1v2zm3 4v1h-1v-1zm-2 11v1h-1v-1zm0 10h-1v-1h1z",
    fill: "#a20d0e"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M87 49v1h-1v-1zm-2 3v-1h1v1zm1 8h1v1h-1zm1 24v-1h1v1zm-45 3v1h-1v-1z",
    fill: "#c22026"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50v1h-1v-1zm-1 7h1v1h-1zm1 1h1v1h-1zm26 12h-1v-1h1zm-27 4h1v1h-1z",
    fill: "#a10c0d"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60h-1v-1h1zm-23 3h-1v-1h1zm-10 4h1v1h-1zm10 2h-1v-1h1zm-9 10h1v1h-1z",
    fill: "#a40b0d"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M44 81v1h-1v-2h1zm6-20v-1h1v1zm3 8v1h-1v-1zm1 2h-1v-1h1z",
    fill: "#ae1215"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74v3h-1v-3zm7-14v1h-1v-1zm-6 17v-1h1v1z",
    fill: "#a40c0e"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M83 60h1v1h-1zM43 87v1h-1v-1zm15 4h-1v-1h1zm-10 6h1v1h-1zm29 9v1h-1v-1z",
    fill: "#c21c23"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M53 80h1v2h-1v-1zm1-19v1h-1v-1zm1 13v1h-1v-1zm-4 5h-1v-1h1z",
    fill: "#ad1115"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M88 65h-1v-4h1v1zm-46 46h1v1h-1z",
    fill: "#c02227"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M89 62v-1h1v5h-1z",
    fill: "#bd2628"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M52 64v-2h1v2zm1 10h1v1h-1zm-1 9h1v1h-1zm11 34h1v1h-1z",
    fill: "#b31319"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65v1h-1v-1zm-1 4h1v1h-1zm1 6h-1v-1h1zm-36 36v1h-1v-1zm11 4v1h-1v-1z",
    fill: "#c21d22"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78h-2v-1h2zm-1-12v1h-1v-1zm-1 4h1v1h-1zm0 4h1v1h-1z",
    fill: "#ab1113"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M76 117h1v2h-2v-1h1zM52 66h1v1h-1zm-1 1h1v1h-1z",
    fill: "#b21419"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78h-1v-3h1zm0-10v1h-1v-1zm0 13v-1h1v1z",
    fill: "#a50c0e"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M51 71v-1h1v1zm3 0v-1h1v1zm1 5h-1v-1h1zm-12 4v-1h1v1zm1 2v-1h1v1z",
    fill: "#ad1114"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M51 80v-1h1v2h-1zm28-8v1h-1v-1zm-25 7v-1h1v1zm0 3v-1h1v1z",
    fill: "#a80d11"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M56 111h1v2h-1v-1zm28-29h-1v-1h1zm0 5h-1v-1h1zm-13 21v1h-1v-1z",
    fill: "#c52026"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M51 87v-1h3v1zm-5-2v1h-1v-1zm9 2v-1h1v1z",
    fill: "#ba151b"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v-1h1v1zm13 4h-1v-1h1zm20 7v-1h1v1zm-1 1v-1h1v1zm2-1h1v1h-1z",
    fill: "#bd1a20"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M86 88v-1h1v2h-1zm-2 13v1h-1v-2h1zm-1 9h1v1h-1z",
    fill: "#c8232a"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M76 95v2h-1v-2zm-29-7v1h-1v-1zm2 1v-1h1v1zm-1 0v1h-1v-1z",
    fill: "#bc181f"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M51 88h2v1h-2zm5 1h-1v-1h1zm-1 0v1h-1v-1zm-1 27v1h-1v-1z",
    fill: "#bd181e"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M83 88v2h-1v-1h-1v-1zm-39 17v1h-1v-1zm14 9h-1v-1h1z",
    fill: "#c52027"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M77 4V3h2v1h-1zm4-1h1v1h-2V3z",
    fill: "#c0c1b4"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15h1v1h-1zm65 25h1v1h-1zm0 5h1v1h-1zm-59 77v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.008
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M88 93h-1v-2h1v1zm-2-73h-1v-1h1zm1 83h-1v-1h1z",
    fill: "#ca262d"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M46 22h1v1h-1zm-1 3h1v1h-1zm13 8v-1h1v1zM39 76h-1v-1h1z",
    fill: "#b1181a"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M45 26h-1v-3h1v1zm-2 19v1h-1v-1z",
    fill: "#b3191b"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M46 23h1v1h-1zm14 11v1h-1v-1zM41 48v-1h1v1zm-2 26v-1h1v1z",
    fill: "#b01719"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M72 25h-1v-1h1zM54 73v1h-1v-1zm1 11v-1h1v1zm-1 1v-1h1v1z",
    fill: "#b31318"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26h-1v-1h1zm-2 1v-1h1v1zm1 1v-1h1v1zm5 10h-1v-1h1z",
    fill: "#a91316"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M87 47v1h-1v-2h1zm-2-22h1v1h-1zm0 21v1h-1v-1z",
    fill: "#c12028"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M55 65v-2h1v2zm21-39v1h-1v-1zM55 78v-1h1v1z",
    fill: "#a30a0c"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28h-1v-1h1zm-1 24h1v1h-1zm1 12v-1h1v1zm0 8h1v1h-1z",
    fill: "#c12025"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35h-1v-2h1v1zm1-5h-1v-1h1zm-1 1h-1v-1h1z",
    fill: "#ad161b"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M48 29h1v1h-1zm0 8h-1v-1h1zm-1 2h1v1h-1zm1 3v1h-1v-1z",
    fill: "#a91416"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31v-1h1v1zm-10 1v1h-1v-1zm12 17v1h-1v-1zm-4 27h-1v-1h1z",
    fill: "#c0c1bb"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M47 39v-2h1v2zm1-7h-1v-1h1zm0 8v1h-1v-1z",
    fill: "#aa1417"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33h-1v-1h1zm1 2h-1v-1h1zm-4 0h1v1h-1zm3 10h1v1h-1z",
    fill: "#c11f27"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M38 37h-1v-4h1v1z",
    fill: "#b82a2a"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M63 40h-1v-3h1v1zm13 21h1v1h-1z",
    fill: "#9b0c0e"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M83 37h1v1h-1zm-2 33h-1v-1h1zm-4 36h-1v-1h1zm-29 3h-1v-1h1z",
    fill: "#c11b22"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39v-1h1v1zm-4 59v-1h1v1zm-25 3v-1h1v1zm-4 4v1h-1v-1z",
    fill: "#c41e24"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M43 42h-2v-3h1v2h1z",
    fill: "#b51a1e"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M93 41h1v2h-1v-1zm1 12h-1v-2h1v1z",
    fill: "#ba4042"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M89 43h1v4h-1v-2z",
    fill: "#be272b"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47h-1v-1h1zm-1 1v1h-1v-1zm23 11h-1v-1h1zm-24 6h1v1h-1z",
    fill: "#ab1214"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M49 47v1h-1v-2h1zm0 2v-1h1v1zm-1 16h1v1h-1z",
    fill: "#9f0c0c"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M50 56h-1v-2h1v1zm-2-6v-1h1v1zm-1 17v-1h1v1z",
    fill: "#a00c0c"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49h1v1h-1zm-13 9h1v1h-1zm14 3h-1v-1h1zm0 9h1v1h-1z",
    fill: "#a20e12"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h1v1h-1zm2 28v1h-1v-1zm0 7h-1v-1h1zm-30 29v-1h1v1z",
    fill: "#c32127"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M89 62v3h-1v-3zm-1-11v-1h1v1z",
    fill: "#be2428"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M90 53h-1v-3h1v1zm0 16v1h-1v-1z",
    fill: "#bd2629"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M87 52v1h-1v-2h1zm1 23v1h-1v-1zM41 87v1h-1v-1z",
    fill: "#c22127"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M70 63h1v1h-2v-1zm-12-8h1v1h-1zm3 3v1h-1v-1z",
    fill: "#bfc1bd"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M52 74v-1h1v2h-1zm0-13h-1v-1h1zm1 16v-1h1v1z",
    fill: "#b21318"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v1h-1v-2h1zm0 8h-1v-2h1v1z",
    fill: "#a30c0e"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M68 66v1h-1v-1zm-14 3h1v1h-1zm-9 4h1v1h-1zm3 9h-1v-1h1z",
    fill: "#a70d0f"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M43 70v1h-1v-2h1zm-1 3v1h-1v-1zm3 9v1h-1v-1z",
    fill: "#ad1315"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M51 69h1v1h-1zm-11 7h1v1h-1zm2 1v1h-1v-1zm0 5v-1h1v1z",
    fill: "#b01417"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M55 70v-1h1v1zm-10 3v-1h1v1zm1 1h1v1h-1zm10 3v-1h1v1z",
    fill: "#a60d0f"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M86 77v-2h1v2zm0 5h1v1h-2v-1z",
    fill: "#c31f26"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M86 77h1v3h-1zm-27 37v-1h1v1z",
    fill: "#c41f26"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78h2v3h-1v-2h-1z",
    fill: "#ac1013"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M86 79h-1v-1h1zm-19 28h1v1h-1zm-17 2h-1v-1h1zm4 1h-1v-1h1z",
    fill: "#c41d24"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80v-1h1v1zm-34 22v-1h1v1zm31 2v1h-1v-1zm-7 4v-1h1v1z",
    fill: "#c31d23"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83h1v2h-1v-1zm3 2h-1v-1h1zm1 0h1v1h-1z",
    fill: "#b41319"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86v-1h2v1h-1zm-5-1h-1v-1h1zm31 11v-1h1v1z",
    fill: "#b7151a"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86h-1v-1h1zm2-1v1h-1v-1zm4 1h-1v-1h1zm13 1h-1v-1h1z",
    fill: "#b6151a"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M94 87h-1v-2h1v1zm0 4v2h-1v-2z",
    fill: "#d1cfcd"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87h-1v-1h1zm-6 0h1v1h-1zm2 1v-1h1v1zm13 20h-1v-1h1z",
    fill: "#bc171d"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88h2v1h-2zm0 0h-1v-1h1zm29 7v-1h1v1z",
    fill: "#bb171e"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89v-1h1v1zm11 9v-1h1v1zm-16 17v1h-1v-1zm3 1v-1h1v1z",
    fill: "#bf1a20"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M53 116h-2v-1h2zm-1-26h-1v-1h1zm23 10v-1h1v1z",
    fill: "#bf191f"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M84 100h1v3h-1zm2-10v-1h1v1z",
    fill: "#c9242b"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M35 94h-1v-4h1v1z",
    fill: "#c34e4f"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M83 91v-1h1v2h-1zm0 9v1h-1v-1zm2 8h1v1h-1z",
    fill: "#c82128"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95v-1h1v1zm2 6h1v1h-1zm27 5v-1h1v1zm-28 8v-1h1v1z",
    fill: "#c11b20"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M85 103v4h-1v-4z",
    fill: "#c9252b"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M90 118h-4v-1h4z",
    fill: "#bebdbb"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M91 2h-1V1h1zm6 15h-1v-1h1zm0 3v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.027
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M43 3h1v1h-2V3zm3 0h1v1h-1z",
    fill: "#b3b4a6"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M73 4h-3V3h3z",
    fill: "#c2beb2"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M50 7V6h1v1zm-2 23h1v1h-1zm25 2v1h-1v-1z",
    fill: "#a71315"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M56 8V7h1v1zm-7 15h1v1h-1zm-3 21v1h-1v-1z",
    fill: "#ac1516"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M73 8V7h1v1zM60 40v-1h1v1zm11 14h-1v-1h1z",
    fill: "#ac1316"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M42 40v-1h1v2h-1zM71 8h1v1h-1z",
    fill: "#b4191d"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M84 16v-1h1v1zm1 2v1h-1v-1zm4 78h-1v-1h1z",
    fill: "#ca282d"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17v1h-1v-1zm66 18h-1v-1h1zm-64 84h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.035
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M41 20v-1h1v1zm47 54h1v1h-1zm1 8v-1h1v1z",
    fill: "#c12529"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M84 62v-2h1v2zM42 20v1h-1v-1z",
    fill: "#be2024"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21v-1h1v1zM48 67v-1h1v1zm29 7h1v1h-1z",
    fill: "#9f0a0b"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M47 22v-1h1v1zm10 12h1v1h-1zM41 79v1h-1v-1z",
    fill: "#b4171a"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M50 22h1v1h-1zm-9 56h1v1h-1zm1 4h1v1h-1z",
    fill: "#b11518"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v1h-1v-2h1zm53 31h-1v-1h1z",
    fill: "#bc2a2d"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23v1h-1v-1zm-4 22h1v1h-1zm-4 28h1v1h-1z",
    fill: "#ae1517"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24h-1v-1h1zM62 78v-1h1v1zm8 14h1v1h-1z",
    fill: "#c2c5c0"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M90 24h-1v-1h1zm2 61v-1h1v1zm-3 34v1h-1v-1z",
    fill: "#cfceca"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M92 26v-3h1v3z",
    fill: "#bb343b"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24v1h-1v-1zm0 3v1h-1v-1zm-1 3v-1h1v1z",
    fill: "#b82323"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26v-2h1v2zm-4 51v-1h1v1z",
    fill: "#b51e1f"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24h1v1h-1zm14 13h-1v-1h1zm-2 10v-1h1v1z",
    fill: "#ac1416"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M62 25v1h-1v-1zm12 8h1v1h-1zm-6 13v1h-1v-1z",
    fill: "#a51114"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M38 31v2h-1v-2zm0-5v1h-1v-1z",
    fill: "#ba2a2c"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27h-1v-1h1zm9 0h-1v-1h1zM42 65h1v1h-1z",
    fill: "#a61314"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M84 26h1v1h-1zm1 3v1h-1v-1zm0 8h1v1h-1z",
    fill: "#c11e27"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M35 34v-1h1v2h-1zm0-7h1v1h-1z",
    fill: "#b83a3a"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M39 29v2h-1v-2zm-1-2h1v1h-1z",
    fill: "#b82626"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M51 29v-1h1v1zm22 2v1h-1v-1zm-5 18h-1v-1h1z",
    fill: "#ab1216"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M59 28h1v1h-1zm11 64h-1v-1h1zm14 25v-1h1v1z",
    fill: "#c1c3be"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M73 29h-1v-1h1zm7 1v1h-1v-1zM69 83v-1h1v1z",
    fill: "#c2c3c0"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M86 68v1h-1v-2h1zm-4-40h1v1h-1z",
    fill: "#c21d25"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42v1h-1v-2h1zm-3-13v-1h1v1z",
    fill: "#bf1f27"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30v-1h1v1zm17 7v1h-1v-1zm4 1v1h-1v-1z",
    fill: "#c0c4bf"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M93 29h1v3h-1v-1z",
    fill: "#b93e43"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v-1h1v1zm15 0h-1v-1h1zm0 34v-1h1v1z",
    fill: "#bfc0b9"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M80 32v-1h1v1zm-7 27h-1v-1h1zM62 77h-1v-1h1z",
    fill: "#c4c3c0"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M85 33h-1v-2h1v1zm2 6v1h-1v-1z",
    fill: "#bf2125"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h-1v-1h1zm0 4h-1v-1h1zm0 1v1h-1v-1z",
    fill: "#bb3133"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33h-1v-1h1zm-4 38h1v1h-1zm-12 8h1v1h-1z",
    fill: "#b11417"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M42 36h-1v-3h1z",
    fill: "#b61d20"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M42 33h1v3h-1z",
    fill: "#b41b1e"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35h-1v-1h1zm-6 44h1v1h-1zm3 3v-1h1v1z",
    fill: "#c1c0be"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M87 43v2h-1v-2zm-1-7v-1h1v1z",
    fill: "#c02027"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M64 40h-1v-2h1v1zm0-3h-1v-1h1z",
    fill: "#930a0d"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v-2h1v2zm-2 3v-1h1v1z",
    fill: "#940a0d"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M46 37v1h-1v-1zm0 3h-1v-1h1zm0 0h1v1h-1z",
    fill: "#ac1519"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M74 37h1v1h-1zm5 1v1h-1v-1zm-4 28v-1h1v1z",
    fill: "#bdc0b9"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M84 38v1h-1v-1zM67 97v1h-1v-1zm13 21h-1v-1h1z",
    fill: "#bc1b21"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M39 56h-1v-2h1v1zm18-17h1v1h-1z",
    fill: "#ae1618"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M58 40v1h-1v-1zM43 69h1v1h-1zm2 13h1v1h-1z",
    fill: "#ac1114"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M88 40v3h-1v-3z",
    fill: "#c02127"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42v3h-1v-3z",
    fill: "#e5c7b9",
    fillOpacity: 0.545
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h1v1h-1zm6 17h1v1h-1zm-7 12h-1v-1h1z",
    fill: "#a00a0e"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43v-1h1v1zM51 58v1h-1v-1zm7 21h-1v-1h1z",
    fill: "#a91013"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45h-1v-1h1zM64 65v1h-1v-1zm-4 14v1h-1v-1z",
    fill: "#a11211"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h-1v-1h1zm-2 1h1v1h-1zm6 22h1v1h-1z",
    fill: "#ac1315"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v-1h1v1zm0 18h1v1h-1zm-36 40v-1h1v1z",
    fill: "#c11e24"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M38 79v1h-1v-2h1zm1-32v-1h1v1z",
    fill: "#b32020"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M84 47v1h-1v-1zm-1 41h-1v-1h1zm-11 22h-1v-1h1z",
    fill: "#c51f26"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M45 49v-1h1v1zm13 17h-1v-1h1zm-8 15h-1v-1h1z",
    fill: "#a80f11"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M49 64v1h-1v-2h1zm-1-16h1v1h-1z",
    fill: "#9e0c0c"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h-1v-2h1v1zm-1-3v-1h1v1z",
    fill: "#c12327"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M89 50v-1h1v1zm1 17v1h-1v-1zm-1 6h1v1h-1z",
    fill: "#be272a"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M46 50h1v1h-1zm1 6h-1v-1h1zm-1 3h1v1h-1z",
    fill: "#a30e0d"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50h1v1h-1zm25 20h1v1h-1zm-27 1v1h-1v-1z",
    fill: "#a20c0e"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M64 118v1h-2v-1h1zm-6-67h-1v-1h1z",
    fill: "#b11114"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M79 50v1h-1v-1zm-10 6v-1h1v1zm6 59v-1h1v1z",
    fill: "#c4bfbd"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M41 55h1v2h-1v-1zm3-4v1h-1v-1z",
    fill: "#ab1212"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M89 52v1h-1v-2h1zm-1 10v-1h1v1z",
    fill: "#bf2528"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M80 54h-1v-1h1zM56 84h1v1h-1zm20 9h1v1h-1z",
    fill: "#bc171e"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M85 53v1h-1v-1zm-2 5h-1v-1h1zm2 7h1v1h-1z",
    fill: "#c11d24"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M90 56h-1v-3h1z",
    fill: "#bc2728"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M50 54h1v1h-1zm28 5v1h-1v-1zm-4 12h1v1h-1z",
    fill: "#a10c0e"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M43 55h1v1h-1zm14 15h-1v-1h1zM47 83h-1v-1h1z",
    fill: "#ab1012"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M46 56h1v3h-1z",
    fill: "#a30f0d"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M77 58v-1h1v1zm0 14v1h-1v-1zm0 4v1h-1v-1z",
    fill: "#9d080a"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M87 58h1v3h-1z",
    fill: "#bf2327"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59v-1h1v1zm1 9h-1v-1h1zm-44 45h1v1h-1z",
    fill: "#bf292d"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60v-1h1v1zm8 7v-1h1v1zm0 1h1v1h-1z",
    fill: "#a70f13"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v1h-1v-1zm-14 59v-1h1v1zm9 0v-1h1v1z",
    fill: "#bb1a20"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M85 59v1h-1v-1zm1 13v1h-1v-1zm-37 36v1h-1v-1z",
    fill: "#c11f24"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M55 61v-1h1v1zm-6 15v1h-1v-1zm0 3v1h-1v-1z",
    fill: "#a00a0b"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M34 62h1v1h-1zm0 2h-1v-1h1zm46 14v1h-1v-1z",
    fill: "#c7c8c3"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64v1h-1v-1zm-1 4v1h-1v-1zm-16 1v1h-1v-1z",
    fill: "#a20b10"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M72 65v-1h2v1h-1zm5 1h-1v-1h1z",
    fill: "#bebfba"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65v1h-1v-1zm6 1h-1v-1h1zm-6 2v1h-1v-1z",
    fill: "#a20a0d"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v1h-1v-1zm-3 8h-1v-1h1zm-10 4v-1h1v1z",
    fill: "#af1317"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M83 66v1h-1v-1zm-3 25v-1h1v1zm-32 6v-1h1v1z",
    fill: "#c21b21"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M88 66v3h-1v-3z",
    fill: "#c12126"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67v1h-1v-1zm-1 11h1v1h-1zm3 4h1v1h-1z",
    fill: "#a90d10"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M49 73v1h-1v-2h1zm-1-6v1h-1v-1z",
    fill: "#a10b0d"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v-1h1v1zm12 0h-1v-1h1zm-12 8h1v1h-1z",
    fill: "#ae1316"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M55 69h-1v-1h1zm2 8v1h-1v-1zm-1 4v1h-1v-1z",
    fill: "#a80e11"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68h1v1h-1zm-5 35h-1v-1h1zm-28 11h1v1h-1z",
    fill: "#c11b21"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69v1h-1v-1zm0 13v-1h1v1zm37 37v-1h1v1z",
    fill: "#b21619"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69v1h-1v-1zm1 9v-1h1v1zm-11 1v1h-1v-1z",
    fill: "#a40b0e"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M91 75h-1v-2h1v1zm0-5v1h-1v-1z",
    fill: "#c02a2e"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M57 72h-2v-1h2zm-1 3v1h-1v-1z",
    fill: "#a50b0d"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M46 82h-1v-2h1v1zm11-7h-1v-1h1z",
    fill: "#ab0f12"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M83 78v1h-1v-1zm-1 8v1h-1v-1zm-3 18h-1v-1h1z",
    fill: "#c41c22"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79v1h-1v-1zm4 1v1h-1v-1zm-4 2h-1v-1h1z",
    fill: "#ab0f13"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79v1h-1v-1zm-34 23h-1v-1h1zm0 10v1h-1v-1z",
    fill: "#c11d23"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81v-1h1v1zM58 91v-1h1v1zm9 7h1v1h-1z",
    fill: "#c11d22"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M87 82h-1v-1h1zm0 5h-1v-1h1zm-1 2h-1v-1h1z",
    fill: "#c72229"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83v2h-1v-2zm-1 0h-1v-1h1z",
    fill: "#b71b1e"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86v1h-1v-1zm2 1h-1v-1h1zm-1 1h-1v-1h1z",
    fill: "#b9151c"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86v1h-1v-1zm-10 5h-1v-1h1zm15 14h-1v-1h1z",
    fill: "#bb1920"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86v1h-1v-1zM56 99h1v1h-1zm-14 7v-1h1v1z",
    fill: "#c62027"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88v-1h1v1zm31 7h1v1h-1zm1 2v-1h1v1z",
    fill: "#bb181e"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M53 87v1h-1v-1zm2 0h1v1h-1zm0 2h-1v-1h1z",
    fill: "#bb161c"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M57 88v-1h1v1zm-3 9h1v1h-1zm21 9v1h-1v-1z",
    fill: "#c11a20"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M87 90v-3h1v3z",
    fill: "#c8252c"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88h1v1h-1zm6 0v1h-1v-1zm25 9v1h-1v-1z",
    fill: "#bd1920"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v1h-1v-1zm17 13h-1v-1h1zm0 2v-1h1v1z",
    fill: "#c01b22"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M82 90h-1v-1h1zm0 1v1h-1v-1zm-25 8h1v1h-1z",
    fill: "#c61f27"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M36 91v1h-1v-2h1zm-1 2h1v1h-1z",
    fill: "#c24042"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M83 90v2h-1v-2zm-2 4h1v1h-1z",
    fill: "#c72027"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M87 90h1v1h-1zm-1 9h1v1h-1zm1 3h-1v-1h1z",
    fill: "#c9262d"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M89 93h-1v-3h1z",
    fill: "#c72a2d"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M72 96h1v1h-1zm-24 18h1v1h-1zm9 3v-1h1v1z",
    fill: "#bf1c21"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M91 99h1v3h-1v-1z",
    fill: "#cbcac9"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M83 103h-1v-1h1zm-27 8h-1v-1h1zm28 3h-1v-1h1z",
    fill: "#c61e26"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M69 107v1h-1v-1zm-14 1h1v1h-1zm16 2h-1v-1h1z",
    fill: "#c61f25"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M70 107h2v1h-2zm-1 2h-1v-1h1z",
    fill: "#c52025"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M62 109h-1v-1h1zm11 5h-1v-1h1zm4 0v-1h1v1z",
    fill: "#c1c2bf"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M63 110v1h-1v-1zm13 3h1v1h-1zm13 8v-1h1v1z",
    fill: "#c2c1be"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M67 112h2v1h-2zm-1 0h-1v-1h1z",
    fill: "#bfc1be"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M51 116v1h-3v-1z",
    fill: "#be181f"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M53 117h2v1h-2zm-1 0v1h-1v-1z",
    fill: "#bc191c"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M62 125h1v1h-2v-1zm7-3h1v1h-1z",
    fill: "#a1a2a1"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M68 124v-1h2v1h-1zm-10-1v1h-1v-1z",
    fill: "#a2a39e"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M61 123v1h-2v-1h1zm7 0v1h-1v-1z",
    fill: "#a1a29d"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M82 123h3v1h-3z",
    fill: "#b1b0ac"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M61 124h2v1h-2zm3 1v-1h1v1z",
    fill: "#aaaba6"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M71 1h1v1h-2V1z",
    fill: "#e4e4d8",
    fillOpacity: 0.263
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M72 2v1h-2V2h1z",
    fill: "#e4e2d5"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M75 3v1h-1V3zm2 0v1h-1V3z",
    fill: "#bebfb2"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M47 4v1h-1V4zm2 1h-1V4h1z",
    fill: "#ac9d92"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M37 6V5h1v1zm61 27v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.047
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M52 7V6h1v1zm3 0V6h1v1z",
    fill: "#a41313"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M53 6h1v1h-1zm1 32h1v1h-1z",
    fill: "#a41312"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M65 7h-1V6h1zM55 44h1v1h-1z",
    fill: "#9d0c0c"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M61 7v1h-1V7zM41 69h-1v-1h1z",
    fill: "#af171a"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M72 8V7h1v1zM59 42v-1h1v1z",
    fill: "#ac1417"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M74 8V7h1v1zM44 47v-1h1v1z",
    fill: "#ad1416"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M81 8h-1V7h1zM38 51v1h-1v-1z",
    fill: "#b01d1d"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M85 7v1h-1V7zM65 111h-1v-1h1z",
    fill: "#c0c2bf"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M57 9V8h1v1zM41 117h1v1h-1z",
    fill: "#b51d1d"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M68 9h-1V8h1zm9 86v-1h1v1z",
    fill: "#b51419"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M68 8h1v1h-1zM44 84h-1v-1h1z",
    fill: "#b4161a"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M74 8v1h-1V8zm-5 79v1h-1v-1z",
    fill: "#ba191d"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M85 10h-1V9h1zm-6 78h-1v-1h1z",
    fill: "#c7cbc9"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M85 9h1v1h-1zm6 96v-1h1v1z",
    fill: "#cbcbc9"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M60 12h-1v-1h1zm10 0h1v1h-1z",
    fill: "#fc7370"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M82 11h1v1h-1zm7 81v-1h1v1z",
    fill: "#c52a2b"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M42 12h1v1h-1zm-1 3h-1v-1h1z",
    fill: "#c23432"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M80 13v-1h1v1zm3 3v1h-1v-1z",
    fill: "#d32c31"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M58 13h1v1h-1zm11 1v-1h1v1z",
    fill: "#fe7372"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M84 13v1h-1v-1zm5 81h-1v-1h1z",
    fill: "#c82a2e"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M46 15v1h-1v-2h1z",
    fill: "#cc292a"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M35 17v-1h1v1zm-1 1v-1h1v1z",
    fill: "#c76d6c"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M40 18v1h-1v-1zm-2 86h1v1h-1z",
    fill: "#c22d2e"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M43 20h-1v-1h1zm45 14h1v1h-1z",
    fill: "#c12427"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M50 20v-1h1v1zm-15 91v-1h1v1z",
    fill: "#c23c3f"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19v1h-1v-1zm-5 73h1v1h-1z",
    fill: "#c3181d"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19h1v1h-1zM54 61h-1v-1h1z",
    fill: "#ab1014"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M44 20v1h-1v-1zm43 3h1v1h-1z",
    fill: "#ba1f21"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M46 20h1v1h-1zm11 97h1v1h-1z",
    fill: "#bc1b1f"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h-1v-1h1zm8 40v1h-1v-1z",
    fill: "#9d1011"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M86 21v-1h1v1zm-1 1v-1h1v1z",
    fill: "#c32224"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M40 22v-1h1v1zm48 10v-1h1v1z",
    fill: "#bb2124"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M47 21v1h-1v-1zm-4 21v1h-1v-1z",
    fill: "#b4191c"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M49 21v1h-1v-1zm-9 58v-1h1v1z",
    fill: "#b31619"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M50 21v1h-1v-1zm-9 60v-1h1v1z",
    fill: "#b21518"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22h-1v-1h1zm10 56v1h-1v-1z",
    fill: "#9d0a0d"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M85 21v1h-1v-1zm2 62v1h-1v-1z",
    fill: "#c42027"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M38 22h1v2h-1v-1z",
    fill: "#b92526"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M40 23v-1h1v2h-1z",
    fill: "#b82123"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22v1h-1v-1zm11 63v-1h1v1z",
    fill: "#a9141d"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M75 23v-1h1v1zm13 87h1v1h-1z",
    fill: "#c5c8c4"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M80 22v1h-1v-1zM52 93v1h-1v-1z",
    fill: "#c8a4a0"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23v-1h1v1zm-33 86h1v1h-1z",
    fill: "#c51d24"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M84 23v-1h1v1zm-15 85v-1h1v1z",
    fill: "#c61f26"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23v2h-1v-2z",
    fill: "#ba3b3d"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23h1v1h-1zm0 3h1v1h-1z",
    fill: "#b61d1f"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M48 24v-1h1v1zm0 2h-1v-1h1z",
    fill: "#ab1516"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24v-1h1v1zm9 7h1v1h-1z",
    fill: "#af1319"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M70 23v1h-1v-1zm9 30v-1h1v1z",
    fill: "#bf5f5f"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M84 24v-1h1v1zm-31 82h1v1h-1z",
    fill: "#c61e27"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M85 23h1v1h-1zm-2 64h-1v-1h1z",
    fill: "#c51f25"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M94 23h1v1h-1zm0 7h1v1h-1z",
    fill: "#bb5254"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26h-1v-2h1v1z",
    fill: "#b62122"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h-1v-1h1zm7 15v-1h1v1z",
    fill: "#ab1415"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25v-1h2v1h-1z",
    fill: "#aa1418"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M58 25h-1v-1h1zm37 55h-1v-1h1z",
    fill: "#ab555b"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25v-1h1v1zm-4 50v1h-1v-1z",
    fill: "#c5c6be"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M80 24v1h-1v-1zm7 88h1v1h-1z",
    fill: "#c5c5c2"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M39 27h-1v-2h1v1z",
    fill: "#b72626"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M39 25h1v1h-1zm0 16h-1v-1h1z",
    fill: "#b72424"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25v1h-1v-1zm37 47v-1h1v1z",
    fill: "#b41c1e"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M48 25h1v1h-1zm12 13h1v1h-1z",
    fill: "#aa1415"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25h1v1h-1zm10 21v-1h1v1z",
    fill: "#9e0d0f"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h-1v-1h1zm10 23h1v1h-1z",
    fill: "#c3c5bf"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25v1h-1v-1zm-1 87v1h-1v-1z",
    fill: "#c9c4bc"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M80 25v1h-1v-1zm-15 76v1h-1v-1z",
    fill: "#c2c5be"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M80 25h1v1h-1zm-9 32h-1v-1h1z",
    fill: "#c3c4c0"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M84 25v1h-1v-1zM50 89h1v1h-1z",
    fill: "#bf1a21"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M84 26v-1h1v1zm2 15v-1h1v1z",
    fill: "#c02025"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M91 26v-1h1v1zm-9 22h1v1h-1z",
    fill: "#b92930"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M46 26h1v1h-1zm11 10h-1v-1h1z",
    fill: "#ae1718"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M49 26h1v1h-1zm-2 10v-1h1v1z",
    fill: "#a91417"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h1v1h-1zm-6 88v-1h1v1z",
    fill: "#c7c1bf"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M74 27v-1h1v1zm-8 29v1h-1v-1z",
    fill: "#9c0c10"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28h-1v-1h1zm-2 16v-1h1v1z",
    fill: "#ac1617"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h-1v-1h1zm17 19h-1v-1h1z",
    fill: "#9e2326"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28v-1h1v1zm-6 5v1h-1v-1z",
    fill: "#c3c4bc"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M92 28v-1h1v1zm0 7v-1h1v1z",
    fill: "#bd333a"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28v1h-1v-1zm-1 14h-1v-1h1z",
    fill: "#ad1719"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v-1h1v1zm6 9v1h-1v-1z",
    fill: "#aa1316"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M55 28h1v1h-1zm-1 3h1v1h-1z",
    fill: "#c5c0b9"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v1h-1v-1zm22 4v1h-1v-1z",
    fill: "#a70f14"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30v-1h1v1zm21 8v-1h1v1z",
    fill: "#bcc2bc"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h-1v-1h1zm5 60h1v1h-1z",
    fill: "#c0c5bf"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29v1h-1v-1zm-10 73v-1h1v1z",
    fill: "#bec1bc"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30h1v2h-1v-1z",
    fill: "#b82022"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31h-1v-1h1zm21 1v-1h1v1z",
    fill: "#a71215"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30v1h-1v-1zm15 82h1v1h-1z",
    fill: "#c4c4c0"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M72 30v1h-1v-1zM57 45h-1v-1h1z",
    fill: "#a91113"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M77 30v1h-1v-1zm2 1v1h-1v-1z",
    fill: "#c1bfbd"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M78 31h-1v-1h1zm-24 71h1v1h-1z",
    fill: "#c0c4c2"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M84 30v1h-1v-1zm-7 77v-1h1v1z",
    fill: "#c31b22"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M84 31v-1h1v1zm-1 14h1v1h-1z",
    fill: "#c21e26"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M87 30h1v1h-1zm0 3h1v1h-1z",
    fill: "#c12128"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31v2h-1v-2z",
    fill: "#b93a39"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31h1v2h-1v-1z",
    fill: "#b82325"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v-2h1v2z",
    fill: "#a81315"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31v1h-1v-1zm-6 34v-1h1v1z",
    fill: "#a81114"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M77 32h-1v-1h1zM67 80v1h-1v-1z",
    fill: "#c2c4c1"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M86 32h-1v-1h1zm-4 68h-1v-1h1z",
    fill: "#c11f28"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M97 32v-1h1v2h-1z",
    fill: "#fff",
    fillOpacity: 0.059
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32v1h-1v-1zm0 3v1h-1v-1z",
    fill: "#ad151a"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33h-1v-1h1zm12 9h-1v-1h1z",
    fill: "#a81215"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M53 32v1h-1v-1zM41 62v1h-1v-1z",
    fill: "#c1c2bd"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32v1h-1v-1zm-15 9v-1h1v1z",
    fill: "#b2181c"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32h1v1h-1zM50 80v-1h1v1z",
    fill: "#ab1115"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33v-1h1v1zm-4 4v1h-1v-1z",
    fill: "#c7c4be"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32h1v1h-1zm-7 44h1v1h-1z",
    fill: "#c1c0bc"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M83 32h1v1h-1zm-23 82v-1h1v1z",
    fill: "#c21b23"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33h-1v-1h1zm-3 15v-1h1v1z",
    fill: "#c12027"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M94 33v-1h1v1zm1 3v1h-1v-1z",
    fill: "#ba5455"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35v-2h1v2z",
    fill: "#b72325"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M49 33v1h-1v-1zm0 5v1h-1v-1z",
    fill: "#a81415"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33v1h-1v-1zm-4 13h1v1h-1z",
    fill: "#a61011"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33v1h-1v-1zM39 67h1v1h-1z",
    fill: "#b11819"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M60 33h1v1h-1zm-1 5h1v1h-1z",
    fill: "#ad1517"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33h1v1h-1zm-1 57h1v1h-1z",
    fill: "#c1c2bc"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34v-1h1v1zM51 53v1h-1v-1z",
    fill: "#a00e0f"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M37 36h-1v-2h1v1z",
    fill: "#b93032"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v-2h1v2z",
    fill: "#b52625"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34h1v1h-1zm-1 5v1h-1v-1z",
    fill: "#ae1518"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M67 34h1v1h-1zm7 15h1v1h-1z",
    fill: "#c3c7c1"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M81 34h1v1h-1zm-21 82h1v1h-1z",
    fill: "#b8191e"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M85 34v1h-1v-1zm-3 11h1v1h-1z",
    fill: "#c01f24"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M60 35h1v1h-1zm-1 5v-1h1v1z",
    fill: "#ad1417"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M70 35v1h-1v-1zm-10 72h1v1h-1z",
    fill: "#c5c3bf"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M94 36h-1v-1h1zm-1 2h1v1h-1z",
    fill: "#bb3e42"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37h-1v-1h1zm0 2h-1v-1h1z",
    fill: "#b62224"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M43 37h-1v-1h1zm0 2h-1v-1h1z",
    fill: "#b31a1d"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37v1h-1v-2h1z",
    fill: "#b11718"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M61 36h1v2h-1v-1z",
    fill: "#a71314"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36h1v1h-1zm1 15v1h-1v-1z",
    fill: "#9d0c0d"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h-1v-1h1zM63 98v-1h1v1z",
    fill: "#bb8e8f"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M85 36v1h-2v-1h1z",
    fill: "#c11c26"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36h1v1h-1zm-1 73h1v1h-1z",
    fill: "#be2226"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M93 37v-1h1v1zM82 51v-1h1v1z",
    fill: "#ba3e42"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M32 37v2h-1v-2z",
    fill: "#e3c6ba",
    fillOpacity: 0.553
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v-1h1v1zm10 72h-1v-1h1z",
    fill: "#b82a2b"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38v-1h1v1zm-1 8h-1v-1h1z",
    fill: "#b11b1d"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M51 37h1v1h-1zm18 8h-1v-1h1z",
    fill: "#c9c2bc"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h1v1h-1zm8 16v1h-1v-1z",
    fill: "#a61112"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h1v1h-1zm1 16h1v1h-1z",
    fill: "#90090d"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M66 37h1v1h-1zm-5 3v-1h1v1z",
    fill: "#a81214"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M79 37v1h-1v-1zm1 0h1v1h-1z",
    fill: "#c3c3be"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M80 37v1h-1v-1zm-9 54v1h-1v-1z",
    fill: "#c3c3bd"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M89 39v-2h1v2z",
    fill: "#b82224"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38h-1v-1h1zm-13 2h1v1h-1z",
    fill: "#bb3e43"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M57 38v1h-1v-1zm9 46h1v1h-1z",
    fill: "#b1141a"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38v1h-1v-1zm-13 2h-1v-1h1z",
    fill: "#a71214"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v1h-1v-1zm-1 8v-1h1v1z",
    fill: "#92090d"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M76 38v1h-1v-1zM66 79h-1v-1h1z",
    fill: "#c3c4bb"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39h1v2h-1v-1z",
    fill: "#bb3131"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M39 40h-1v-1h1zm-2 44v-1h1v1z",
    fill: "#b62425"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39v2h-1v-2z",
    fill: "#91090d"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39h1v1h-1zm-8 38v-1h1v1z",
    fill: "#c5c5be"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M90 40h-1v-1h1zM38 84h1v1h-1z",
    fill: "#ba2325"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M94 40v1h-1v-2h1z",
    fill: "#bd3e42"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M40 41h-1v-1h1zm0 2h-1v-1h1z",
    fill: "#b72122"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42v-2h1v2z",
    fill: "#b71e20"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40h1v1h-1zm12 13h1v1h-1z",
    fill: "#a71213"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M60 41v-1h1v1zm-2 11v-1h1v1z",
    fill: "#ad1418"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41v-1h1v1zm15 21v-1h1v1z",
    fill: "#9c0b0e"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h1v1h-1zm20 61h-1v-1h1z",
    fill: "#b82b2a"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M47 41v1h-1v-1zm-1 1v1h-1v-1z",
    fill: "#ac1618"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M47 42v-1h1v1zm-1 1v-1h1v1z",
    fill: "#ab1517"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42v-1h1v1zM53 57h-1v-1h1z",
    fill: "#a60d12"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42h-1v-1h1zM59 88h-1v-1h1z",
    fill: "#be1a22"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M82 42h-1v-1h1zm-20 62h-1v-1h1z",
    fill: "#c01b23"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M93 43h-1v-2h1v1z",
    fill: "#b73439"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v-2h1v2z",
    fill: "#c47b6f"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M39 42v2h-1v-2z",
    fill: "#b72324"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v-1h1v1zm0 0v1h-1v-1z",
    fill: "#a71113"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M60 42h1v1h-1zm0 10v-1h1v1z",
    fill: "#a91015"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h-1v-1h1zM51 59v-1h1v1z",
    fill: "#aa1114"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M79 43v-1h1v1zm2 2h1v1h-1z",
    fill: "#bc1b20"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M80 42h1v1h-1zm3 37v-1h1v1z",
    fill: "#c11e23"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43h1v1h-1zm0 3h-1v-1h1z",
    fill: "#a40f10"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h1v1h-1zm4 2v-1h1v1z",
    fill: "#9b0d0f"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43h1v1h-1zm3 1v1h-1v-1z",
    fill: "#930a0c"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43h1v1h-1zm3 22v-1h1v1z",
    fill: "#c01d24"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M94 43v1h-1v-1zm0 3v1h-1v-1z",
    fill: "#bb3f42"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45v-1h1v1zm19 48h-1v-1h1z",
    fill: "#b72827"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M47 45h-1v-1h1zm-3 12h-1v-1h1z",
    fill: "#a91314"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M47 44h1v1h-1zm10 1v1h-1v-1z",
    fill: "#a51011"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M71 44v1h-1v-1zm-8 64v1h-1v-1z",
    fill: "#c6c6bf"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M33 46v1h-1v-2h1z",
    fill: "#c4796b"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M75 46v-1h1v1zm-27 8h-1v-1h1z",
    fill: "#a30f0f"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M38 47v-1h1v1zm-2 30v-1h1v1z",
    fill: "#b52222"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M57 46h1v1h-1zm13 7v-1h1v1z",
    fill: "#a51316"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47h-1v-1h1zM64 62h1v1h-1z",
    fill: "#c8b1b0"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v-1h1v1zm2 2v1h-1v-1z",
    fill: "#c41e26"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M40 48h-1v-1h1zm-3 34h1v1h-1z",
    fill: "#b52323"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M45 47h1v1h-1zm-1 2h1v1h-1z",
    fill: "#aa1113"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v1h-1v-1zm5 8v-1h1v1z",
    fill: "#c5c3b8"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h1v1h-1zm7 0h1v1h-1z",
    fill: "#a60e16"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M87 47h1v2h-1v-1z",
    fill: "#c22228"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M97 48v1h-1v-2h1z",
    fill: "#d7b3b1",
    fillOpacity: 0.757
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48h1v1h-1zm-1 2h1v1h-1z",
    fill: "#b21e1e"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h-1v-1h1zm-2 30h1v1h-1z",
    fill: "#b21c1d"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M41 49h-1v-1h1zm-3 6v1h-1v-1z",
    fill: "#b01b1b"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49h-1v-1h1zm26 20h1v1h-1z",
    fill: "#a50e0f"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49h-1v-1h1zm12 61h-1v-1h1z",
    fill: "#c9c6c0"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v-1h1v1zm0 2v1h-1v-1z",
    fill: "#98090f"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M67 48v1h-1v-1zm0 10v-1h1v1z",
    fill: "#a31115"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M69 48h1v1h-1zm4 6v1h-1v-1z",
    fill: "#ab1016"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48v1h-1v-1zm-9 63v-1h1v1z",
    fill: "#c0c5c0"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48h1v1h-1zm-5 65v-1h1v1z",
    fill: "#c2c2be"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M95 49h-1v-1h1zm0 4h-1v-1h1z",
    fill: "#b6494b"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v1h-1v-2h1z",
    fill: "#e5cabc",
    fillOpacity: 0.553
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49h1v2h-1v-1z",
    fill: "#c67f6f"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M40 50h-1v-1h1zm-2 0h1v1h-1z",
    fill: "#b21a1b"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M46 49v1h-1v-1zm11 17h1v1h-1z",
    fill: "#a60f0f"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v1h-1v-1zm-2 7v-1h1v1z",
    fill: "#a40f0e"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49v1h-1v-1zm-15 5h1v1h-1z",
    fill: "#a50f13"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50v-1h1v1zm-9 12h-1v-1h1z",
    fill: "#c0c4be"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50h1v1h-1zm0 17h1v1h-1z",
    fill: "#b01517"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50h1v1h-1zm-3 4h1v1h-1z",
    fill: "#ac1314"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50v1h-1v-1zm13 4h-1v-1h1z",
    fill: "#9a0a0f"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h-1v-1h1zM65 91h-1v-1h1z",
    fill: "#c5c6c1"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50v1h-1v-1zm0 33h-1v-1h1z",
    fill: "#c3c7c2"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51v-1h1v1zm-3 65v-1h1v1z",
    fill: "#c31e26"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M87 50h1v1h-1zm2 30h-1v-1h1z",
    fill: "#c12328"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51v1h-1v-2h1z",
    fill: "#b4494a"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52h-1v-1h1zm-1 2v-1h1v1z",
    fill: "#ab3b34"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M46 53v-2h1v2z",
    fill: "#a20d0d"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M51 51v1h-1v-1zm-5 13h1v1h-1z",
    fill: "#a40d0e"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M57 51h1v1h-1zm1 9h1v1h-1z",
    fill: "#a51218"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h-1v-1h1zm-2 3h1v1h-1z",
    fill: "#ac1312"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M43 52h1v1h-1zm16 26h1v1h-1z",
    fill: "#a9110f"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52h1v2h-1v-1z",
    fill: "#a70f0e"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52v1h-1v-1zm12 4v1h-1v-1z",
    fill: "#9a0b0d"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v1h-1v-1zm-10 7h1v1h-1z",
    fill: "#ad1216"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M75 53v-1h1v1zm0 7v-1h1v1z",
    fill: "#a75958"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M84 53v-1h1v1zm-1 4h1v1h-1z",
    fill: "#c01e25"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54v1h-1v-2h1z",
    fill: "#a60e0d"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v-1h1v1zm-1 19v-1h1v1z",
    fill: "#9e0a0c"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h1v1h-1zm-24 62h1v1h-1z",
    fill: "#c21e22"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M52 55h-1v-1h1zm11 10v1h-1v-1z",
    fill: "#a10e0f"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54v1h-1v-1zm10 10v-1h1v1z",
    fill: "#bdc2bd"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54v1h-1v-1zm-21 2v1h-1v-1z",
    fill: "#a61012"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55v-1h1v1zm4 59v1h-1v-1z",
    fill: "#bc1f25"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56v-1h1v1zm-4 17v-1h1v1z",
    fill: "#a30d0f"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55h1v1h-1zm5 16h-1v-1h1z",
    fill: "#a40c10"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M57 56v-1h1v1zm12 58h-1v-1h1z",
    fill: "#c1c0bd"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M68 55h1v1h-1zm-3 33v1h-1v-1z",
    fill: "#c5c7c0"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M74 56v-1h1v1zm-16 7h-1v-1h1z",
    fill: "#a10e12"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v-1h1v1zm57 52h1v1h-1z",
    fill: "#c9cbcb"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57v-1h1v1zm35 28h1v1h-1z",
    fill: "#af1414"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57v-1h1v1zm0 19h-1v-1h1z",
    fill: "#a10b0c"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M54 56v1h-1v-1zm17 14h-1v-1h1z",
    fill: "#a30d12"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57h-1v-1h1zm-6 10h1v1h-1z",
    fill: "#a1090c"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h-1v-1h1zm24 62v-1h1v1z",
    fill: "#bdbfb8"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M69 56h1v1h-1zm-10 52h-1v-1h1z",
    fill: "#c4c3c4"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M81 56h1v1h-1zm-3 47h-1v-1h1z",
    fill: "#c11c23"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57h1v1h-1zm0 2h1v1h-1z",
    fill: "#ae1417"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M72 57h1v1h-1zm-3 45v1h-1v-1z",
    fill: "#c2c4bf"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M75 58v-1h1v1zm1 14v1h-1v-1z",
    fill: "#9e0b0c"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58v-1h1v1zm2 12v1h-1v-1z",
    fill: "#c21d26"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M94 58v-1h1v2h-1z",
    fill: "#b44b4c"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59h-1v-1h1zm13 61v1h-1v-1z",
    fill: "#c4c6c2"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M42 59h-1v-1h1zm4 5h-1v-1h1z",
    fill: "#a90e10"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M74 59h-1v-1h1zm-1 5v-1h1v1z",
    fill: "#c6c4bf"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58v1h-1v-1zM50 91v-1h1v1z",
    fill: "#c01a20"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v-1h1v1zm-33 53h-1v-1h1z",
    fill: "#c11d25"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58h1v1h-1zm0 2h1v1h-1z",
    fill: "#be2528"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M32 60h-1v-1h1zm0 2h-1v-1h1z",
    fill: "#e7e5e1",
    fillOpacity: 0.506
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60v-1h1v1zm17 9h-1v-1h1z",
    fill: "#a20b0d"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M52 60h-1v-1h1zm-1 15v1h-1v-1z",
    fill: "#ae1216"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M54 60v-1h1v1zm4 9v1h-1v-1z",
    fill: "#a20a0f"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59h1v1h-1zm-8 18v1h-1v-1z",
    fill: "#a40c0f"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M62 60h-1v-1h1zm-4 46h-1v-1h1z",
    fill: "#c3c2c1"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60h-1v-1h1zM50 82h-1v-1h1z",
    fill: "#ab0e13"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M77 59v1h-1v-1zM63 80h1v1h-1z",
    fill: "#960b10"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M91 59v2h-1v-2z",
    fill: "#be2a2d"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M46 61h-1v-1h1zm31 8h1v1h-1z",
    fill: "#a00c0a"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h1v1h-1zm-1 17v1h-1v-1z",
    fill: "#a30b0d"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M78 61h-1v-1h1zM67 71h-1v-1h1z",
    fill: "#a1080e"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M33 61h1v1h-1zm54 57h1v1h-1z",
    fill: "#c8c7c2"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h-1v-1h1zm34 21v-1h1v1z",
    fill: "#c1c3bd"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M42 61v1h-1v-1zm30 19h1v1h-1z",
    fill: "#c2c2c0"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M42 62v-1h1v1zm48 52h-1v-1h1z",
    fill: "#c5c6c6"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M48 63v-2h1v2z",
    fill: "#9e0b0b"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62v-1h1v1zm-3 8v-1h1v1z",
    fill: "#a30b0e"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h-1v-1h1zm20 21v1h-1v-1z",
    fill: "#a1090b"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61h1v1h-1zm8 4h1v1h-1z",
    fill: "#c1beba"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v1h-1v-1zM63 98h-1v-1h1z",
    fill: "#c8c9c7"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h1v1h-1zm52 51v-1h1v1z",
    fill: "#c5c6c3"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62h1v1h-1zm21 48h-1v-1h1z",
    fill: "#c2c1bd"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62h1v1h-1zm7 40v1h-1v-1z",
    fill: "#bfbebb"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M69 63h-1v-1h1zm2 52v-1h1v1z",
    fill: "#bfc1bc"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62h1v1h-1zm-27 54h1v1h-1z",
    fill: "#bf1b20"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M84 63v-1h1v2h-1z",
    fill: "#bf1f24"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63v1h-1v-1zm25 25v-1h1v1z",
    fill: "#c1c6c0"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M62 64v-1h1v1zm13 15h1v1h-1z",
    fill: "#a30b0f"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M73 63v1h-1v-1zM61 99v-1h1v1z",
    fill: "#c5c5c1"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M91 64h-1v-1h1zm0 2h-1v-1h1z",
    fill: "#c0292e"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64h1v1h-1zm29 11h-1v-1h1z",
    fill: "#c3a5a5"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64h1v1h-1zm20 22h1v1h-1z",
    fill: "#c7adaa"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65h-1v-1h1zm11 7h-1v-1h1z",
    fill: "#a50c11"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65h-1v-1h1zm4 0h-1v-1h1z",
    fill: "#bfc0ba"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M77 64h1v1h-1zm-12 8h1v1h-1z",
    fill: "#bec2bc"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65h-1v-1h1zm-20 44v-1h1v1z",
    fill: "#c4c2be"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v1h-1v-1zm-8 25h1v1h-1z",
    fill: "#c9c9c5"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M90 64h1v1h-1zm1 13h-1v-1h1z",
    fill: "#c1292d"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65h1v1h-1zm40 24h-1v-1h1z",
    fill: "#ccbebb"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65v1h-1v-1zm31 22h-1v-1h1z",
    fill: "#b01213"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65v1h-1v-1zm-12 6h1v1h-1z",
    fill: "#a70d10"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v1h-1v-1zm12 7v-1h1v1z",
    fill: "#a70d12"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M45 67h-1v-1h1zm8 3v-1h1v1z",
    fill: "#ac1113"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66h1v1h-1zm4 12v1h-1v-1z",
    fill: "#ae1115"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M73 66v1h-1v-1zm-9 6v1h-1v-1z",
    fill: "#c9b8b4"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67h1v2h-1v-1z",
    fill: "#ae1114"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M56 67v1h-1v-1zm0 12h-1v-1h1z",
    fill: "#a30a0d"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M56 68v-1h1v1zm-2 11h1v1h-1z",
    fill: "#a70c10"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M63 67v1h-1v-1zm16 3v1h-1v-1z",
    fill: "#a70e13"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M69 68v-1h1v1zM59 78h-1v-1h1z",
    fill: "#aa110f"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v1h-1v-1zM69 87h1v1h-1z",
    fill: "#bb1a22"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M32 69v-1h1v1zm1 1v1h-1v-1z",
    fill: "#dcdedb"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h-1v-1h1zm0 2h1v1h-1z",
    fill: "#a20b0f"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M49 68v1h-1v-1zm0 3h-1v-1h1z",
    fill: "#a0090e"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M52 69h-1v-1h1zm1 2v1h-1v-1z",
    fill: "#b21519"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M57 68v1h-1v-1zm-12 2h-1v-1h1z",
    fill: "#aa0f12"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68v2h-1v-2z",
    fill: "#c0292c"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70v-1h1v1zm11 44v1h-1v-1z",
    fill: "#bfc4c3"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M72 69v1h-1v-1zM55 82h1v1h-1z",
    fill: "#ad0e13"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M80 69v1h-1v-1zM59 90h1v1h-1z",
    fill: "#bc1920"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M46 70h1v1h-1zm2 1v1h-1v-1z",
    fill: "#a10b0e"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M62 71v-1h1v1zm28 47v-1h1v1z",
    fill: "#bfc3be"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M76 72v-2h1v2z",
    fill: "#9e090b"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M83 71v-1h1v1zm-23 45v1h-1v-1z",
    fill: "#bc1d21"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M92 71v1h-1v-2h1z",
    fill: "#b62f2f"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72v1h-1v-2h1z",
    fill: "#ad1d1c"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M38 71v2h-1v-2z",
    fill: "#ae1c1c"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M42 72v-1h1v2h-1z",
    fill: "#ac1214"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72h-1v-1h1zm-3 1v1h-1v-1z",
    fill: "#a40d0f"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71v1h-1v-1zm8 32v1h-1v-1z",
    fill: "#c6c2c0"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M90 72v-1h1v2h-1z",
    fill: "#c02a2d"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M47 72v1h-1v-1zm0 6h1v1h-1z",
    fill: "#a20c0d"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72h1v1h-1zm-7 9h1v1h-1z",
    fill: "#a40a0c"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v-1h1v1zm9 2h-1v-1h1z",
    fill: "#c1c4bf"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72h1v1h-1zm-32 34h1v1h-1z",
    fill: "#c31d24"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h-1v-1h1zm0 2h-1v-1h1z",
    fill: "#ad1214"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73v1h-1v-1zm-11 3v-1h1v1z",
    fill: "#b01317"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M51 74v-1h1v1zm1 2h1v1h-1z",
    fill: "#b11217"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74h-1v-1h1zm-37 26h1v1h-1z",
    fill: "#c01e23"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74v-1h1v1zm-38 31v1h-1v-1z",
    fill: "#c31e23"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h-1v-1h1zm-3 8h1v1h-1z",
    fill: "#b01016"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74v1h-1v-1zm-9 33h1v1h-1z",
    fill: "#c4c3c2"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M87 74v1h-1v-1zm1 9h-1v-1h1z",
    fill: "#c21f26"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M40 75v2h-1v-2z",
    fill: "#b11619"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M88 76v-1h1v1zm0 2h1v1h-1z",
    fill: "#c22429"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M51 77v1h-1v-2h1z",
    fill: "#ae1116"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76h1v1h-1zm1 2v-1h1v1z",
    fill: "#ae0f14"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77h-1v-1h1zm-1 14h1v1h-1z",
    fill: "#c5c9c4"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76v1h-1v-1zM55 97h1v1h-1z",
    fill: "#c31c22"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M36 78v1h-1v-2h1z",
    fill: "#b6302f"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M52 77v1h-1v-1zm2 5h1v1h-1z",
    fill: "#ac0d12"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77v1h-1v-1zm10 37v1h-1v-1z",
    fill: "#c2c0bd"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M91 77v1h-1v-1zM38 92h-1v-1h1z",
    fill: "#c1282c"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M36 80v-2h1v2z",
    fill: "#b42523"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M47 79v1h-1v-2h1z",
    fill: "#a60c0e"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v-1h1v1zm-5 3v-1h1v1z",
    fill: "#aa0e12"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M84 78h1v1h-1zm-34 32v-1h1v1z",
    fill: "#c21e23"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M89 79v-1h1v1zm2 3v1h-1v-1z",
    fill: "#c1262a"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79h1v1h-1zm3 4h-1v-1h1z",
    fill: "#aa0e11"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80h-1v-1h1zm-5 1v-1h1v1z",
    fill: "#aa0f13"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79v1h-1v-1zm-6 12v-1h1v1z",
    fill: "#c2c9c4"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81h-1v-1h1zm-31 22h-1v-1h1z",
    fill: "#be191e"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80h1v1h-1zm-2 5v-1h1v1z",
    fill: "#c62229"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81h1v1h-1zm2 2h1v1h-1z",
    fill: "#b6191c"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82h-1v-1h1zm-24 39v-1h1v1z",
    fill: "#c1c1bd"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h-1v-1h1zm-7 9v-1h1v1z",
    fill: "#c5c3c0"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M85 82v-1h1v1zm-1 27v1h-1v-1z",
    fill: "#c72329"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M89 82h-1v-1h1zm-2 24v1h-1v-1z",
    fill: "#c12428"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h1v1h-1zm2 2h-1v-1h1z",
    fill: "#b81c1f"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M56 82h1v1h-1zm10 2v-1h1v1z",
    fill: "#b00d13"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M39 84v-1h1v1zm9 32h-1v-1h1z",
    fill: "#b91d20"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M55 83v1h-1v-1zm7 36h-1v-1h1z",
    fill: "#b11116"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M84 84h-1v-1h1zm-34 18v1h-1v-1z",
    fill: "#c41c24"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M86 84h-1v-1h1zm-33 25v-1h1v1z",
    fill: "#c41e25"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84v1h-1v-1zm2 1h-1v-1h1z",
    fill: "#b21217"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M51 84h1v1h-1zm9 34h1v1h-1z",
    fill: "#b31218"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M60 85h-1v-1h1zm26 28v-1h1v1z",
    fill: "#c7c9c3"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M86 85v-1h1v1zm-44 21h-1v-1h1z",
    fill: "#c52127"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86h-1v-1h1zm-5 3v1h-1v-1z",
    fill: "#b8161c"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86h-1v-1h2v1z",
    fill: "#b21219"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M83 85h1v1h-1zm-24 16h1v1h-1z",
    fill: "#c71f24"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M36 87v-1h1v1zm1 25v1h-1v-1z",
    fill: "#c23438"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v-1h1v1zm10 16h-1v-1h1z",
    fill: "#c01e21"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88v-1h1v1zm1 1v1h-1v-1z",
    fill: "#c14042"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M43 88v-1h1v1zm28 8v-1h1v1z",
    fill: "#c01a21"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M82 88h-1v-1h1zm-23 15h-1v-1h1z",
    fill: "#c71d25"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M89 89h-1v-2h1v1z",
    fill: "#c6282f"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M45 89h-1v-1h1zm20 18v-1h1v1z",
    fill: "#be1920"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M78 89v-1h1v1zm14 6v-1h1v1z",
    fill: "#cacdca"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M38 89h1v1h-1zm0 26v1h-1v-1z",
    fill: "#b82b2c"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M80 89h1v1h-1zm-31 4v1h-1v-1z",
    fill: "#c21920"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M34 92h-1v-2h1v1z",
    fill: "#c76b65"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M49 90v1h-1v-1zm29 7v1h-1v-1z",
    fill: "#bc1a20"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90v1h-1v-1zm7 16v-1h1v1z",
    fill: "#bc161c"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90v1h-1v-1zm-15 11h-1v-1h1z",
    fill: "#c5c8c0"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M93 90h1v1h-1zm-2 3h1v1h-1z",
    fill: "#d2d0ce"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M48 91v1h-1v-1zm26 9v-1h1v1z",
    fill: "#bb151b"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M72 91v1h-1v-1zm15 27v1h-1v-1z",
    fill: "#c4c3be"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M72 92v-1h1v1zm-4 19v1h-1v-1z",
    fill: "#c2c2bf"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M81 91v1h-1v-1zm-31 8v1h-1v-1z",
    fill: "#c31a21"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M81 92h1v1h-1zm0 3h1v1h-1z",
    fill: "#c52126"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94v-1h1v1zm1 12v1h-1v-1z",
    fill: "#c6353a"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M75 93h1v1h-1zm-4 24v1h-1v-1z",
    fill: "#ba181c"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M80 94v-1h1v1zm-3 6v1h-1v-1z",
    fill: "#bd1c24"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94v1h-1v-1zm36 12v1h-1v-1z",
    fill: "#cacac7"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M61 94h1v1h-1zm3 13h-1v-1h1z",
    fill: "#bb1416"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M85 94h1v1h-1zm0 14v-1h1v1z",
    fill: "#ca242a"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v-1h1v1zm29 15h-1v-1h1z",
    fill: "#bf171a"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M75 96v1h-1v-2h1z",
    fill: "#bd1721"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M87 95h1v1h-1zm-1 3h1v1h-1z",
    fill: "#cb262e"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h-1v-2h1v1z",
    fill: "#c6383d"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98v1h-1v-2h1z",
    fill: "#c0181f"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97v1h-1v-1zm-1 9v1h-1v-1z",
    fill: "#be1923"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97h1v1h-1zm-13 3v1h-1v-1z",
    fill: "#be1822"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v2h-1v-2z",
    fill: "#c74c52"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h1v1h-1zm-2 8v1h-1v-1z",
    fill: "#c01e22"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M50 99h-1v-1h1zm29 2h-1v-1h1z",
    fill: "#c01720"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M58 99h-1v-1h1zm24 3v-1h1v1z",
    fill: "#c72026"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98v1h-1v-1zm9 3h1v1h-1z",
    fill: "#c0c3c1"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M37 101h-1v-1h1zm-1 1h1v1h-1z",
    fill: "#c6383c"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M56 100v1h-1v-1zm11 10v-1h1v1z",
    fill: "#b72e2f"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M58 101h-1v-1h1zm25 11v1h-1v-1z",
    fill: "#c72028"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M85 101v-1h1v2h-1z",
    fill: "#c9252c"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M36 102v1h-1v-2h1z",
    fill: "#c54144"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101h1v1h-1zm-7 6h-1v-1h1z",
    fill: "#c3c4bf"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M79 101v1h-1v-1zm-13 6h1v1h-1z",
    fill: "#c11a23"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M34 102h1v2h-1v-1z",
    fill: "#c44b4e"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102v1h-1v-1zm-11 8h1v1h-1z",
    fill: "#c2c1c0"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M48 103v2h-1v-2z",
    fill: "#c41e22"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M60 104v-1h1v1zm-9 3v-1h1v1z",
    fill: "#c61c24"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M62 103h1v1h-1zm3 3v-1h1v1z",
    fill: "#c0191e"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M92 103h1v2h-1v-1z",
    fill: "#cecfd2"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M34 106h-1v-2h1v1z",
    fill: "#c96262"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M57 104v1h-1v-1zm18 10h-1v-1h1z",
    fill: "#c2c2c1"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M44 106v-1h1v1zm25 2h1v1h-1z",
    fill: "#c42026"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h-1v-1h1zm11 9v-1h1v1z",
    fill: "#c51f24"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M59 105v1h-1v-1zm28 7v-1h1v1z",
    fill: "#c5c7c2"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M78 105h1v1h-1zm-29 2v1h-1v-1z",
    fill: "#c41e23"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M86 106h-1v-1h1zm-2 1h1v1h-1z",
    fill: "#cb252c"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M90 105v1h-1v-1zm0 6v-1h1v1z",
    fill: "#c8c9c8"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M32 107h-1v-1h1zm-1 2v-1h1v1z",
    fill: "#d9b2a8",
    fillOpacity: 0.741
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M66 106h1v1h-1zm-17 7v1h-1v-1z",
    fill: "#c01c21"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M68 107v-1h1v1zm-11 3h1v1h-1z",
    fill: "#c61f24"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M69 107v-1h1v1zm13 9v-1h1v1z",
    fill: "#c41c23"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M35 108v1h-1v-1zm-1 4v-1h1v1z",
    fill: "#c2474b"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M68 108v1h-1v-1zm9 1v-1h1v1z",
    fill: "#c11d21"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M36 111v-2h1v2z",
    fill: "#c23535"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M62 111h-1v-1h1zm24 3h1v1h-1z",
    fill: "#c3c4c3"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M92 111h-1v-1h1zm0 2v1h-1v-1z",
    fill: "#caccce"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M49 112v1h-1v-1zm10 4v-1h1v1z",
    fill: "#c01d22"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M65 112h1v1h-1zm24 4v1h-1v-1z",
    fill: "silver"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M33 115v-2h1v2z",
    fill: "#bf5e5d"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M63 114v1h-1v-1zm1 1v1h-1v-1z",
    fill: "#b6161d"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M61 115v1h-1v-1zm20 3h-1v-1h1z",
    fill: "#be1a21"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M65 116h-1v-1h1zm1 2h1v1h-1z",
    fill: "#b6141c"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M90 115v1h-2v-1h1z",
    fill: "#c1c1c1"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M53 117h-2v-1h2z",
    fill: "#be181e"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M85 117v1h-1v-1zm0 4v-1h1v1z",
    fill: "#bfbebc"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M59 118v1h-1v-1zm16 0v1h-1v-1z",
    fill: "#b41317"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M40 120h1v1h-1zm3 1h-1v-1h1z",
    fill: "#b6b5b2"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M75 121h-1v-1h2v1z",
    fill: "#d6d5cb"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M42 122v-1h1v1zm11 2h1v1h-1z",
    fill: "#a8aaa5"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M43 122v-1h1v1zm3-1h1v1h-1z",
    fill: "#a7a8a4"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M46 121v1h-1v-1zm35 2v-1h1v1z",
    fill: "#a7a7a4"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M53 121h1v1h-1zm29 3h-1v-1h1z",
    fill: "#afafac"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M60 122h-1v-1h1zm3 0v-1h1v1z",
    fill: "#b7b9b3"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M88 122h-1v-1h1zm-46 1v1h-1v-1z",
    fill: "#b2b1af"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M41 123h-1v-1h1zm45 1h-1v-1h1z",
    fill: "#b3b2ae"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M43 122h1v1h-1zm7 2v1h-1v-1z",
    fill: "#aaaaa6"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M61 123v-1h1v1zm5 0h1v1h-1z",
    fill: "#a1a19c"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M63 122h1v1h-2v-1z",
    fill: "#a2a29e"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M69 122v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#a2a2a1"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M73 123v-1h1v1zm-14 0v1h-1v-1z",
    fill: "#a2a39d"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M76 122h1v1h-1zm-8 4v-1h1v1z",
    fill: "#a3a5a0"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M85 123h-1v-1h1zm-15 1v1h-1v-1z",
    fill: "#aaaba5"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M51 124v-1h2v1h-1z",
    fill: "#a5a39c"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M54 124v-1h2v1h-1z",
    fill: "#a4a4a0"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M64 124h-2v-1h2z",
    fill: "#a0a19b"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M73 124h-1v-1h2v1z",
    fill: "#a5a6a1"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M56 125h-1v-1h1zm1 0v-1h1v1z",
    fill: "#aaaca7"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M58 125v-1h1v1zm3 0h-1v-1h1z",
    fill: "#abaca7"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M67 124v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#abaca5"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M71 125v-1h2v1h-1z",
    fill: "#afb0aa"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M68 125v1h-1v-1zm2 0h1v1h-1z",
    fill: "#a3a5a1"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M69 126v-1h1v1zm2 0v-1h1v1z",
    fill: "#a3a4a1"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M66 126h2v1h-2z",
    fill: "#878a8a",
    fillOpacity: 0.325
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M38 2V1h1v1z",
    fill: "#f4f4f4",
    fillOpacity: 0.098
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M40 1v1h-1V1z",
    fill: "#eeeee2",
    fillOpacity: 0.176
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M41 1v1h-1V1z",
    fill: "#e6e6dd",
    fillOpacity: 0.208
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M42 2h-1V1h1z",
    fill: "#dfe4d6",
    fillOpacity: 0.224
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M42 1h1v1h-1z",
    fill: "#dde1d5",
    fillOpacity: 0.239
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M44 1v1h-1V1z",
    fill: "#daddd2",
    fillOpacity: 0.271
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M45 1v1h-1V1z",
    fill: "#dde1d3",
    fillOpacity: 0.302
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M45 2V1h1v1z",
    fill: "#dcdfd3",
    fillOpacity: 0.322
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M47 1v1h-1V1z",
    fill: "#dee1d5",
    fillOpacity: 0.333
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M47 2V1h1v1z",
    fill: "#dbded3",
    fillOpacity: 0.341
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M48 2V1h1v1z",
    fill: "#dce2d4",
    fillOpacity: 0.349
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M50 1v1h-1V1z",
    fill: "#dde0d4",
    fillOpacity: 0.357
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M50 2V1h1v1z",
    fill: "#dee0d5",
    fillOpacity: 0.365
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M52 1v1h-1V1z",
    fill: "#dcdfd4",
    fillOpacity: 0.376
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M52 2V1h1v1z",
    fill: "#dfe1d4",
    fillOpacity: 0.376
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M54 2h-1V1h1z",
    fill: "#e1e3d6",
    fillOpacity: 0.369
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M55 2h-1V1h1z",
    fill: "#e4e4d7",
    fillOpacity: 0.376
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M55 1h1v1h-1z",
    fill: "#e6e6d8",
    fillOpacity: 0.365
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M57 1v1h-1V1z",
    fill: "#eaeadc",
    fillOpacity: 0.345
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M57 2V1h1v1z",
    fill: "#e8e5d8",
    fillOpacity: 0.314
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M58 1h1v1h-1z",
    fill: "#dfdcce",
    fillOpacity: 0.29
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M60 2h-1V1h1z",
    fill: "#edeadc",
    fillOpacity: 0.286
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M61 1v1h-1V1z",
    fill: "#f5f1e4",
    fillOpacity: 0.302
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M61 1h1v1h-1z",
    fill: "#f3f0e4",
    fillOpacity: 0.333
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M63 1v1h-1V1z",
    fill: "#f0ede4",
    fillOpacity: 0.337
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M63 2V1h1v1z",
    fill: "#ece9dd",
    fillOpacity: 0.325
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M64 2V1h1v1z",
    fill: "#ece9dc",
    fillOpacity: 0.322
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M65 2V1h1v1z",
    fill: "#efefe3",
    fillOpacity: 0.329
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M67 1v1h-1V1z",
    fill: "#efefe3",
    fillOpacity: 0.322
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M67 1h1v1h-1z",
    fill: "#eeeee1",
    fillOpacity: 0.302
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1v1h-1V1z",
    fill: "#e9edde",
    fillOpacity: 0.278
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M70 1v1h-1V1z",
    fill: "#ebebe0",
    fillOpacity: 0.259
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M73 2h-1V1h1z",
    fill: "#e0e0d4",
    fillOpacity: 0.259
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M74 1v1h-1V1z",
    fill: "#ddddd2",
    fillOpacity: 0.267
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M74 2V1h1v1z",
    fill: "#ddddd0",
    fillOpacity: 0.298
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M76 1v1h-1V1z",
    fill: "#dbdbd2",
    fillOpacity: 0.314
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M76 2V1h1v1z",
    fill: "#ddddd3",
    fillOpacity: 0.325
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M77 2V1h1v1z",
    fill: "#dbdbcf",
    fillOpacity: 0.337
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M79 1v1h-1V1z",
    fill: "#dbdbd0",
    fillOpacity: 0.341
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M79 2V1h1v1z",
    fill: "#dbdbcf",
    fillOpacity: 0.333
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M81 1v1h-1V1z",
    fill: "#dadad0",
    fillOpacity: 0.325
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M81 1h1v1h-1z",
    fill: "#d7d7cd",
    fillOpacity: 0.306
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M82 1h1v1h-1z",
    fill: "#d5d5ca",
    fillOpacity: 0.286
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M84 2h-1V1h1z",
    fill: "#d6d6cc",
    fillOpacity: 0.275
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M84 1h1v1h-1z",
    fill: "#d7d7cf",
    fillOpacity: 0.251
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M86 1v1h-1V1z",
    fill: "#dbdbcd",
    fillOpacity: 0.224
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M87 2h-1V1h1z",
    fill: "#d8d8ce",
    fillOpacity: 0.208
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M87 1h1v1h-1z",
    fill: "#e4e4da",
    fillOpacity: 0.192
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M89 1v1h-1V1z",
    fill: "#e7ede2",
    fillOpacity: 0.173
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M89 1h1v1h-1z",
    fill: "#eeeee6",
    fillOpacity: 0.122
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M37 2h1v1h-1z",
    fill: "#e1e1da",
    fillOpacity: 0.271
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M39 3h-1V2h1z",
    fill: "#d8d8cc",
    fillOpacity: 0.91
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M39 2h1v1h-1z",
    fill: "#d3d4c6",
    fillOpacity: 0.98
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M41 3h-1V2h1z",
    fill: "#cdcec1",
    fillOpacity: 0.996
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M42 3h-1V2h1z",
    fill: "#cdcfc1"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M42 3V2h1v1z",
    fill: "#cdd0c1"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M43 2h1v1h-1z",
    fill: "#cfd2c2"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M44 3V2h1v1z",
    fill: "#d2d4c5"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M46 3h-1V2h1z",
    fill: "#d2d5c6"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M47 3h-1V2h1z",
    fill: "#d5d7c8"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M47 2h1v1h-1z",
    fill: "#d6d8c9"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M49 3h-1V2h1z",
    fill: "#d6d9ca"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M49 3V2h1v1z",
    fill: "#d7daca"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M51 2v1h-1V2z",
    fill: "#d8dacc"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M51 2h1v1h-1z",
    fill: "#d9dbcd"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M52 2h1v1h-1z",
    fill: "#dbdecf"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M53 2h1v1h-1z",
    fill: "#dde0cd"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M54 3V2h1v1z",
    fill: "#e1e3cf"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M55 3V2h1v1z",
    fill: "#e2e3cf"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M56 3V2h1v1z",
    fill: "#e4e3d0"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M58 3h-1V2h1z",
    fill: "#e1decf"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M59 3h-1V2h1z",
    fill: "#dddacc"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M59 3V2h1v1z",
    fill: "#e1dfcf"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M60 3V2h1v1z",
    fill: "#e7e6d5"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M62 3h-1V2h1z",
    fill: "#eae8d6"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M62 2h1v1h-1z",
    fill: "#e7e4d2"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M64 2v1h-1V2z",
    fill: "#dfdcca"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M65 2v1h-1V2z",
    fill: "#dedbc9"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M65 2h1v1h-1z",
    fill: "#edebd8"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M66 3V2h1v1z",
    fill: "#edecd9"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3h-1V2h1z",
    fill: "#e5e4d0"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M69 3h-1V2h1z",
    fill: "#e3e2ce"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M69 2h1v1h-1z",
    fill: "#e4e2d1"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M73 2v1h-1V2z",
    fill: "#e3e1d4"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M74 3h-1V2h1z",
    fill: "#e3e2d5"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M74 2h1v1h-1z",
    fill: "#e0e1d3"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M75 2h1v1h-1z",
    fill: "#dfdfd2"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M76 2h1v1h-1z",
    fill: "#dfe0d2"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M77 3V2h1v1z",
    fill: "#dbdbce"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M78 3V2h1v1z",
    fill: "#d7d8ca"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M80 2v1h-1V2z",
    fill: "#d5d6c9"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M81 3h-1V2h1z",
    fill: "#d4d5c7"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M81 2h1v1h-1z",
    fill: "#d3d4c6"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M83 2v1h-1V2z",
    fill: "#d3d3c6"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M83 3V2h1v1z",
    fill: "#d2d2c5"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M85 2v1h-1V2z",
    fill: "#d0d1c3"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M86 3h-1V2h1z",
    fill: "#d0d1c4"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M86 2h1v1h-1z",
    fill: "#d0cfc3",
    fillOpacity: 0.992
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M88 3h-1V2h1z",
    fill: "#cfcfc3",
    fillOpacity: 0.988
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M88 3V2h1v1z",
    fill: "#d1d0c4",
    fillOpacity: 0.976
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M90 2v1h-1V2z",
    fill: "#d4d4c8",
    fillOpacity: 0.941
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M91 3h-1V2h1z",
    fill: "#d1d3cc",
    fillOpacity: 0.706
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M92 2v1h-1V2z",
    fill: "#e5e5e5",
    fillOpacity: 0.039
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M37 3h1v1h-1z",
    fill: "#dbdbd4",
    fillOpacity: 0.427
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M38 4V3h1v1z",
    fill: "#cdcdc1"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M40 3v1h-1V3z",
    fill: "#bcbdad"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M41 3v1h-1V3z",
    fill: "#b5b7a8"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M42 3v1h-1V3z",
    fill: "#b5b6a8"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M45 4h-1V3h1z",
    fill: "#b2b3a5"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M46 3v1h-1V3z",
    fill: "#b1b3a5"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M48 3v1h-1V3z",
    fill: "#b2b4a6"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M49 3v1h-1V3z",
    fill: "#b3b5a7"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M49 3h1v1h-1z",
    fill: "#b2b5a6"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M50 4V3h1v1z",
    fill: "#b1b4a7"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M52 4h-1V3h1z",
    fill: "#b2b6a9"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M52 4V3h1v1z",
    fill: "#b4b7aa"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M53 3h1v1h-1z",
    fill: "#b3b6aa"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M55 4h-1V3h1z",
    fill: "#b5b7aa"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M56 3v1h-1V3z",
    fill: "#b8b8ab"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M56 3h1v1h-1z",
    fill: "#bab8ac"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M57 4V3h1v1z",
    fill: "#bebcb1"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M58 3h1v1h-1z",
    fill: "#c0c0b4"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M60 3v1h-1V3z",
    fill: "#bfbfb1"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M60 4V3h1v1z",
    fill: "#bebfaf"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M62 4h-1V3h1z",
    fill: "#bdbdac"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M63 3v1h-1V3z",
    fill: "#bab8a7"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M63 3h1v1h-1z",
    fill: "#b7b6a5"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M65 4h-1V3h1z",
    fill: "#b5b3a2"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M65 4V3h1v1z",
    fill: "#b6b4a5"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M66 3h1v1h-1z",
    fill: "#bcb8ab"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M67 4V3h1v1z",
    fill: "#c0bdb0"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3h1v1h-1z",
    fill: "#c3bfb2"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M69 3h1v1h-1z",
    fill: "#c2bfb3"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M74 3v1h-1V3z",
    fill: "#c1bfb2"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M76 4h-1V3h1z",
    fill: "#bdbfb1"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M79 4V3h1v1z",
    fill: "#c2c4b6"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M83 4h-1V3h1z",
    fill: "#bec1b3"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M84 3v1h-1V3z",
    fill: "#bcbdb0"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M85 3v1h-1V3z",
    fill: "#bbbdaf"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M86 3v1h-1V3z",
    fill: "#bbbcaf"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M86 4V3h1v1z",
    fill: "#bcbab0"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M87 3h1v1h-1z",
    fill: "#bab9af"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M89 3v1h-1V3z",
    fill: "#bbb9b0"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M90 4h-1V3h1z",
    fill: "#c0beb4"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M91 3v1h-1V3z",
    fill: "#c4c4be",
    fillOpacity: 0.91
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M92 3v1h-1V3z",
    fill: "#e2e2e2",
    fillOpacity: 0.071
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M38 4v1h-1V4z",
    fill: "#ebebe6",
    fillOpacity: 0.2
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M38 5V4h1v1z",
    fill: "#cbc7ba",
    fillOpacity: 0.949
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M40 5h-1V4h1z",
    fill: "#b8a89e"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M41 5h-1V4h1z",
    fill: "#b1a59a"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M41 4h1v1h-1z",
    fill: "#ab9e92"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M43 5h-1V4h1z",
    fill: "#b0a095"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M43 5V4h1v1z",
    fill: "#b3a298"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M45 4v1h-1V4z",
    fill: "#af9f94"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M45 5V4h1v1z",
    fill: "#ad9d92"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M47 5V4h1v1z",
    fill: "#ad9e93"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M50 4v1h-1V4z",
    fill: "#b2a59a"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M50 4h1v1h-1z",
    fill: "#b4a99e"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M51 4h1v1h-1z",
    fill: "#b7aea4"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M53 5h-1V4h1z",
    fill: "#b7b0a6"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M53 4h1v1h-1z",
    fill: "#b5aea5"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M55 5h-1V4h1z",
    fill: "#b4ada4"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M55 4h1v1h-1z",
    fill: "#b3b0a2"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M57 4v1h-1V4z",
    fill: "#b1aea0"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M58 5h-1V4h1z",
    fill: "#b3afa1"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M59 4v1h-1V4z",
    fill: "#b5afa1"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M59 5V4h1v1z",
    fill: "#b4afa1"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M61 4v1h-1V4z",
    fill: "#b5b0a3"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M61 5V4h1v1z",
    fill: "#b6b2a3"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M62 4h1v1h-1z",
    fill: "#b6b1a3"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M63 4h1v1h-1z",
    fill: "#b2ada2"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M65 5h-1V4h1z",
    fill: "#b2b0a3"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M66 5h-1V4h1z",
    fill: "#b5b3a7"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M66 5V4h1v1z",
    fill: "#b6b2a9"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M68 4v1h-1V4z",
    fill: "#b3b3a8"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M69 4v1h-1V4z",
    fill: "#b3b4a8"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M70 5h-1V4h1z",
    fill: "#b6b6ab"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M70 4h1v1h-1z",
    fill: "#b9b6ab"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M71 4h1v1h-1z",
    fill: "#b8b6ac"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M72 5V4h1v1z",
    fill: "#bbb8ae"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M74 5h-1V4h1z",
    fill: "#b9b8ad"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M74 4h1v1h-1z",
    fill: "#b7baae"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M76 4v1h-1V4z",
    fill: "#b8baad"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M76 5V4h1v1z",
    fill: "#b6b7aa"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M77 5V4h1v1z",
    fill: "#b5b5a7"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M78 5V4h1v1z",
    fill: "#b5b5a8"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M80 5h-1V4h1z",
    fill: "#b0b3a5"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M80 4h1v1h-1z",
    fill: "#b3b5a6"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M82 4v1h-1V4z",
    fill: "#bcbbad"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M82 4h1v1h-1z",
    fill: "#bcbbae"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M83 5V4h1v1z",
    fill: "#bbb7ad"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M85 4v1h-1V4z",
    fill: "#b5b9ae"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M86 5h-1V4h1z",
    fill: "#b3b4a9"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M87 4v1h-1V4z",
    fill: "#b9b5ab"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M88 4v1h-1V4z",
    fill: "#beb8b3"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M88 5V4h1v1z",
    fill: "#c0b8b1"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M90 4v1h-1V4z",
    fill: "#c5bfb5"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M90 5V4h1v1z",
    fill: "#d1cac5",
    fillOpacity: 0.576
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M38 5h1v1h-1z",
    fill: "#c9ad9f",
    fillOpacity: 0.855
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M39 5h1v1h-1z",
    fill: "#b67a72"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M40 5h1v1h-1z",
    fill: "#a85f57"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M41 6V5h1v1z",
    fill: "#a04c45"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M42 6V5h1v1z",
    fill: "#a34742"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M43 6V5h1v1z",
    fill: "#a2423f"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M45 5v1h-1V5z",
    fill: "#a13f3b"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M46 5v1h-1V5z",
    fill: "#a03d39"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M47 6h-1V5h1z",
    fill: "#9f3b38"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M47 5h1v1h-1z",
    fill: "#9e3a37"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M48 6V5h1v1z",
    fill: "#a03c38"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M49 6V5h1v1z",
    fill: "#a3403a"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M50 5h1v1h-1z",
    fill: "#a4423b"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M52 6h-1V5h1z",
    fill: "#a3443d"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M52 5h1v1h-1z",
    fill: "#a4473f"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M54 5v1h-1V5z",
    fill: "#a34a42"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M55 5v1h-1V5z",
    fill: "#a44b44"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M56 5v1h-1V5z",
    fill: "#a75047"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M57 6h-1V5h1z",
    fill: "#ab564e"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M58 5v1h-1V5z",
    fill: "#ad5e55"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M59 5v1h-1V5z",
    fill: "#af645b"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M59 6V5h1v1z",
    fill: "#b0685f"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M60 6V5h1v1z",
    fill: "#af6b61"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M61 5h1v1h-1z",
    fill: "#ae695f"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M62 6V5h1v1z",
    fill: "#ac645b"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M64 6h-1V5h1z",
    fill: "#a95f58"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M64 6V5h1v1z",
    fill: "#a96259"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M65 5h1v1h-1z",
    fill: "#ab695e"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M67 6h-1V5h1z",
    fill: "#ad6e62"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M67 6V5h1v1z",
    fill: "#af7467"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M69 6h-1V5h1z",
    fill: "#b0796a"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M70 5v1h-1V5z",
    fill: "#b27a6d"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M71 6h-1V5h1z",
    fill: "#b5796e"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M72 5v1h-1V5z",
    fill: "#b3786d"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M72 6V5h1v1z",
    fill: "#b1756b"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M74 6h-1V5h1z",
    fill: "#af7268"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M75 5v1h-1V5z",
    fill: "#b2746a"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M75 6V5h1v1z",
    fill: "#b4756b"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M77 5v1h-1V5z",
    fill: "#b17267"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M77 6V5h1v1z",
    fill: "#af6f64"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M78 5h1v1h-1z",
    fill: "#ae6f63"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M79 6V5h1v1z",
    fill: "#ad6c62"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M81 6h-1V5h1z",
    fill: "#af6a61"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M82 6h-1V5h1z",
    fill: "#b1655e"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M82 6V5h1v1z",
    fill: "#a67068"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M83 5h1v1h-1z",
    fill: "#b9b3af"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M84 6V5h1v1z",
    fill: "#b9bab7"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M86 5v1h-1V5z",
    fill: "#bdbcb7"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M86 6V5h1v1z",
    fill: "#b58b8a"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M87 5h1v1h-1z",
    fill: "#ab6464"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M89 5v1h-1V5z",
    fill: "#b97774"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M89 6V5h1v1z",
    fill: "#c09691"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M91 6h-1V5h1z",
    fill: "#d2bab7",
    fillOpacity: 0.408
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M38 6v1h-1V6z",
    fill: "#fff4ea",
    fillOpacity: 0.098
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M39 6v1h-1V6z",
    fill: "#cba196",
    fillOpacity: 0.906
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M39 7V6h1v1z",
    fill: "#b86d66"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M41 7h-1V6h1z",
    fill: "#aa4b46"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M42 7h-1V6h1z",
    fill: "#a63836"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M42 7V6h1v1z",
    fill: "#a82f30"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M44 7h-1V6h1z",
    fill: "#a8272b"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M45 7h-1V6h1z",
    fill: "#a72124"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M46 7h-1V6h1z",
    fill: "#a51e1e"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M47 7h-1V6h1z",
    fill: "#a41b1b"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M47 7V6h1v1z",
    fill: "#a41819"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M49 7h-1V6h1z",
    fill: "#a51618"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M49 6h1v1h-1z",
    fill: "#a81417"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M52 6v1h-1V6z",
    fill: "#a51214"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M55 7h-1V6h1z",
    fill: "#a51212"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M57 6v1h-1V6z",
    fill: "#a81717"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M57 7V6h1v1z",
    fill: "#ac1d1c"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M58 6h1v1h-1z",
    fill: "#ae2320"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M59 6h1v1h-1z",
    fill: "#ad2523"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M61 6v1h-1V6z",
    fill: "#ab2523"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M62 6v1h-1V6z",
    fill: "#a71d19"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M63 6v1h-1V6z",
    fill: "#a41310"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M64 6v1h-1V6z",
    fill: "#9f0c0d"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M66 7h-1V6h1z",
    fill: "#9f0f0d"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M67 7h-1V6h1z",
    fill: "#a51512"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M67 6h1v1h-1z",
    fill: "#a81c18"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M69 6v1h-1V6z",
    fill: "#ad231e"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M70 7h-1V6h1z",
    fill: "#ab231d"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M71 6v1h-1V6z",
    fill: "#aa211a"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M71 7V6h1v1z",
    fill: "#a71c17"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M73 7h-1V6h1z",
    fill: "#a31611"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M74 6v1h-1V6z",
    fill: "#a2130f"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M74 6h1v1h-1z",
    fill: "#a3130f"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M76 6v1h-1V6z",
    fill: "#a31310"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M77 7h-1V6h1z",
    fill: "#a41411"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M77 6h1v1h-1z",
    fill: "#a51714"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M79 6v1h-1V6z",
    fill: "#a51a17"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M80 7h-1V6h1z",
    fill: "#a71918"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M81 6v1h-1V6z",
    fill: "#a81819"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M82 6h1v1h-1z",
    fill: "#a5413e"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M84 7h-1V6h1z",
    fill: "#c4babd"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M85 7h-1V6h1z",
    fill: "#bebec0"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M86 7h-1V6h1z",
    fill: "#c6c4c1"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M86 6h1v1h-1z",
    fill: "#af6f71"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M87 6h1v1h-1z",
    fill: "#a53635"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M89 6v1h-1V6z",
    fill: "#b15350"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M90 7h-1V6h1z",
    fill: "#b97d78"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M90 6h1v1h-1z",
    fill: "#cbaaa6",
    fillOpacity: 0.463
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M38 7v1h-1V7z",
    fill: "#ebd7cc",
    fillOpacity: 0.255
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M38 7h1v1h-1z",
    fill: "#c7978c",
    fillOpacity: 0.984
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8h-1V7h1z",
    fill: "#b76a64"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M40 7h1v1h-1z",
    fill: "#ad4a49"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M41 8V7h1v1z",
    fill: "#aa3838"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M42 8V7h1v1z",
    fill: "#ad3232"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M44 7v1h-1V7z",
    fill: "#af2a2c"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M45 8h-1V7h1z",
    fill: "#ae2527"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M45 7h1v1h-1z",
    fill: "#ad2122"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M47 7v1h-1V7z",
    fill: "#ad1f20"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M48 7v1h-1V7z",
    fill: "#b01d20"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M48 8V7h1v1z",
    fill: "#b11b1f"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M49 8V7h1v1z",
    fill: "#af1a1e"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M51 7v1h-1V7z",
    fill: "#ae191c"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M51 7h1v1h-1z",
    fill: "#ad191b"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M52 7h1v1h-1z",
    fill: "#ab1819"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M53 8V7h1v1z",
    fill: "#ac171b"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M54 8V7h1v1z",
    fill: "#ab1519"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M55 8V7h1v1z",
    fill: "#aa1416"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M57 7h1v1h-1z",
    fill: "#ac1717"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M59 7v1h-1V7z",
    fill: "#ac1718"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M59 8V7h1v1z",
    fill: "#ae171a"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M61 8V7h1v1z",
    fill: "#aa1515"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M62 7h1v1h-1z",
    fill: "#a71210"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M64 7h1v1h-1z",
    fill: "#a60e0f"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M65 8V7h1v1z",
    fill: "#a5110f"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M67 8h-1V7h1z",
    fill: "#a71413"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M68 8h-1V7h1z",
    fill: "#aa1716"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M69 8h-1V7h1z",
    fill: "#ad1a18"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M70 8h-1V7h1z",
    fill: "#ad1a19"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M71 8h-1V7h1z",
    fill: "#aa1718"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M77 7v1h-1V7z",
    fill: "#af171b"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M77 7h1v1h-1z",
    fill: "#b0191d"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M79 7v1h-1V7z",
    fill: "#b41c1f"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M80 7v1h-1V7z",
    fill: "#b41b1f"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M82 8h-1V7h1z",
    fill: "#ae1c1a"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M83 7v1h-1V7z",
    fill: "#ad4746"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M83 7h1v1h-1z",
    fill: "#cbbdc2"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M86 8h-1V7h1z",
    fill: "#c7c5c3"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M87 8h-1V7h1z",
    fill: "#b56a6f"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M88 7v1h-1V7z",
    fill: "#ae3839"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M89 8h-1V7h1z",
    fill: "#b35557"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M90 7v1h-1V7z",
    fill: "#be7975"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M91 8h-1V7h1z",
    fill: "#caa49c",
    fillOpacity: 0.651
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M38 8v1h-1V8z",
    fill: "#debfb6",
    fillOpacity: 0.58
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M39 9h-1V8h1z",
    fill: "#c88b82"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8v1h-1V8z",
    fill: "#b86762"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M41 8v1h-1V8z",
    fill: "#b44a49"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M41 8h1v1h-1z",
    fill: "#b03938"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M43 8v1h-1V8z",
    fill: "#b43232"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M43 8h1v1h-1z",
    fill: "#b62c2d"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M45 9h-1V8h1z",
    fill: "#b42929"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M45 8h1v1h-1z",
    fill: "#b32626"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M46 8h1v1h-1z",
    fill: "#b62525"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M48 8v1h-1V8z",
    fill: "#bb2324"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M49 8v1h-1V8z",
    fill: "#bd2222"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M50 8v1h-1V8z",
    fill: "#bb2322"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M50 9V8h1v1z",
    fill: "#be2125"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M51 8h1v1h-1z",
    fill: "#bc2423"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M53 8v1h-1V8z",
    fill: "#be2222"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M53 8h1v1h-1z",
    fill: "#bb2125"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M55 9h-1V8h1z",
    fill: "#ba1f24"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M56 9h-1V8h1z",
    fill: "#b61e22"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M56 8h1v1h-1z",
    fill: "#b91c20"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M58 9V8h1v1z",
    fill: "#b7191e"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M60 9h-1V8h1z",
    fill: "#b4181e"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M60 8h1v1h-1z",
    fill: "#b2171d"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M62 8v1h-1V8z",
    fill: "#b21317"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M62 9V8h1v1z",
    fill: "#b11113"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M64 8v1h-1V8z",
    fill: "#b31013"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M64 9V8h1v1z",
    fill: "#b20f12"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M65 8h1v1h-1z",
    fill: "#b10f12"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M67 9h-1V8h1z",
    fill: "#b21115"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M70 9h-1V8h1z",
    fill: "#b5171c"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M71 9h-1V8h1z",
    fill: "#b4181c"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M73 9h-1V8h1z",
    fill: "#b7181c"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M75 9h-1V8h1z",
    fill: "#b81d1c"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M75 9V8h1v1z",
    fill: "#b81f1e"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M76 8h1v1h-1z",
    fill: "#ba2021"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M78 9h-1V8h1z",
    fill: "#bb2023"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M79 9h-1V8h1z",
    fill: "#bd1f24"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M79 9V8h1v1z",
    fill: "#bc2024"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M80 8h1v1h-1z",
    fill: "#ba2224"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M82 9h-1V8h1z",
    fill: "#b5201f"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M83 8v1h-1V8z",
    fill: "#b1403f"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M84 8v1h-1V8z",
    fill: "#ccbabc"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M84 9V8h1v1z",
    fill: "#c1c5c4"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M86 8v1h-1V8z",
    fill: "#cac8c6"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M86 9V8h1v1z",
    fill: "#b87579"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M87 8h1v1h-1z",
    fill: "#ac3939"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M89 8v1h-1V8z",
    fill: "#b45558"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M89 8h1v1h-1z",
    fill: "#b97370"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M91 8v1h-1V8z",
    fill: "#c39792",
    fillOpacity: 0.902
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M92 8v1h-1V8z",
    fill: "#e7dcdc",
    fillOpacity: 0.086
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M37 9v1h-1V9z",
    fill: "#f1e3dc",
    fillOpacity: 0.145
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M38 10h-1V9h1z",
    fill: "#d3aaa0",
    fillOpacity: 0.929
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M39 9v1h-1V9z",
    fill: "#c17871"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M40 10h-1V9h1z",
    fill: "#ba6461"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M41 10h-1V9h1z",
    fill: "#b94a4a"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M41 9h1v1h-1z",
    fill: "#b53838"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M43 10h-1V9h1z",
    fill: "#b83434"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M43 9h1v1h-1z",
    fill: "#bb2f30"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M44 10V9h1v1z",
    fill: "#ba2d2c"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M45 9h1v1h-1z",
    fill: "#bc2a2a"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M47 9v1h-1V9z",
    fill: "#c02a29"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M47 10V9h1v1z",
    fill: "#c62927"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M48 10V9h1v1z",
    fill: "#cb2928"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M50 10h-1V9h1z",
    fill: "#cf2b2a"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M51 9v1h-1V9z",
    fill: "#d22e30"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M52 9v1h-1V9z",
    fill: "#d13433"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M52 10V9h1v1z",
    fill: "#d73639"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M54 10h-1V9h1z",
    fill: "#db353a"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M55 10h-1V9h1z",
    fill: "#e33d41"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M56 10h-1V9h1z",
    fill: "#e64c4d"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M57 9v1h-1V9z",
    fill: "#ea5657"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M57 9h1v1h-1z",
    fill: "#ec5b5b"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10h-1V9h1z",
    fill: "#ec585a"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10V9h1v1z",
    fill: "#e55055"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M61 9v1h-1V9z",
    fill: "#e0454a"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M61 10V9h1v1z",
    fill: "#dd3438"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M62 10V9h1v1z",
    fill: "#d62629"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M63 9h1v1h-1z",
    fill: "#d31d22"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M64 9h1v1h-1z",
    fill: "#d41c22"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M66 9v1h-1V9z",
    fill: "#d62025"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M66 10V9h1v1z",
    fill: "#db2b2e"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M67 9h1v1h-1z",
    fill: "#df393a"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M69 10h-1V9h1z",
    fill: "#e14847"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M69 10V9h1v1z",
    fill: "#e45251"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M71 9v1h-1V9z",
    fill: "#e75857"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M72 10h-1V9h1z",
    fill: "#e75756"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M73 10h-1V9h1z",
    fill: "#e64d4d"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M74 9v1h-1V9z",
    fill: "#e33f41"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M74 10V9h1v1z",
    fill: "#dc3334"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M76 10h-1V9h1z",
    fill: "#d52c2e"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M77 10h-1V9h1z",
    fill: "#d0292b"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M77 10V9h1v1z",
    fill: "#cc2629"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M79 10h-1V9h1z",
    fill: "#cc252b"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M80 10h-1V9h1z",
    fill: "#ca262b"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M80 10V9h1v1z",
    fill: "#c6282c"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M82 9v1h-1V9z",
    fill: "#c02828"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M83 9v1h-1V9z",
    fill: "#b42f31"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M84 10h-1V9h1z",
    fill: "#cdaaa9"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M87 10h-1V9h1z",
    fill: "#c09896"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M88 9v1h-1V9z",
    fill: "#ae3d3f"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M88 10V9h1v1z",
    fill: "#b95455"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M90 9v1h-1V9z",
    fill: "#bb6a69"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M90 10V9h1v1z",
    fill: "#c88986"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M92 10h-1V9h1z",
    fill: "#d6b4b0",
    fillOpacity: 0.494
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M36 11v-1h1v1z",
    fill: "#dbbdb6",
    fillOpacity: 0.624
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M37 11v-1h1v1z",
    fill: "#ce948a"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M38 11v-1h1v1z",
    fill: "#bb6e67"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M39 10h1v1h-1z",
    fill: "#bd6160"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M41 10v1h-1v-1z",
    fill: "#bb4949"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M41 10h1v1h-1z",
    fill: "#b93736"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M43 10v1h-1v-1z",
    fill: "#bd3434"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M43 10h1v1h-1z",
    fill: "#c03231"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M45 11h-1v-1h1z",
    fill: "#c02f2e"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M46 10v1h-1v-1z",
    fill: "#c32d2b"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M46 11v-1h1v1z",
    fill: "#c72c29"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M47 10h1v1h-1z",
    fill: "#cd2b29"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M48 11v-1h1v1z",
    fill: "#d32e2b"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M50 11h-1v-1h1z",
    fill: "#d9302d"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11h-1v-1h1z",
    fill: "#e13132"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11v-1h1v1z",
    fill: "#e03434"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M52 10h1v1h-1z",
    fill: "#dd504c"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M53 11v-1h1v1z",
    fill: "#e56362"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M54 11v-1h1v1z",
    fill: "#f1444b"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M55 11v-1h1v1z",
    fill: "#fc5d5c"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M57 11h-1v-1h1z",
    fill: "#ff6e6d"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M57 10h1v1h-1z",
    fill: "#ff7b79"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10v1h-1v-1z",
    fill: "#ff7e7c"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M60 10v1h-1v-1z",
    fill: "#fe7776"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M60 10h1v1h-1z",
    fill: "#fe6869"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M62 11h-1v-1h1z",
    fill: "#fa4f51"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M63 11h-1v-1h1z",
    fill: "#f0393b"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M63 10h1v1h-1z",
    fill: "#e9292e"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M64 11v-1h1v1z",
    fill: "#ea262d"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M65 10h1v1h-1z",
    fill: "#ee2e32"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M66 10h1v1h-1z",
    fill: "#f64141"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M67 11v-1h1v1z",
    fill: "#fc5a56"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M68 11v-1h1v1z",
    fill: "#fd7068"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11v-1h1v1z",
    fill: "#ff7c74"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M71 10v1h-1v-1z",
    fill: "#ff8078"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M72 11h-1v-1h1z",
    fill: "#ff7b73"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M73 10v1h-1v-1z",
    fill: "#fe6a66"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M74 10v1h-1v-1z",
    fill: "#f95454"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M75 10v1h-1v-1z",
    fill: "#f03d40"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M75 11v-1h1v1z",
    fill: "#e93136"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M77 10v1h-1v-1z",
    fill: "#e22c30"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M77 11v-1h1v1z",
    fill: "#db2a2d"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M79 11h-1v-1h1z",
    fill: "#d9292e"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M80 10v1h-1v-1z",
    fill: "#d4282e"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M81 11h-1v-1h1z",
    fill: "#cc292d"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M81 10h1v1h-1z",
    fill: "#c72c2e"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M82 11v-1h1v1z",
    fill: "#bb2629"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M83 10h1v1h-1z",
    fill: "#c9807f"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M84 11v-1h1v1z",
    fill: "#d3cfcb"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M86 11h-1v-1h1z",
    fill: "#cccccb"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M87 11h-1v-1h1z",
    fill: "#ceb9b8"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M87 11v-1h1v1z",
    fill: "#b24b50"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M89 11h-1v-1h1z",
    fill: "#b74e4c"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M89 11v-1h1v1z",
    fill: "#bb6764"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M91 10v1h-1v-1z",
    fill: "#c17471"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M91 11v-1h1v1z",
    fill: "#cfa29c",
    fillOpacity: 0.925
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M93 11h-1v-1h1z",
    fill: "#e7d5cf",
    fillOpacity: 0.169
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12v-1h1v1z",
    fill: "#e8d5ca",
    fillOpacity: 0.267
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M36 12v-1h1v1z",
    fill: "#d5a59b",
    fillOpacity: 0.973
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M38 11v1h-1v-1z",
    fill: "#c27772"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M39 12h-1v-1h1z",
    fill: "#bd6b65"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12h-1v-1h1z",
    fill: "#bf5a59"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12v-1h1v1z",
    fill: "#bc4140"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M41 11h1v1h-1z",
    fill: "#bd3534"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M42 11h1v1h-1z",
    fill: "#bf3433"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M44 12h-1v-1h1z",
    fill: "#c33332"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M44 11h1v1h-1z",
    fill: "#c4302f"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M46 12h-1v-1h1z",
    fill: "#c62e2c"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M47 11v1h-1v-1z",
    fill: "#c92c2a"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M47 12v-1h1v1z",
    fill: "#cf2c2a"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M49 12h-1v-1h1z",
    fill: "#d62e2d"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M50 12h-1v-1h1z",
    fill: "#dc302d"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M50 12v-1h1v1z",
    fill: "#e13332"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11h1v1h-1z",
    fill: "#e73532"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M52 12v-1h1v1z",
    fill: "#df3b3c"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M53 11h1v1h-1z",
    fill: "#ed9392"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12h-1v-1h1z",
    fill: "#eb7375"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12v-1h1v1z",
    fill: "#fa595b"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M56 12v-1h1v1z",
    fill: "#fa6c67"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M58 12h-1v-1h1z",
    fill: "#fc7371"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M58 11h1v1h-1z",
    fill: "#fe7674"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M60 11h1v1h-1z",
    fill: "#fe6462"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M62 11v1h-1v-1z",
    fill: "#fc4e4e"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M62 12v-1h1v1z",
    fill: "#f33a3c"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M64 11v1h-1v-1z",
    fill: "#ee2930"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M64 12v-1h1v1z",
    fill: "#ee272e"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M66 12h-1v-1h1z",
    fill: "#f12e32"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M66 11h1v1h-1z",
    fill: "#f83f3e"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M68 12h-1v-1h1z",
    fill: "#fd5653"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11v1h-1v-1z",
    fill: "#fd6a65"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11h1v1h-1z",
    fill: "#ff7670"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M71 12h-1v-1h1z",
    fill: "#fd7973"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M71 11h1v1h-1z",
    fill: "#fb7770"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M73 12h-1v-1h1z",
    fill: "#fc6c68"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M74 11v1h-1v-1z",
    fill: "#fb5b5b"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M74 11h1v1h-1z",
    fill: "#f44749"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M75 11h1v1h-1z",
    fill: "#ed3338"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M77 12h-1v-1h1z",
    fill: "#e52a2f"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M78 11v1h-1v-1z",
    fill: "#de2a2d"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M78 12v-1h1v1z",
    fill: "#dc2b2e"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M79 12v-1h1v1z",
    fill: "#d82a2d"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M81 11v1h-1v-1z",
    fill: "#d22a2e"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M81 12v-1h1v1z",
    fill: "#cd2d2f"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M84 11v1h-1v-1z",
    fill: "#bb4a4c"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M84 12v-1h1v1z",
    fill: "#d7c3c1"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M86 11v1h-1v-1z",
    fill: "#cdcecc"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M86 12v-1h1v1z",
    fill: "#d4cdcd"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M87 11h1v1h-1z",
    fill: "#bb6f71"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M89 11v1h-1v-1z",
    fill: "#b64442"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M90 12h-1v-1h1z",
    fill: "#c05f5e"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M91 11v1h-1v-1z",
    fill: "#bf6c6b"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M91 11h1v1h-1z",
    fill: "#cd8988"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M93 11v1h-1v-1z",
    fill: "#d6b4b1",
    fillOpacity: 0.698
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.051
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13h-1v-1h1z",
    fill: "#d9b7a9",
    fillOpacity: 0.808
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M37 12v1h-1v-1z",
    fill: "#cd8982"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M37 13v-1h1v1z",
    fill: "#bf6b68"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M38 13v-1h1v1z",
    fill: "#c3635e"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M39 13v-1h1v1z",
    fill: "#c04f4a"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12h1v1h-1z",
    fill: "#bd3837"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13v-1h1v1z",
    fill: "#bf3432"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13h-1v-1h1z",
    fill: "#c4322f"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13v-1h1v1z",
    fill: "#c62f2d"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M46 12v1h-1v-1z",
    fill: "#c82e2d"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13v-1h1v1z",
    fill: "#cb2d2b"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M48 13h-1v-1h1z",
    fill: "#d02d2c"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M49 13h-1v-1h1z",
    fill: "#d72f2f"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M49 12h1v1h-1z",
    fill: "#de3031"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M51 13h-1v-1h1z",
    fill: "#e13432"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M51 12h1v1h-1z",
    fill: "#e83634"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M53 12v1h-1v-1z",
    fill: "#ee3236"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M53 13v-1h1v1z",
    fill: "#ed6f70"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12v1h-1v-1z",
    fill: "#f2c7c1"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M55 13v-1h1v1z",
    fill: "#f27b7d"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M57 13h-1v-1h1z",
    fill: "#fa6b67"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M57 12h1v1h-1z",
    fill: "#fd6c6d"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M58 13v-1h1v1z",
    fill: "#fc6b6b"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M59 13v-1h1v1z",
    fill: "#fa6865"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M60 13v-1h1v1z",
    fill: "#fd5b59"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13h-1v-1h1z",
    fill: "#fc4749"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M63 13h-1v-1h1z",
    fill: "#f4353a"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M63 12h1v1h-1z",
    fill: "#f22a32"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M65 13h-1v-1h1z",
    fill: "#f02830"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M66 12v1h-1v-1z",
    fill: "#f12d30"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M67 13h-1v-1h1z",
    fill: "#f73b3b"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M68 12v1h-1v-1z",
    fill: "#fc5050"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M69 13h-1v-1h1z",
    fill: "#fd6162"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M70 12v1h-1v-1z",
    fill: "#fe6c6c"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M71 13v-1h1v1z",
    fill: "#fb7772"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M72 13v-1h1v1z",
    fill: "#fe7571"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M73 13v-1h1v1z",
    fill: "#ff6c6b"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M75 12v1h-1v-1z",
    fill: "#fb5858"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M76 13h-1v-1h1z",
    fill: "#f23c40"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M77 12v1h-1v-1z",
    fill: "#e2292f"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M77 12h1v1h-1z",
    fill: "#db252b"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M79 13h-1v-1h1z",
    fill: "#db292c"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M80 12v1h-1v-1z",
    fill: "#d82b2e"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M82 13h-1v-1h1z",
    fill: "#d02d32"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M82 13v-1h1v1z",
    fill: "#c82f30"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M84 13h-1v-1h1z",
    fill: "#bc2d33"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M85 12v1h-1v-1z",
    fill: "#cf9995"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M86 13h-1v-1h1z",
    fill: "#d0d2cf"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M87 13h-1v-1h1z",
    fill: "#d1d1d2"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M87 13v-1h1v1z",
    fill: "#cba2a6"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M88 12h1v1h-1z",
    fill: "#b64446"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M90 12v1h-1v-1z",
    fill: "#bf5654"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M91 13h-1v-1h1z",
    fill: "#c36967"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M92 13h-1v-1h1z",
    fill: "#c36f6f"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M92 13v-1h1v1z",
    fill: "#d29b98",
    fillOpacity: 0.996
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M94 12v1h-1v-1z",
    fill: "#dbc2ba",
    fillOpacity: 0.365
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M34 13h1v1h-1z",
    fill: "#e1ccbd",
    fillOpacity: 0.471
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13v1h-1v-1z",
    fill: "#d4a193"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13h1v1h-1z",
    fill: "#bf6e6e"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M37 13h1v1h-1z",
    fill: "#c56868"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M38 14v-1h1v1z",
    fill: "#c55753"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M40 13v1h-1v-1z",
    fill: "#bc3f39"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13v1h-1v-1z",
    fill: "#c03332"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13h1v1h-1z",
    fill: "#c23433"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14h-1v-1h1z",
    fill: "#c43331"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14v-1h1v1z",
    fill: "#c72f2d"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13h1v1h-1z",
    fill: "#c82c2b"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13v1h-1v-1z",
    fill: "#ca2c2b"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13h1v1h-1z",
    fill: "#ce2c2b"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M47 14v-1h1v1z",
    fill: "#d32d2c"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M48 14v-1h1v1z",
    fill: "#da3031"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M50 14h-1v-1h1z",
    fill: "#df3233"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M51 14h-1v-1h1z",
    fill: "#e33433"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M51 13h1v1h-1z",
    fill: "#e83635"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M53 13v1h-1v-1z",
    fill: "#f03739"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14h-1v-1h1z",
    fill: "#f0484b"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M55 13v1h-1v-1z",
    fill: "#ebbeb9"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M55 14v-1h1v1z",
    fill: "#ebc2b9"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M57 13v1h-1v-1z",
    fill: "#f57371"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M57 14v-1h1v1z",
    fill: "#fe7271"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M59 13h1v1h-1z",
    fill: "#fc6e6c"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14v-1h1v1z",
    fill: "#fb5f5c"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13v1h-1v-1z",
    fill: "#fa4949"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M63 13v1h-1v-1z",
    fill: "#f3363a"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M64 13v1h-1v-1z",
    fill: "#ee282f"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M65 13v1h-1v-1z",
    fill: "#ee262d"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M65 14v-1h1v1z",
    fill: "#f02b2f"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M67 13v1h-1v-1z",
    fill: "#f63a3b"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M67 14v-1h1v1z",
    fill: "#fa5051"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M69 13v1h-1v-1z",
    fill: "#fd6565"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M71 14h-1v-1h1z",
    fill: "#fb7873"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M71 13h1v1h-1z",
    fill: "#fb7a75"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M72 14v-1h1v1z",
    fill: "#fd7774"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M74 13v1h-1v-1z",
    fill: "#ff6f6f"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M75 13v1h-1v-1z",
    fill: "#fe5c5e"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M75 14v-1h1v1z",
    fill: "#f63f46"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M76 14v-1h1v1z",
    fill: "#e52a33"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M78 13v1h-1v-1z",
    fill: "#dd242d"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M79 14h-1v-1h1z",
    fill: "#d9292c"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M79 14v-1h1v1z",
    fill: "#d72b2f"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M81 13v1h-1v-1z",
    fill: "#d32d32"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M81 14v-1h1v1z",
    fill: "#d02d34"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M82 13h1v1h-1z",
    fill: "#cd2e33"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M85 14h-1v-1h1z",
    fill: "#c15956"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M85 13h1v1h-1z",
    fill: "#dacac5"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M86 14v-1h1v1z",
    fill: "#cdd0d1"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M87 13h1v1h-1z",
    fill: "#d7c5c9"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M89 14h-1v-1h1z",
    fill: "#b75a5c"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M89 14v-1h1v1z",
    fill: "#ba4645"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M90 14v-1h1v1z",
    fill: "#c25e5d"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M91 14v-1h1v1z",
    fill: "#c26c6a"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M93 13v1h-1v-1z",
    fill: "#c78981"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M93 14v-1h1v1z",
    fill: "#d9bdb8",
    fillOpacity: 0.875
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M94 13h1v1h-1z",
    fill: "#fff5f5",
    fillOpacity: 0.102
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14h1v1h-1z",
    fill: "#f8e4de",
    fillOpacity: 0.153
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15h-1v-1h1z",
    fill: "#d6b1a2",
    fillOpacity: 0.922
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15v-1h1v1z",
    fill: "#c38377"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M37 15h-1v-1h1z",
    fill: "#c26a6a"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M37 15v-1h1v1z",
    fill: "#c76362"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M39 14v1h-1v-1z",
    fill: "#c04945"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M40 14v1h-1v-1z",
    fill: "#b9352f"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M42 14v1h-1v-1z",
    fill: "#c43333"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M42 15v-1h1v1z",
    fill: "#c63030"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14h1v1h-1z",
    fill: "#c92d2d"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15h-1v-1h1z",
    fill: "#cb2a2a"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M47 15h-1v-1h1z",
    fill: "#d02b2b"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M48 15h-1v-1h1z",
    fill: "#d62e2e"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M49 15h-1v-1h1z",
    fill: "#dd3032"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M50 14v1h-1v-1z",
    fill: "#e13435"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M50 15v-1h1v1z",
    fill: "#e43535"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M51 15v-1h1v1z",
    fill: "#e83535"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M52 15v-1h1v1z",
    fill: "#ed3638"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14v1h-1v-1z",
    fill: "#f23e3e"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14h1v1h-1z",
    fill: "#f08a8e"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M55 14h1v1h-1z",
    fill: "#eaddd5"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M57 14v1h-1v-1z",
    fill: "#f2a7a2"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h-1v-1h1z",
    fill: "#fc7f7d"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M59 14v1h-1v-1z",
    fill: "#ff8180"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M59 15v-1h1v1z",
    fill: "#ff7b7a"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14h1v1h-1z",
    fill: "#fe6866"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M62 15h-1v-1h1z",
    fill: "#fa4d4d"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M62 14h1v1h-1z",
    fill: "#ed3336"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M63 14h1v1h-1z",
    fill: "#e62229"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M64 14h1v1h-1z",
    fill: "#e62027"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M65 15v-1h1v1z",
    fill: "#eb282e"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M66 15v-1h1v1z",
    fill: "#f43a3e"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M68 15h-1v-1h1z",
    fill: "#fa5556"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M69 14v1h-1v-1z",
    fill: "#fd6d6b"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M70 15h-1v-1h1z",
    fill: "#ff7e7a"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M71 14v1h-1v-1z",
    fill: "#fe837e"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M71 15v-1h1v1z",
    fill: "#fc817c"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h-1v-1h1z",
    fill: "#fc7775"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15v-1h1v1z",
    fill: "#fc6a6b"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M75 15h-1v-1h1z",
    fill: "#fb5559"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M75 14h1v1h-1z",
    fill: "#f53c43"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M77 14v1h-1v-1z",
    fill: "#e72c34"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M78 14v1h-1v-1z",
    fill: "#e12930"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M79 14v1h-1v-1z",
    fill: "#db2c30"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M80 14v1h-1v-1z",
    fill: "#d82d32"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M81 15h-1v-1h1z",
    fill: "#d42d32"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M81 14h1v1h-1z",
    fill: "#d12e33"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M82 14h1v1h-1z",
    fill: "#cf2d32"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M84 15h-1v-1h1z",
    fill: "#cd2d2d"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M84 15v-1h1v1z",
    fill: "#bf2f2f"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M86 15h-1v-1h1z",
    fill: "#d49f99"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M86 14h1v1h-1z",
    fill: "#d1d3d0"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M88 14v1h-1v-1z",
    fill: "#d2d2d2"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M88 14h1v1h-1z",
    fill: "#c2888a"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M90 14v1h-1v-1z",
    fill: "#b83d41"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M91 15h-1v-1h1z",
    fill: "#c0504f"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M91 14h1v1h-1z",
    fill: "#c46765"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M92 14h1v1h-1z",
    fill: "#c68178"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M94 14v1h-1v-1z",
    fill: "#dbb1ab"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M95 14v1h-1v-1z",
    fill: "#d6c3c0",
    fillOpacity: 0.592
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M34 15v1h-1v-1z",
    fill: "#dfc2b6",
    fillOpacity: 0.675
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16v-1h1v1z",
    fill: "#d7998d"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15v1h-1v-1z",
    fill: "#bc6f6b"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15h1v1h-1z",
    fill: "#c86c69"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M37 16v-1h1v1z",
    fill: "#c75853"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M39 16h-1v-1h1z",
    fill: "#bd3a35"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M40 15v1h-1v-1z",
    fill: "#c03531"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15v1h-1v-1z",
    fill: "#c33434"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15h1v1h-1z",
    fill: "#c63132"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16h-1v-1h1z",
    fill: "#c62e2f"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16v-1h1v1z",
    fill: "#c82d2c"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M45 16h-1v-1h1z",
    fill: "#c92b2a"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M47 16h-1v-1h1z",
    fill: "#d12b2b"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M48 16h-1v-1h1z",
    fill: "#d72e2f"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M49 15v1h-1v-1z",
    fill: "#dd3234"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M50 16h-1v-1h1z",
    fill: "#e23537"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M50 15h1v1h-1z",
    fill: "#e43635"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M51 15h1v1h-1z",
    fill: "#e83433"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M52 15h1v1h-1z",
    fill: "#ee3537"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M53 16v-1h1v1z",
    fill: "#fa4041"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M55 15v1h-1v-1z",
    fill: "#f46b6f"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M56 15v1h-1v-1z",
    fill: "#e7d6d3"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M56 15h1v1h-1z",
    fill: "#ecd2ce"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15v1h-1v-1z",
    fill: "#f5908b"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h1v1h-1z",
    fill: "#fd8785"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M60 15v1h-1v-1z",
    fill: "#ff7e81"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M60 16v-1h1v1z",
    fill: "#fe6768"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M62 16h-1v-1h1z",
    fill: "#fa4a4c"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M63 16h-1v-1h1z",
    fill: "#e92f32"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M63 15h1v1h-1z",
    fill: "#e22227"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M65 16h-1v-1h1z",
    fill: "#df2025"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M65 16v-1h1v1z",
    fill: "#e3262b"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M66 16v-1h1v1z",
    fill: "#ef373d"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v-1h1v1z",
    fill: "#f85455"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M69 16h-1v-1h1z",
    fill: "#fc706e"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M70 16h-1v-1h1z",
    fill: "#fe817d"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M70 16v-1h1v1z",
    fill: "#fd8884"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M71 15h1v1h-1z",
    fill: "#fd8682"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15v1h-1v-1z",
    fill: "#fe7d7d"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h1v1h-1z",
    fill: "#fe6e71"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16h-1v-1h1z",
    fill: "#fe575a"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16v-1h1v1z",
    fill: "#f63f43"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M76 16v-1h1v1z",
    fill: "#e72e33"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M77 15h1v1h-1z",
    fill: "#df2b2e"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M79 16h-1v-1h1z",
    fill: "#dc2b31"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M80 16h-1v-1h1z",
    fill: "#d92a31"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M81 16h-1v-1h1z",
    fill: "#d62b31"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M81 16v-1h1v1z",
    fill: "#d32c30"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M82 15h1v1h-1z",
    fill: "#d12c30"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M84 15v1h-1v-1z",
    fill: "#cd2d31"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M85 15h1v1h-1z",
    fill: "#c05d57"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M86 16v-1h1v1z",
    fill: "#d7ccc5"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M87 16v-1h1v1z",
    fill: "#cdd3d2"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M88 15h1v1h-1z",
    fill: "#d4b6bb"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M90 16h-1v-1h1z",
    fill: "#b44a4c"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M90 15h1v1h-1z",
    fill: "#bd4746"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M91 16v-1h1v1z",
    fill: "#c35a59"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M92 16v-1h1v1z",
    fill: "#c56f68"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M94 16h-1v-1h1z",
    fill: "#ca928c"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M94 15h1v1h-1z",
    fill: "#dcc4c2",
    fillOpacity: 0.969
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M96 16h-1v-1h1z",
    fill: "#e5e1dd",
    fillOpacity: 0.239
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17h-1v-1h1z",
    fill: "#ead6cb",
    fillOpacity: 0.349
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17v-1h1v1z",
    fill: "#dbac9f",
    fillOpacity: 0.992
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16h1v1h-1z",
    fill: "#c97773"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M36 16h1v1h-1z",
    fill: "#ce6663"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M38 16v1h-1v-1z",
    fill: "#c74944"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M38 16h1v1h-1z",
    fill: "#bc312e"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M39 17v-1h1v1z",
    fill: "#c73635"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M40 17v-1h1v1z",
    fill: "#c63334"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M42 17h-1v-1h1z",
    fill: "#c73032"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M42 16h1v1h-1z",
    fill: "#c72d2f"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16h1v1h-1z",
    fill: "#c82c2d"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M45 16v1h-1v-1z",
    fill: "#ca2b2b"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M45 17v-1h1v1z",
    fill: "#ce2a2b"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M47 17h-1v-1h1z",
    fill: "#d32c2c"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M48 17h-1v-1h1z",
    fill: "#d82f30"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M49 17h-1v-1h1z",
    fill: "#dd3535"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M50 16v1h-1v-1z",
    fill: "#e2373a"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M50 17v-1h1v1z",
    fill: "#e43733"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M52 16v1h-1v-1z",
    fill: "#e03638"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M52 17v-1h1v1z",
    fill: "#e04349"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M54 17h-1v-1h1z",
    fill: "#ee4b4f"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M54 17v-1h1v1z",
    fill: "#f46268"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M55 16h1v1h-1z",
    fill: "#ebc6c2"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M57 16v1h-1v-1z",
    fill: "#e7e5e1"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M57 17v-1h1v1z",
    fill: "#f5b5af"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v-1h1v1z",
    fill: "#f98986"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M60 17h-1v-1h1z",
    fill: "#fd8184"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M61 17h-1v-1h1z",
    fill: "#fe676a"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M61 17v-1h1v1z",
    fill: "#f84848"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M62 17v-1h1v1z",
    fill: "#e52a2d"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M64 16v1h-1v-1z",
    fill: "#dd1f25"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M64 17v-1h1v1z",
    fill: "#da1e22"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M66 17h-1v-1h1z",
    fill: "#da1f21"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v1h-1v-1z",
    fill: "#e65b5f"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16h1v1h-1z",
    fill: "#ec8080"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M68 16h1v1h-1z",
    fill: "#f37471"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M69 16h1v1h-1z",
    fill: "#fe8281"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M71 17h-1v-1h1z",
    fill: "#fe8e89"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M72 17h-1v-1h1z",
    fill: "#fe8c88"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M72 16h1v1h-1z",
    fill: "#ff8484"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M74 16v1h-1v-1z",
    fill: "#fa7b7c"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16v1h-1v-1z",
    fill: "#f76167"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M76 16v1h-1v-1z",
    fill: "#f33e42"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M77 17h-1v-1h1z",
    fill: "#e42e2b"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M77 16h1v1h-1z",
    fill: "#e02a30"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M79 16v1h-1v-1z",
    fill: "#de2a33"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M79 16h1v1h-1z",
    fill: "#da2c32"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M80 16h1v1h-1z",
    fill: "#d82c31"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M82 16v1h-1v-1z",
    fill: "#d52c32"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M84 16v1h-1v-1z",
    fill: "#d02c34"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17h-1v-1h1z",
    fill: "#d02a31"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17v-1h1v1z",
    fill: "#be302f"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M86 17v-1h1v1z",
    fill: "#d0a299"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M87 16h1v1h-1z",
    fill: "#ced5d2"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M89 17h-1v-1h1z",
    fill: "#d9cfce"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M90 17h-1v-1h1z",
    fill: "#be6d71"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M90 17v-1h1v1z",
    fill: "#bc3c3f"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M91 17v-1h1v1z",
    fill: "#c04b49"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M92 16h1v1h-1z",
    fill: "#c96663"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M93 16h1v1h-1z",
    fill: "#bf7b73"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M94 16h1v1h-1z",
    fill: "#debdb6"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M96 16v1h-1v-1z",
    fill: "#e3dad3",
    fillOpacity: 0.761
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17h1v1h-1z",
    fill: "#ddbbb1",
    fillOpacity: 0.804
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17h1v1h-1z",
    fill: "#cc8a82"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M35 17h1v1h-1z",
    fill: "#ca6461"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M36 18v-1h1v1z",
    fill: "#c14744"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M38 18h-1v-1h1z",
    fill: "#be3936"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M39 18h-1v-1h1z",
    fill: "#c13534"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M39 17h1v1h-1z",
    fill: "#c63333"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M41 17v1h-1v-1z",
    fill: "#c63131"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M42 17v1h-1v-1z",
    fill: "#c72d30"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M43 18h-1v-1h1z",
    fill: "#c82b2d"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M44 17v1h-1v-1z",
    fill: "#c92a2b"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M44 17h1v1h-1z",
    fill: "#cc2a2a"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M45 17h1v1h-1z",
    fill: "#d02a2a"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M46 18v-1h1v1z",
    fill: "#d52d2d"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M47 17h1v1h-1z",
    fill: "#db3131"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M49 18h-1v-1h1z",
    fill: "#df3635"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M50 18h-1v-1h1z",
    fill: "#e33833"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M51 17v1h-1v-1z",
    fill: "#dd383b"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M51 17h1v1h-1z",
    fill: "#e08893"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M53 17v1h-1v-1z",
    fill: "#e7c3c5"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M53 17h1v1h-1z",
    fill: "#e8bdb6"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18h-1v-1h1z",
    fill: "#f09ba2"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18v-1h1v1z",
    fill: "#efb9c0"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18v-1h1v1z",
    fill: "#e3e6e2"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v1h-1v-1z",
    fill: "#f0d2cc"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18v-1h1v1z",
    fill: "#f98e8a"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M59 17h1v1h-1z",
    fill: "#ff7b7b"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v-1h1v1z",
    fill: "#fc6366"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M62 18h-1v-1h1z",
    fill: "#f04243"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M63 17v1h-1v-1z",
    fill: "#d92327"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18v-1h1v1z",
    fill: "#d0181e"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M64 17h1v1h-1z",
    fill: "#d0181c"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M65 18v-1h1v1z",
    fill: "#ce1619"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h-1v-1h1z",
    fill: "#da6e75"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M68 17v1h-1v-1z",
    fill: "#edd5d5"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18h-1v-1h1z",
    fill: "#edbeb7"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M70 17v1h-1v-1z",
    fill: "#f29c9d"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M70 18v-1h1v1z",
    fill: "#f9878a"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M71 18v-1h1v1z",
    fill: "#ff8886"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M72 18v-1h1v1z",
    fill: "#ff8782"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18h-1v-1h1z",
    fill: "#f98989"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M75 18h-1v-1h1z",
    fill: "#f6b6b5"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M75 18v-1h1v1z",
    fill: "#e16c77"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M77 17v1h-1v-1z",
    fill: "#d72c36"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M78 17v1h-1v-1z",
    fill: "#e0272e"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M78 18v-1h1v1z",
    fill: "#de2932"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M79 18v-1h1v1z",
    fill: "#db2a33"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M81 18h-1v-1h1z",
    fill: "#d92931"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M82 18h-1v-1h1z",
    fill: "#d62a30"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M83 17v1h-1v-1z",
    fill: "#d02d2f"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M84 18h-1v-1h1z",
    fill: "#ce2c31"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17v1h-1v-1z",
    fill: "#ce2a30"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18h-1v-1h1z",
    fill: "#ca252a"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M87 18h-1v-1h1z",
    fill: "#c45959"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M87 18v-1h1v1z",
    fill: "#d7ccc8"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M88 17h1v1h-1z",
    fill: "#d4d3cf"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M90 18h-1v-1h1z",
    fill: "#d09ca0"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M91 18h-1v-1h1z",
    fill: "#bc3941"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M92 18h-1v-1h1z",
    fill: "#c13f40"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M92 18v-1h1v1z",
    fill: "#c04f50"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M94 17v1h-1v-1z",
    fill: "#c46c67"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M95 18h-1v-1h1z",
    fill: "#cc9089"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M96 18h-1v-1h1z",
    fill: "#d7b6b2",
    fillOpacity: 0.996
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M96 17h1v1h-1z",
    fill: "#e8d4d4",
    fillOpacity: 0.306
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M31 18h1v1h-1z",
    fill: "#f5ddce",
    fillOpacity: 0.208
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18v1h-1v-1z",
    fill: "#d7a89c",
    fillOpacity: 0.984
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M33 19v-1h1v1z",
    fill: "#c57572"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19h-1v-1h1z",
    fill: "#cb6766"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M36 19h-1v-1h1z",
    fill: "#b8403f"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M36 19v-1h1v1z",
    fill: "#bd3636"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M38 18v1h-1v-1z",
    fill: "#c23a37"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M38 19v-1h1v1z",
    fill: "#c23333"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19v-1h1v1z",
    fill: "#c32b2c"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M41 19v-1h1v1z",
    fill: "#c4282a"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M43 19h-1v-1h1z",
    fill: "#c52728"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M44 18v1h-1v-1z",
    fill: "#c62626"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M45 19h-1v-1h1z",
    fill: "#c92726"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M45 19v-1h1v1z",
    fill: "#cd2827"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M47 18v1h-1v-1z",
    fill: "#d32b2a"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M47 19v-1h1v1z",
    fill: "#d72e2e"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M48 19v-1h1v1z",
    fill: "#da3230"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M49 18h1v1h-1z",
    fill: "#db3231"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M51 19h-1v-1h1z",
    fill: "#da4752"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M52 19h-1v-1h1z",
    fill: "#e4bfc1"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M52 19v-1h1v1z",
    fill: "#c97c76"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M53 18h1v1h-1z",
    fill: "#dc857f"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M54 18h1v1h-1z",
    fill: "#e9bbb0"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18h1v1h-1z",
    fill: "#e2a9ad"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18h1v1h-1z",
    fill: "#dbd9d5"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18v1h-1v-1z",
    fill: "#dcd4cc"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M59 19h-1v-1h1z",
    fill: "#e17470"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v1h-1v-1z",
    fill: "#ea4340"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M60 19v-1h1v1z",
    fill: "#e13939"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M61 18h1v1h-1z",
    fill: "#d6282b"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M63 19h-1v-1h1z",
    fill: "#c0171c"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18h1v1h-1z",
    fill: "#bb1017"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v-1h1v1z",
    fill: "#bd1116"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M66 18v1h-1v-1z",
    fill: "#ba0c0e"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18v1h-1v-1z",
    fill: "#c95f62"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h1v1h-1z",
    fill: "#d9d4d3"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18v1h-1v-1z",
    fill: "#d8d4cf"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18h1v1h-1z",
    fill: "#e3d1cc"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M70 18h1v1h-1z",
    fill: "#e6a8a8"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M72 19h-1v-1h1z",
    fill: "#e26a6b"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M73 19h-1v-1h1z",
    fill: "#eb514f"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18v1h-1v-1z",
    fill: "#ef524f"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M74 19v-1h1v1z",
    fill: "#e0877d"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M75 19v-1h1v1z",
    fill: "#ecc0be"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M76 19v-1h1v1z",
    fill: "#df8893"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M78 19h-1v-1h1z",
    fill: "#cc303f"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M79 18v1h-1v-1z",
    fill: "#d6212b"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M79 19v-1h1v1z",
    fill: "#d6262d"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M80 18h1v1h-1z",
    fill: "#d2272b"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M81 19v-1h1v1z",
    fill: "#d32228"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M83 19h-1v-1h1z",
    fill: "#d0262b"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M84 18v1h-1v-1z",
    fill: "#cf272b"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18v1h-1v-1z",
    fill: "#cd252d"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18h1v1h-1z",
    fill: "#c02b30"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M88 19h-1v-1h1z",
    fill: "#cea69f"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M88 18h1v1h-1z",
    fill: "#cfd1cc"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M89 18h1v1h-1z",
    fill: "#d2bbba"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M91 18v1h-1v-1z",
    fill: "#b9454d"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M91 19v-1h1v1z",
    fill: "#c13539"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M93 18v1h-1v-1z",
    fill: "#be4042"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M93 19v-1h1v1z",
    fill: "#c15252"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M94 18h1v1h-1z",
    fill: "#cf8079"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M96 18v1h-1v-1z",
    fill: "#d4a49f"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M96 18h1v1h-1z",
    fill: "#e1c7c7",
    fillOpacity: 0.643
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M32 19v1h-1v-1z",
    fill: "#e8cfc3",
    fillOpacity: 0.404
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M33 20h-1v-1h1z",
    fill: "#d09a8c"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M33 20v-1h1v1z",
    fill: "#ca7672"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19v1h-1v-1z",
    fill: "#c45655"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20v-1h1v1z",
    fill: "#b73535"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M36 20v-1h1v1z",
    fill: "#c13c3c"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M38 19v1h-1v-1z",
    fill: "#bf3533"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M39 19v1h-1v-1z",
    fill: "#c02e2e"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19v1h-1v-1z",
    fill: "#c1292b"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19h1v1h-1z",
    fill: "#c2282a"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M44 19v1h-1v-1z",
    fill: "#c22425"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M44 19h1v1h-1z",
    fill: "#c32423"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M45 20v-1h1v1z",
    fill: "#c52324"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M47 19v1h-1v-1z",
    fill: "#c92424"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M48 20h-1v-1h1z",
    fill: "#cb2524"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M49 19v1h-1v-1z",
    fill: "#cb2624"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20v-1h1v1z",
    fill: "#cb2421"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M51 20v-1h1v1z",
    fill: "#dfbdba"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M52 20v-1h1v1z",
    fill: "#c87572"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M54 19v1h-1v-1z",
    fill: "#b61517"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M54 19h1v1h-1z",
    fill: "#ba2d2b"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M56 19v1h-1v-1z",
    fill: "#c45c63"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M57 20h-1v-1h1z",
    fill: "#d4c8c4"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M58 20h-1v-1h1z",
    fill: "#d1ccc9"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M59 20h-1v-1h1z",
    fill: "#c86d69"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h-1v-1h1z",
    fill: "#c11418"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19h1v1h-1z",
    fill: "#bc151a"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M62 19h1v1h-1z",
    fill: "#b01117"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v1h-1v-1z",
    fill: "#ab1015"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M66 20h-1v-1h1z",
    fill: "#a80b0c"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20h-1v-1h1z",
    fill: "#b24342"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M67 19h1v1h-1z",
    fill: "#cac4b8"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20v-1h1v1z",
    fill: "#c9cec5"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M70 19v1h-1v-1z",
    fill: "#c8cdc5"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M71 19v1h-1v-1z",
    fill: "#d3cdc8"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M72 20h-1v-1h1z",
    fill: "#dab7b4"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20h-1v-1h1z",
    fill: "#cd6c6c"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20v-1h1v1z",
    fill: "#bf2a2c"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M75 20h-1v-1h1z",
    fill: "#bd1b18"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M76 20h-1v-1h1z",
    fill: "#c44543"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M77 20h-1v-1h1z",
    fill: "#dea7a4"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M78 20h-1v-1h1z",
    fill: "#e29fa3"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M78 20v-1h1v1z",
    fill: "#c23d49"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M80 19v1h-1v-1z",
    fill: "#cf1d28"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M80 19h1v1h-1z",
    fill: "#ca2e33"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20h-1v-1h1z",
    fill: "#c7494e"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20v-1h1v1z",
    fill: "#c32a31"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M84 20h-1v-1h1z",
    fill: "#ce222b"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M86 19h1v1h-1z",
    fill: "#c22226"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M88 20h-1v-1h1z",
    fill: "#c36e6c"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M89 20h-1v-1h1z",
    fill: "#cfcdca"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M90 19v1h-1v-1z",
    fill: "#cfcac5"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M90 20v-1h1v1z",
    fill: "#bc5d61"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M91 19h1v1h-1z",
    fill: "#bc3033"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M92 19h1v1h-1z",
    fill: "#bf3c3c"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M94 19v1h-1v-1z",
    fill: "#bf4446"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M95 19v1h-1v-1z",
    fill: "#c36c66"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M96 20h-1v-1h1z",
    fill: "#d39d99"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M96 19h1v1h-1z",
    fill: "#dabebe",
    fillOpacity: 0.82
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M31 21v-1h1v1z",
    fill: "#e0c6bc",
    fillOpacity: 0.529
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M32 20h1v1h-1z",
    fill: "#c48d82"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M34 20v1h-1v-1z",
    fill: "#ca7770"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M35 21h-1v-1h1z",
    fill: "#bf4e4a"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20h1v1h-1z",
    fill: "#bc3a3e"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M36 20h1v1h-1z",
    fill: "#bd3a3b"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M38 21h-1v-1h1z",
    fill: "#bd3131"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M38 20h1v1h-1z",
    fill: "#bc292a"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20v1h-1v-1z",
    fill: "#be2627"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M41 20v1h-1v-1z",
    fill: "#be2326"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M43 20v1h-1v-1z",
    fill: "#bc2023"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M45 21h-1v-1h1z",
    fill: "#ba1f20"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M46 20v1h-1v-1z",
    fill: "#bc1e20"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M47 20h1v1h-1z",
    fill: "#bc1a1d"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20v1h-1v-1z",
    fill: "#ba191c"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20h1v1h-1z",
    fill: "#ba181b"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M50 20h1v1h-1z",
    fill: "#b11921"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21h-1v-1h1z",
    fill: "#ca9396"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M53 20v1h-1v-1z",
    fill: "#cebbb7"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M53 21v-1h1v1z",
    fill: "#ad3e3d"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20v1h-1v-1z",
    fill: "#af090e"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20h1v1h-1z",
    fill: "#b23d45"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21h-1v-1h1z",
    fill: "#cfc5c1"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21v-1h1v1z",
    fill: "#c9ccc9"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M59 21h-1v-1h1z",
    fill: "#c38786"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20v1h-1v-1z",
    fill: "#b1222e"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h1v1h-1z",
    fill: "#b31620"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M62 21h-1v-1h1z",
    fill: "#b51518"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M63 20v1h-1v-1z",
    fill: "#a80f16"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21v-1h1v1z",
    fill: "#a50d16"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20v1h-1v-1z",
    fill: "#a22730"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v-1h1v1z",
    fill: "#c5a6a2"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20h1v1h-1z",
    fill: "#cec0ba"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h-1v-1h1z",
    fill: "#c9cac3"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21v-1h1v1z",
    fill: "#c4cfc7"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M71 20h1v1h-1z",
    fill: "#c6cbc7"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M72 20h1v1h-1z",
    fill: "#ccc7c2"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20h1v1h-1z",
    fill: "#c59c9c"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M75 21h-1v-1h1z",
    fill: "#ab454a"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M76 21h-1v-1h1z",
    fill: "#a81012"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M77 21h-1v-1h1z",
    fill: "#b02025"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M78 21h-1v-1h1z",
    fill: "#cb8b86"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M79 20v1h-1v-1z",
    fill: "#dbafb0"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M79 20h1v1h-1z",
    fill: "#ba3f4b"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M81 20v1h-1v-1z",
    fill: "#c25254"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21v-1h1v1z",
    fill: "#e7bfbc"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20h1v1h-1z",
    fill: "#c14a4c"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M83 20h1v1h-1z",
    fill: "#c61d26"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M85 21h-1v-1h1z",
    fill: "#c62228"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M85 20h1v1h-1z",
    fill: "#c62327"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M88 21h-1v-1h1z",
    fill: "#bd3d42"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M88 20h1v1h-1z",
    fill: "#cdbeb8"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M90 21h-1v-1h1z",
    fill: "#cdccc9"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M90 20h1v1h-1z",
    fill: "#c17274"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M92 21h-1v-1h1z",
    fill: "#b52d2d"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M92 21v-1h1v1z",
    fill: "#bb3739"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M94 20v1h-1v-1z",
    fill: "#bd3f40"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M95 21h-1v-1h1z",
    fill: "#bf5c59"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M95 20h1v1h-1z",
    fill: "#d09190"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M96 20h1v1h-1z",
    fill: "#d0aeb2",
    fillOpacity: 0.859
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M98 20v1h-1v-1z",
    fill: "#ecffff",
    fillOpacity: 0.055
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M31 21h1v1h-1z",
    fill: "#e1d5c9",
    fillOpacity: 0.576
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M33 21v1h-1v-1z",
    fill: "#d8b6ae"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22v-1h1v1z",
    fill: "#c77871"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M35 21v1h-1v-1z",
    fill: "#b94842"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M36 22h-1v-1h1z",
    fill: "#b93a3f"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M36 21h1v1h-1z",
    fill: "#bc3539"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M38 21v1h-1v-1z",
    fill: "#bb2c2e"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M38 22v-1h1v1z",
    fill: "#ba2727"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M39 22v-1h1v1z",
    fill: "#bc2425"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M41 21h1v1h-1z",
    fill: "#ba1d20"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M42 21h1v1h-1z",
    fill: "#b91c1f"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M43 22v-1h1v1z",
    fill: "#b71c1f"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22v-1h1v1z",
    fill: "#b51a1d"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M51 21v1h-1v-1z",
    fill: "#ac1215"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21v1h-1v-1z",
    fill: "#b34a52"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21h1v1h-1z",
    fill: "#d0c3bd"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M54 22h-1v-1h1z",
    fill: "#c4a29a"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21v1h-1v-1z",
    fill: "#ac2c31"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21h1v1h-1z",
    fill: "#b8494e"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M57 22h-1v-1h1z",
    fill: "#d2c6c0"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22h-1v-1h1z",
    fill: "#c9ccc6"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M58 21h1v1h-1z",
    fill: "#cba4a5"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M59 22v-1h1v1z",
    fill: "#d78b95"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M61 22h-1v-1h1z",
    fill: "#c25c61"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22h-1v-1h1z",
    fill: "#b31b22"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22v-1h1v1z",
    fill: "#a71117"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21h1v1h-1z",
    fill: "#9e0b11"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h1v1h-1z",
    fill: "#99090b"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v1h-1v-1z",
    fill: "#bc7377"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M67 22v-1h1v1z",
    fill: "#cfc0bd"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M69 21v1h-1v-1z",
    fill: "#bb5a5d"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M69 22v-1h1v1z",
    fill: "#cc7070"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h1v1h-1z",
    fill: "#d7bab6"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M71 21h1v1h-1z",
    fill: "#cbcdc6"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M73 21v1h-1v-1z",
    fill: "#bfc7bf"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M73 21h1v1h-1z",
    fill: "#c1c9c1"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M74 22v-1h1v1z",
    fill: "#c8bebb"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M76 21v1h-1v-1z",
    fill: "#bb8588"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M77 22h-1v-1h1z",
    fill: "#a83137"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M78 22h-1v-1h1z",
    fill: "#a0181a"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M78 21h1v1h-1z",
    fill: "#c3827d"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M79 21h1v1h-1z",
    fill: "#d3b0ad"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21v1h-1v-1z",
    fill: "#b3545f"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21h1v1h-1z",
    fill: "#d37e7e"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M82 21h1v1h-1z",
    fill: "#c1393c"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M84 21v1h-1v-1z",
    fill: "#c61e24"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M86 21h1v1h-1z",
    fill: "#c42123"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h-1v-1h1z",
    fill: "#bc282e"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M89 22h-1v-1h1z",
    fill: "#caa7a0"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M90 21v1h-1v-1z",
    fill: "#cfcbcb"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M91 22h-1v-1h1z",
    fill: "#c3797d"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M91 21h1v1h-1z",
    fill: "#b42b2c"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M92 21h1v1h-1z",
    fill: "#b93537"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M94 22h-1v-1h1z",
    fill: "#ba3d3e"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M94 21h1v1h-1z",
    fill: "#bd5352"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M96 22h-1v-1h1z",
    fill: "#d09b96"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M97 21v1h-1v-1z",
    fill: "#e1d0ce",
    fillOpacity: 0.867
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M97 22v-1h1v1z",
    fill: "#efffff",
    fillOpacity: 0.063
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M31 23v-1h1v1z",
    fill: "#e2e3d9",
    fillOpacity: 0.592
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22v1h-1v-1z",
    fill: "#e3dad5"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22h1v1h-1z",
    fill: "#c98a81"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M34 23v-1h1v1z",
    fill: "#b4443d"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M35 22h1v1h-1z",
    fill: "#b93a3d"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23v-1h1v1z",
    fill: "#ba3236"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M38 23h-1v-1h1z",
    fill: "#bb2b2d"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M39 22h1v1h-1z",
    fill: "#b92424"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M42 23v-1h1v1z",
    fill: "#b71c1e"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M50 23h-1v-1h1z",
    fill: "#af161a"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22h1v1h-1z",
    fill: "#bf8482"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M53 23v-1h1v1z",
    fill: "#c6ccc2"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h-1v-1h1z",
    fill: "#c69896"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M56 22v1h-1v-1z",
    fill: "#b04c53"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M57 23h-1v-1h1z",
    fill: "#d4b0ab"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22v1h-1v-1z",
    fill: "#cccfc7"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v-1h1v1z",
    fill: "#c9a6a1"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23v-1h1v1z",
    fill: "#c86e71"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M60 22h1v1h-1z",
    fill: "#dcb4ac"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v-1h1v1z",
    fill: "#b96669"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23h-1v-1h1z",
    fill: "#9b0d17"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23v-1h1v1z",
    fill: "#930608"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22v1h-1v-1z",
    fill: "#940509"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23v-1h1v1z",
    fill: "#930a0f"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23h-1v-1h1z",
    fill: "#c38286"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M68 22v1h-1v-1z",
    fill: "#cec9c9"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M69 23h-1v-1h1z",
    fill: "#c77976"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M70 22v1h-1v-1z",
    fill: "#bf2524"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M71 22v1h-1v-1z",
    fill: "#c64243"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h-1v-1h1z",
    fill: "#d08c89"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23v-1h1v1z",
    fill: "#cdc3b9"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M74 22v1h-1v-1z",
    fill: "#c5c7be"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M75 23h-1v-1h1z",
    fill: "#c4c4be"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M77 22v1h-1v-1z",
    fill: "#cbb1af"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M77 23v-1h1v1z",
    fill: "#b15b60"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M79 23h-1v-1h1z",
    fill: "#97262e"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M81 23h-1v-1h1z",
    fill: "#cfa1a9"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23h-1v-1h1z",
    fill: "#b32d38"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M83 23v-1h1v1z",
    fill: "#c32223"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M85 22h1v1h-1z",
    fill: "#c42025"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M87 23h-1v-1h1z",
    fill: "#c52124"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M88 23h-1v-1h1z",
    fill: "#b92126"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h1v1h-1z",
    fill: "#c68e8a"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M90 22v1h-1v-1z",
    fill: "#cecdcb"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23h-1v-1h1z",
    fill: "#c27d81"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23v-1h1v1z",
    fill: "#b62a2d"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M93 22v1h-1v-1z",
    fill: "#ba3539"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23v-1h1v1z",
    fill: "#bb3e40"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M94 23v-1h1v1z",
    fill: "#bb5152"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M96 23h-1v-1h1z",
    fill: "#cc9591"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M96 23v-1h1v1z",
    fill: "#dec9c9",
    fillOpacity: 0.882
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M97 22h1v1h-1z",
    fill: "#e6e6e6",
    fillOpacity: 0.082
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24v-1h1v1z",
    fill: "#e2e4dd",
    fillOpacity: 0.604
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24h-1v-1h1z",
    fill: "#dcdad4"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M34 24h-1v-1h1z",
    fill: "#cc9c92"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M35 24h-1v-1h1z",
    fill: "#b1423c"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M36 24v-1h1v1z",
    fill: "#bc3135"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24h-1v-1h1z",
    fill: "#b92323"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h-1v-1h1z",
    fill: "#ac1116"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24v-1h1v1z",
    fill: "#a2282c"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M53 24v-1h1v1z",
    fill: "#c3a29d"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M54 23h1v1h-1z",
    fill: "#c3cac0"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h1v1h-1z",
    fill: "#c39393"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M56 23h1v1h-1z",
    fill: "#ad555b"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v1h-1v-1z",
    fill: "#caada8"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M59 24h-1v-1h1z",
    fill: "#cea198"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23h1v1h-1z",
    fill: "#b52427"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v1h-1v-1z",
    fill: "#bb4c4c"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M62 23v1h-1v-1z",
    fill: "#d3aba5"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v-1h1v1z",
    fill: "#b26d6c"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v-1h1v1z",
    fill: "#890a11"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M64 23h1v1h-1z",
    fill: "#900208"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23h1v1h-1z",
    fill: "#96070c"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23v1h-1v-1z",
    fill: "#b15b5d"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M67 24v-1h1v1z",
    fill: "#cac9c4"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h-1v-1h1z",
    fill: "#cbbdba"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24h-1v-1h1z",
    fill: "#b6191a"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v-1h1v1z",
    fill: "#b31e1f"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h1v1h-1z",
    fill: "#b44b4b"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24h-1v-1h1z",
    fill: "#c99f98"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24v-1h1v1z",
    fill: "#c6c9bc"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M76 23v1h-1v-1z",
    fill: "#c0c6bc"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24v-1h1v1z",
    fill: "#c7c3c1"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M78 23h1v1h-1z",
    fill: "#ba9797"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M79 24v-1h1v1z",
    fill: "#bba8a3"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M81 24h-1v-1h1z",
    fill: "#cbc9c4"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M81 24v-1h1v1z",
    fill: "#c67980"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23h1v1h-1z",
    fill: "#be1e26"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M84 23v1h-1v-1z",
    fill: "#c42124"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M86 24v-1h1v1z",
    fill: "#c22125"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M89 23v1h-1v-1z",
    fill: "#c47574"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23v1h-1v-1z",
    fill: "#c28185"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M91 24v-1h1v1z",
    fill: "#b9282f"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23h1v1h-1z",
    fill: "#bb3f43"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M96 24h-1v-1h1z",
    fill: "#c78385"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M97 24h-1v-1h1z",
    fill: "#c6a1a7",
    fillOpacity: 0.902
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M98 23v1h-1v-1z",
    fill: "#f4e9e9",
    fillOpacity: 0.094
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24h1v1h-1z",
    fill: "#e4e2dd",
    fillOpacity: 0.604
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24v1h-1v-1z",
    fill: "#dcdbd3"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M34 25h-1v-1h1z",
    fill: "#d1ada3"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M34 25v-1h1v1z",
    fill: "#b1423b"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M37 25h-1v-1h1z",
    fill: "#be3135"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25v-1h1v1z",
    fill: "#b92626"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h-1v-1h1z",
    fill: "#b51c1e"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24v1h-1v-1z",
    fill: "#b41b1c"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25h-1v-1h1z",
    fill: "#ab1514"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h1v1h-1z",
    fill: "#a20f14"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M54 24v1h-1v-1z",
    fill: "#a63a3e"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25v-1h1v1z",
    fill: "#c8b3af"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M55 25v-1h1v1z",
    fill: "#c7c7bf"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M56 25v-1h1v1z",
    fill: "#c19790"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h-1v-1h1z",
    fill: "#c46d6f"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25v-1h1v1z",
    fill: "#af2025"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M61 24v1h-1v-1z",
    fill: "#b31117"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v1h-1v-1z",
    fill: "#a43636"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v1h-1v-1z",
    fill: "#ce9e99"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25h-1v-1h1z",
    fill: "#b2817a"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M64 24h1v1h-1z",
    fill: "#861010"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v-1h1v1z",
    fill: "#9a050d"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25v-1h1v1z",
    fill: "#a22028"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h-1v-1h1z",
    fill: "#c7aaa2"
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24v1h-1v-1z",
    fill: "#c7c8c2"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h1v1h-1z",
    fill: "#ccb8b5"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v1h-1v-1z",
    fill: "#b85b63"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M73 25h-1v-1h1z",
    fill: "#af1112"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M74 25h-1v-1h1z",
    fill: "#a01e23"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24h1v1h-1z",
    fill: "#b66868"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M76 25h-1v-1h1z",
    fill: "#ceb6b0"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24v1h-1v-1z",
    fill: "#c4c6be"
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v-1h1v1z",
    fill: "#bcc3b8"
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M81 25h-1v-1h1z",
    fill: "#c1c7bf"
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M82 24v1h-1v-1z",
    fill: "#cdb7b1"
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M83 25h-1v-1h1z",
    fill: "#bb363e"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M84 25h-1v-1h1z",
    fill: "#c41b22"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M85 24v1h-1v-1z",
    fill: "#c32024"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M86 25h-1v-1h1z",
    fill: "#c32025"
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M87 25h-1v-1h1z",
    fill: "#c22126"
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M87 25v-1h1v1z",
    fill: "#bf1d22"
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25h-1v-1h1z",
    fill: "#c05b5c"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M90 24v1h-1v-1z",
    fill: "#d2cbc9"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M91 25h-1v-1h1z",
    fill: "#c48389"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M92 25h-1v-1h1z",
    fill: "#b9272f"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M94 24v1h-1v-1z",
    fill: "#ba3f43"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M95 24v1h-1v-1z",
    fill: "#bd5153"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M95 25v-1h1v1z",
    fill: "#c98987"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M96 24h1v1h-1z",
    fill: "#d7bab9",
    fillOpacity: 0.89
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M97 25v-1h1v1z",
    fill: "#e7e7e7",
    fillOpacity: 0.086
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26v-1h1v1z",
    fill: "#e4e4df",
    fillOpacity: 0.596
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25h1v1h-1z",
    fill: "#dcdbd7"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M33 26v-1h1v1z",
    fill: "#d4baae"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M35 25v1h-1v-1z",
    fill: "#b0463d"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25v1h-1v-1z",
    fill: "#b83b3d"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25h1v1h-1z",
    fill: "#bd3134"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25v1h-1v-1z",
    fill: "#bb2a2d"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h1v1h-1z",
    fill: "#a91515"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25v1h-1v-1z",
    fill: "#a61216"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25h1v1h-1z",
    fill: "#9d0f13"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25h1v1h-1z",
    fill: "#a94948"
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M56 26h-1v-1h1z",
    fill: "#ccb6b5"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M57 25v1h-1v-1z",
    fill: "#c2c8c1"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v-1h1v1z",
    fill: "#c3a49f"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M59 26h-1v-1h1z",
    fill: "#af434b"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h1v1h-1z",
    fill: "#ad151d"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M60 26v-1h1v1z",
    fill: "#b2151a"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M62 26v-1h1v1z",
    fill: "#9c2227"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25v1h-1v-1z",
    fill: "#c59490"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v1h-1v-1z",
    fill: "#b6847f"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M65 26v-1h1v1z",
    fill: "#8f1518"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M67 25h1v1h-1z",
    fill: "#b44a4d"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h1v1h-1z",
    fill: "#cebfb9"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h-1v-1h1z",
    fill: "#c4bbb5"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M72 26h-1v-1h1z",
    fill: "#b66e72"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M72 25h1v1h-1z",
    fill: "#a11d23"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M73 25h1v1h-1z",
    fill: "#a70a10"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M75 25v1h-1v-1z",
    fill: "#9e0c12"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M75 26v-1h1v1z",
    fill: "#a33a36"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v1h-1v-1z",
    fill: "#c69991"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25h1v1h-1z",
    fill: "#c5c1bc"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M82 25v1h-1v-1z",
    fill: "#ccc3bf"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26v-1h1v1z",
    fill: "#bf545c"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M88 26h-1v-1h1z",
    fill: "#bf1e26"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25v1h-1v-1z",
    fill: "#b94948"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M89 26v-1h1v1z",
    fill: "#d0c7c3"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M90 25h1v1h-1z",
    fill: "#c5858b"
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M94 26h-1v-1h1z",
    fill: "#b93e42"
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M95 26h-1v-1h1z",
    fill: "#bb5253"
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M96 25v1h-1v-1z",
    fill: "#c4847e"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M96 26v-1h1v1z",
    fill: "#ccaca7",
    fillOpacity: 0.894
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M97 25h1v1h-1z",
    fill: "#f3f3f3",
    fillOpacity: 0.09
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M32 27h-1v-1h1z",
    fill: "#e5e3e0",
    fillOpacity: 0.592
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27h-1v-1h1z",
    fill: "#dadcd7"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27v-1h1v1z",
    fill: "#d2bdb0"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27h-1v-1h1z",
    fill: "#b0493f"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27v-1h1v1z",
    fill: "#b63b3c"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M36 27v-1h1v1z",
    fill: "#bb3233"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M39 27v-1h1v1z",
    fill: "#b72323"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M48 27h-1v-1h1z",
    fill: "#ab1616"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M54 27h-1v-1h1z",
    fill: "#a21216"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M54 26h1v1h-1z",
    fill: "#a93c3e"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M55 26h1v1h-1z",
    fill: "#ab5c61"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v1h-1v-1z",
    fill: "#c7b9b4"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27h-1v-1h1z",
    fill: "#c2c7bf"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M59 27h-1v-1h1z",
    fill: "#c7b4ac"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27h-1v-1h1z",
    fill: "#b15a5a"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M61 27h-1v-1h1z",
    fill: "#a4161c"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27v-1h1v1z",
    fill: "#990c0d"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M64 26v1h-1v-1z",
    fill: "#90161d"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h-1v-1h1z",
    fill: "#bd8d8a"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M66 26v1h-1v-1z",
    fill: "#bd8684"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M66 27v-1h1v1z",
    fill: "#9a1b1f"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M68 27h-1v-1h1z",
    fill: "#a31012"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M69 26v1h-1v-1z",
    fill: "#b66463"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M70 27h-1v-1h1z",
    fill: "#cbc4bb"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h1v1h-1z",
    fill: "#c1c6bd"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h-1v-1h1z",
    fill: "#bb8c89"
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27v-1h1v1z",
    fill: "#9f2a30"
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27h-1v-1h1z",
    fill: "#9b1f1e"
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M78 26v1h-1v-1z",
    fill: "#b67a74"
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27v-1h1v1z",
    fill: "#c8c2b9"
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M80 27h-1v-1h1z",
    fill: "#c4c5be"
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M81 26v1h-1v-1z",
    fill: "#c9c8c3"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M81 26h1v1h-1z",
    fill: "#d1c0bb"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26h1v1h-1z",
    fill: "#bc494d"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M83 27v-1h1v1z",
    fill: "#bc1a21"
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M86 26v1h-1v-1z",
    fill: "#c12029"
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M86 26h1v1h-1z",
    fill: "#c02328"
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M87 26h1v1h-1z",
    fill: "#be2027"
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M89 27h-1v-1h1z",
    fill: "#b63a3b"
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M89 26h1v1h-1z",
    fill: "#d1beba"
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M90 27v-1h1v1z",
    fill: "#c4898e"
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M91 26h1v1h-1z",
    fill: "#b82931"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M92 26h1v1h-1z",
    fill: "#bc333a"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M93 26h1v1h-1z",
    fill: "#ba3e41"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M95 26v1h-1v-1z",
    fill: "#bb5353"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M96 27h-1v-1h1z",
    fill: "#c37f7c"
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M96 26h1v1h-1z",
    fill: "#cda6a5",
    fillOpacity: 0.894
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M98 27h-1v-1h1z",
    fill: "#f3f3e7",
    fillOpacity: 0.086
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M31 27h1v1h-1z",
    fill: "#e5e4e0",
    fillOpacity: 0.596
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27v1h-1v-1z",
    fill: "#dadbd8"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27h1v1h-1z",
    fill: "#d3bcb1"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28v-1h1v1z",
    fill: "#b2473f"
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v-1h1v1z",
    fill: "#ba3332"
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M37 28v-1h1v1z",
    fill: "#b92b2c"
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27h1v1h-1z",
    fill: "#b71f21"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M45 28h-1v-1h1z",
    fill: "#b01819"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27h1v1h-1z",
    fill: "#ae1719"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M48 27v1h-1v-1z",
    fill: "#ab1617"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M48 28v-1h1v1z",
    fill: "#aa1616"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27v1h-1v-1z",
    fill: "#a61013"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M53 28v-1h1v1z",
    fill: "#9f2a34"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27v1h-1v-1z",
    fill: "#c8aeaf"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27h1v1h-1z",
    fill: "#b27471"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M57 28h-1v-1h1z",
    fill: "#a85c59"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27v1h-1v-1z",
    fill: "#c8bbb2"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28v-1h1v1z",
    fill: "#c0c6ba"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27v1h-1v-1z",
    fill: "#c9c0b7"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M60 28v-1h1v1z",
    fill: "#b87e7b"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h1v1h-1z",
    fill: "#9a080f"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M63 27h1v1h-1z",
    fill: "#98050a"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27v1h-1v-1z",
    fill: "#8b1417"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h1v1h-1z",
    fill: "#bc8987"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28h-1v-1h1z",
    fill: "#bb8c88"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v-1h1v1z",
    fill: "#9e1e23"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27v1h-1v-1z",
    fill: "#a71015"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27h1v1h-1z",
    fill: "#b56a66"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M71 27v1h-1v-1z",
    fill: "#ccc3b8"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M72 27v1h-1v-1z",
    fill: "#c1c6bb"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h1v1h-1z",
    fill: "#c4a9a7"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M75 27v1h-1v-1z",
    fill: "#a75456"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v-1h1v1z",
    fill: "#9b161e"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27v1h-1v-1z",
    fill: "#9e0b10"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M77 28v-1h1v1z",
    fill: "#a20c13"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27h1v1h-1z",
    fill: "#b56762"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M80 28h-1v-1h1z",
    fill: "#ccc1ba"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M80 27h1v1h-1z",
    fill: "#c19a9c"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28h-1v-1h1z",
    fill: "#bf5c60"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28v-1h1v1z",
    fill: "#bb2327"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M83 27h1v1h-1z",
    fill: "#c31f22"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M87 28h-1v-1h1z",
    fill: "#c02229"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M88 28h-1v-1h1z",
    fill: "#be2228"
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M89 27v1h-1v-1z",
    fill: "#b72c2f"
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v-1h1v1z",
    fill: "#ceaeab"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M91 27v1h-1v-1z",
    fill: "#c48d91"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28v-1h1v1z",
    fill: "#b72a32"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M94 28h-1v-1h1z",
    fill: "#b93e3f"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M94 28v-1h1v1z",
    fill: "#bb5252"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M95 27h1v1h-1z",
    fill: "#c6847f"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M96 28v-1h1v1z",
    fill: "#d3b0ae",
    fillOpacity: 0.882
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M97 27h1v1h-1z",
    fill: "#f2f2e5",
    fillOpacity: 0.078
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M31 28h1v1h-1z",
    fill: "#e4e2e1",
    fillOpacity: 0.6
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M33 28v1h-1v-1z",
    fill: "#dbdbda"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28v1h-1v-1z",
    fill: "#d4b5ac"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28h1v1h-1z",
    fill: "#b3423b"
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v1h-1v-1z",
    fill: "#b9393b"
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v-1h1v1z",
    fill: "#bb3332"
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M38 28v1h-1v-1z",
    fill: "#bb2c2c"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M38 29v-1h1v1z",
    fill: "#b82727"
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M39 28h1v1h-1z",
    fill: "#b92324"
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28v1h-1v-1z",
    fill: "#b81f21"
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M46 28v1h-1v-1z",
    fill: "#ae181a"
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M47 29v-1h1v1z",
    fill: "#ab1717"
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M49 29h-1v-1h1z",
    fill: "#aa1516"
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v-1h1v1z",
    fill: "#9e0f17"
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M53 29v-1h1v1z",
    fill: "#b47179"
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M55 29h-1v-1h1z",
    fill: "#c2c4c0"
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M56 28h1v1h-1z",
    fill: "#b57873"
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29v-1h1v1z",
    fill: "#ad5b5a"
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28h1v1h-1z",
    fill: "#cdb5ad"
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M61 29h-1v-1h1z",
    fill: "#c3c6c0"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M61 28h1v1h-1z",
    fill: "#c29d9b"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h1v1h-1z",
    fill: "#973b3c"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M63 29v-1h1v1z",
    fill: "#8c080d"
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29h-1v-1h1z",
    fill: "#92030b"
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29v-1h1v1z",
    fill: "#8c1419"
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v1h-1v-1z",
    fill: "#c38a8c"
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29v-1h1v1z",
    fill: "#bf8a87"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M68 28h1v1h-1z",
    fill: "#a11c23"
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "M70 28v1h-1v-1z",
    fill: "#a9121a"
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29v-1h1v1z",
    fill: "#b7615f"
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28v1h-1v-1z",
    fill: "#cfbcb6"
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "M74 28v1h-1v-1z",
    fill: "#bfc2bb"
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v1h-1v-1z",
    fill: "#c5bfb8"
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "M76 28v1h-1v-1z",
    fill: "#bc9395"
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "M77 29h-1v-1h1z",
    fill: "#a6454a"
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29h-1v-1h1z",
    fill: "#981616"
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "M79 28v1h-1v-1z",
    fill: "#941113"
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "M79 29v-1h1v1z",
    fill: "#c39496"
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28v1h-1v-1z",
    fill: "#c79f9f"
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28h1v1h-1z",
    fill: "#b52530"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "M83 28h1v1h-1z",
    fill: "#c02124"
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28v1h-1v-1z",
    fill: "#c41d27"
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28h1v1h-1z",
    fill: "#c12129"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "M87 28h1v1h-1z",
    fill: "#c02128"
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v1h-1v-1z",
    fill: "#b8242a"
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29h-1v-1h1z",
    fill: "#ca9b9a"
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28v1h-1v-1z",
    fill: "#c49195"
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28h1v1h-1z",
    fill: "#b62b33"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "M92 29v-1h1v1z",
    fill: "#bc3339"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "M93 29v-1h1v1z",
    fill: "#ba3e40"
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "M95 29h-1v-1h1z",
    fill: "#ba5253"
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "M95 28h1v1h-1z",
    fill: "#c68883"
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "M96 28h1v1h-1z",
    fill: "#d9bcb7",
    fillOpacity: 0.871
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "M98 28v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.067
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29h1v1h-1z",
    fill: "#e5e3e1",
    fillOpacity: 0.58
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "M32 29h1v1h-1z",
    fill: "#dbdcd9"
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30h-1v-1h1z",
    fill: "#cfa599"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "M35 30h-1v-1h1z",
    fill: "#b03f35"
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v1h-1v-1z",
    fill: "#b83a3d"
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "M37 29v1h-1v-1z",
    fill: "#bc3232"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30h-1v-1h1z",
    fill: "#bc2c2b"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30v-1h1v1z",
    fill: "#b82020"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30v-1h1v1z",
    fill: "#ae171c"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h-1v-1h1z",
    fill: "#ab1518"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v1h-1v-1z",
    fill: "#a81317"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "M51 30h-1v-1h1z",
    fill: "#aa1217"
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29h1v1h-1z",
    fill: "#a03542"
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v-1h1v1z",
    fill: "#c4b3b5"
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "M55 30v-1h1v1z",
    fill: "#c0c2be"
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "M57 30h-1v-1h1z",
    fill: "#c89e94"
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29h1v1h-1z",
    fill: "#a62024"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "M58 30v-1h1v1z",
    fill: "#b24b4e"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v-1h1v1z",
    fill: "#c9b2ab"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30h-1v-1h1z",
    fill: "#c3b9b2"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30v-1h1v1z",
    fill: "#a56869"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h-1v-1h1z",
    fill: "#851319"
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "M66 29v1h-1v-1z",
    fill: "#8c0009"
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "M67 30h-1v-1h1z",
    fill: "#9a1e22"
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29h1v1h-1z",
    fill: "#ca958e"
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v-1h1v1z",
    fill: "#bc8082"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "M69 29h1v1h-1z",
    fill: "#a51822"
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29h1v1h-1z",
    fill: "#a71316"
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "M71 30v-1h1v1z",
    fill: "#b2484b"
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h-1v-1h1z",
    fill: "#caaca7"
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30v-1h1v1z",
    fill: "#c2c6bc"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "M76 29h1v1h-1z",
    fill: "#c6bcb6"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29v1h-1v-1z",
    fill: "#bd9592"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "M79 30h-1v-1h1z",
    fill: "#af7071"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "M79 29h1v1h-1z",
    fill: "#c0a8a9"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30v-1h1v1z",
    fill: "#cbc6c1"
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29v1h-1v-1z",
    fill: "#c1757c"
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29h1v1h-1z",
    fill: "#ba1b27"
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "M86 30h-1v-1h1z",
    fill: "#c01e28"
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "M86 29h1v1h-1z",
    fill: "#bf2027"
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "M88 30v-1h1v1z",
    fill: "#b62126"
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29v1h-1v-1z",
    fill: "#c78283"
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "M91 30h-1v-1h1z",
    fill: "#c9969b"
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "M92 30h-1v-1h1z",
    fill: "#b42c35"
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "M92 30v-1h1v1z",
    fill: "#ba3438"
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "M95 29v1h-1v-1z",
    fill: "#ba5354"
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "M96 30h-1v-1h1z",
    fill: "#c18581"
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "M96 29h1v1h-1z",
    fill: "#d0b5b1",
    fillOpacity: 0.867
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30h-1v-1h1z",
    fill: "#ffffef",
    fillOpacity: 0.063
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31h-1v-1h1z",
    fill: "#e0e4de",
    fillOpacity: 0.561
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "M33 30v1h-1v-1z",
    fill: "#e2dcd3"
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "M33 31v-1h1v1z",
    fill: "#c5897a"
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30h1v1h-1z",
    fill: "#b13e34"
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31h-1v-1h1z",
    fill: "#b83b3b"
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31v-1h1v1z",
    fill: "#bb3232"
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30v1h-1v-1z",
    fill: "#bb2c2b"
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31h-1v-1h1z",
    fill: "#b82324"
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "M43 30v1h-1v-1z",
    fill: "#b41a1d"
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "M51 31h-1v-1h1z",
    fill: "#aa1213"
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "M52 30v1h-1v-1z",
    fill: "#a0141d"
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v1h-1v-1z",
    fill: "#b9858e"
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v-1h1v1z",
    fill: "#bfc3c0"
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30h1v1h-1z",
    fill: "#bebebb"
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "M55 31v-1h1v1z",
    fill: "#c7bbb5"
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31h-1v-1h1z",
    fill: "#b15450"
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "M58 31h-1v-1h1z",
    fill: "#b2121a"
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v1h-1v-1z",
    fill: "#ad141c"
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30h1v1h-1z",
    fill: "#b03e44"
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "M61 31h-1v-1h1z",
    fill: "#c9a4a2"
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h1v1h-1z",
    fill: "#c1c1c0"
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "M64 30v1h-1v-1z",
    fill: "#c4c3c1"
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31v-1h1v1z",
    fill: "#b89694"
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h1v1h-1z",
    fill: "#943a3f"
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "M67 31h-1v-1h1z",
    fill: "#960e12"
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v1h-1v-1z",
    fill: "#a92326"
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30v1h-1v-1z",
    fill: "#d09c97"
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30h1v1h-1z",
    fill: "#bb6d72"
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31h-1v-1h1z",
    fill: "#a7151a"
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "M72 31v-1h1v1z",
    fill: "#a53133"
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h1v1h-1z",
    fill: "#c09189"
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31h-1v-1h1z",
    fill: "#c9c3bc"
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31h-1v-1h1z",
    fill: "#c3c5c3"
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "M81 31h-1v-1h1z",
    fill: "#c8c2c2"
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "M82 30v1h-1v-1z",
    fill: "#cbaeb1"
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31v-1h1v1z",
    fill: "#b73139"
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "M86 30v1h-1v-1z",
    fill: "#be2028"
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "M86 31v-1h1v1z",
    fill: "#c02028"
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "M89 31h-1v-1h1z",
    fill: "#b92025"
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "M89 31v-1h1v1z",
    fill: "#c16d6e"
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "M91 31h-1v-1h1z",
    fill: "#ce9b9f"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "M91 31v-1h1v1z",
    fill: "#b42f36"
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "M93 30v1h-1v-1z",
    fill: "#bb3338"
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "M95 30h1v1h-1z",
    fill: "#c58a85"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "M96 31v-1h1v1z",
    fill: "#dabfbb",
    fillOpacity: 0.839
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.043
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31v1h-1v-1z",
    fill: "#ded5cc",
    fillOpacity: 0.549
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31h1v1h-1z",
    fill: "#dab6ab"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32v-1h1v1z",
    fill: "#be6c60"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "M34 31h1v1h-1z",
    fill: "#b43f39"
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "M37 32h-1v-1h1z",
    fill: "#ba3132"
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31v1h-1v-1z",
    fill: "#b82527"
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32h-1v-1h1z",
    fill: "#a40e13"
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32v-1h1v1z",
    fill: "#a9424d"
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v1h-1v-1z",
    fill: "#c6bbbc"
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31h1v1h-1z",
    fill: "#bcc0ba"
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "M56 32h-1v-1h1z",
    fill: "#c2807a"
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31v1h-1v-1z",
    fill: "#ab191b"
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32h-1v-1h1z",
    fill: "#b3161c"
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "M60 31h1v1h-1z",
    fill: "#a92b33"
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31v1h-1v-1z",
    fill: "#c48f90"
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31h1v1h-1z",
    fill: "#c8c2bc"
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31h1v1h-1z",
    fill: "#c3c2bf"
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v-1h1v1z",
    fill: "#bfbbb3"
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "M66 32v-1h1v1z",
    fill: "#b68084"
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32h-1v-1h1z",
    fill: "#a42e36"
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31v1h-1v-1z",
    fill: "#a33234"
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31h1v1h-1z",
    fill: "#d2a0a1"
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31v1h-1v-1z",
    fill: "#b35658"
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v-1h1v1z",
    fill: "#a1181a"
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "M74 31h1v1h-1z",
    fill: "#b56561"
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "M76 32h-1v-1h1z",
    fill: "#c7bab4"
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31h1v1h-1z",
    fill: "#c0c3be"
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "M81 31h1v1h-1z",
    fill: "#cdbfbd"
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31h1v1h-1z",
    fill: "#bd4b51"
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "M83 32v-1h1v1z",
    fill: "#be1b21"
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "M87 32h-1v-1h1z",
    fill: "#bf2127"
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "M88 31v1h-1v-1z",
    fill: "#be2329"
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "M90 32h-1v-1h1z",
    fill: "#bb585a"
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "M91 32h-1v-1h1z",
    fill: "#d19fa1"
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "M92 31v1h-1v-1z",
    fill: "#b63139"
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "M92 31h1v1h-1z",
    fill: "#bc3439"
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "M95 31v1h-1v-1z",
    fill: "#bb5354"
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "M96 32h-1v-1h1z",
    fill: "#c17f7c"
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "M97 32h-1v-1h1z",
    fill: "#cda9a6",
    fillOpacity: 0.863
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32v1h-1v-1z",
    fill: "#dec5b7",
    fillOpacity: 0.561
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32v1h-1v-1z",
    fill: "#c38579"
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32h1v1h-1z",
    fill: "#be605a"
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "M34 33v-1h1v1z",
    fill: "#b63f3c"
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "M38 32h1v1h-1z",
    fill: "#b72527"
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32v1h-1v-1z",
    fill: "#b72023"
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33h-1v-1h1z",
    fill: "#a1121e"
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33v-1h1v1z",
    fill: "#ba878d"
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33v-1h1v1z",
    fill: "#bdc1b9"
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "M55 32v1h-1v-1z",
    fill: "#c3a89e"
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "M56 33h-1v-1h1z",
    fill: "#ab302d"
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32v1h-1v-1z",
    fill: "#b51519"
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33h-1v-1h1z",
    fill: "#9e1c1d"
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v1h-1v-1z",
    fill: "#b56e6c"
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32h1v1h-1z",
    fill: "#c7b9b7"
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "M65 33v-1h1v1z",
    fill: "#bbc0b7"
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "M66 33v-1h1v1z",
    fill: "#c2c4bc"
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32v1h-1v-1z",
    fill: "#c7b4ab"
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h-1v-1h1z",
    fill: "#af6c6c"
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33h-1v-1h1z",
    fill: "#a35f63"
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33v-1h1v1z",
    fill: "#caa3a1"
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32h1v1h-1z",
    fill: "#aa373c"
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "M74 32v1h-1v-1z",
    fill: "#a51311"
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "M75 32v1h-1v-1z",
    fill: "#9f0f12"
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "M75 33v-1h1v1z",
    fill: "#a83f3f"
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33h-1v-1h1z",
    fill: "#c69e99"
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "M80 32v1h-1v-1z",
    fill: "#c4bfc0"
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33h-1v-1h1z",
    fill: "#c0c8c2"
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "M81 32h1v1h-1z",
    fill: "#cfbab9"
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "M82 33v-1h1v1z",
    fill: "#be3b45"
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33v-1h1v1z",
    fill: "#bf2229"
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33h-1v-1h1z",
    fill: "#c12125"
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33v-1h1v1z",
    fill: "#b84548"
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "M90 32h1v1h-1z",
    fill: "#d29d9e"
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "M92 32v1h-1v-1z",
    fill: "#b7353c"
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "M93 33h-1v-1h1z",
    fill: "#bd3339"
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "M93 32h1v1h-1z",
    fill: "#ba3d43"
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "M96 32v1h-1v-1z",
    fill: "#c17977"
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "M96 33v-1h1v1z",
    fill: "#cb9f9f",
    fillOpacity: 0.867
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h-1v-1h1z",
    fill: "#e2c6b8",
    fillOpacity: 0.569
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33v1h-1v-1z",
    fill: "#c78379"
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34v-1h1v1z",
    fill: "#bc615a"
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "M35 33v1h-1v-1z",
    fill: "#b4403a"
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "M36 33h1v1h-1z",
    fill: "#b93133"
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33h1v1h-1z",
    fill: "#b52626"
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34v-1h1v1z",
    fill: "#a62e3b"
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "M52 33v1h-1v-1z",
    fill: "#c7b0b1"
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v-1h1v1z",
    fill: "#c0bfb9"
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33h1v1h-1z",
    fill: "#c5bdb5"
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "M54 33h1v1h-1z",
    fill: "#b15955"
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "M56 34h-1v-1h1z",
    fill: "#a71111"
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "M59 33h1v1h-1z",
    fill: "#b11618"
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33v1h-1v-1z",
    fill: "#a81113"
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "M62 34v-1h1v1z",
    fill: "#94090e"
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "M64 33v1h-1v-1z",
    fill: "#9b3f42"
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "M64 34v-1h1v1z",
    fill: "#bfa29c"
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33v1h-1v-1z",
    fill: "#c0c0ba"
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "M69 34h-1v-1h1z",
    fill: "#c8c3bc"
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h1v1h-1z",
    fill: "#c1a8a3"
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "M71 34h-1v-1h1z",
    fill: "#c2b1af"
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h-1v-1h1z",
    fill: "#c69291"
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "M73 34h-1v-1h1z",
    fill: "#a31b1c"
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "M77 34h-1v-1h1z",
    fill: "#9b2125"
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "M78 33v1h-1v-1z",
    fill: "#ba7b7c"
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "M79 33v1h-1v-1z",
    fill: "#cbc2c0"
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "M80 34h-1v-1h1z",
    fill: "#c5b5b6"
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33v1h-1v-1z",
    fill: "#c89f99"
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33h1v1h-1z",
    fill: "#c8646a"
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "M82 34v-1h1v1z",
    fill: "#bc2028"
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "M84 33v1h-1v-1z",
    fill: "#c11e26"
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33h1v1h-1z",
    fill: "#bf2026"
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33v1h-1v-1z",
    fill: "#c02427"
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "M90 34h-1v-1h1z",
    fill: "#b6383b"
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "M91 33v1h-1v-1z",
    fill: "#d39897"
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "M91 33h1v1h-1z",
    fill: "#b53940"
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "M93 34h-1v-1h1z",
    fill: "#bf3239"
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "M93 33h1v1h-1z",
    fill: "#bc3d43"
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "M95 33v1h-1v-1z",
    fill: "#ba5657"
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "M96 33v1h-1v-1z",
    fill: "#c07977"
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "M96 33h1v1h-1z",
    fill: "#cba1a0",
    fillOpacity: 0.847
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34v1h-1v-1z",
    fill: "#e0c4b8",
    fillOpacity: 0.565
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h1v1h-1z",
    fill: "#c88379"
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34h1v1h-1z",
    fill: "#bc6059"
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35v-1h1v1z",
    fill: "#b33f39"
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35v-1h1v1z",
    fill: "#a20f11"
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34h1v1h-1z",
    fill: "#ab565b"
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v1h-1v-1z",
    fill: "#c3bfbd"
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "M53 34v1h-1v-1z",
    fill: "#c1c0b9"
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v-1h1v1z",
    fill: "#c08e86"
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "M55 34v1h-1v-1z",
    fill: "#a5171a"
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v-1h1v1z",
    fill: "#aa1312"
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "M56 35v-1h1v1z",
    fill: "#af1719"
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35v-1h1v1z",
    fill: "#aa1318"
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "M63 35h-1v-1h1z",
    fill: "#980d0d"
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "M64 35h-1v-1h1z",
    fill: "#8f0707"
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34v1h-1v-1z",
    fill: "#8e191d"
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34h1v1h-1z",
    fill: "#b16d6d"
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35h-1v-1h1z",
    fill: "#c9bbb4"
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35h-1v-1h1z",
    fill: "#c5bfbc"
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "M69 34h1v1h-1z",
    fill: "#c1c3ba"
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35v-1h1v1z",
    fill: "#c9bfba"
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h1v1h-1z",
    fill: "#b67270"
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "M73 35v-1h1v1z",
    fill: "#992029"
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v-1h1v1z",
    fill: "#9b0e13"
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "M77 34v1h-1v-1z",
    fill: "#a01212"
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "M78 34v1h-1v-1z",
    fill: "#9c1218"
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35v-1h1v1z",
    fill: "#bb6a6e"
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "M79 34h1v1h-1z",
    fill: "#cdb1ad"
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "M80 34h1v1h-1z",
    fill: "#b04b50"
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "M87 35v-1h1v1z",
    fill: "#c32029"
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "M90 35h-1v-1h1z",
    fill: "#b62e33"
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "M90 34h1v1h-1z",
    fill: "#d09291"
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "M92 35h-1v-1h1z",
    fill: "#b33f44"
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "M93 34h1v1h-1z",
    fill: "#bc3d44"
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "M95 35h-1v-1h1z",
    fill: "#bc5557"
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "M96 35h-1v-1h1z",
    fill: "#c37d7d"
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "M97 35h-1v-1h1z",
    fill: "#d4acac",
    fillOpacity: 0.827
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36v-1h1v1z",
    fill: "#e2c5b9",
    fillOpacity: 0.561
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "M32 35h1v1h-1z",
    fill: "#c78279"
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "M33 35h1v1h-1z",
    fill: "#bb5f58"
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35h1v1h-1z",
    fill: "#b43e39"
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "M35 35h1v1h-1z",
    fill: "#b9393a"
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35h1v1h-1z",
    fill: "#b62324"
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h1v1h-1z",
    fill: "#a40d12"
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "M50 35h1v1h-1z",
    fill: "#b67478"
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "M51 35h1v1h-1z",
    fill: "#bfc4c1"
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v1h-1v-1z",
    fill: "#c5b6ad"
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35h1v1h-1z",
    fill: "#a7403a"
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v1h-1v-1z",
    fill: "#a30f0c"
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "M55 36v-1h1v1z",
    fill: "#ad1414"
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "M58 36h-1v-1h1z",
    fill: "#af1819"
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35h1v1h-1z",
    fill: "#a71417"
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v-1h1v1z",
    fill: "#9c0c0c"
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "M63 36v-1h1v1z",
    fill: "#940c08"
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "M65 35v1h-1v-1z",
    fill: "#8f0a0a"
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "M65 36v-1h1v1z",
    fill: "#89080b"
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35v1h-1v-1z",
    fill: "#a23d3b"
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36v-1h1v1z",
    fill: "#c3938c"
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35v1h-1v-1z",
    fill: "#cac2bb"
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36v-1h1v1z",
    fill: "#bfc0bb"
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "M72 36h-1v-1h1z",
    fill: "#c1bfbc"
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "M72 35h1v1h-1z",
    fill: "#c5c2bb"
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v1h-1v-1z",
    fill: "#c1a69f"
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h-1v-1h1z",
    fill: "#ab6865"
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36v-1h1v1z",
    fill: "#9c3133"
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "M77 36h-1v-1h1z",
    fill: "#981518"
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "M77 35h1v1h-1z",
    fill: "#a20910"
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35h1v1h-1z",
    fill: "#9c0d16"
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "M80 36h-1v-1h1z",
    fill: "#c28b8a"
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "M80 35h1v1h-1z",
    fill: "#d0aeaa"
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "M81 35h1v1h-1z",
    fill: "#b6353d"
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "M82 36v-1h1v1z",
    fill: "#c01c25"
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "M87 36v-1h1v1z",
    fill: "#c41f29"
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "M89 36h-1v-1h1z",
    fill: "#bf2527"
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "M89 36v-1h1v1z",
    fill: "#b7272b"
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "M91 35v1h-1v-1z",
    fill: "#cc8686"
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "M91 36v-1h1v1z",
    fill: "#b7464a"
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "M92 36v-1h1v1z",
    fill: "#bc333b"
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "M94 36v-1h1v1z",
    fill: "#bb5455"
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "M96 35v1h-1v-1z",
    fill: "#c38181"
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "M96 36v-1h1v1z",
    fill: "#d3b1b2",
    fillOpacity: 0.824
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "M98 35v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.031
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36h1v1h-1z",
    fill: "#e2c7b8",
    fillOpacity: 0.557
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "M32 36h1v1h-1z",
    fill: "#c78278"
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "M33 37v-1h1v1z",
    fill: "#ba5b56"
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "M35 36v1h-1v-1z",
    fill: "#b33d38"
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "M36 37h-1v-1h1z",
    fill: "#b83939"
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36h1v1h-1z",
    fill: "#b42424"
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "M41 37v-1h1v1z",
    fill: "#b51c1f"
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "M46 36v1h-1v-1z",
    fill: "#ac1419"
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "M50 36v1h-1v-1z",
    fill: "#a00f14"
  })), _path2602 || (_path2602 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36v1h-1v-1z",
    fill: "#b88082"
  })), _path2603 || (_path2603 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36h1v1h-1z",
    fill: "#c3c5c1"
  })), _path2604 || (_path2604 = /*#__PURE__*/React.createElement("path", {
    d: "M53 37h-1v-1h1z",
    fill: "#bb8b84"
  })), _path2605 || (_path2605 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h-1v-1h1z",
    fill: "#9c1110"
  })), _path2606 || (_path2606 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37v-1h1v1z",
    fill: "#a6110e"
  })), _path2607 || (_path2607 = /*#__PURE__*/React.createElement("path", {
    d: "M57 37h-1v-1h1z",
    fill: "#b01516"
  })), _path2608 || (_path2608 = /*#__PURE__*/React.createElement("path", {
    d: "M65 37h-1v-1h1z",
    fill: "#8f0a0d"
  })), _path2609 || (_path2609 = /*#__PURE__*/React.createElement("path", {
    d: "M67 37h-1v-1h1z",
    fill: "#a10e10"
  })), _path2610 || (_path2610 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36h1v1h-1z",
    fill: "#a21919"
  })), _path2611 || (_path2611 = /*#__PURE__*/React.createElement("path", {
    d: "M68 37v-1h1v1z",
    fill: "#ad5553"
  })), _path2612 || (_path2612 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36v1h-1v-1z",
    fill: "#c7a09c"
  })), _path2613 || (_path2613 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36h1v1h-1z",
    fill: "#ccc3bc"
  })), _path2614 || (_path2614 = /*#__PURE__*/React.createElement("path", {
    d: "M72 36v1h-1v-1z",
    fill: "#c1c3c0"
  })), _path2615 || (_path2615 = /*#__PURE__*/React.createElement("path", {
    d: "M73 36v1h-1v-1z",
    fill: "#bdc0bd"
  })), _path2616 || (_path2616 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v-1h1v1z",
    fill: "#bec3ba"
  })), _path2617 || (_path2617 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h1v1h-1z",
    fill: "#c4b5b1"
  })), _path2618 || (_path2618 = /*#__PURE__*/React.createElement("path", {
    d: "M78 36v1h-1v-1z",
    fill: "#ad676b"
  })), _path2619 || (_path2619 = /*#__PURE__*/React.createElement("path", {
    d: "M79 37h-1v-1h1z",
    fill: "#a55556"
  })), _path2620 || (_path2620 = /*#__PURE__*/React.createElement("path", {
    d: "M79 36h1v1h-1z",
    fill: "#bb9595"
  })), _path2621 || (_path2621 = /*#__PURE__*/React.createElement("path", {
    d: "M81 36v1h-1v-1z",
    fill: "#cbc9c6"
  })), _path2622 || (_path2622 = /*#__PURE__*/React.createElement("path", {
    d: "M81 36h1v1h-1z",
    fill: "#c7878a"
  })), _path2623 || (_path2623 = /*#__PURE__*/React.createElement("path", {
    d: "M82 36h1v1h-1z",
    fill: "#b62029"
  })), _path2624 || (_path2624 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36v1h-1v-1z",
    fill: "#be1f26"
  })), _path2625 || (_path2625 = /*#__PURE__*/React.createElement("path", {
    d: "M87 36h1v1h-1z",
    fill: "#c22129"
  })), _path2626 || (_path2626 = /*#__PURE__*/React.createElement("path", {
    d: "M88 37v-1h1v1z",
    fill: "#bd2527"
  })), _path2627 || (_path2627 = /*#__PURE__*/React.createElement("path", {
    d: "M90 36v1h-1v-1z",
    fill: "#b82226"
  })), _path2628 || (_path2628 = /*#__PURE__*/React.createElement("path", {
    d: "M90 37v-1h1v1z",
    fill: "#c87779"
  })), _path2629 || (_path2629 = /*#__PURE__*/React.createElement("path", {
    d: "M92 37h-1v-1h1z",
    fill: "#bb4b51"
  })), _path2630 || (_path2630 = /*#__PURE__*/React.createElement("path", {
    d: "M93 36v1h-1v-1z",
    fill: "#bb323a"
  })), _path2631 || (_path2631 = /*#__PURE__*/React.createElement("path", {
    d: "M96 37h-1v-1h1z",
    fill: "#be807f"
  })), _path2632 || (_path2632 = /*#__PURE__*/React.createElement("path", {
    d: "M97 36v1h-1v-1z",
    fill: "#dabebd",
    fillOpacity: 0.804
  })), _path2633 || (_path2633 = /*#__PURE__*/React.createElement("path", {
    d: "M97 37v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.02
  })), _path2634 || (_path2634 = /*#__PURE__*/React.createElement("path", {
    d: "M32 37h1v1h-1z",
    fill: "#c78076"
  })), _path2635 || (_path2635 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37v1h-1v-1z",
    fill: "#b75653"
  })), _path2636 || (_path2636 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37h1v1h-1z",
    fill: "#b13b3a"
  })), _path2637 || (_path2637 = /*#__PURE__*/React.createElement("path", {
    d: "M35 37h1v1h-1z",
    fill: "#b7393b"
  })), _path2638 || (_path2638 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37v1h-1v-1z",
    fill: "#ba3234"
  })), _path2639 || (_path2639 = /*#__PURE__*/React.createElement("path", {
    d: "M39 37v1h-1v-1z",
    fill: "#b42426"
  })), _path2640 || (_path2640 = /*#__PURE__*/React.createElement("path", {
    d: "M39 38v-1h1v1z",
    fill: "#b62226"
  })), _path2641 || (_path2641 = /*#__PURE__*/React.createElement("path", {
    d: "M41 38h-1v-1h1z",
    fill: "#b51f23"
  })), _path2642 || (_path2642 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38h-1v-1h1z",
    fill: "#b31d1f"
  })), _path2643 || (_path2643 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v-1h1v1z",
    fill: "#9f0f14"
  })), _path2644 || (_path2644 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h-1v-1h1z",
    fill: "#b77e81"
  })), _path2645 || (_path2645 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38h-1v-1h1z",
    fill: "#ab504d"
  })), _path2646 || (_path2646 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38v-1h1v1z",
    fill: "#a00809"
  })), _path2647 || (_path2647 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h1v1h-1z",
    fill: "#ae1617"
  })), _path2648 || (_path2648 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37v1h-1v-1z",
    fill: "#ad1617"
  })), _path2649 || (_path2649 = /*#__PURE__*/React.createElement("path", {
    d: "M63 38v-1h1v1z",
    fill: "#930b0d"
  })), _path2650 || (_path2650 = /*#__PURE__*/React.createElement("path", {
    d: "M68 38h-1v-1h1z",
    fill: "#b01014"
  })), _path2651 || (_path2651 = /*#__PURE__*/React.createElement("path", {
    d: "M70 37v1h-1v-1z",
    fill: "#a22320"
  })), _path2652 || (_path2652 = /*#__PURE__*/React.createElement("path", {
    d: "M70 38v-1h1v1z",
    fill: "#b2625d"
  })), _path2653 || (_path2653 = /*#__PURE__*/React.createElement("path", {
    d: "M72 37v1h-1v-1z",
    fill: "#c8a4a1"
  })), _path2654 || (_path2654 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37h1v1h-1z",
    fill: "#c1bfb9"
  })), _path2655 || (_path2655 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h1v1h-1z",
    fill: "#c6c3c0"
  })), _path2656 || (_path2656 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38v-1h1v1z",
    fill: "#ccb7b5"
  })), _path2657 || (_path2657 = /*#__PURE__*/React.createElement("path", {
    d: "M82 38v-1h1v1z",
    fill: "#bc3b42"
  })), _path2658 || (_path2658 = /*#__PURE__*/React.createElement("path", {
    d: "M84 37h1v1h-1z",
    fill: "#c01e26"
  })), _path2659 || (_path2659 = /*#__PURE__*/React.createElement("path", {
    d: "M91 38h-1v-1h1z",
    fill: "#c36969"
  })), _path2660 || (_path2660 = /*#__PURE__*/React.createElement("path", {
    d: "M92 37v1h-1v-1z",
    fill: "#bc515b"
  })), _path2661 || (_path2661 = /*#__PURE__*/React.createElement("path", {
    d: "M93 38h-1v-1h1z",
    fill: "#bb3238"
  })), _path2662 || (_path2662 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38v-1h1v1z",
    fill: "#bb5457"
  })), _path2663 || (_path2663 = /*#__PURE__*/React.createElement("path", {
    d: "M95 37h1v1h-1z",
    fill: "#ba7a76"
  })), _path2664 || (_path2664 = /*#__PURE__*/React.createElement("path", {
    d: "M96 38v-1h1v1z",
    fill: "#d1b6b1",
    fillOpacity: 0.788
  })), _path2665 || (_path2665 = /*#__PURE__*/React.createElement("path", {
    d: "M97 37h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.016
  })), _path2666 || (_path2666 = /*#__PURE__*/React.createElement("path", {
    d: "M33 38v1h-1v-1z",
    fill: "#c67f74"
  })), _path2667 || (_path2667 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v-1h1v1z",
    fill: "#b4534f"
  })), _path2668 || (_path2668 = /*#__PURE__*/React.createElement("path", {
    d: "M34 38h1v1h-1z",
    fill: "#b13a39"
  })), _path2669 || (_path2669 = /*#__PURE__*/React.createElement("path", {
    d: "M36 38v1h-1v-1z",
    fill: "#b8393c"
  })), _path2670 || (_path2670 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38v1h-1v-1z",
    fill: "#b92a2a"
  })), _path2671 || (_path2671 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38h1v1h-1z",
    fill: "#b52424"
  })), _path2672 || (_path2672 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39v-1h1v1z",
    fill: "#b51f21"
  })), _path2673 || (_path2673 = /*#__PURE__*/React.createElement("path", {
    d: "M42 39h-1v-1h1z",
    fill: "#b31b1e"
  })), _path2674 || (_path2674 = /*#__PURE__*/React.createElement("path", {
    d: "M50 38v1h-1v-1z",
    fill: "#9f0e12"
  })), _path2675 || (_path2675 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v-1h1v1z",
    fill: "#b56a72"
  })), _path2676 || (_path2676 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h1v1h-1z",
    fill: "#c8bbb4"
  })), _path2677 || (_path2677 = /*#__PURE__*/React.createElement("path", {
    d: "M52 39v-1h1v1z",
    fill: "#9f332a"
  })), _path2678 || (_path2678 = /*#__PURE__*/React.createElement("path", {
    d: "M54 39h-1v-1h1z",
    fill: "#9e0c06"
  })), _path2679 || (_path2679 = /*#__PURE__*/React.createElement("path", {
    d: "M58 39h-1v-1h1z",
    fill: "#b1151a"
  })), _path2680 || (_path2680 = /*#__PURE__*/React.createElement("path", {
    d: "M66 39h-1v-1h1z",
    fill: "#97090c"
  })), _path2681 || (_path2681 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38v1h-1v-1z",
    fill: "#a21014"
  })), _path2682 || (_path2682 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38h1v1h-1z",
    fill: "#a11d1e"
  })), _path2683 || (_path2683 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39v-1h1v1z",
    fill: "#a62c2e"
  })), _path2684 || (_path2684 = /*#__PURE__*/React.createElement("path", {
    d: "M69 39v-1h1v1z",
    fill: "#a5242b"
  })), _path2685 || (_path2685 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39h-1v-1h1z",
    fill: "#9d1317"
  })), _path2686 || (_path2686 = /*#__PURE__*/React.createElement("path", {
    d: "M71 38h1v1h-1z",
    fill: "#9f1f20"
  })), _path2687 || (_path2687 = /*#__PURE__*/React.createElement("path", {
    d: "M72 39v-1h1v1z",
    fill: "#b66768"
  })), _path2688 || (_path2688 = /*#__PURE__*/React.createElement("path", {
    d: "M73 38h1v1h-1z",
    fill: "#c3bdb6"
  })), _path2689 || (_path2689 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39v-1h1v1z",
    fill: "#c4c1bc"
  })), _path2690 || (_path2690 = /*#__PURE__*/React.createElement("path", {
    d: "M77 39h-1v-1h1z",
    fill: "#bdc2b9"
  })), _path2691 || (_path2691 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39h-1v-1h1z",
    fill: "#bfbfb9"
  })), _path2692 || (_path2692 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38h1v1h-1z",
    fill: "#cebcba"
  })), _path2693 || (_path2693 = /*#__PURE__*/React.createElement("path", {
    d: "M82 38h1v1h-1z",
    fill: "#bb454a"
  })), _path2694 || (_path2694 = /*#__PURE__*/React.createElement("path", {
    d: "M84 38h1v1h-1z",
    fill: "#c41d25"
  })), _path2695 || (_path2695 = /*#__PURE__*/React.createElement("path", {
    d: "M91 39h-1v-1h1z",
    fill: "#c15c5c"
  })), _path2696 || (_path2696 = /*#__PURE__*/React.createElement("path", {
    d: "M91 38h1v1h-1z",
    fill: "#c15961"
  })), _path2697 || (_path2697 = /*#__PURE__*/React.createElement("path", {
    d: "M92 38h1v1h-1z",
    fill: "#ba3238"
  })), _path2698 || (_path2698 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38h1v1h-1z",
    fill: "#ba5656"
  })), _path2699 || (_path2699 = /*#__PURE__*/React.createElement("path", {
    d: "M96 39h-1v-1h1z",
    fill: "#b7746f"
  })), _path2700 || (_path2700 = /*#__PURE__*/React.createElement("path", {
    d: "M96 38h1v1h-1z",
    fill: "#cfaca7",
    fillOpacity: 0.78
  })), _path2701 || (_path2701 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40v-1h1v1z",
    fill: "#e3c6b8",
    fillOpacity: 0.553
  })), _path2702 || (_path2702 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v1h-1v-1z",
    fill: "#c57d72"
  })), _path2703 || (_path2703 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39h1v1h-1z",
    fill: "#b2504b"
  })), _path2704 || (_path2704 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v-1h1v1z",
    fill: "#b1393a"
  })), _path2705 || (_path2705 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39v1h-1v-1z",
    fill: "#b9393c"
  })), _path2706 || (_path2706 = /*#__PURE__*/React.createElement("path", {
    d: "M37 40v-1h1v1z",
    fill: "#ba2b2a"
  })), _path2707 || (_path2707 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39v1h-1v-1z",
    fill: "#b62123"
  })), _path2708 || (_path2708 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39v1h-1v-1z",
    fill: "#b61e21"
  })), _path2709 || (_path2709 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v1h-1v-1z",
    fill: "#a40b10"
  })), _path2710 || (_path2710 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39v1h-1v-1z",
    fill: "#aa4d56"
  })), _path2711 || (_path2711 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39h1v1h-1z",
    fill: "#c9b4ad"
  })), _path2712 || (_path2712 = /*#__PURE__*/React.createElement("path", {
    d: "M53 39v1h-1v-1z",
    fill: "#9a2726"
  })), _path2713 || (_path2713 = /*#__PURE__*/React.createElement("path", {
    d: "M53 40v-1h1v1z",
    fill: "#990608"
  })), _path2714 || (_path2714 = /*#__PURE__*/React.createElement("path", {
    d: "M54 40v-1h1v1z",
    fill: "#a10c10"
  })), _path2715 || (_path2715 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40h-1v-1h1z",
    fill: "#a71011"
  })), _path2716 || (_path2716 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39h1v1h-1z",
    fill: "#96050a"
  })), _path2717 || (_path2717 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40h-1v-1h1z",
    fill: "#a1393e"
  })), _path2718 || (_path2718 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h-1v-1h1z",
    fill: "#c59c99"
  })), _path2719 || (_path2719 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39h1v1h-1z",
    fill: "#cfb3ab"
  })), _path2720 || (_path2720 = /*#__PURE__*/React.createElement("path", {
    d: "M70 40h-1v-1h1z",
    fill: "#cda8a8"
  })), _path2721 || (_path2721 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39v1h-1v-1z",
    fill: "#cc9191"
  })), _path2722 || (_path2722 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40v-1h1v1z",
    fill: "#ab5e5b"
  })), _path2723 || (_path2723 = /*#__PURE__*/React.createElement("path", {
    d: "M72 40v-1h1v1z",
    fill: "#982c36"
  })), _path2724 || (_path2724 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40h-1v-1h1z",
    fill: "#c09592"
  })), _path2725 || (_path2725 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39h1v1h-1z",
    fill: "#a46568"
  })), _path2726 || (_path2726 = /*#__PURE__*/React.createElement("path", {
    d: "M75 40v-1h1v1z",
    fill: "#b6827e"
  })), _path2727 || (_path2727 = /*#__PURE__*/React.createElement("path", {
    d: "M76 39h1v1h-1z",
    fill: "#c7b0a9"
  })), _path2728 || (_path2728 = /*#__PURE__*/React.createElement("path", {
    d: "M77 40v-1h1v1z",
    fill: "#c8c1bd"
  })), _path2729 || (_path2729 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40h-1v-1h1z",
    fill: "#c6c5c1"
  })), _path2730 || (_path2730 = /*#__PURE__*/React.createElement("path", {
    d: "M81 40h-1v-1h1z",
    fill: "#c7cac3"
  })), _path2731 || (_path2731 = /*#__PURE__*/React.createElement("path", {
    d: "M82 39v1h-1v-1z",
    fill: "#cea3a4"
  })), _path2732 || (_path2732 = /*#__PURE__*/React.createElement("path", {
    d: "M83 40h-1v-1h1z",
    fill: "#b82c35"
  })), _path2733 || (_path2733 = /*#__PURE__*/React.createElement("path", {
    d: "M84 39v1h-1v-1z",
    fill: "#c01c23"
  })), _path2734 || (_path2734 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39h1v1h-1z",
    fill: "#bd2124"
  })), _path2735 || (_path2735 = /*#__PURE__*/React.createElement("path", {
    d: "M90 39h1v1h-1z",
    fill: "#c04f51"
  })), _path2736 || (_path2736 = /*#__PURE__*/React.createElement("path", {
    d: "M91 39h1v1h-1z",
    fill: "#c35d64"
  })), _path2737 || (_path2737 = /*#__PURE__*/React.createElement("path", {
    d: "M92 40v-1h1v1z",
    fill: "#b83339"
  })), _path2738 || (_path2738 = /*#__PURE__*/React.createElement("path", {
    d: "M95 39v1h-1v-1z",
    fill: "#b95554"
  })), _path2739 || (_path2739 = /*#__PURE__*/React.createElement("path", {
    d: "M96 40h-1v-1h1z",
    fill: "#b4716c"
  })), _path2740 || (_path2740 = /*#__PURE__*/React.createElement("path", {
    d: "M97 39v1h-1v-1z",
    fill: "#cdaca5",
    fillOpacity: 0.784
  })), _path2741 || (_path2741 = /*#__PURE__*/React.createElement("path", {
    d: "M31 41v-1h1v1z",
    fill: "#e3c6b9",
    fillOpacity: 0.549
  })), _path2742 || (_path2742 = /*#__PURE__*/React.createElement("path", {
    d: "M32 40h1v1h-1z",
    fill: "#c47d71"
  })), _path2743 || (_path2743 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v1h-1v-1z",
    fill: "#af4c47"
  })), _path2744 || (_path2744 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v-1h1v1z",
    fill: "#b1373a"
  })), _path2745 || (_path2745 = /*#__PURE__*/React.createElement("path", {
    d: "M36 40v1h-1v-1z",
    fill: "#b7363b"
  })), _path2746 || (_path2746 = /*#__PURE__*/React.createElement("path", {
    d: "M38 41h-1v-1h1z",
    fill: "#bb2a2a"
  })), _path2747 || (_path2747 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v-1h1v1z",
    fill: "#ad161a"
  })), _path2748 || (_path2748 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h1v1h-1z",
    fill: "#a60d11"
  })), _path2749 || (_path2749 = /*#__PURE__*/React.createElement("path", {
    d: "M50 41v-1h1v1z",
    fill: "#9f2733"
  })), _path2750 || (_path2750 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41h-1v-1h1z",
    fill: "#c7aba6"
  })), _path2751 || (_path2751 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v-1h1v1z",
    fill: "#ac7471"
  })), _path2752 || (_path2752 = /*#__PURE__*/React.createElement("path", {
    d: "M53 41v-1h1v1z",
    fill: "#a55d5c"
  })), _path2753 || (_path2753 = /*#__PURE__*/React.createElement("path", {
    d: "M55 41h-1v-1h1z",
    fill: "#a24a4b"
  })), _path2754 || (_path2754 = /*#__PURE__*/React.createElement("path", {
    d: "M55 40h1v1h-1z",
    fill: "#9c2829"
  })), _path2755 || (_path2755 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h-1v-1h1z",
    fill: "#a21215"
  })), _path2756 || (_path2756 = /*#__PURE__*/React.createElement("path", {
    d: "M59 41h-1v-1h1z",
    fill: "#af1418"
  })), _path2757 || (_path2757 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v1h-1v-1z",
    fill: "#ae1418"
  })), _path2758 || (_path2758 = /*#__PURE__*/React.createElement("path", {
    d: "M62 40v1h-1v-1z",
    fill: "#aa1215"
  })), _path2759 || (_path2759 = /*#__PURE__*/React.createElement("path", {
    d: "M65 40h1v1h-1z",
    fill: "#8d080c"
  })), _path2760 || (_path2760 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40v1h-1v-1z",
    fill: "#bc8385"
  })), _path2761 || (_path2761 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41v-1h1v1z",
    fill: "#cbb5b5"
  })), _path2762 || (_path2762 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h1v1h-1z",
    fill: "#ac5554"
  })), _path2763 || (_path2763 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41v-1h1v1z",
    fill: "#a93f3d"
  })), _path2764 || (_path2764 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41v-1h1v1z",
    fill: "#b55e5b"
  })), _path2765 || (_path2765 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40h1v1h-1z",
    fill: "#c7938f"
  })), _path2766 || (_path2766 = /*#__PURE__*/React.createElement("path", {
    d: "M73 40v1h-1v-1z",
    fill: "#c9a2a4"
  })), _path2767 || (_path2767 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40v1h-1v-1z",
    fill: "#c4aaa8"
  })), _path2768 || (_path2768 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v-1h1v1z",
    fill: "#973d40"
  })), _path2769 || (_path2769 = /*#__PURE__*/React.createElement("path", {
    d: "M76 40v1h-1v-1z",
    fill: "#8c090d"
  })), _path2770 || (_path2770 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v-1h1v1z",
    fill: "#a02727"
  })), _path2771 || (_path2771 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40v1h-1v-1z",
    fill: "#ab4e4d"
  })), _path2772 || (_path2772 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40h1v1h-1z",
    fill: "#ba716e"
  })), _path2773 || (_path2773 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40v1h-1v-1z",
    fill: "#cd8683"
  })), _path2774 || (_path2774 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40h1v1h-1z",
    fill: "#c87d78"
  })), _path2775 || (_path2775 = /*#__PURE__*/React.createElement("path", {
    d: "M83 41h-1v-1h1z",
    fill: "#be1c25"
  })), _path2776 || (_path2776 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41v-1h1v1z",
    fill: "#bb2425"
  })), _path2777 || (_path2777 = /*#__PURE__*/React.createElement("path", {
    d: "M91 40v1h-1v-1z",
    fill: "#bc4345"
  })), _path2778 || (_path2778 = /*#__PURE__*/React.createElement("path", {
    d: "M92 40v1h-1v-1z",
    fill: "#c66266"
  })), _path2779 || (_path2779 = /*#__PURE__*/React.createElement("path", {
    d: "M92 41v-1h1v1z",
    fill: "#b63339"
  })), _path2780 || (_path2780 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41v-1h1v1z",
    fill: "#b85253"
  })), _path2781 || (_path2781 = /*#__PURE__*/React.createElement("path", {
    d: "M96 40v1h-1v-1z",
    fill: "#b37470"
  })), _path2782 || (_path2782 = /*#__PURE__*/React.createElement("path", {
    d: "M96 41v-1h1v1z",
    fill: "#d9bfba",
    fillOpacity: 0.773
  })), _path2783 || (_path2783 = /*#__PURE__*/React.createElement("path", {
    d: "M32 41v1h-1v-1z",
    fill: "#e5c6b7",
    fillOpacity: 0.549
  })), _path2784 || (_path2784 = /*#__PURE__*/React.createElement("path", {
    d: "M33 41v1h-1v-1z",
    fill: "#c47c6f"
  })), _path2785 || (_path2785 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v1h-1v-1z",
    fill: "#b04843"
  })), _path2786 || (_path2786 = /*#__PURE__*/React.createElement("path", {
    d: "M35 41v1h-1v-1z",
    fill: "#b13638"
  })), _path2787 || (_path2787 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42h-1v-1h1z",
    fill: "#b83239"
  })), _path2788 || (_path2788 = /*#__PURE__*/React.createElement("path", {
    d: "M36 41h1v1h-1z",
    fill: "#ba3031"
  })), _path2789 || (_path2789 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41v1h-1v-1z",
    fill: "#b72425"
  })), _path2790 || (_path2790 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h1v1h-1z",
    fill: "#b72022"
  })), _path2791 || (_path2791 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v1h-1v-1z",
    fill: "#b0181b"
  })), _path2792 || (_path2792 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h-1v-1h1z",
    fill: "#a81314"
  })), _path2793 || (_path2793 = /*#__PURE__*/React.createElement("path", {
    d: "M49 41h1v1h-1z",
    fill: "#a50e10"
  })), _path2794 || (_path2794 = /*#__PURE__*/React.createElement("path", {
    d: "M51 41v1h-1v-1z",
    fill: "#9a2432"
  })), _path2795 || (_path2795 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v1h-1v-1z",
    fill: "#c2adaa"
  })), _path2796 || (_path2796 = /*#__PURE__*/React.createElement("path", {
    d: "M53 42h-1v-1h1z",
    fill: "#c0b6ad"
  })), _path2797 || (_path2797 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h-1v-1h1z",
    fill: "#be9592"
  })), _path2798 || (_path2798 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42v-1h1v1z",
    fill: "#cbaaa5"
  })), _path2799 || (_path2799 = /*#__PURE__*/React.createElement("path", {
    d: "M55 42v-1h1v1z",
    fill: "#c9aca7"
  })), _path2800 || (_path2800 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41v1h-1v-1z",
    fill: "#ba7f7a"
  })), _path2801 || (_path2801 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h1v1h-1z",
    fill: "#a73536"
  })), _path2802 || (_path2802 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h-1v-1h1z",
    fill: "#a61215"
  })), _path2803 || (_path2803 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41h1v1h-1z",
    fill: "#9d0b0f"
  })), _path2804 || (_path2804 = /*#__PURE__*/React.createElement("path", {
    d: "M64 42h-1v-1h1z",
    fill: "#97080f"
  })), _path2805 || (_path2805 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42h-1v-1h1z",
    fill: "#92080c"
  })), _path2806 || (_path2806 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42h-1v-1h1z",
    fill: "#8e090e"
  })), _path2807 || (_path2807 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42v-1h1v1z",
    fill: "#be918f"
  })), _path2808 || (_path2808 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41h1v1h-1z",
    fill: "#c3a8a5"
  })), _path2809 || (_path2809 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v-1h1v1z",
    fill: "#a21d22"
  })), _path2810 || (_path2810 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41h1v1h-1z",
    fill: "#ad0e0d"
  })), _path2811 || (_path2811 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41h1v1h-1z",
    fill: "#ac0f10"
  })), _path2812 || (_path2812 = /*#__PURE__*/React.createElement("path", {
    d: "M72 42h-1v-1h1z",
    fill: "#a21617"
  })), _path2813 || (_path2813 = /*#__PURE__*/React.createElement("path", {
    d: "M73 41v1h-1v-1z",
    fill: "#a85056"
  })), _path2814 || (_path2814 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v1h-1v-1z",
    fill: "#c9b9b7"
  })), _path2815 || (_path2815 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41h1v1h-1z",
    fill: "#c4a49f"
  })), _path2816 || (_path2816 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v1h-1v-1z",
    fill: "#a14e4f"
  })), _path2817 || (_path2817 = /*#__PURE__*/React.createElement("path", {
    d: "M77 41v1h-1v-1z",
    fill: "#921114"
  })), _path2818 || (_path2818 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42h-1v-1h1z",
    fill: "#9f080c"
  })), _path2819 || (_path2819 = /*#__PURE__*/React.createElement("path", {
    d: "M79 41h1v1h-1z",
    fill: "#b9181e"
  })), _path2820 || (_path2820 = /*#__PURE__*/React.createElement("path", {
    d: "M88 42v-1h1v1z",
    fill: "#bf2427"
  })), _path2821 || (_path2821 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41h1v1h-1z",
    fill: "#bc2328"
  })), _path2822 || (_path2822 = /*#__PURE__*/React.createElement("path", {
    d: "M91 42h-1v-1h1z",
    fill: "#ba3a3c"
  })), _path2823 || (_path2823 = /*#__PURE__*/React.createElement("path", {
    d: "M92 41v1h-1v-1z",
    fill: "#c56566"
  })), _path2824 || (_path2824 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41h1v1h-1z",
    fill: "#b84e51"
  })), _path2825 || (_path2825 = /*#__PURE__*/React.createElement("path", {
    d: "M95 42v-1h1v1z",
    fill: "#b16e6d"
  })), _path2826 || (_path2826 = /*#__PURE__*/React.createElement("path", {
    d: "M97 41v1h-1v-1z",
    fill: "#d4c1bb",
    fillOpacity: 0.78
  })), _path2827 || (_path2827 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42v1h-1v-1z",
    fill: "#b04541"
  })), _path2828 || (_path2828 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42h1v1h-1z",
    fill: "#b23637"
  })), _path2829 || (_path2829 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42v1h-1v-1z",
    fill: "#b83137"
  })), _path2830 || (_path2830 = /*#__PURE__*/React.createElement("path", {
    d: "M36 43v-1h1v1z",
    fill: "#b83030"
  })), _path2831 || (_path2831 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43h-1v-1h1z",
    fill: "#b82b29"
  })), _path2832 || (_path2832 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42h1v1h-1z",
    fill: "#b61f20"
  })), _path2833 || (_path2833 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h-1v-1h1z",
    fill: "#b51b1e"
  })), _path2834 || (_path2834 = /*#__PURE__*/React.createElement("path", {
    d: "M51 42v1h-1v-1z",
    fill: "#aa6063"
  })), _path2835 || (_path2835 = /*#__PURE__*/React.createElement("path", {
    d: "M51 43v-1h1v1z",
    fill: "#c5acaa"
  })), _path2836 || (_path2836 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h-1v-1h1z",
    fill: "#c2a09c"
  })), _path2837 || (_path2837 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43v-1h1v1z",
    fill: "#932a2c"
  })), _path2838 || (_path2838 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h1v1h-1z",
    fill: "#9a201e"
  })), _path2839 || (_path2839 = /*#__PURE__*/React.createElement("path", {
    d: "M56 42v1h-1v-1z",
    fill: "#ac4b4a"
  })), _path2840 || (_path2840 = /*#__PURE__*/React.createElement("path", {
    d: "M56 43v-1h1v1z",
    fill: "#c58e8c"
  })), _path2841 || (_path2841 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v-1h1v1z",
    fill: "#d4aeab"
  })), _path2842 || (_path2842 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43v-1h1v1z",
    fill: "#b57069"
  })), _path2843 || (_path2843 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h1v1h-1z",
    fill: "#9e2120"
  })), _path2844 || (_path2844 = /*#__PURE__*/React.createElement("path", {
    d: "M63 42v1h-1v-1z",
    fill: "#9e0b0e"
  })), _path2845 || (_path2845 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43v-1h1v1z",
    fill: "#950a0e"
  })), _path2846 || (_path2846 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42v1h-1v-1z",
    fill: "#93080e"
  })), _path2847 || (_path2847 = /*#__PURE__*/React.createElement("path", {
    d: "M65 43v-1h1v1z",
    fill: "#8e040a"
  })), _path2848 || (_path2848 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h-1v-1h1z",
    fill: "#b06868"
  })), _path2849 || (_path2849 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v1h-1v-1z",
    fill: "#d0c3be"
  })), _path2850 || (_path2850 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h-1v-1h1z",
    fill: "#b56966"
  })), _path2851 || (_path2851 = /*#__PURE__*/React.createElement("path", {
    d: "M70 42v1h-1v-1z",
    fill: "#a11515"
  })), _path2852 || (_path2852 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43v-1h1v1z",
    fill: "#a30d16"
  })), _path2853 || (_path2853 = /*#__PURE__*/React.createElement("path", {
    d: "M72 43v-1h1v1z",
    fill: "#b16164"
  })), _path2854 || (_path2854 = /*#__PURE__*/React.createElement("path", {
    d: "M74 43h-1v-1h1z",
    fill: "#c29593"
  })), _path2855 || (_path2855 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43h-1v-1h1z",
    fill: "#a65d5f"
  })), _path2856 || (_path2856 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43v-1h1v1z",
    fill: "#cea5a6"
  })), _path2857 || (_path2857 = /*#__PURE__*/React.createElement("path", {
    d: "M77 42v1h-1v-1z",
    fill: "#bb8584"
  })), _path2858 || (_path2858 = /*#__PURE__*/React.createElement("path", {
    d: "M77 43v-1h1v1z",
    fill: "#9b252a"
  })), _path2859 || (_path2859 = /*#__PURE__*/React.createElement("path", {
    d: "M79 42v1h-1v-1z",
    fill: "#a90c14"
  })), _path2860 || (_path2860 = /*#__PURE__*/React.createElement("path", {
    d: "M89 42h1v1h-1z",
    fill: "#bd2529"
  })), _path2861 || (_path2861 = /*#__PURE__*/React.createElement("path", {
    d: "M90 42h1v1h-1z",
    fill: "#b83336"
  })), _path2862 || (_path2862 = /*#__PURE__*/React.createElement("path", {
    d: "M91 42h1v1h-1z",
    fill: "#c76566"
  })), _path2863 || (_path2863 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43h-1v-1h1z",
    fill: "#b84f51"
  })), _path2864 || (_path2864 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43h-1v-1h1z",
    fill: "#ad6362"
  })), _path2865 || (_path2865 = /*#__PURE__*/React.createElement("path", {
    d: "M97 43h-1v-1h1z",
    fill: "#d1b1ae",
    fillOpacity: 0.784
  })), _path2866 || (_path2866 = /*#__PURE__*/React.createElement("path", {
    d: "M33 44v-1h1v1z",
    fill: "#af413d"
  })), _path2867 || (_path2867 = /*#__PURE__*/React.createElement("path", {
    d: "M35 43v1h-1v-1z",
    fill: "#b23435"
  })), _path2868 || (_path2868 = /*#__PURE__*/React.createElement("path", {
    d: "M36 44h-1v-1h1z",
    fill: "#b83035"
  })), _path2869 || (_path2869 = /*#__PURE__*/React.createElement("path", {
    d: "M37 44h-1v-1h1z",
    fill: "#b82f2d"
  })), _path2870 || (_path2870 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43v1h-1v-1z",
    fill: "#b82928"
  })), _path2871 || (_path2871 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43v1h-1v-1z",
    fill: "#b82223"
  })), _path2872 || (_path2872 = /*#__PURE__*/React.createElement("path", {
    d: "M41 43v1h-1v-1z",
    fill: "#b92425"
  })), _path2873 || (_path2873 = /*#__PURE__*/React.createElement("path", {
    d: "M49 43h1v1h-1z",
    fill: "#990c0f"
  })), _path2874 || (_path2874 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44v-1h1v1z",
    fill: "#b97e81"
  })), _path2875 || (_path2875 = /*#__PURE__*/React.createElement("path", {
    d: "M52 43v1h-1v-1z",
    fill: "#b37f80"
  })), _path2876 || (_path2876 = /*#__PURE__*/React.createElement("path", {
    d: "M53 44h-1v-1h1z",
    fill: "#b17372"
  })), _path2877 || (_path2877 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h1v1h-1z",
    fill: "#be847b"
  })), _path2878 || (_path2878 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h-1v-1h1z",
    fill: "#980f0b"
  })), _path2879 || (_path2879 = /*#__PURE__*/React.createElement("path", {
    d: "M55 43h1v1h-1z",
    fill: "#a30e09"
  })), _path2880 || (_path2880 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v1h-1v-1z",
    fill: "#9f1318"
  })), _path2881 || (_path2881 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44h-1v-1h1z",
    fill: "#ab464b"
  })), _path2882 || (_path2882 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43h1v1h-1z",
    fill: "#c6a199"
  })), _path2883 || (_path2883 = /*#__PURE__*/React.createElement("path", {
    d: "M59 44v-1h1v1z",
    fill: "#c89a9a"
  })), _path2884 || (_path2884 = /*#__PURE__*/React.createElement("path", {
    d: "M60 43h1v1h-1z",
    fill: "#a33138"
  })), _path2885 || (_path2885 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43v1h-1v-1z",
    fill: "#9d0f11"
  })), _path2886 || (_path2886 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44h-1v-1h1z",
    fill: "#92080d"
  })), _path2887 || (_path2887 = /*#__PURE__*/React.createElement("path", {
    d: "M66 43v1h-1v-1z",
    fill: "#95050d"
  })), _path2888 || (_path2888 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43v1h-1v-1z",
    fill: "#9d282f"
  })), _path2889 || (_path2889 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h1v1h-1z",
    fill: "#cbaead"
  })), _path2890 || (_path2890 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43v1h-1v-1z",
    fill: "#c4c0b8"
  })), _path2891 || (_path2891 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h1v1h-1z",
    fill: "#b7817c"
  })), _path2892 || (_path2892 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43h1v1h-1z",
    fill: "#ac5257"
  })), _path2893 || (_path2893 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43h1v1h-1z",
    fill: "#b87676"
  })), _path2894 || (_path2894 = /*#__PURE__*/React.createElement("path", {
    d: "M73 43v1h-1v-1z",
    fill: "#d1aba3"
  })), _path2895 || (_path2895 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44v-1h1v1z",
    fill: "#aa3942"
  })), _path2896 || (_path2896 = /*#__PURE__*/React.createElement("path", {
    d: "M74 44v-1h1v1z",
    fill: "#9b060b"
  })), _path2897 || (_path2897 = /*#__PURE__*/React.createElement("path", {
    d: "M76 43v1h-1v-1z",
    fill: "#9d2729"
  })), _path2898 || (_path2898 = /*#__PURE__*/React.createElement("path", {
    d: "M77 44h-1v-1h1z",
    fill: "#c88d8a"
  })), _path2899 || (_path2899 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44h-1v-1h1z",
    fill: "#c6a6a3"
  })), _path2900 || (_path2900 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44v-1h1v1z",
    fill: "#a23a3d"
  })), _path2901 || (_path2901 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44h-1v-1h1z",
    fill: "#b6141f"
  })), _path2902 || (_path2902 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43v1h-1v-1z",
    fill: "#bf1d23"
  })), _path2903 || (_path2903 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v-1h1v1z",
    fill: "#b92e32"
  })), _path2904 || (_path2904 = /*#__PURE__*/React.createElement("path", {
    d: "M91 44v-1h1v1z",
    fill: "#c86466"
  })), _path2905 || (_path2905 = /*#__PURE__*/React.createElement("path", {
    d: "M92 43h1v1h-1z",
    fill: "#b8363d"
  })), _path2906 || (_path2906 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43v1h-1v-1z",
    fill: "#b84f4f"
  })), _path2907 || (_path2907 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43v1h-1v-1z",
    fill: "#af6362"
  })), _path2908 || (_path2908 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43h1v1h-1z",
    fill: "#d4b1ae",
    fillOpacity: 0.784
  })), _path2909 || (_path2909 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45v-1h1v1z",
    fill: "#c47a6d"
  })), _path2910 || (_path2910 = /*#__PURE__*/React.createElement("path", {
    d: "M34 44v1h-1v-1z",
    fill: "#ae3d39"
  })), _path2911 || (_path2911 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v-1h1v1z",
    fill: "#b33234"
  })), _path2912 || (_path2912 = /*#__PURE__*/React.createElement("path", {
    d: "M35 44h1v1h-1z",
    fill: "#b72d32"
  })), _path2913 || (_path2913 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45h-1v-1h1z",
    fill: "#b72d2b"
  })), _path2914 || (_path2914 = /*#__PURE__*/React.createElement("path", {
    d: "M38 44h1v1h-1z",
    fill: "#b62223"
  })), _path2915 || (_path2915 = /*#__PURE__*/React.createElement("path", {
    d: "M40 45h-1v-1h1z",
    fill: "#b62021"
  })), _path2916 || (_path2916 = /*#__PURE__*/React.createElement("path", {
    d: "M41 44v1h-1v-1z",
    fill: "#b31e1e"
  })), _path2917 || (_path2917 = /*#__PURE__*/React.createElement("path", {
    d: "M48 45v-1h1v1z",
    fill: "#a30e0e"
  })), _path2918 || (_path2918 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45h-1v-1h1z",
    fill: "#980b0d"
  })), _path2919 || (_path2919 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44h1v1h-1z",
    fill: "#b97d81"
  })), _path2920 || (_path2920 = /*#__PURE__*/React.createElement("path", {
    d: "M51 45v-1h1v1z",
    fill: "#bfa094"
  })), _path2921 || (_path2921 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45h-1v-1h1z",
    fill: "#91282d"
  })), _path2922 || (_path2922 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45v-1h1v1z",
    fill: "#ca9b9b"
  })), _path2923 || (_path2923 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44v1h-1v-1z",
    fill: "#b0605c"
  })), _path2924 || (_path2924 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44v1h-1v-1z",
    fill: "#a81014"
  })), _path2925 || (_path2925 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45v-1h1v1z",
    fill: "#a52025"
  })), _path2926 || (_path2926 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45v-1h1v1z",
    fill: "#bc8280"
  })), _path2927 || (_path2927 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h-1v-1h1z",
    fill: "#cea9a5"
  })), _path2928 || (_path2928 = /*#__PURE__*/React.createElement("path", {
    d: "M61 44h1v1h-1z",
    fill: "#a03c3f"
  })), _path2929 || (_path2929 = /*#__PURE__*/React.createElement("path", {
    d: "M63 45h-1v-1h1z",
    fill: "#930b0f"
  })), _path2930 || (_path2930 = /*#__PURE__*/React.createElement("path", {
    d: "M64 45h-1v-1h1z",
    fill: "#96090a"
  })), _path2931 || (_path2931 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44v1h-1v-1z",
    fill: "#93080b"
  })), _path2932 || (_path2932 = /*#__PURE__*/React.createElement("path", {
    d: "M68 44v1h-1v-1z",
    fill: "#b35a5b"
  })), _path2933 || (_path2933 = /*#__PURE__*/React.createElement("path", {
    d: "M69 44h1v1h-1z",
    fill: "#c2c5bd"
  })), _path2934 || (_path2934 = /*#__PURE__*/React.createElement("path", {
    d: "M72 44v1h-1v-1z",
    fill: "#c6b6b0"
  })), _path2935 || (_path2935 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v-1h1v1z",
    fill: "#a6494b"
  })), _path2936 || (_path2936 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44h1v1h-1z",
    fill: "#9c1112"
  })), _path2937 || (_path2937 = /*#__PURE__*/React.createElement("path", {
    d: "M76 44h1v1h-1z",
    fill: "#96161a"
  })), _path2938 || (_path2938 = /*#__PURE__*/React.createElement("path", {
    d: "M77 45v-1h1v1z",
    fill: "#b97a79"
  })), _path2939 || (_path2939 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v-1h1v1z",
    fill: "#d1ada8"
  })), _path2940 || (_path2940 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44v1h-1v-1z",
    fill: "#b24448"
  })), _path2941 || (_path2941 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h-1v-1h1z",
    fill: "#b91921"
  })), _path2942 || (_path2942 = /*#__PURE__*/React.createElement("path", {
    d: "M82 44v1h-1v-1z",
    fill: "#bd1f25"
  })), _path2943 || (_path2943 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44h1v1h-1z",
    fill: "#b92a2f"
  })), _path2944 || (_path2944 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45h-1v-1h1z",
    fill: "#c96266"
  })), _path2945 || (_path2945 = /*#__PURE__*/React.createElement("path", {
    d: "M93 45h-1v-1h1z",
    fill: "#bb3941"
  })), _path2946 || (_path2946 = /*#__PURE__*/React.createElement("path", {
    d: "M94 45h-1v-1h1z",
    fill: "#bb3f41"
  })), _path2947 || (_path2947 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44v1h-1v-1z",
    fill: "#b54d4c"
  })), _path2948 || (_path2948 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44h1v1h-1z",
    fill: "#af6965"
  })), _path2949 || (_path2949 = /*#__PURE__*/React.createElement("path", {
    d: "M96 45v-1h1v1z",
    fill: "#dec3bd",
    fillOpacity: 0.761
  })), _path2950 || (_path2950 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46v-1h1v1z",
    fill: "#e4c9ba",
    fillOpacity: 0.537
  })), _path2951 || (_path2951 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v1h-1v-1z",
    fill: "#ae3838"
  })), _path2952 || (_path2952 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45h1v1h-1z",
    fill: "#b23334"
  })), _path2953 || (_path2953 = /*#__PURE__*/React.createElement("path", {
    d: "M36 45v1h-1v-1z",
    fill: "#b32e2f"
  })), _path2954 || (_path2954 = /*#__PURE__*/React.createElement("path", {
    d: "M36 46v-1h1v1z",
    fill: "#b72a2b"
  })), _path2955 || (_path2955 = /*#__PURE__*/React.createElement("path", {
    d: "M38 45v1h-1v-1z",
    fill: "#b72625"
  })), _path2956 || (_path2956 = /*#__PURE__*/React.createElement("path", {
    d: "M39 46h-1v-1h1z",
    fill: "#b62222"
  })), _path2957 || (_path2957 = /*#__PURE__*/React.createElement("path", {
    d: "M40 46h-1v-1h1z",
    fill: "#b51f20"
  })), _path2958 || (_path2958 = /*#__PURE__*/React.createElement("path", {
    d: "M46 45h1v1h-1z",
    fill: "#a81213"
  })), _path2959 || (_path2959 = /*#__PURE__*/React.createElement("path", {
    d: "M49 46h-1v-1h1z",
    fill: "#a00d0c"
  })), _path2960 || (_path2960 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45v1h-1v-1z",
    fill: "#9a0809"
  })), _path2961 || (_path2961 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v-1h1v1z",
    fill: "#ab6467"
  })), _path2962 || (_path2962 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45v1h-1v-1z",
    fill: "#cac0b8"
  })), _path2963 || (_path2963 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45h1v1h-1z",
    fill: "#a03c3b"
  })), _path2964 || (_path2964 = /*#__PURE__*/React.createElement("path", {
    d: "M54 46h-1v-1h1z",
    fill: "#9b3537"
  })), _path2965 || (_path2965 = /*#__PURE__*/React.createElement("path", {
    d: "M54 45h1v1h-1z",
    fill: "#cfa9a6"
  })), _path2966 || (_path2966 = /*#__PURE__*/React.createElement("path", {
    d: "M56 45v1h-1v-1z",
    fill: "#ac5650"
  })), _path2967 || (_path2967 = /*#__PURE__*/React.createElement("path", {
    d: "M58 46h-1v-1h1z",
    fill: "#ad1318"
  })), _path2968 || (_path2968 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45h1v1h-1z",
    fill: "#af1214"
  })), _path2969 || (_path2969 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45h1v1h-1z",
    fill: "#a5161c"
  })), _path2970 || (_path2970 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46h-1v-1h1z",
    fill: "#b67674"
  })), _path2971 || (_path2971 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h1v1h-1z",
    fill: "#d1a9a4"
  })), _path2972 || (_path2972 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v-1h1v1z",
    fill: "#962c34"
  })), _path2973 || (_path2973 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46v-1h1v1z",
    fill: "#940607"
  })), _path2974 || (_path2974 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46h-1v-1h1z",
    fill: "#95090d"
  })), _path2975 || (_path2975 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45v1h-1v-1z",
    fill: "#a11212"
  })), _path2976 || (_path2976 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45h1v1h-1z",
    fill: "#a11518"
  })), _path2977 || (_path2977 = /*#__PURE__*/React.createElement("path", {
    d: "M68 45h1v1h-1z",
    fill: "#bd7d7b"
  })), _path2978 || (_path2978 = /*#__PURE__*/React.createElement("path", {
    d: "M69 46v-1h1v1z",
    fill: "#c8c5bf"
  })), _path2979 || (_path2979 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v1h-1v-1z",
    fill: "#c0b7b2"
  })), _path2980 || (_path2980 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45h1v1h-1z",
    fill: "#ac6060"
  })), _path2981 || (_path2981 = /*#__PURE__*/React.createElement("path", {
    d: "M73 45h1v1h-1z",
    fill: "#99181a"
  })), _path2982 || (_path2982 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45v1h-1v-1z",
    fill: "#9e0c10"
  })), _path2983 || (_path2983 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v1h-1v-1z",
    fill: "#971218"
  })), _path2984 || (_path2984 = /*#__PURE__*/React.createElement("path", {
    d: "M79 45v1h-1v-1z",
    fill: "#bf8686"
  })), _path2985 || (_path2985 = /*#__PURE__*/React.createElement("path", {
    d: "M80 46h-1v-1h1z",
    fill: "#d5b0ae"
  })), _path2986 || (_path2986 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45v1h-1v-1z",
    fill: "#b43b40"
  })), _path2987 || (_path2987 = /*#__PURE__*/React.createElement("path", {
    d: "M90 45h1v1h-1z",
    fill: "#bb2931"
  })), _path2988 || (_path2988 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45v1h-1v-1z",
    fill: "#c76063"
  })), _path2989 || (_path2989 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46v-1h1v1z",
    fill: "#bc3e46"
  })), _path2990 || (_path2990 = /*#__PURE__*/React.createElement("path", {
    d: "M93 46v-1h1v1z",
    fill: "#ba4041"
  })), _path2991 || (_path2991 = /*#__PURE__*/React.createElement("path", {
    d: "M95 46h-1v-1h1z",
    fill: "#b64d4c"
  })), _path2992 || (_path2992 = /*#__PURE__*/React.createElement("path", {
    d: "M96 46h-1v-1h1z",
    fill: "#ac6362"
  })), _path2993 || (_path2993 = /*#__PURE__*/React.createElement("path", {
    d: "M96 45h1v1h-1z",
    fill: "#ddc3bd",
    fillOpacity: 0.769
  })), _path2994 || (_path2994 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46h1v1h-1z",
    fill: "#e6cabb",
    fillOpacity: 0.537
  })), _path2995 || (_path2995 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47h-1v-1h1z",
    fill: "#ac3635"
  })), _path2996 || (_path2996 = /*#__PURE__*/React.createElement("path", {
    d: "M35 47h-1v-1h1z",
    fill: "#b13333"
  })), _path2997 || (_path2997 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47h-1v-1h1z",
    fill: "#b22e2d"
  })), _path2998 || (_path2998 = /*#__PURE__*/React.createElement("path", {
    d: "M37 46v1h-1v-1z",
    fill: "#b6292a"
  })), _path2999 || (_path2999 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v-1h1v1z",
    fill: "#b62424"
  })), _path3000 || (_path3000 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47h-1v-1h1z",
    fill: "#b11f1f"
  })), _path3001 || (_path3001 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v1h-1v-1z",
    fill: "#9c0808"
  })), _path3002 || (_path3002 = /*#__PURE__*/React.createElement("path", {
    d: "M51 46v1h-1v-1z",
    fill: "#9e3c41"
  })), _path3003 || (_path3003 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47h-1v-1h1z",
    fill: "#cabfba"
  })), _path3004 || (_path3004 = /*#__PURE__*/React.createElement("path", {
    d: "M52 46h1v1h-1z",
    fill: "#bb9187"
  })), _path3005 || (_path3005 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v-1h1v1z",
    fill: "#8b1211"
  })), _path3006 || (_path3006 = /*#__PURE__*/React.createElement("path", {
    d: "M54 47v-1h1v1z",
    fill: "#a54649"
  })), _path3007 || (_path3007 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46v1h-1v-1z",
    fill: "#d0b0ab"
  })), _path3008 || (_path3008 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46h1v1h-1z",
    fill: "#b15f58"
  })), _path3009 || (_path3009 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46v1h-1v-1z",
    fill: "#9d171d"
  })), _path3010 || (_path3010 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v1h-1v-1z",
    fill: "#bf837e"
  })), _path3011 || (_path3011 = /*#__PURE__*/React.createElement("path", {
    d: "M63 47h-1v-1h1z",
    fill: "#be8e8c"
  })), _path3012 || (_path3012 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46h1v1h-1z",
    fill: "#901112"
  })), _path3013 || (_path3013 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46h1v1h-1z",
    fill: "#93080d"
  })), _path3014 || (_path3014 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46v1h-1v-1z",
    fill: "#96080f"
  })), _path3015 || (_path3015 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47v-1h1v1z",
    fill: "#a21015"
  })), _path3016 || (_path3016 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47v-1h1v1z",
    fill: "#a71c26"
  })), _path3017 || (_path3017 = /*#__PURE__*/React.createElement("path", {
    d: "M69 47v-1h1v1z",
    fill: "#c48989"
  })), _path3018 || (_path3018 = /*#__PURE__*/React.createElement("path", {
    d: "M71 46v1h-1v-1z",
    fill: "#cac5c1"
  })), _path3019 || (_path3019 = /*#__PURE__*/React.createElement("path", {
    d: "M71 47v-1h1v1z",
    fill: "#c2c1bf"
  })), _path3020 || (_path3020 = /*#__PURE__*/React.createElement("path", {
    d: "M73 46v1h-1v-1z",
    fill: "#c7c3bc"
  })), _path3021 || (_path3021 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47v-1h1v1z",
    fill: "#ba8d89"
  })), _path3022 || (_path3022 = /*#__PURE__*/React.createElement("path", {
    d: "M74 46h1v1h-1z",
    fill: "#9c3037"
  })), _path3023 || (_path3023 = /*#__PURE__*/React.createElement("path", {
    d: "M76 47h-1v-1h1z",
    fill: "#980b11"
  })), _path3024 || (_path3024 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46h1v1h-1z",
    fill: "#a00c0b"
  })), _path3025 || (_path3025 = /*#__PURE__*/React.createElement("path", {
    d: "M78 46v1h-1v-1z",
    fill: "#a00c07"
  })), _path3026 || (_path3026 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47h-1v-1h1z",
    fill: "#c99898"
  })), _path3027 || (_path3027 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47v-1h1v1z",
    fill: "#b7242c"
  })), _path3028 || (_path3028 = /*#__PURE__*/React.createElement("path", {
    d: "M83 46v1h-1v-1z",
    fill: "#c41d23"
  })), _path3029 || (_path3029 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46h1v1h-1z",
    fill: "#c01f27"
  })), _path3030 || (_path3030 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47h-1v-1h1z",
    fill: "#ba282e"
  })), _path3031 || (_path3031 = /*#__PURE__*/React.createElement("path", {
    d: "M91 46h1v1h-1z",
    fill: "#c55c5f"
  })), _path3032 || (_path3032 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46h1v1h-1z",
    fill: "#bd434a"
  })), _path3033 || (_path3033 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47h-1v-1h1z",
    fill: "#b74b4c"
  })), _path3034 || (_path3034 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47v-1h1v1z",
    fill: "#a7595a"
  })), _path3035 || (_path3035 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47h-1v-1h1z",
    fill: "#d3b4b1",
    fillOpacity: 0.761
  })), _path3036 || (_path3036 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48h-1v-1h1z",
    fill: "#e6cbbc",
    fillOpacity: 0.541
  })), _path3037 || (_path3037 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48v-1h1v1z",
    fill: "#c47b6c"
  })), _path3038 || (_path3038 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47v1h-1v-1z",
    fill: "#a83532"
  })), _path3039 || (_path3039 = /*#__PURE__*/React.createElement("path", {
    d: "M35 48h-1v-1h1z",
    fill: "#af2f2e"
  })), _path3040 || (_path3040 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47v1h-1v-1z",
    fill: "#b32d2c"
  })), _path3041 || (_path3041 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v1h-1v-1z",
    fill: "#b62928"
  })), _path3042 || (_path3042 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47h1v1h-1z",
    fill: "#b52423"
  })), _path3043 || (_path3043 = /*#__PURE__*/React.createElement("path", {
    d: "M39 48h-1v-1h1z",
    fill: "#b52121"
  })), _path3044 || (_path3044 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47v1h-1v-1z",
    fill: "#b22120"
  })), _path3045 || (_path3045 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48v-1h1v1z",
    fill: "#a50f10"
  })), _path3046 || (_path3046 = /*#__PURE__*/React.createElement("path", {
    d: "M50 48h-1v-1h1z",
    fill: "#9e0b0a"
  })), _path3047 || (_path3047 = /*#__PURE__*/React.createElement("path", {
    d: "M51 48h-1v-1h1z",
    fill: "#98171b"
  })), _path3048 || (_path3048 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47v1h-1v-1z",
    fill: "#c19f9f"
  })), _path3049 || (_path3049 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48v-1h1v1z",
    fill: "#a7564e"
  })), _path3050 || (_path3050 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48v-1h1v1z",
    fill: "#950505"
  })), _path3051 || (_path3051 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48v-1h1v1z",
    fill: "#a94c4f"
  })), _path3052 || (_path3052 = /*#__PURE__*/React.createElement("path", {
    d: "M56 47h1v1h-1z",
    fill: "#d3b0ae"
  })), _path3053 || (_path3053 = /*#__PURE__*/React.createElement("path", {
    d: "M58 47v1h-1v-1z",
    fill: "#ba7d75"
  })), _path3054 || (_path3054 = /*#__PURE__*/React.createElement("path", {
    d: "M59 48h-1v-1h1z",
    fill: "#a32228"
  })), _path3055 || (_path3055 = /*#__PURE__*/React.createElement("path", {
    d: "M61 47v1h-1v-1z",
    fill: "#aa0e15"
  })), _path3056 || (_path3056 = /*#__PURE__*/React.createElement("path", {
    d: "M61 48v-1h1v1z",
    fill: "#a1252d"
  })), _path3057 || (_path3057 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v-1h1v1z",
    fill: "#c8a5a4"
  })), _path3058 || (_path3058 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48h-1v-1h1z",
    fill: "#a03c3c"
  })), _path3059 || (_path3059 = /*#__PURE__*/React.createElement("path", {
    d: "M65 47v1h-1v-1z",
    fill: "#93040a"
  })), _path3060 || (_path3060 = /*#__PURE__*/React.createElement("path", {
    d: "M66 48h-1v-1h1z",
    fill: "#940a0f"
  })), _path3061 || (_path3061 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h-1v-1h1z",
    fill: "#ac1115"
  })), _path3062 || (_path3062 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47h1v1h-1z",
    fill: "#a61115"
  })), _path3063 || (_path3063 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48h-1v-1h1z",
    fill: "#a51e28"
  })), _path3064 || (_path3064 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48v-1h1v1z",
    fill: "#c18787"
  })), _path3065 || (_path3065 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47v1h-1v-1z",
    fill: "#c7c5be"
  })), _path3066 || (_path3066 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47h1v1h-1z",
    fill: "#bfc2bf"
  })), _path3067 || (_path3067 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47h1v1h-1z",
    fill: "#c5c4c2"
  })), _path3068 || (_path3068 = /*#__PURE__*/React.createElement("path", {
    d: "M75 47v1h-1v-1z",
    fill: "#c5b1b0"
  })), _path3069 || (_path3069 = /*#__PURE__*/React.createElement("path", {
    d: "M75 48v-1h1v1z",
    fill: "#ab7171"
  })), _path3070 || (_path3070 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48v-1h1v1z",
    fill: "#963334"
  })), _path3071 || (_path3071 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47v1h-1v-1z",
    fill: "#951516"
  })), _path3072 || (_path3072 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47h1v1h-1z",
    fill: "#941a1d"
  })), _path3073 || (_path3073 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47v1h-1v-1z",
    fill: "#c19da1"
  })), _path3074 || (_path3074 = /*#__PURE__*/React.createElement("path", {
    d: "M81 48h-1v-1h1z",
    fill: "#cdcac7"
  })), _path3075 || (_path3075 = /*#__PURE__*/React.createElement("path", {
    d: "M82 47v1h-1v-1z",
    fill: "#bd6466"
  })), _path3076 || (_path3076 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v1h-1v-1z",
    fill: "#be1b23"
  })), _path3077 || (_path3077 = /*#__PURE__*/React.createElement("path", {
    d: "M85 47h1v1h-1z",
    fill: "#c02029"
  })), _path3078 || (_path3078 = /*#__PURE__*/React.createElement("path", {
    d: "M90 48h-1v-1h1z",
    fill: "#bd272b"
  })), _path3079 || (_path3079 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47v1h-1v-1z",
    fill: "#ba272c"
  })), _path3080 || (_path3080 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47h1v1h-1z",
    fill: "#c5585b"
  })), _path3081 || (_path3081 = /*#__PURE__*/React.createElement("path", {
    d: "M93 47v1h-1v-1z",
    fill: "#bd494d"
  })), _path3082 || (_path3082 = /*#__PURE__*/React.createElement("path", {
    d: "M94 47v1h-1v-1z",
    fill: "#bd4043"
  })), _path3083 || (_path3083 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v-1h1v1z",
    fill: "#b74a4b"
  })), _path3084 || (_path3084 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47h1v1h-1z",
    fill: "#ab585a"
  })), _path3085 || (_path3085 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48h1v1h-1z",
    fill: "#e7c9bb",
    fillOpacity: 0.545
  })), _path3086 || (_path3086 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v-1h1v1z",
    fill: "#c67d6e"
  })), _path3087 || (_path3087 = /*#__PURE__*/React.createElement("path", {
    d: "M33 49v-1h1v1z",
    fill: "#a73530"
  })), _path3088 || (_path3088 = /*#__PURE__*/React.createElement("path", {
    d: "M34 48h1v1h-1z",
    fill: "#ac2b2a"
  })), _path3089 || (_path3089 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49v-1h1v1z",
    fill: "#b12b28"
  })), _path3090 || (_path3090 = /*#__PURE__*/React.createElement("path", {
    d: "M36 48h1v1h-1z",
    fill: "#b32725"
  })), _path3091 || (_path3091 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48v1h-1v-1z",
    fill: "#b22221"
  })), _path3092 || (_path3092 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49v-1h1v1z",
    fill: "#990909"
  })), _path3093 || (_path3093 = /*#__PURE__*/React.createElement("path", {
    d: "M52 48v1h-1v-1z",
    fill: "#b1626b"
  })), _path3094 || (_path3094 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48h1v1h-1z",
    fill: "#c4aea0"
  })), _path3095 || (_path3095 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48h1v1h-1z",
    fill: "#982d2c"
  })), _path3096 || (_path3096 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48h1v1h-1z",
    fill: "#9a090f"
  })), _path3097 || (_path3097 = /*#__PURE__*/React.createElement("path", {
    d: "M57 48v1h-1v-1z",
    fill: "#ab3740"
  })), _path3098 || (_path3098 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49v-1h1v1z",
    fill: "#c59b95"
  })), _path3099 || (_path3099 = /*#__PURE__*/React.createElement("path", {
    d: "M59 49h-1v-1h1z",
    fill: "#c8a79d"
  })), _path3100 || (_path3100 = /*#__PURE__*/React.createElement("path", {
    d: "M60 49h-1v-1h1z",
    fill: "#a95b58"
  })), _path3101 || (_path3101 = /*#__PURE__*/React.createElement("path", {
    d: "M60 48h1v1h-1z",
    fill: "#9c2427"
  })), _path3102 || (_path3102 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v1h-1v-1z",
    fill: "#92191e"
  })), _path3103 || (_path3103 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h-1v-1h1z",
    fill: "#bc9493"
  })), _path3104 || (_path3104 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49v-1h1v1z",
    fill: "#ab5755"
  })), _path3105 || (_path3105 = /*#__PURE__*/React.createElement("path", {
    d: "M64 49v-1h1v1z",
    fill: "#8f050a"
  })), _path3106 || (_path3106 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h1v1h-1z",
    fill: "#ab1317"
  })), _path3107 || (_path3107 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49v-1h1v1z",
    fill: "#a31a1f"
  })), _path3108 || (_path3108 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49v-1h1v1z",
    fill: "#b87675"
  })), _path3109 || (_path3109 = /*#__PURE__*/React.createElement("path", {
    d: "M73 48v1h-1v-1z",
    fill: "#cac2bc"
  })), _path3110 || (_path3110 = /*#__PURE__*/React.createElement("path", {
    d: "M76 49h-1v-1h1z",
    fill: "#c5c4be"
  })), _path3111 || (_path3111 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48h1v1h-1z",
    fill: "#c2b7b2"
  })), _path3112 || (_path3112 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h-1v-1h1z",
    fill: "#b69896"
  })), _path3113 || (_path3113 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49v-1h1v1z",
    fill: "#bc9898"
  })), _path3114 || (_path3114 = /*#__PURE__*/React.createElement("path", {
    d: "M80 48v1h-1v-1z",
    fill: "#c4c2b9"
  })), _path3115 || (_path3115 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49v-1h1v1z",
    fill: "#c7c6c3"
  })), _path3116 || (_path3116 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49v-1h1v1z",
    fill: "#cfa19e"
  })), _path3117 || (_path3117 = /*#__PURE__*/React.createElement("path", {
    d: "M85 48h1v1h-1z",
    fill: "#c22027"
  })), _path3118 || (_path3118 = /*#__PURE__*/React.createElement("path", {
    d: "M86 49v-1h1v1z",
    fill: "#c22028"
  })), _path3119 || (_path3119 = /*#__PURE__*/React.createElement("path", {
    d: "M90 48v1h-1v-1z",
    fill: "#bc272b"
  })), _path3120 || (_path3120 = /*#__PURE__*/React.createElement("path", {
    d: "M91 49h-1v-1h1z",
    fill: "#bb272c"
  })), _path3121 || (_path3121 = /*#__PURE__*/React.createElement("path", {
    d: "M92 48v1h-1v-1z",
    fill: "#c55457"
  })), _path3122 || (_path3122 = /*#__PURE__*/React.createElement("path", {
    d: "M93 48v1h-1v-1z",
    fill: "#be4f53"
  })), _path3123 || (_path3123 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v1h-1v-1z",
    fill: "#bd4045"
  })), _path3124 || (_path3124 = /*#__PURE__*/React.createElement("path", {
    d: "M95 48h1v1h-1z",
    fill: "#a75355"
  })), _path3125 || (_path3125 = /*#__PURE__*/React.createElement("path", {
    d: "M34 49v1h-1v-1z",
    fill: "#a83632"
  })), _path3126 || (_path3126 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50v-1h1v1z",
    fill: "#ad2929"
  })), _path3127 || (_path3127 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49h1v1h-1z",
    fill: "#b12727"
  })), _path3128 || (_path3128 = /*#__PURE__*/React.createElement("path", {
    d: "M37 49v1h-1v-1z",
    fill: "#b22524"
  })), _path3129 || (_path3129 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v-1h1v1z",
    fill: "#b21f1f"
  })), _path3130 || (_path3130 = /*#__PURE__*/React.createElement("path", {
    d: "M39 49v1h-1v-1z",
    fill: "#b21b1d"
  })), _path3131 || (_path3131 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h1v1h-1z",
    fill: "#b01817"
  })), _path3132 || (_path3132 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h1v1h-1z",
    fill: "#ad1316"
  })), _path3133 || (_path3133 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49h1v1h-1z",
    fill: "#a00d0f"
  })), _path3134 || (_path3134 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49h1v1h-1z",
    fill: "#9e0b0d"
  })), _path3135 || (_path3135 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50h-1v-1h1z",
    fill: "#9b272c"
  })), _path3136 || (_path3136 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49v1h-1v-1z",
    fill: "#c7aead"
  })), _path3137 || (_path3137 = /*#__PURE__*/React.createElement("path", {
    d: "M53 50v-1h1v1z",
    fill: "#c3c7be"
  })), _path3138 || (_path3138 = /*#__PURE__*/React.createElement("path", {
    d: "M55 49v1h-1v-1z",
    fill: "#ba8d87"
  })), _path3139 || (_path3139 = /*#__PURE__*/React.createElement("path", {
    d: "M56 49v1h-1v-1z",
    fill: "#99181b"
  })), _path3140 || (_path3140 = /*#__PURE__*/React.createElement("path", {
    d: "M56 50v-1h1v1z",
    fill: "#a90d13"
  })), _path3141 || (_path3141 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49h1v1h-1z",
    fill: "#a71b24"
  })), _path3142 || (_path3142 = /*#__PURE__*/React.createElement("path", {
    d: "M58 49h1v1h-1z",
    fill: "#b86062"
  })), _path3143 || (_path3143 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50v-1h1v1z",
    fill: "#cca59e"
  })), _path3144 || (_path3144 = /*#__PURE__*/React.createElement("path", {
    d: "M61 49v1h-1v-1z",
    fill: "#c9a8a1"
  })), _path3145 || (_path3145 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h-1v-1h1z",
    fill: "#c1a099"
  })), _path3146 || (_path3146 = /*#__PURE__*/React.createElement("path", {
    d: "M63 50h-1v-1h1z",
    fill: "#cda69f"
  })), _path3147 || (_path3147 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h1v1h-1z",
    fill: "#9a3230"
  })), _path3148 || (_path3148 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v1h-1v-1z",
    fill: "#94060b"
  })), _path3149 || (_path3149 = /*#__PURE__*/React.createElement("path", {
    d: "M66 49v1h-1v-1z",
    fill: "#960a11"
  })), _path3150 || (_path3150 = /*#__PURE__*/React.createElement("path", {
    d: "M67 50h-1v-1h1z",
    fill: "#a21115"
  })), _path3151 || (_path3151 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50v-1h1v1z",
    fill: "#a51015"
  })), _path3152 || (_path3152 = /*#__PURE__*/React.createElement("path", {
    d: "M69 49h1v1h-1z",
    fill: "#a41216"
  })), _path3153 || (_path3153 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49h1v1h-1z",
    fill: "#a00f16"
  })), _path3154 || (_path3154 = /*#__PURE__*/React.createElement("path", {
    d: "M73 49v1h-1v-1z",
    fill: "#b45358"
  })), _path3155 || (_path3155 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50v-1h1v1z",
    fill: "#c6b1ac"
  })), _path3156 || (_path3156 = /*#__PURE__*/React.createElement("path", {
    d: "M76 50h-1v-1h1z",
    fill: "#bdc3ba"
  })), _path3157 || (_path3157 = /*#__PURE__*/React.createElement("path", {
    d: "M80 50h-1v-1h1z",
    fill: "#c0c4bc"
  })), _path3158 || (_path3158 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49h1v1h-1z",
    fill: "#cfb9b7"
  })), _path3159 || (_path3159 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v1h-1v-1z",
    fill: "#bb3f44"
  })), _path3160 || (_path3160 = /*#__PURE__*/React.createElement("path", {
    d: "M84 50h-1v-1h1z",
    fill: "#be1e23"
  })), _path3161 || (_path3161 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h-1v-1h1z",
    fill: "#c21f27"
  })), _path3162 || (_path3162 = /*#__PURE__*/React.createElement("path", {
    d: "M89 49v1h-1v-1z",
    fill: "#bf2529"
  })), _path3163 || (_path3163 = /*#__PURE__*/React.createElement("path", {
    d: "M90 49h1v1h-1z",
    fill: "#bc272c"
  })), _path3164 || (_path3164 = /*#__PURE__*/React.createElement("path", {
    d: "M92 49v1h-1v-1z",
    fill: "#c14f51"
  })), _path3165 || (_path3165 = /*#__PURE__*/React.createElement("path", {
    d: "M93 50h-1v-1h1z",
    fill: "#c15359"
  })), _path3166 || (_path3166 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50h-1v-1h1z",
    fill: "#bc4043"
  })), _path3167 || (_path3167 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50v-1h1v1z",
    fill: "#b44949"
  })), _path3168 || (_path3168 = /*#__PURE__*/React.createElement("path", {
    d: "M95 50v-1h1v1z",
    fill: "#ab5452"
  })), _path3169 || (_path3169 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50v-1h1v1z",
    fill: "#d9b2af",
    fillOpacity: 0.729
  })), _path3170 || (_path3170 = /*#__PURE__*/React.createElement("path", {
    d: "M34 51h-1v-1h1z",
    fill: "#a93833"
  })), _path3171 || (_path3171 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50h1v1h-1z",
    fill: "#ae2928"
  })), _path3172 || (_path3172 = /*#__PURE__*/React.createElement("path", {
    d: "M36 51h-1v-1h1z",
    fill: "#af2424"
  })), _path3173 || (_path3173 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v1h-1v-1z",
    fill: "#b12322"
  })), _path3174 || (_path3174 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h-1v-1h1z",
    fill: "#b2191a"
  })), _path3175 || (_path3175 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50v1h-1v-1z",
    fill: "#af1716"
  })), _path3176 || (_path3176 = /*#__PURE__*/React.createElement("path", {
    d: "M44 50h1v1h-1z",
    fill: "#a91112"
  })), _path3177 || (_path3177 = /*#__PURE__*/React.createElement("path", {
    d: "M45 51v-1h1v1z",
    fill: "#a50f0e"
  })), _path3178 || (_path3178 = /*#__PURE__*/React.createElement("path", {
    d: "M50 51v-1h1v1z",
    fill: "#9e0f0f"
  })), _path3179 || (_path3179 = /*#__PURE__*/React.createElement("path", {
    d: "M53 51h-1v-1h1z",
    fill: "#b2696c"
  })), _path3180 || (_path3180 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h-1v-1h1z",
    fill: "#c4c5bd"
  })), _path3181 || (_path3181 = /*#__PURE__*/React.createElement("path", {
    d: "M54 50h1v1h-1z",
    fill: "#c2c2ba"
  })), _path3182 || (_path3182 = /*#__PURE__*/React.createElement("path", {
    d: "M56 50v1h-1v-1z",
    fill: "#b37973"
  })), _path3183 || (_path3183 = /*#__PURE__*/React.createElement("path", {
    d: "M57 50v1h-1v-1z",
    fill: "#a31519"
  })), _path3184 || (_path3184 = /*#__PURE__*/React.createElement("path", {
    d: "M59 51h-1v-1h1z",
    fill: "#a90f15"
  })), _path3185 || (_path3185 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50h1v1h-1z",
    fill: "#a81f27"
  })), _path3186 || (_path3186 = /*#__PURE__*/React.createElement("path", {
    d: "M61 51h-1v-1h1z",
    fill: "#ad4546"
  })), _path3187 || (_path3187 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50v1h-1v-1z",
    fill: "#b25756"
  })), _path3188 || (_path3188 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h1v1h-1z",
    fill: "#9f3434"
  })), _path3189 || (_path3189 = /*#__PURE__*/React.createElement("path", {
    d: "M64 50v1h-1v-1z",
    fill: "#930b0e"
  })), _path3190 || (_path3190 = /*#__PURE__*/React.createElement("path", {
    d: "M64 51v-1h1v1z",
    fill: "#9a080e"
  })), _path3191 || (_path3191 = /*#__PURE__*/React.createElement("path", {
    d: "M65 50h1v1h-1z",
    fill: "#950b10"
  })), _path3192 || (_path3192 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50h1v1h-1z",
    fill: "#9b121a"
  })), _path3193 || (_path3193 = /*#__PURE__*/React.createElement("path", {
    d: "M67 51v-1h1v1z",
    fill: "#ab4a51"
  })), _path3194 || (_path3194 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50h1v1h-1z",
    fill: "#ba8485"
  })), _path3195 || (_path3195 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51v-1h1v1z",
    fill: "#bf898b"
  })), _path3196 || (_path3196 = /*#__PURE__*/React.createElement("path", {
    d: "M71 51h-1v-1h1z",
    fill: "#b87677"
  })), _path3197 || (_path3197 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50v1h-1v-1z",
    fill: "#aa4a4c"
  })), _path3198 || (_path3198 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50h1v1h-1z",
    fill: "#962022"
  })), _path3199 || (_path3199 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50h1v1h-1z",
    fill: "#9b2b2b"
  })), _path3200 || (_path3200 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51h-1v-1h1z",
    fill: "#bf7e7e"
  })), _path3201 || (_path3201 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51v-1h1v1z",
    fill: "#ccbab9"
  })), _path3202 || (_path3202 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50h1v1h-1z",
    fill: "#bfc3ba"
  })), _path3203 || (_path3203 = /*#__PURE__*/React.createElement("path", {
    d: "M80 51h-1v-1h1z",
    fill: "#c2c3bf"
  })), _path3204 || (_path3204 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50h1v1h-1z",
    fill: "#cdbab9"
  })), _path3205 || (_path3205 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v-1h1v1z",
    fill: "#bd1e21"
  })), _path3206 || (_path3206 = /*#__PURE__*/React.createElement("path", {
    d: "M91 50v1h-1v-1z",
    fill: "#bc282c"
  })), _path3207 || (_path3207 = /*#__PURE__*/React.createElement("path", {
    d: "M91 50h1v1h-1z",
    fill: "#c04c4e"
  })), _path3208 || (_path3208 = /*#__PURE__*/React.createElement("path", {
    d: "M93 50v1h-1v-1z",
    fill: "#c2595e"
  })), _path3209 || (_path3209 = /*#__PURE__*/React.createElement("path", {
    d: "M94 51h-1v-1h1z",
    fill: "#bb4043"
  })), _path3210 || (_path3210 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50v1h-1v-1z",
    fill: "#ad5956"
  })), _path3211 || (_path3211 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50h1v1h-1z",
    fill: "#d4b2ac",
    fillOpacity: 0.729
  })), _path3212 || (_path3212 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h-1v-1h1z",
    fill: "#e5cabb",
    fillOpacity: 0.549
  })), _path3213 || (_path3213 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51v1h-1v-1z",
    fill: "#c6806f"
  })), _path3214 || (_path3214 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52h-1v-1h1z",
    fill: "#ad2927"
  })), _path3215 || (_path3215 = /*#__PURE__*/React.createElement("path", {
    d: "M35 51h1v1h-1z",
    fill: "#ae2220"
  })), _path3216 || (_path3216 = /*#__PURE__*/React.createElement("path", {
    d: "M37 52h-1v-1h1z",
    fill: "#b02120"
  })), _path3217 || (_path3217 = /*#__PURE__*/React.createElement("path", {
    d: "M39 52v-1h1v1z",
    fill: "#b01718"
  })), _path3218 || (_path3218 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h1v1h-1z",
    fill: "#ae1515"
  })), _path3219 || (_path3219 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52h-1v-1h1z",
    fill: "#ae1414"
  })), _path3220 || (_path3220 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52v-1h1v1z",
    fill: "#ad1313"
  })), _path3221 || (_path3221 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52v-1h1v1z",
    fill: "#a8110f"
  })), _path3222 || (_path3222 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52h-1v-1h1z",
    fill: "#a50e0d"
  })), _path3223 || (_path3223 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52v-1h1v1z",
    fill: "#9f0d0e"
  })), _path3224 || (_path3224 = /*#__PURE__*/React.createElement("path", {
    d: "M52 52h-1v-1h1z",
    fill: "#a20a0c"
  })), _path3225 || (_path3225 = /*#__PURE__*/React.createElement("path", {
    d: "M52 51h1v1h-1z",
    fill: "#992024"
  })), _path3226 || (_path3226 = /*#__PURE__*/React.createElement("path", {
    d: "M54 52h-1v-1h1z",
    fill: "#c3aaa4"
  })), _path3227 || (_path3227 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h1v1h-1z",
    fill: "#bdc2c0"
  })), _path3228 || (_path3228 = /*#__PURE__*/React.createElement("path", {
    d: "M56 52h-1v-1h1z",
    fill: "#c7beb7"
  })), _path3229 || (_path3229 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h-1v-1h1z",
    fill: "#b36b64"
  })), _path3230 || (_path3230 = /*#__PURE__*/React.createElement("path", {
    d: "M60 51v1h-1v-1z",
    fill: "#ab1417"
  })), _path3231 || (_path3231 = /*#__PURE__*/React.createElement("path", {
    d: "M62 52h-1v-1h1z",
    fill: "#a20c10"
  })), _path3232 || (_path3232 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51h1v1h-1z",
    fill: "#980a0d"
  })), _path3233 || (_path3233 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51h1v1h-1z",
    fill: "#92060d"
  })), _path3234 || (_path3234 = /*#__PURE__*/React.createElement("path", {
    d: "M67 52h-1v-1h1z",
    fill: "#ab575b"
  })), _path3235 || (_path3235 = /*#__PURE__*/React.createElement("path", {
    d: "M68 51v1h-1v-1z",
    fill: "#d4bab6"
  })), _path3236 || (_path3236 = /*#__PURE__*/React.createElement("path", {
    d: "M68 52v-1h1v1z",
    fill: "#c0908e"
  })), _path3237 || (_path3237 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51h1v1h-1z",
    fill: "#b9787a"
  })), _path3238 || (_path3238 = /*#__PURE__*/React.createElement("path", {
    d: "M70 51h1v1h-1z",
    fill: "#c58f90"
  })), _path3239 || (_path3239 = /*#__PURE__*/React.createElement("path", {
    d: "M71 52v-1h1v1z",
    fill: "#d1aaaa"
  })), _path3240 || (_path3240 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h-1v-1h1z",
    fill: "#cfa7a7"
  })), _path3241 || (_path3241 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52v-1h1v1z",
    fill: "#b16d6e"
  })), _path3242 || (_path3242 = /*#__PURE__*/React.createElement("path", {
    d: "M75 52h-1v-1h1z",
    fill: "#902828"
  })), _path3243 || (_path3243 = /*#__PURE__*/React.createElement("path", {
    d: "M76 52h-1v-1h1z",
    fill: "#9f3538"
  })), _path3244 || (_path3244 = /*#__PURE__*/React.createElement("path", {
    d: "M76 51h1v1h-1z",
    fill: "#b97f7e"
  })), _path3245 || (_path3245 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h1v1h-1z",
    fill: "#c7aeac"
  })), _path3246 || (_path3246 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52v-1h1v1z",
    fill: "#c9c2bb"
  })), _path3247 || (_path3247 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52h-1v-1h1z",
    fill: "#c6c8c0"
  })), _path3248 || (_path3248 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52v-1h1v1z",
    fill: "#d3c2bf"
  })), _path3249 || (_path3249 = /*#__PURE__*/React.createElement("path", {
    d: "M82 52h-1v-1h1z",
    fill: "#c6848a"
  })), _path3250 || (_path3250 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v1h-1v-1z",
    fill: "#b4262c"
  })), _path3251 || (_path3251 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51h1v1h-1z",
    fill: "#bf1f23"
  })), _path3252 || (_path3252 = /*#__PURE__*/React.createElement("path", {
    d: "M90 52v-1h1v1z",
    fill: "#bc282d"
  })), _path3253 || (_path3253 = /*#__PURE__*/React.createElement("path", {
    d: "M92 51v1h-1v-1z",
    fill: "#bf484b"
  })), _path3254 || (_path3254 = /*#__PURE__*/React.createElement("path", {
    d: "M92 52v-1h1v1z",
    fill: "#c46265"
  })), _path3255 || (_path3255 = /*#__PURE__*/React.createElement("path", {
    d: "M96 52h-1v-1h1z",
    fill: "#ae645f"
  })), _path3256 || (_path3256 = /*#__PURE__*/React.createElement("path", {
    d: "M97 52h-1v-1h1z",
    fill: "#d4b9b2",
    fillOpacity: 0.729
  })), _path3257 || (_path3257 = /*#__PURE__*/React.createElement("path", {
    d: "M32 53h-1v-1h1z",
    fill: "#e5c9b9",
    fillOpacity: 0.545
  })), _path3258 || (_path3258 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h1v1h-1z",
    fill: "#c98372"
  })), _path3259 || (_path3259 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52v1h-1v-1z",
    fill: "#aa3c33"
  })), _path3260 || (_path3260 = /*#__PURE__*/React.createElement("path", {
    d: "M35 53h-1v-1h1z",
    fill: "#ae2a27"
  })), _path3261 || (_path3261 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h-1v-1h1z",
    fill: "#ad221f"
  })), _path3262 || (_path3262 = /*#__PURE__*/React.createElement("path", {
    d: "M36 52h1v1h-1z",
    fill: "#b01e1e"
  })), _path3263 || (_path3263 = /*#__PURE__*/React.createElement("path", {
    d: "M38 52v1h-1v-1z",
    fill: "#ae1b1b"
  })), _path3264 || (_path3264 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v-1h1v1z",
    fill: "#af1718"
  })), _path3265 || (_path3265 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53h-1v-1h1z",
    fill: "#ae1616"
  })), _path3266 || (_path3266 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h-1v-1h1z",
    fill: "#ac1413"
  })), _path3267 || (_path3267 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53v-1h1v1z",
    fill: "#ab1211"
  })), _path3268 || (_path3268 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52v1h-1v-1z",
    fill: "#a40e0d"
  })), _path3269 || (_path3269 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h1v1h-1z",
    fill: "#a30e0f"
  })), _path3270 || (_path3270 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h1v1h-1z",
    fill: "#a20e10"
  })), _path3271 || (_path3271 = /*#__PURE__*/React.createElement("path", {
    d: "M50 52h1v1h-1z",
    fill: "#a20d10"
  })), _path3272 || (_path3272 = /*#__PURE__*/React.createElement("path", {
    d: "M51 52h1v1h-1z",
    fill: "#a20d0c"
  })), _path3273 || (_path3273 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52h1v1h-1z",
    fill: "#ad5056"
  })), _path3274 || (_path3274 = /*#__PURE__*/React.createElement("path", {
    d: "M55 52v1h-1v-1z",
    fill: "#c6c0bd"
  })), _path3275 || (_path3275 = /*#__PURE__*/React.createElement("path", {
    d: "M55 53v-1h1v1z",
    fill: "#c0bebb"
  })), _path3276 || (_path3276 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53h-1v-1h1z",
    fill: "#c8c1b6"
  })), _path3277 || (_path3277 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h1v1h-1z",
    fill: "#b26664"
  })), _path3278 || (_path3278 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52h1v1h-1z",
    fill: "#a2141c"
  })), _path3279 || (_path3279 = /*#__PURE__*/React.createElement("path", {
    d: "M61 53h-1v-1h1z",
    fill: "#a71516"
  })), _path3280 || (_path3280 = /*#__PURE__*/React.createElement("path", {
    d: "M61 52h1v1h-1z",
    fill: "#a41112"
  })), _path3281 || (_path3281 = /*#__PURE__*/React.createElement("path", {
    d: "M63 53h-1v-1h1z",
    fill: "#9e0d10"
  })), _path3282 || (_path3282 = /*#__PURE__*/React.createElement("path", {
    d: "M63 52h1v1h-1z",
    fill: "#990c12"
  })), _path3283 || (_path3283 = /*#__PURE__*/React.createElement("path", {
    d: "M65 52v1h-1v-1z",
    fill: "#980a10"
  })), _path3284 || (_path3284 = /*#__PURE__*/React.createElement("path", {
    d: "M66 53h-1v-1h1z",
    fill: "#93090f"
  })), _path3285 || (_path3285 = /*#__PURE__*/React.createElement("path", {
    d: "M66 52h1v1h-1z",
    fill: "#c1918f"
  })), _path3286 || (_path3286 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v-1h1v1z",
    fill: "#c7b7af"
  })), _path3287 || (_path3287 = /*#__PURE__*/React.createElement("path", {
    d: "M69 52v1h-1v-1z",
    fill: "#9a2c2b"
  })), _path3288 || (_path3288 = /*#__PURE__*/React.createElement("path", {
    d: "M70 52v1h-1v-1z",
    fill: "#a30d11"
  })), _path3289 || (_path3289 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h-1v-1h1z",
    fill: "#a32427"
  })), _path3290 || (_path3290 = /*#__PURE__*/React.createElement("path", {
    d: "M72 52h1v1h-1z",
    fill: "#ac5656"
  })), _path3291 || (_path3291 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h1v1h-1z",
    fill: "#c99c9a"
  })), _path3292 || (_path3292 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53v-1h1v1z",
    fill: "#ceaba9"
  })), _path3293 || (_path3293 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v-1h1v1z",
    fill: "#8d1115"
  })), _path3294 || (_path3294 = /*#__PURE__*/React.createElement("path", {
    d: "M77 52h1v1h-1z",
    fill: "#9d1e20"
  })), _path3295 || (_path3295 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52h1v1h-1z",
    fill: "#ae4343"
  })), _path3296 || (_path3296 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h-1v-1h1z",
    fill: "#c05052"
  })), _path3297 || (_path3297 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53h-1v-1h1z",
    fill: "#bd252e"
  })), _path3298 || (_path3298 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53v-1h1v1z",
    fill: "#c11d27"
  })), _path3299 || (_path3299 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52v1h-1v-1z",
    fill: "#bc292d"
  })), _path3300 || (_path3300 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52h1v1h-1z",
    fill: "#bc4347"
  })), _path3301 || (_path3301 = /*#__PURE__*/React.createElement("path", {
    d: "M92 53v-1h1v1z",
    fill: "#c6696b"
  })), _path3302 || (_path3302 = /*#__PURE__*/React.createElement("path", {
    d: "M95 52h1v1h-1z",
    fill: "#b37069"
  })), _path3303 || (_path3303 = /*#__PURE__*/React.createElement("path", {
    d: "M96 53v-1h1v1z",
    fill: "#dac5bd",
    fillOpacity: 0.718
  })), _path3304 || (_path3304 = /*#__PURE__*/React.createElement("path", {
    d: "M31 53h1v1h-1z",
    fill: "#e1c9ba",
    fillOpacity: 0.537
  })), _path3305 || (_path3305 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v-1h1v1z",
    fill: "#c98676"
  })), _path3306 || (_path3306 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h-1v-1h1z",
    fill: "#ad2b28"
  })), _path3307 || (_path3307 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53v1h-1v-1z",
    fill: "#ae211f"
  })), _path3308 || (_path3308 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h1v1h-1z",
    fill: "#af1e1d"
  })), _path3309 || (_path3309 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v1h-1v-1z",
    fill: "#ad1b1c"
  })), _path3310 || (_path3310 = /*#__PURE__*/React.createElement("path", {
    d: "M38 54v-1h1v1z",
    fill: "#ae1619"
  })), _path3311 || (_path3311 = /*#__PURE__*/React.createElement("path", {
    d: "M41 54h-1v-1h1z",
    fill: "#ad1213"
  })), _path3312 || (_path3312 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h1v1h-1z",
    fill: "#ac1111"
  })), _path3313 || (_path3313 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h1v1h-1z",
    fill: "#ab1110"
  })), _path3314 || (_path3314 = /*#__PURE__*/React.createElement("path", {
    d: "M44 53v1h-1v-1z",
    fill: "#a9100f"
  })), _path3315 || (_path3315 = /*#__PURE__*/React.createElement("path", {
    d: "M47 53v1h-1v-1z",
    fill: "#a30d0c"
  })), _path3316 || (_path3316 = /*#__PURE__*/React.createElement("path", {
    d: "M49 54h-1v-1h1z",
    fill: "#a10e0e"
  })), _path3317 || (_path3317 = /*#__PURE__*/React.createElement("path", {
    d: "M51 54v-1h1v1z",
    fill: "#a10f0f"
  })), _path3318 || (_path3318 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h-1v-1h1z",
    fill: "#a31113"
  })), _path3319 || (_path3319 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54h-1v-1h1z",
    fill: "#9a151a"
  })), _path3320 || (_path3320 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54v-1h1v1z",
    fill: "#b47d7e"
  })), _path3321 || (_path3321 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54h-1v-1h1z",
    fill: "#c3c3c2"
  })), _path3322 || (_path3322 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53v1h-1v-1z",
    fill: "#bcc1bc"
  })), _path3323 || (_path3323 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54h-1v-1h1z",
    fill: "#c7c1b5"
  })), _path3324 || (_path3324 = /*#__PURE__*/React.createElement("path", {
    d: "M58 53h1v1h-1z",
    fill: "#b56765"
  })), _path3325 || (_path3325 = /*#__PURE__*/React.createElement("path", {
    d: "M59 53h1v1h-1z",
    fill: "#a01418"
  })), _path3326 || (_path3326 = /*#__PURE__*/React.createElement("path", {
    d: "M62 54v-1h1v1z",
    fill: "#9e0e12"
  })), _path3327 || (_path3327 = /*#__PURE__*/React.createElement("path", {
    d: "M64 53v1h-1v-1z",
    fill: "#9a0b13"
  })), _path3328 || (_path3328 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v1h-1v-1z",
    fill: "#b8807e"
  })), _path3329 || (_path3329 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53h1v1h-1z",
    fill: "#cdc2be"
  })), _path3330 || (_path3330 = /*#__PURE__*/React.createElement("path", {
    d: "M69 53v1h-1v-1z",
    fill: "#b0605f"
  })), _path3331 || (_path3331 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v1h-1v-1z",
    fill: "#a11012"
  })), _path3332 || (_path3332 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54h-1v-1h1z",
    fill: "#a81419"
  })), _path3333 || (_path3333 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h1v1h-1z",
    fill: "#a60e18"
  })), _path3334 || (_path3334 = /*#__PURE__*/React.createElement("path", {
    d: "M73 53h1v1h-1z",
    fill: "#9e171c"
  })), _path3335 || (_path3335 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53h1v1h-1z",
    fill: "#b05657"
  })), _path3336 || (_path3336 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v1h-1v-1z",
    fill: "#ceadaa"
  })), _path3337 || (_path3337 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53h1v1h-1z",
    fill: "#bd8685"
  })), _path3338 || (_path3338 = /*#__PURE__*/React.createElement("path", {
    d: "M78 53v1h-1v-1z",
    fill: "#962225"
  })), _path3339 || (_path3339 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53v1h-1v-1z",
    fill: "#be1b26"
  })), _path3340 || (_path3340 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53v1h-1v-1z",
    fill: "#bb292d"
  })), _path3341 || (_path3341 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53h1v1h-1z",
    fill: "#bc3f44"
  })), _path3342 || (_path3342 = /*#__PURE__*/React.createElement("path", {
    d: "M93 53v1h-1v-1z",
    fill: "#c76f73"
  })), _path3343 || (_path3343 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54h-1v-1h1z",
    fill: "#b84045"
  })), _path3344 || (_path3344 = /*#__PURE__*/React.createElement("path", {
    d: "M94 53h1v1h-1z",
    fill: "#b6494d"
  })), _path3345 || (_path3345 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53h1v1h-1z",
    fill: "#b3756d"
  })), _path3346 || (_path3346 = /*#__PURE__*/React.createElement("path", {
    d: "M96 53h1v1h-1z",
    fill: "#ddccc4",
    fillOpacity: 0.718
  })), _path3347 || (_path3347 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v1h-1v-1z",
    fill: "#e6cbbb",
    fillOpacity: 0.522
  })), _path3348 || (_path3348 = /*#__PURE__*/React.createElement("path", {
    d: "M32 55v-1h1v1z",
    fill: "#cb8776"
  })), _path3349 || (_path3349 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54h1v1h-1z",
    fill: "#aa3c34"
  })), _path3350 || (_path3350 = /*#__PURE__*/React.createElement("path", {
    d: "M35 55h-1v-1h1z",
    fill: "#ab2e29"
  })), _path3351 || (_path3351 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h1v1h-1z",
    fill: "#ac2324"
  })), _path3352 || (_path3352 = /*#__PURE__*/React.createElement("path", {
    d: "M37 55h-1v-1h1z",
    fill: "#ae1f23"
  })), _path3353 || (_path3353 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55h-1v-1h1z",
    fill: "#ae1b1c"
  })), _path3354 || (_path3354 = /*#__PURE__*/React.createElement("path", {
    d: "M42 54v1h-1v-1z",
    fill: "#ac1212"
  })), _path3355 || (_path3355 = /*#__PURE__*/React.createElement("path", {
    d: "M42 55v-1h1v1z",
    fill: "#ab1111"
  })), _path3356 || (_path3356 = /*#__PURE__*/React.createElement("path", {
    d: "M44 54v1h-1v-1z",
    fill: "#aa1010"
  })), _path3357 || (_path3357 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55v-1h1v1z",
    fill: "#a90f0f"
  })), _path3358 || (_path3358 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55h-1v-1h1z",
    fill: "#a20c0b"
  })), _path3359 || (_path3359 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54h1v1h-1z",
    fill: "#a61212"
  })), _path3360 || (_path3360 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h1v1h-1z",
    fill: "#a00d0d"
  })), _path3361 || (_path3361 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54v1h-1v-1z",
    fill: "#a20f12"
  })), _path3362 || (_path3362 = /*#__PURE__*/React.createElement("path", {
    d: "M55 54v1h-1v-1z",
    fill: "#921c23"
  })), _path3363 || (_path3363 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54v1h-1v-1z",
    fill: "#bf9d9c"
  })), _path3364 || (_path3364 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55v-1h1v1z",
    fill: "#bfc2c0"
  })), _path3365 || (_path3365 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54v1h-1v-1z",
    fill: "#b5716f"
  })), _path3366 || (_path3366 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54h1v1h-1z",
    fill: "#9c181c"
  })), _path3367 || (_path3367 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55h-1v-1h1z",
    fill: "#a31011"
  })), _path3368 || (_path3368 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54v1h-1v-1z",
    fill: "#a00e12"
  })), _path3369 || (_path3369 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54h1v1h-1z",
    fill: "#9a0c12"
  })), _path3370 || (_path3370 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54v1h-1v-1z",
    fill: "#980c12"
  })), _path3371 || (_path3371 = /*#__PURE__*/React.createElement("path", {
    d: "M66 55h-1v-1h1z",
    fill: "#95060d"
  })), _path3372 || (_path3372 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55h-1v-1h1z",
    fill: "#a74a4c"
  })), _path3373 || (_path3373 = /*#__PURE__*/React.createElement("path", {
    d: "M68 54v1h-1v-1z",
    fill: "#cac3bc"
  })), _path3374 || (_path3374 = /*#__PURE__*/React.createElement("path", {
    d: "M69 55h-1v-1h1z",
    fill: "#c6b9b2"
  })), _path3375 || (_path3375 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55h-1v-1h1z",
    fill: "#af605d"
  })), _path3376 || (_path3376 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55v-1h1v1z",
    fill: "#a11b1b"
  })), _path3377 || (_path3377 = /*#__PURE__*/React.createElement("path", {
    d: "M73 55v-1h1v1z",
    fill: "#a70f12"
  })), _path3378 || (_path3378 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54v1h-1v-1z",
    fill: "#9d0a0c"
  })), _path3379 || (_path3379 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54h1v1h-1z",
    fill: "#9d2c30"
  })), _path3380 || (_path3380 = /*#__PURE__*/React.createElement("path", {
    d: "M76 54h1v1h-1z",
    fill: "#c69d98"
  })), _path3381 || (_path3381 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v1h-1v-1z",
    fill: "#c4a29f"
  })), _path3382 || (_path3382 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54h1v1h-1z",
    fill: "#9f3237"
  })), _path3383 || (_path3383 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h-1v-1h1z",
    fill: "#b6171d"
  })), _path3384 || (_path3384 = /*#__PURE__*/React.createElement("path", {
    d: "M81 55v-1h1v1z",
    fill: "#c11d26"
  })), _path3385 || (_path3385 = /*#__PURE__*/React.createElement("path", {
    d: "M92 54v1h-1v-1z",
    fill: "#ba3b40"
  })), _path3386 || (_path3386 = /*#__PURE__*/React.createElement("path", {
    d: "M92 54h1v1h-1z",
    fill: "#cb7579"
  })), _path3387 || (_path3387 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54v1h-1v-1z",
    fill: "#b74249"
  })), _path3388 || (_path3388 = /*#__PURE__*/React.createElement("path", {
    d: "M94 55v-1h1v1z",
    fill: "#b64a4e"
  })), _path3389 || (_path3389 = /*#__PURE__*/React.createElement("path", {
    d: "M95 54h1v1h-1z",
    fill: "#ae6461"
  })), _path3390 || (_path3390 = /*#__PURE__*/React.createElement("path", {
    d: "M97 54v1h-1v-1z",
    fill: "#d7b5b2",
    fillOpacity: 0.718
  })), _path3391 || (_path3391 = /*#__PURE__*/React.createElement("path", {
    d: "M32 56h-1v-1h1z",
    fill: "#e6cbc0",
    fillOpacity: 0.525
  })), _path3392 || (_path3392 = /*#__PURE__*/React.createElement("path", {
    d: "M33 55v1h-1v-1z",
    fill: "#cb8677"
  })), _path3393 || (_path3393 = /*#__PURE__*/React.createElement("path", {
    d: "M34 56h-1v-1h1z",
    fill: "#a54e49"
  })), _path3394 || (_path3394 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56h-1v-1h1z",
    fill: "#c59694"
  })), _path3395 || (_path3395 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56v-1h1v1z",
    fill: "#ad5d5a"
  })), _path3396 || (_path3396 = /*#__PURE__*/React.createElement("path", {
    d: "M37 56h-1v-1h1z",
    fill: "#aa1c18"
  })), _path3397 || (_path3397 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h-1v-1h1z",
    fill: "#ae1516"
  })), _path3398 || (_path3398 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56v-1h1v1z",
    fill: "#ab1412"
  })), _path3399 || (_path3399 = /*#__PURE__*/React.createElement("path", {
    d: "M43 56h-1v-1h1z",
    fill: "#ac1011"
  })), _path3400 || (_path3400 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55h1v1h-1z",
    fill: "#a70f11"
  })), _path3401 || (_path3401 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55v1h-1v-1z",
    fill: "#a51110"
  })), _path3402 || (_path3402 = /*#__PURE__*/React.createElement("path", {
    d: "M51 55v1h-1v-1z",
    fill: "#a20d0f"
  })), _path3403 || (_path3403 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55v1h-1v-1z",
    fill: "#a40d11"
  })), _path3404 || (_path3404 = /*#__PURE__*/React.createElement("path", {
    d: "M55 56h-1v-1h1z",
    fill: "#9a050a"
  })), _path3405 || (_path3405 = /*#__PURE__*/React.createElement("path", {
    d: "M55 55h1v1h-1z",
    fill: "#9d3136"
  })), _path3406 || (_path3406 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55h1v1h-1z",
    fill: "#c6b1ae"
  })), _path3407 || (_path3407 = /*#__PURE__*/React.createElement("path", {
    d: "M60 56h-1v-1h1z",
    fill: "#c7c2bb"
  })), _path3408 || (_path3408 = /*#__PURE__*/React.createElement("path", {
    d: "M61 55v1h-1v-1z",
    fill: "#be8680"
  })), _path3409 || (_path3409 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55v1h-1v-1z",
    fill: "#982524"
  })), _path3410 || (_path3410 = /*#__PURE__*/React.createElement("path", {
    d: "M63 55v1h-1v-1z",
    fill: "#9c0d0f"
  })), _path3411 || (_path3411 = /*#__PURE__*/React.createElement("path", {
    d: "M64 55v1h-1v-1z",
    fill: "#9f0c0e"
  })), _path3412 || (_path3412 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56h-1v-1h1z",
    fill: "#980d0e"
  })), _path3413 || (_path3413 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55h1v1h-1z",
    fill: "#9a0b0e"
  })), _path3414 || (_path3414 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55v1h-1v-1z",
    fill: "#9e151d"
  })), _path3415 || (_path3415 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56v-1h1v1z",
    fill: "#c3948f"
  })), _path3416 || (_path3416 = /*#__PURE__*/React.createElement("path", {
    d: "M71 56h-1v-1h1z",
    fill: "#bd9992"
  })), _path3417 || (_path3417 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56h-1v-1h1z",
    fill: "#a85751"
  })), _path3418 || (_path3418 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56v-1h1v1z",
    fill: "#9b2928"
  })), _path3419 || (_path3419 = /*#__PURE__*/React.createElement("path", {
    d: "M74 55v1h-1v-1z",
    fill: "#a11217"
  })), _path3420 || (_path3420 = /*#__PURE__*/React.createElement("path", {
    d: "M76 55v1h-1v-1z",
    fill: "#9c0908"
  })), _path3421 || (_path3421 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56v-1h1v1z",
    fill: "#9a1c20"
  })), _path3422 || (_path3422 = /*#__PURE__*/React.createElement("path", {
    d: "M78 55v1h-1v-1z",
    fill: "#c3928f"
  })), _path3423 || (_path3423 = /*#__PURE__*/React.createElement("path", {
    d: "M79 55v1h-1v-1z",
    fill: "#cca9a4"
  })), _path3424 || (_path3424 = /*#__PURE__*/React.createElement("path", {
    d: "M79 56v-1h1v1z",
    fill: "#ad3d3f"
  })), _path3425 || (_path3425 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h1v1h-1z",
    fill: "#bf1821"
  })), _path3426 || (_path3426 = /*#__PURE__*/React.createElement("path", {
    d: "M82 55v1h-1v-1z",
    fill: "#c21e27"
  })), _path3427 || (_path3427 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55v1h-1v-1z",
    fill: "#bc292c"
  })), _path3428 || (_path3428 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55h1v1h-1z",
    fill: "#ba383d"
  })), _path3429 || (_path3429 = /*#__PURE__*/React.createElement("path", {
    d: "M92 55h1v1h-1z",
    fill: "#cb7b7d"
  })), _path3430 || (_path3430 = /*#__PURE__*/React.createElement("path", {
    d: "M93 55h1v1h-1z",
    fill: "#b7444b"
  })), _path3431 || (_path3431 = /*#__PURE__*/React.createElement("path", {
    d: "M95 56h-1v-1h1z",
    fill: "#b8484c"
  })), _path3432 || (_path3432 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55v1h-1v-1z",
    fill: "#b1716c"
  })), _path3433 || (_path3433 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55h1v1h-1z",
    fill: "#dac6c2",
    fillOpacity: 0.694
  })), _path3434 || (_path3434 = /*#__PURE__*/React.createElement("path", {
    d: "M31 56h1v1h-1z",
    fill: "#ead4ca",
    fillOpacity: 0.537
  })), _path3435 || (_path3435 = /*#__PURE__*/React.createElement("path", {
    d: "M32 57v-1h1v1z",
    fill: "#c3867e"
  })), _path3436 || (_path3436 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56h1v1h-1z",
    fill: "#b68d8d"
  })), _path3437 || (_path3437 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56v1h-1v-1z",
    fill: "#c8bbb3"
  })), _path3438 || (_path3438 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56h1v1h-1z",
    fill: "#b65950"
  })), _path3439 || (_path3439 = /*#__PURE__*/React.createElement("path", {
    d: "M38 57h-1v-1h1z",
    fill: "#ab1818"
  })), _path3440 || (_path3440 = /*#__PURE__*/React.createElement("path", {
    d: "M39 56v1h-1v-1z",
    fill: "#ae1717"
  })), _path3441 || (_path3441 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57v-1h1v1z",
    fill: "#ab1112"
  })), _path3442 || (_path3442 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57v-1h1v1z",
    fill: "#a51717"
  })), _path3443 || (_path3443 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56h1v1h-1z",
    fill: "#a2100e"
  })), _path3444 || (_path3444 = /*#__PURE__*/React.createElement("path", {
    d: "M56 56v1h-1v-1z",
    fill: "#99080e"
  })), _path3445 || (_path3445 = /*#__PURE__*/React.createElement("path", {
    d: "M56 57v-1h1v1z",
    fill: "#ab484e"
  })), _path3446 || (_path3446 = /*#__PURE__*/React.createElement("path", {
    d: "M58 56v1h-1v-1z",
    fill: "#cbb6b1"
  })), _path3447 || (_path3447 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57v-1h1v1z",
    fill: "#bfc1ba"
  })), _path3448 || (_path3448 = /*#__PURE__*/React.createElement("path", {
    d: "M61 57h-1v-1h1z",
    fill: "#c3c5bb"
  })), _path3449 || (_path3449 = /*#__PURE__*/React.createElement("path", {
    d: "M61 57v-1h1v1z",
    fill: "#baa096"
  })), _path3450 || (_path3450 = /*#__PURE__*/React.createElement("path", {
    d: "M63 57h-1v-1h1z",
    fill: "#973938"
  })), _path3451 || (_path3451 = /*#__PURE__*/React.createElement("path", {
    d: "M63 56h1v1h-1z",
    fill: "#950c0e"
  })), _path3452 || (_path3452 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v-1h1v1z",
    fill: "#a20b12"
  })), _path3453 || (_path3453 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56h1v1h-1z",
    fill: "#a93339"
  })), _path3454 || (_path3454 = /*#__PURE__*/React.createElement("path", {
    d: "M68 56h1v1h-1z",
    fill: "#ccb1ad"
  })), _path3455 || (_path3455 = /*#__PURE__*/React.createElement("path", {
    d: "M71 57v-1h1v1z",
    fill: "#c7c3bd"
  })), _path3456 || (_path3456 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56h1v1h-1z",
    fill: "#c5b2a9"
  })), _path3457 || (_path3457 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57h-1v-1h1z",
    fill: "#af5151"
  })), _path3458 || (_path3458 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57h-1v-1h1z",
    fill: "#9c0b11"
  })), _path3459 || (_path3459 = /*#__PURE__*/React.createElement("path", {
    d: "M76 57h-1v-1h1z",
    fill: "#a10d0f"
  })), _path3460 || (_path3460 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56h1v1h-1z",
    fill: "#9c090b"
  })), _path3461 || (_path3461 = /*#__PURE__*/React.createElement("path", {
    d: "M78 56v1h-1v-1z",
    fill: "#992021"
  })), _path3462 || (_path3462 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57v-1h1v1z",
    fill: "#ca9e9c"
  })), _path3463 || (_path3463 = /*#__PURE__*/React.createElement("path", {
    d: "M80 56v1h-1v-1z",
    fill: "#cba4a3"
  })), _path3464 || (_path3464 = /*#__PURE__*/React.createElement("path", {
    d: "M81 57h-1v-1h1z",
    fill: "#b32b35"
  })), _path3465 || (_path3465 = /*#__PURE__*/React.createElement("path", {
    d: "M89 56h1v1h-1z",
    fill: "#bb2728"
  })), _path3466 || (_path3466 = /*#__PURE__*/React.createElement("path", {
    d: "M90 57v-1h1v1z",
    fill: "#be2a2c"
  })), _path3467 || (_path3467 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57h-1v-1h1z",
    fill: "#b9353a"
  })), _path3468 || (_path3468 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57v-1h1v1z",
    fill: "#cb8080"
  })), _path3469 || (_path3469 = /*#__PURE__*/React.createElement("path", {
    d: "M93 56h1v1h-1z",
    fill: "#b8474e"
  })), _path3470 || (_path3470 = /*#__PURE__*/React.createElement("path", {
    d: "M95 56v1h-1v-1z",
    fill: "#b5474b"
  })), _path3471 || (_path3471 = /*#__PURE__*/React.createElement("path", {
    d: "M96 57h-1v-1h1z",
    fill: "#bd8a81"
  })), _path3472 || (_path3472 = /*#__PURE__*/React.createElement("path", {
    d: "M97 56v1h-1v-1z",
    fill: "#e6e3dc",
    fillOpacity: 0.698
  })), _path3473 || (_path3473 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58v-1h1v1z",
    fill: "#ecdbd0",
    fillOpacity: 0.541
  })), _path3474 || (_path3474 = /*#__PURE__*/React.createElement("path", {
    d: "M33 57v1h-1v-1z",
    fill: "#c9a39c"
  })), _path3475 || (_path3475 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v1h-1v-1z",
    fill: "#c6b9b8"
  })), _path3476 || (_path3476 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58h-1v-1h1z",
    fill: "#c6c5c2"
  })), _path3477 || (_path3477 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58v-1h1v1z",
    fill: "#c6c7c1"
  })), _path3478 || (_path3478 = /*#__PURE__*/React.createElement("path", {
    d: "M36 57h1v1h-1z",
    fill: "#c9a9a2"
  })), _path3479 || (_path3479 = /*#__PURE__*/React.createElement("path", {
    d: "M38 58h-1v-1h1z",
    fill: "#a82723"
  })), _path3480 || (_path3480 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h-1v-1h1z",
    fill: "#af1615"
  })), _path3481 || (_path3481 = /*#__PURE__*/React.createElement("path", {
    d: "M40 57h1v1h-1z",
    fill: "#ac1310"
  })), _path3482 || (_path3482 = /*#__PURE__*/React.createElement("path", {
    d: "M41 57h1v1h-1z",
    fill: "#ac1213"
  })), _path3483 || (_path3483 = /*#__PURE__*/React.createElement("path", {
    d: "M43 58h-1v-1h1z",
    fill: "#af0f14"
  })), _path3484 || (_path3484 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58h-1v-1h1z",
    fill: "#a71d1f"
  })), _path3485 || (_path3485 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v-1h1v1z",
    fill: "#b84242"
  })), _path3486 || (_path3486 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v-1h1v1z",
    fill: "#a10e0d"
  })), _path3487 || (_path3487 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57h1v1h-1z",
    fill: "#a10c0c"
  })), _path3488 || (_path3488 = /*#__PURE__*/React.createElement("path", {
    d: "M50 57h1v1h-1z",
    fill: "#a50f11"
  })), _path3489 || (_path3489 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h-1v-1h1z",
    fill: "#a71012"
  })), _path3490 || (_path3490 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58v-1h1v1z",
    fill: "#a71114"
  })), _path3491 || (_path3491 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h1v1h-1z",
    fill: "#a30c11"
  })), _path3492 || (_path3492 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h-1v-1h1z",
    fill: "#9f0a0d"
  })), _path3493 || (_path3493 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57h1v1h-1z",
    fill: "#9f0a0e"
  })), _path3494 || (_path3494 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h-1v-1h1z",
    fill: "#9f0d12"
  })), _path3495 || (_path3495 = /*#__PURE__*/React.createElement("path", {
    d: "M58 58h-1v-1h1z",
    fill: "#af4f51"
  })), _path3496 || (_path3496 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57h1v1h-1z",
    fill: "#cab6b4"
  })), _path3497 || (_path3497 = /*#__PURE__*/React.createElement("path", {
    d: "M59 58v-1h1v1z",
    fill: "#bdc2b8"
  })), _path3498 || (_path3498 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h1v1h-1z",
    fill: "#bfbeb7"
  })), _path3499 || (_path3499 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58h-1v-1h1z",
    fill: "#c5b1aa"
  })), _path3500 || (_path3500 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v-1h1v1z",
    fill: "#a45b58"
  })), _path3501 || (_path3501 = /*#__PURE__*/React.createElement("path", {
    d: "M65 57v1h-1v-1z",
    fill: "#901014"
  })), _path3502 || (_path3502 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v1h-1v-1z",
    fill: "#9f0610"
  })), _path3503 || (_path3503 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58h-1v-1h1z",
    fill: "#a81016"
  })), _path3504 || (_path3504 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58h-1v-1h1z",
    fill: "#ad4349"
  })), _path3505 || (_path3505 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58v-1h1v1z",
    fill: "#c9b0aa"
  })), _path3506 || (_path3506 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58v-1h1v1z",
    fill: "#c6c7bf"
  })), _path3507 || (_path3507 = /*#__PURE__*/React.createElement("path", {
    d: "M72 58h-1v-1h1z",
    fill: "#bec2bf"
  })), _path3508 || (_path3508 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57v1h-1v-1z",
    fill: "#c3a19b"
  })), _path3509 || (_path3509 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57v1h-1v-1z",
    fill: "#942121"
  })), _path3510 || (_path3510 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v-1h1v1z",
    fill: "#9c0d0e"
  })), _path3511 || (_path3511 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57h1v1h-1z",
    fill: "#a5353a"
  })), _path3512 || (_path3512 = /*#__PURE__*/React.createElement("path", {
    d: "M79 58v-1h1v1z",
    fill: "#d0bdbc"
  })), _path3513 || (_path3513 = /*#__PURE__*/React.createElement("path", {
    d: "M80 57h1v1h-1z",
    fill: "#c77b7c"
  })), _path3514 || (_path3514 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58v-1h1v1z",
    fill: "#bb1b25"
  })), _path3515 || (_path3515 = /*#__PURE__*/React.createElement("path", {
    d: "M89 58v-1h1v1z",
    fill: "#bc2628"
  })), _path3516 || (_path3516 = /*#__PURE__*/React.createElement("path", {
    d: "M91 57v1h-1v-1z",
    fill: "#bf292c"
  })), _path3517 || (_path3517 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57v1h-1v-1z",
    fill: "#b73339"
  })), _path3518 || (_path3518 = /*#__PURE__*/React.createElement("path", {
    d: "M92 58v-1h1v1z",
    fill: "#cb8284"
  })), _path3519 || (_path3519 = /*#__PURE__*/React.createElement("path", {
    d: "M94 57v1h-1v-1z",
    fill: "#b84a52"
  })), _path3520 || (_path3520 = /*#__PURE__*/React.createElement("path", {
    d: "M96 57v1h-1v-1z",
    fill: "#b6716d"
  })), _path3521 || (_path3521 = /*#__PURE__*/React.createElement("path", {
    d: "M96 58v-1h1v1z",
    fill: "#d9c1be",
    fillOpacity: 0.698
  })), _path3522 || (_path3522 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58h1v1h-1z",
    fill: "#ede4dc",
    fillOpacity: 0.522
  })), _path3523 || (_path3523 = /*#__PURE__*/React.createElement("path", {
    d: "M33 58v1h-1v-1z",
    fill: "#cebdb5"
  })), _path3524 || (_path3524 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59h-1v-1h1z",
    fill: "#c7c6c0"
  })), _path3525 || (_path3525 = /*#__PURE__*/React.createElement("path", {
    d: "M36 58h1v1h-1z",
    fill: "#ccc3ba"
  })), _path3526 || (_path3526 = /*#__PURE__*/React.createElement("path", {
    d: "M37 58h1v1h-1z",
    fill: "#b15148"
  })), _path3527 || (_path3527 = /*#__PURE__*/React.createElement("path", {
    d: "M38 59v-1h1v1z",
    fill: "#af1514"
  })), _path3528 || (_path3528 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h1v1h-1z",
    fill: "#af1616"
  })), _path3529 || (_path3529 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h-1v-1h1z",
    fill: "#aa1410"
  })), _path3530 || (_path3530 = /*#__PURE__*/React.createElement("path", {
    d: "M42 58h1v1h-1z",
    fill: "#a70e0d"
  })), _path3531 || (_path3531 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v1h-1v-1z",
    fill: "#a62e33"
  })), _path3532 || (_path3532 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v1h-1v-1z",
    fill: "#c06a63"
  })), _path3533 || (_path3533 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58h1v1h-1z",
    fill: "#a00e0b"
  })), _path3534 || (_path3534 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h1v1h-1z",
    fill: "#a60f13"
  })), _path3535 || (_path3535 = /*#__PURE__*/React.createElement("path", {
    d: "M53 58h1v1h-1z",
    fill: "#a50d12"
  })), _path3536 || (_path3536 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58v1h-1v-1z",
    fill: "#a00a0f"
  })), _path3537 || (_path3537 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h1v1h-1z",
    fill: "#a00b0f"
  })), _path3538 || (_path3538 = /*#__PURE__*/React.createElement("path", {
    d: "M57 59h-1v-1h1z",
    fill: "#a80f14"
  })), _path3539 || (_path3539 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59h-1v-1h1z",
    fill: "#b14d54"
  })), _path3540 || (_path3540 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59v-1h1v1z",
    fill: "#c8b6b6"
  })), _path3541 || (_path3541 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v-1h1v1z",
    fill: "#bdbeba"
  })), _path3542 || (_path3542 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v1h-1v-1z",
    fill: "#bdc2ba"
  })), _path3543 || (_path3543 = /*#__PURE__*/React.createElement("path", {
    d: "M64 58v1h-1v-1z",
    fill: "#c3c3b6"
  })), _path3544 || (_path3544 = /*#__PURE__*/React.createElement("path", {
    d: "M65 59h-1v-1h1z",
    fill: "#b78a80"
  })), _path3545 || (_path3545 = /*#__PURE__*/React.createElement("path", {
    d: "M65 58h1v1h-1z",
    fill: "#9a2f30"
  })), _path3546 || (_path3546 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v1h-1v-1z",
    fill: "#9f0c10"
  })), _path3547 || (_path3547 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59v-1h1v1z",
    fill: "#a90f19"
  })), _path3548 || (_path3548 = /*#__PURE__*/React.createElement("path", {
    d: "M69 59v-1h1v1z",
    fill: "#ab333c"
  })), _path3549 || (_path3549 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58h1v1h-1z",
    fill: "#c3908e"
  })), _path3550 || (_path3550 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59h-1v-1h1z",
    fill: "#cac0bb"
  })), _path3551 || (_path3551 = /*#__PURE__*/React.createElement("path", {
    d: "M74 58h1v1h-1z",
    fill: "#b27370"
  })), _path3552 || (_path3552 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v1h-1v-1z",
    fill: "#970a0f"
  })), _path3553 || (_path3553 = /*#__PURE__*/React.createElement("path", {
    d: "M76 59v-1h1v1z",
    fill: "#9f090c"
  })), _path3554 || (_path3554 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59h-1v-1h1z",
    fill: "#a00d0a"
  })), _path3555 || (_path3555 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v-1h1v1z",
    fill: "#9c0c11"
  })), _path3556 || (_path3556 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h-1v-1h1z",
    fill: "#bc7d7f"
  })), _path3557 || (_path3557 = /*#__PURE__*/React.createElement("path", {
    d: "M80 58h1v1h-1z",
    fill: "#d3beb8"
  })), _path3558 || (_path3558 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58h1v1h-1z",
    fill: "#b93f42"
  })), _path3559 || (_path3559 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58h1v1h-1z",
    fill: "#c31d26"
  })), _path3560 || (_path3560 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59h-1v-1h1z",
    fill: "#bc2729"
  })), _path3561 || (_path3561 = /*#__PURE__*/React.createElement("path", {
    d: "M92 59h-1v-1h1z",
    fill: "#b63239"
  })), _path3562 || (_path3562 = /*#__PURE__*/React.createElement("path", {
    d: "M92 58h1v1h-1z",
    fill: "#cd8589"
  })), _path3563 || (_path3563 = /*#__PURE__*/React.createElement("path", {
    d: "M93 59v-1h1v1z",
    fill: "#b84f57"
  })), _path3564 || (_path3564 = /*#__PURE__*/React.createElement("path", {
    d: "M95 59v-1h1v1z",
    fill: "#b66765"
  })), _path3565 || (_path3565 = /*#__PURE__*/React.createElement("path", {
    d: "M97 58v1h-1v-1z",
    fill: "#d9b7b6",
    fillOpacity: 0.686
  })), _path3566 || (_path3566 = /*#__PURE__*/React.createElement("path", {
    d: "M32 59h1v1h-1z",
    fill: "#d9d8d2"
  })), _path3567 || (_path3567 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59v1h-1v-1z",
    fill: "#c8c9c3"
  })), _path3568 || (_path3568 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59v1h-1v-1z",
    fill: "#c4c6c1"
  })), _path3569 || (_path3569 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h1v1h-1z",
    fill: "#c7c9c2"
  })), _path3570 || (_path3570 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60h-1v-1h1z",
    fill: "#c17570"
  })), _path3571 || (_path3571 = /*#__PURE__*/React.createElement("path", {
    d: "M39 60h-1v-1h1z",
    fill: "#a81814"
  })), _path3572 || (_path3572 = /*#__PURE__*/React.createElement("path", {
    d: "M40 59h1v1h-1z",
    fill: "#a61c21"
  })), _path3573 || (_path3573 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h1v1h-1z",
    fill: "#b04045"
  })), _path3574 || (_path3574 = /*#__PURE__*/React.createElement("path", {
    d: "M42 60v-1h1v1z",
    fill: "#9f2929"
  })), _path3575 || (_path3575 = /*#__PURE__*/React.createElement("path", {
    d: "M43 60v-1h1v1z",
    fill: "#b8767b"
  })), _path3576 || (_path3576 = /*#__PURE__*/React.createElement("path", {
    d: "M45 60h-1v-1h1z",
    fill: "#bc6f6a"
  })), _path3577 || (_path3577 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h-1v-1h1z",
    fill: "#9e0c08"
  })), _path3578 || (_path3578 = /*#__PURE__*/React.createElement("path", {
    d: "M52 59h1v1h-1z",
    fill: "#ac1016"
  })), _path3579 || (_path3579 = /*#__PURE__*/React.createElement("path", {
    d: "M54 59v1h-1v-1z",
    fill: "#a80e14"
  })), _path3580 || (_path3580 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59v1h-1v-1z",
    fill: "#ac0f17"
  })), _path3581 || (_path3581 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60h-1v-1h1z",
    fill: "#aa474a"
  })), _path3582 || (_path3582 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v1h-1v-1z",
    fill: "#c3b0b1"
  })), _path3583 || (_path3583 = /*#__PURE__*/React.createElement("path", {
    d: "M63 60h-1v-1h1z",
    fill: "#bebcba"
  })), _path3584 || (_path3584 = /*#__PURE__*/React.createElement("path", {
    d: "M64 59v1h-1v-1z",
    fill: "#babfb9"
  })), _path3585 || (_path3585 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v-1h1v1z",
    fill: "#c1c4ba"
  })), _path3586 || (_path3586 = /*#__PURE__*/React.createElement("path", {
    d: "M65 60v-1h1v1z",
    fill: "#c4b2a9"
  })), _path3587 || (_path3587 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60h-1v-1h1z",
    fill: "#b06a66"
  })), _path3588 || (_path3588 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h-1v-1h1z",
    fill: "#a42428"
  })), _path3589 || (_path3589 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60v-1h1v1z",
    fill: "#a61214"
  })), _path3590 || (_path3590 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60v-1h1v1z",
    fill: "#a7151d"
  })), _path3591 || (_path3591 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59v1h-1v-1z",
    fill: "#ad4a4d"
  })), _path3592 || (_path3592 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59h1v1h-1z",
    fill: "#bd8f8d"
  })), _path3593 || (_path3593 = /*#__PURE__*/React.createElement("path", {
    d: "M73 59h1v1h-1z",
    fill: "#cbb5b3"
  })), _path3594 || (_path3594 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60h-1v-1h1z",
    fill: "#cfc1b9"
  })), _path3595 || (_path3595 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59v1h-1v-1z",
    fill: "#b14b4e"
  })), _path3596 || (_path3596 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h1v1h-1z",
    fill: "#cfc7c7"
  })), _path3597 || (_path3597 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v-1h1v1z",
    fill: "#c27472"
  })), _path3598 || (_path3598 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59h1v1h-1z",
    fill: "#c31c24"
  })), _path3599 || (_path3599 = /*#__PURE__*/React.createElement("path", {
    d: "M89 60h-1v-1h1z",
    fill: "#bc2528"
  })), _path3600 || (_path3600 = /*#__PURE__*/React.createElement("path", {
    d: "M89 60v-1h1v1z",
    fill: "#bb2729"
  })), _path3601 || (_path3601 = /*#__PURE__*/React.createElement("path", {
    d: "M92 59v1h-1v-1z",
    fill: "#b73038"
  })), _path3602 || (_path3602 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60v-1h1v1z",
    fill: "#ce888b"
  })), _path3603 || (_path3603 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h-1v-1h1z",
    fill: "#b8575d"
  })), _path3604 || (_path3604 = /*#__PURE__*/React.createElement("path", {
    d: "M95 60h-1v-1h1z",
    fill: "#b44a4a"
  })), _path3605 || (_path3605 = /*#__PURE__*/React.createElement("path", {
    d: "M96 60h-1v-1h1z",
    fill: "#b56865"
  })), _path3606 || (_path3606 = /*#__PURE__*/React.createElement("path", {
    d: "M97 60h-1v-1h1z",
    fill: "#dcbbba",
    fillOpacity: 0.686
  })), _path3607 || (_path3607 = /*#__PURE__*/React.createElement("path", {
    d: "M31 61v-1h1v1z",
    fill: "#e9e5e3",
    fillOpacity: 0.502
  })), _path3608 || (_path3608 = /*#__PURE__*/React.createElement("path", {
    d: "M32 61v-1h1v1z",
    fill: "#dbdcd6"
  })), _path3609 || (_path3609 = /*#__PURE__*/React.createElement("path", {
    d: "M33 61v-1h1v1z",
    fill: "#c8cac4"
  })), _path3610 || (_path3610 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61h-1v-1h1z",
    fill: "#c6c8c3"
  })), _path3611 || (_path3611 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60v1h-1v-1z",
    fill: "#c2c3be"
  })), _path3612 || (_path3612 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60h1v1h-1z",
    fill: "#c2c8c4"
  })), _path3613 || (_path3613 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60v1h-1v-1z",
    fill: "#c48f87"
  })), _path3614 || (_path3614 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h-1v-1h1z",
    fill: "#a71a16"
  })), _path3615 || (_path3615 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61h-1v-1h1z",
    fill: "#aa262c"
  })), _path3616 || (_path3616 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61v-1h1v1z",
    fill: "#c09193"
  })), _path3617 || (_path3617 = /*#__PURE__*/React.createElement("path", {
    d: "M41 60h1v1h-1z",
    fill: "#c7bbb9"
  })), _path3618 || (_path3618 = /*#__PURE__*/React.createElement("path", {
    d: "M43 61h-1v-1h1z",
    fill: "#bda2a0"
  })), _path3619 || (_path3619 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60v1h-1v-1z",
    fill: "#ceb9b1"
  })), _path3620 || (_path3620 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60h1v1h-1z",
    fill: "#aa4947"
  })), _path3621 || (_path3621 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h1v1h-1z",
    fill: "#a20e0d"
  })), _path3622 || (_path3622 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h1v1h-1z",
    fill: "#a00b0c"
  })), _path3623 || (_path3623 = /*#__PURE__*/React.createElement("path", {
    d: "M53 61h-1v-1h1z",
    fill: "#b2131a"
  })), _path3624 || (_path3624 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h-1v-1h1z",
    fill: "#aa1016"
  })), _path3625 || (_path3625 = /*#__PURE__*/React.createElement("path", {
    d: "M59 60h1v1h-1z",
    fill: "#9f090e"
  })), _path3626 || (_path3626 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61h-1v-1h1z",
    fill: "#a7353d"
  })), _path3627 || (_path3627 = /*#__PURE__*/React.createElement("path", {
    d: "M61 60h1v1h-1z",
    fill: "#c29fa0"
  })), _path3628 || (_path3628 = /*#__PURE__*/React.createElement("path", {
    d: "M62 61v-1h1v1z",
    fill: "#c5c1bd"
  })), _path3629 || (_path3629 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v1h-1v-1z",
    fill: "#bebeba"
  })), _path3630 || (_path3630 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61v-1h1v1z",
    fill: "#bdbeb9"
  })), _path3631 || (_path3631 = /*#__PURE__*/React.createElement("path", {
    d: "M66 61h-1v-1h1z",
    fill: "#bfbfba"
  })), _path3632 || (_path3632 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60v1h-1v-1z",
    fill: "#c5c4bd"
  })), _path3633 || (_path3633 = /*#__PURE__*/React.createElement("path", {
    d: "M67 61v-1h1v1z",
    fill: "#cca49f"
  })), _path3634 || (_path3634 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h1v1h-1z",
    fill: "#b15a5b"
  })), _path3635 || (_path3635 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60v1h-1v-1z",
    fill: "#a12025"
  })), _path3636 || (_path3636 = /*#__PURE__*/React.createElement("path", {
    d: "M71 60h1v1h-1z",
    fill: "#a60a0f"
  })), _path3637 || (_path3637 = /*#__PURE__*/React.createElement("path", {
    d: "M72 60h1v1h-1z",
    fill: "#9b1318"
  })), _path3638 || (_path3638 = /*#__PURE__*/React.createElement("path", {
    d: "M74 60v1h-1v-1z",
    fill: "#9f2e30"
  })), _path3639 || (_path3639 = /*#__PURE__*/React.createElement("path", {
    d: "M75 61h-1v-1h1z",
    fill: "#b05959"
  })), _path3640 || (_path3640 = /*#__PURE__*/React.createElement("path", {
    d: "M76 60v1h-1v-1z",
    fill: "#bd726e"
  })), _path3641 || (_path3641 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61v-1h1v1z",
    fill: "#a02323"
  })), _path3642 || (_path3642 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60v1h-1v-1z",
    fill: "#a40a0d"
  })), _path3643 || (_path3643 = /*#__PURE__*/React.createElement("path", {
    d: "M80 60v1h-1v-1z",
    fill: "#ae4349"
  })), _path3644 || (_path3644 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v1h-1v-1z",
    fill: "#cfc3c4"
  })), _path3645 || (_path3645 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v-1h1v1z",
    fill: "#cc9e9c"
  })), _path3646 || (_path3646 = /*#__PURE__*/React.createElement("path", {
    d: "M83 61h-1v-1h1z",
    fill: "#b72229"
  })), _path3647 || (_path3647 = /*#__PURE__*/React.createElement("path", {
    d: "M90 61h-1v-1h1z",
    fill: "#bc2629"
  })), _path3648 || (_path3648 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60v1h-1v-1z",
    fill: "#b82f37"
  })), _path3649 || (_path3649 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60h1v1h-1z",
    fill: "#cf8a8d"
  })), _path3650 || (_path3650 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61v-1h1v1z",
    fill: "#b85e61"
  })), _path3651 || (_path3651 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h1v1h-1z",
    fill: "#b34849"
  })), _path3652 || (_path3652 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v-1h1v1z",
    fill: "#b06360"
  })), _path3653 || (_path3653 = /*#__PURE__*/React.createElement("path", {
    d: "M96 60h1v1h-1z",
    fill: "#d9b8b5",
    fillOpacity: 0.671
  })), _path3654 || (_path3654 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62v-1h1v1z",
    fill: "#dcdbd5"
  })), _path3655 || (_path3655 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61v1h-1v-1z",
    fill: "#c5c9c2"
  })), _path3656 || (_path3656 = /*#__PURE__*/React.createElement("path", {
    d: "M36 61h1v1h-1z",
    fill: "#c2c7c3"
  })), _path3657 || (_path3657 = /*#__PURE__*/React.createElement("path", {
    d: "M37 62v-1h1v1z",
    fill: "#c59a8e"
  })), _path3658 || (_path3658 = /*#__PURE__*/React.createElement("path", {
    d: "M38 61h1v1h-1z",
    fill: "#9c1e1c"
  })), _path3659 || (_path3659 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h1v1h-1z",
    fill: "#be838a"
  })), _path3660 || (_path3660 = /*#__PURE__*/React.createElement("path", {
    d: "M41 61v1h-1v-1z",
    fill: "#c6c6c4"
  })), _path3661 || (_path3661 = /*#__PURE__*/React.createElement("path", {
    d: "M44 62h-1v-1h1z",
    fill: "#bda39c"
  })), _path3662 || (_path3662 = /*#__PURE__*/React.createElement("path", {
    d: "M44 61h1v1h-1z",
    fill: "#b04442"
  })), _path3663 || (_path3663 = /*#__PURE__*/React.createElement("path", {
    d: "M45 61h1v1h-1z",
    fill: "#a30c0c"
  })), _path3664 || (_path3664 = /*#__PURE__*/React.createElement("path", {
    d: "M47 62h-1v-1h1z",
    fill: "#a30d0d"
  })), _path3665 || (_path3665 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h-1v-1h1z",
    fill: "#b3141a"
  })), _path3666 || (_path3666 = /*#__PURE__*/React.createElement("path", {
    d: "M57 61h1v1h-1z",
    fill: "#a50e11"
  })), _path3667 || (_path3667 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h1v1h-1z",
    fill: "#b96464"
  })), _path3668 || (_path3668 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h-1v-1h1z",
    fill: "#ac5353"
  })), _path3669 || (_path3669 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61v1h-1v-1z",
    fill: "#9b0f11"
  })), _path3670 || (_path3670 = /*#__PURE__*/React.createElement("path", {
    d: "M61 62v-1h1v1z",
    fill: "#a01d27"
  })), _path3671 || (_path3671 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v-1h1v1z",
    fill: "#c17f83"
  })), _path3672 || (_path3672 = /*#__PURE__*/React.createElement("path", {
    d: "M63 61h1v1h-1z",
    fill: "#c7bfba"
  })), _path3673 || (_path3673 = /*#__PURE__*/React.createElement("path", {
    d: "M65 61h1v1h-1z",
    fill: "#bdbdb8"
  })), _path3674 || (_path3674 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62v-1h1v1z",
    fill: "#bbc0bb"
  })), _path3675 || (_path3675 = /*#__PURE__*/React.createElement("path", {
    d: "M69 61v1h-1v-1z",
    fill: "#c8c2be"
  })), _path3676 || (_path3676 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62h-1v-1h1z",
    fill: "#c3a2a0"
  })), _path3677 || (_path3677 = /*#__PURE__*/React.createElement("path", {
    d: "M71 61v1h-1v-1z",
    fill: "#ae6261"
  })), _path3678 || (_path3678 = /*#__PURE__*/React.createElement("path", {
    d: "M71 62v-1h1v1z",
    fill: "#a3282c"
  })), _path3679 || (_path3679 = /*#__PURE__*/React.createElement("path", {
    d: "M74 62h-1v-1h1z",
    fill: "#9b090a"
  })), _path3680 || (_path3680 = /*#__PURE__*/React.createElement("path", {
    d: "M74 61h1v1h-1z",
    fill: "#9a060a"
  })), _path3681 || (_path3681 = /*#__PURE__*/React.createElement("path", {
    d: "M76 62h-1v-1h1z",
    fill: "#98090e"
  })), _path3682 || (_path3682 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62v-1h1v1z",
    fill: "#99090c"
  })), _path3683 || (_path3683 = /*#__PURE__*/React.createElement("path", {
    d: "M80 62h-1v-1h1z",
    fill: "#bc696f"
  })), _path3684 || (_path3684 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62h-1v-1h1z",
    fill: "#ccb0ae"
  })), _path3685 || (_path3685 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62v-1h1v1z",
    fill: "#b73035"
  })), _path3686 || (_path3686 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62v-1h1v1z",
    fill: "#bf2a2f"
  })), _path3687 || (_path3687 = /*#__PURE__*/React.createElement("path", {
    d: "M91 61h1v1h-1z",
    fill: "#b72e36"
  })), _path3688 || (_path3688 = /*#__PURE__*/React.createElement("path", {
    d: "M92 61h1v1h-1z",
    fill: "#cc8c8e"
  })), _path3689 || (_path3689 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61h1v1h-1z",
    fill: "#ba676b"
  })), _path3690 || (_path3690 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v1h-1v-1z",
    fill: "#b24547"
  })), _path3691 || (_path3691 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61h1v1h-1z",
    fill: "#b36866"
  })), _path3692 || (_path3692 = /*#__PURE__*/React.createElement("path", {
    d: "M97 61v1h-1v-1z",
    fill: "#debebb",
    fillOpacity: 0.651
  })), _path3693 || (_path3693 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63h-1v-1h1z",
    fill: "#e5e7e1",
    fillOpacity: 0.506
  })), _path3694 || (_path3694 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62v1h-1v-1z",
    fill: "#dadcd5"
  })), _path3695 || (_path3695 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62h1v1h-1z",
    fill: "#c6c8c1"
  })), _path3696 || (_path3696 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63v-1h1v1z",
    fill: "#c5c2c0"
  })), _path3697 || (_path3697 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63v-1h1v1z",
    fill: "#bc9a95"
  })), _path3698 || (_path3698 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63h-1v-1h1z",
    fill: "#a7605f"
  })), _path3699 || (_path3699 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63h-1v-1h1z",
    fill: "#c8c0bd"
  })), _path3700 || (_path3700 = /*#__PURE__*/React.createElement("path", {
    d: "M42 63v-1h1v1z",
    fill: "#c1c5be"
  })), _path3701 || (_path3701 = /*#__PURE__*/React.createElement("path", {
    d: "M43 63v-1h1v1z",
    fill: "#ca9f98"
  })), _path3702 || (_path3702 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63h-1v-1h1z",
    fill: "#a92425"
  })), _path3703 || (_path3703 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63v-1h1v1z",
    fill: "#a70c0e"
  })), _path3704 || (_path3704 = /*#__PURE__*/React.createElement("path", {
    d: "M46 62h1v1h-1z",
    fill: "#a30d0e"
  })), _path3705 || (_path3705 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h1v1h-1z",
    fill: "#aa0f11"
  })), _path3706 || (_path3706 = /*#__PURE__*/React.createElement("path", {
    d: "M58 62h1v1h-1z",
    fill: "#bf7d7f"
  })), _path3707 || (_path3707 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62v1h-1v-1z",
    fill: "#c9c3bb"
  })), _path3708 || (_path3708 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h1v1h-1z",
    fill: "#b98278"
  })), _path3709 || (_path3709 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v1h-1v-1z",
    fill: "#a22020"
  })), _path3710 || (_path3710 = /*#__PURE__*/React.createElement("path", {
    d: "M63 62v1h-1v-1z",
    fill: "#9c0f16"
  })), _path3711 || (_path3711 = /*#__PURE__*/React.createElement("path", {
    d: "M63 63v-1h1v1z",
    fill: "#aa5e60"
  })), _path3712 || (_path3712 = /*#__PURE__*/React.createElement("path", {
    d: "M65 62h1v1h-1z",
    fill: "#c5c1bf"
  })), _path3713 || (_path3713 = /*#__PURE__*/React.createElement("path", {
    d: "M67 63v-1h1v1z",
    fill: "#bcc1bb"
  })), _path3714 || (_path3714 = /*#__PURE__*/React.createElement("path", {
    d: "M71 63h-1v-1h1z",
    fill: "#c5c5bd"
  })), _path3715 || (_path3715 = /*#__PURE__*/React.createElement("path", {
    d: "M72 62v1h-1v-1z",
    fill: "#c2b5ab"
  })), _path3716 || (_path3716 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62v1h-1v-1z",
    fill: "#ba8983"
  })), _path3717 || (_path3717 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62h1v1h-1z",
    fill: "#ab5956"
  })), _path3718 || (_path3718 = /*#__PURE__*/React.createElement("path", {
    d: "M75 62v1h-1v-1z",
    fill: "#9b342e"
  })), _path3719 || (_path3719 = /*#__PURE__*/React.createElement("path", {
    d: "M75 63v-1h1v1z",
    fill: "#8f1d19"
  })), _path3720 || (_path3720 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63v-1h1v1z",
    fill: "#8e1514"
  })), _path3721 || (_path3721 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63h-1v-1h1z",
    fill: "#941c1f"
  })), _path3722 || (_path3722 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62h1v1h-1z",
    fill: "#a95454"
  })), _path3723 || (_path3723 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v-1h1v1z",
    fill: "#c7b8b0"
  })), _path3724 || (_path3724 = /*#__PURE__*/React.createElement("path", {
    d: "M80 63v-1h1v1z",
    fill: "#c5c6c5"
  })), _path3725 || (_path3725 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v-1h1v1z",
    fill: "#cbb7b4"
  })), _path3726 || (_path3726 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63h-1v-1h1z",
    fill: "#b9373c"
  })), _path3727 || (_path3727 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62h1v1h-1z",
    fill: "#c02930"
  })), _path3728 || (_path3728 = /*#__PURE__*/React.createElement("path", {
    d: "M92 62v1h-1v-1z",
    fill: "#b72e35"
  })), _path3729 || (_path3729 = /*#__PURE__*/React.createElement("path", {
    d: "M92 63v-1h1v1z",
    fill: "#ca8e8e"
  })), _path3730 || (_path3730 = /*#__PURE__*/React.createElement("path", {
    d: "M93 63v-1h1v1z",
    fill: "#bc6f73"
  })), _path3731 || (_path3731 = /*#__PURE__*/React.createElement("path", {
    d: "M94 63v-1h1v1z",
    fill: "#b14245"
  })), _path3732 || (_path3732 = /*#__PURE__*/React.createElement("path", {
    d: "M95 62h1v1h-1z",
    fill: "#af6664"
  })), _path3733 || (_path3733 = /*#__PURE__*/React.createElement("path", {
    d: "M96 63v-1h1v1z",
    fill: "#dbbbba",
    fillOpacity: 0.639
  })), _path3734 || (_path3734 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63v1h-1v-1z",
    fill: "#e5e5e1",
    fillOpacity: 0.506
  })), _path3735 || (_path3735 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64v-1h1v1z",
    fill: "#daddd7"
  })), _path3736 || (_path3736 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63v1h-1v-1z",
    fill: "#c8c8c5"
  })), _path3737 || (_path3737 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64v-1h1v1z",
    fill: "#c1c7c3"
  })), _path3738 || (_path3738 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63h1v1h-1z",
    fill: "#c6bebb"
  })), _path3739 || (_path3739 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64v-1h1v1z",
    fill: "#cabcbd"
  })), _path3740 || (_path3740 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63h1v1h-1z",
    fill: "#c2c3bc"
  })), _path3741 || (_path3741 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63h1v1h-1z",
    fill: "#c3c0be"
  })), _path3742 || (_path3742 = /*#__PURE__*/React.createElement("path", {
    d: "M41 63h1v1h-1z",
    fill: "#bdc6c1"
  })), _path3743 || (_path3743 = /*#__PURE__*/React.createElement("path", {
    d: "M42 63h1v1h-1z",
    fill: "#cbbdb4"
  })), _path3744 || (_path3744 = /*#__PURE__*/React.createElement("path", {
    d: "M44 64h-1v-1h1z",
    fill: "#ac4e4d"
  })), _path3745 || (_path3745 = /*#__PURE__*/React.createElement("path", {
    d: "M44 64v-1h1v1z",
    fill: "#a60e11"
  })), _path3746 || (_path3746 = /*#__PURE__*/React.createElement("path", {
    d: "M47 63v1h-1v-1z",
    fill: "#a40e0f"
  })), _path3747 || (_path3747 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64v-1h1v1z",
    fill: "#aa1112"
  })), _path3748 || (_path3748 = /*#__PURE__*/React.createElement("path", {
    d: "M57 64h-1v-1h1z",
    fill: "#a90f10"
  })), _path3749 || (_path3749 = /*#__PURE__*/React.createElement("path", {
    d: "M57 63h1v1h-1z",
    fill: "#a20d12"
  })), _path3750 || (_path3750 = /*#__PURE__*/React.createElement("path", {
    d: "M59 63v1h-1v-1z",
    fill: "#be7f80"
  })), _path3751 || (_path3751 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64v-1h1v1z",
    fill: "#c1c8c6"
  })), _path3752 || (_path3752 = /*#__PURE__*/React.createElement("path", {
    d: "M61 64h-1v-1h1z",
    fill: "#c6c4ba"
  })), _path3753 || (_path3753 = /*#__PURE__*/React.createElement("path", {
    d: "M62 63v1h-1v-1z",
    fill: "#b25350"
  })), _path3754 || (_path3754 = /*#__PURE__*/React.createElement("path", {
    d: "M64 64h-1v-1h1z",
    fill: "#9e0e13"
  })), _path3755 || (_path3755 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64h-1v-1h1z",
    fill: "#a4313a"
  })), _path3756 || (_path3756 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64h-1v-1h1z",
    fill: "#c08d90"
  })), _path3757 || (_path3757 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v-1h1v1z",
    fill: "#c7c0bc"
  })), _path3758 || (_path3758 = /*#__PURE__*/React.createElement("path", {
    d: "M68 63v1h-1v-1z",
    fill: "#bdc6bf"
  })), _path3759 || (_path3759 = /*#__PURE__*/React.createElement("path", {
    d: "M71 64v-1h1v1z",
    fill: "#c1c3bf"
  })), _path3760 || (_path3760 = /*#__PURE__*/React.createElement("path", {
    d: "M74 63h1v1h-1z",
    fill: "#c1b9b2"
  })), _path3761 || (_path3761 = /*#__PURE__*/React.createElement("path", {
    d: "M76 64h-1v-1h1z",
    fill: "#baa5a0"
  })), _path3762 || (_path3762 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63h1v1h-1z",
    fill: "#b79e99"
  })), _path3763 || (_path3763 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63v1h-1v-1z",
    fill: "#bdaba7"
  })), _path3764 || (_path3764 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v1h-1v-1z",
    fill: "#c6c1bc"
  })), _path3765 || (_path3765 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63h1v1h-1z",
    fill: "#c1c6be"
  })), _path3766 || (_path3766 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v1h-1v-1z",
    fill: "#c4c7c4"
  })), _path3767 || (_path3767 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v-1h1v1z",
    fill: "#cfadaf"
  })), _path3768 || (_path3768 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63v1h-1v-1z",
    fill: "#b82e35"
  })), _path3769 || (_path3769 = /*#__PURE__*/React.createElement("path", {
    d: "M83 64v-1h1v1z",
    fill: "#be1d20"
  })), _path3770 || (_path3770 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64v-1h1v1z",
    fill: "#c21f23"
  })), _path3771 || (_path3771 = /*#__PURE__*/React.createElement("path", {
    d: "M91 63h1v1h-1z",
    fill: "#b82e34"
  })), _path3772 || (_path3772 = /*#__PURE__*/React.createElement("path", {
    d: "M93 64h-1v-1h1z",
    fill: "#ca8d8e"
  })), _path3773 || (_path3773 = /*#__PURE__*/React.createElement("path", {
    d: "M94 64h-1v-1h1z",
    fill: "#c0767a"
  })), _path3774 || (_path3774 = /*#__PURE__*/React.createElement("path", {
    d: "M95 63v1h-1v-1z",
    fill: "#ad4043"
  })), _path3775 || (_path3775 = /*#__PURE__*/React.createElement("path", {
    d: "M95 64v-1h1v1z",
    fill: "#b06664"
  })), _path3776 || (_path3776 = /*#__PURE__*/React.createElement("path", {
    d: "M97 63v1h-1v-1z",
    fill: "#dcbcba",
    fillOpacity: 0.643
  })), _path3777 || (_path3777 = /*#__PURE__*/React.createElement("path", {
    d: "M31 65v-1h1v1z",
    fill: "#e3e5df",
    fillOpacity: 0.51
  })), _path3778 || (_path3778 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64h1v1h-1z",
    fill: "#dcddd7"
  })), _path3779 || (_path3779 = /*#__PURE__*/React.createElement("path", {
    d: "M34 64v1h-1v-1z",
    fill: "#c9c8c4"
  })), _path3780 || (_path3780 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65v-1h1v1z",
    fill: "#c7cbc8"
  })), _path3781 || (_path3781 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64h1v1h-1z",
    fill: "#c3cdc4"
  })), _path3782 || (_path3782 = /*#__PURE__*/React.createElement("path", {
    d: "M36 64h1v1h-1z",
    fill: "#d1bdb5"
  })), _path3783 || (_path3783 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v-1h1v1z",
    fill: "#af6566"
  })), _path3784 || (_path3784 = /*#__PURE__*/React.createElement("path", {
    d: "M39 64h1v1h-1z",
    fill: "#c9c7c6"
  })), _path3785 || (_path3785 = /*#__PURE__*/React.createElement("path", {
    d: "M40 64h1v1h-1z",
    fill: "#cdc5c1"
  })), _path3786 || (_path3786 = /*#__PURE__*/React.createElement("path", {
    d: "M41 65v-1h1v1z",
    fill: "#ceaea8"
  })), _path3787 || (_path3787 = /*#__PURE__*/React.createElement("path", {
    d: "M43 64v1h-1v-1z",
    fill: "#b05655"
  })), _path3788 || (_path3788 = /*#__PURE__*/React.createElement("path", {
    d: "M43 64h1v1h-1z",
    fill: "#a31216"
  })), _path3789 || (_path3789 = /*#__PURE__*/React.createElement("path", {
    d: "M45 64h1v1h-1z",
    fill: "#a70e11"
  })), _path3790 || (_path3790 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65h-1v-1h1z",
    fill: "#a20b0e"
  })), _path3791 || (_path3791 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64v1h-1v-1z",
    fill: "#a40d10"
  })), _path3792 || (_path3792 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64h1v1h-1z",
    fill: "#ab4b48"
  })), _path3793 || (_path3793 = /*#__PURE__*/React.createElement("path", {
    d: "M60 64h1v1h-1z",
    fill: "#c8c7bd"
  })), _path3794 || (_path3794 = /*#__PURE__*/React.createElement("path", {
    d: "M61 65v-1h1v1z",
    fill: "#b45454"
  })), _path3795 || (_path3795 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65h-1v-1h1z",
    fill: "#a61111"
  })), _path3796 || (_path3796 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v1h-1v-1z",
    fill: "#9b141c"
  })), _path3797 || (_path3797 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v-1h1v1z",
    fill: "#b05359"
  })), _path3798 || (_path3798 = /*#__PURE__*/React.createElement("path", {
    d: "M68 65h-1v-1h1z",
    fill: "#c9a5a5"
  })), _path3799 || (_path3799 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65h-1v-1h1z",
    fill: "#c7c5c1"
  })), _path3800 || (_path3800 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v-1h1v1z",
    fill: "#bec4be"
  })), _path3801 || (_path3801 = /*#__PURE__*/React.createElement("path", {
    d: "M72 64v1h-1v-1z",
    fill: "#c0bfba"
  })), _path3802 || (_path3802 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65v-1h1v1z",
    fill: "#bfc2b9"
  })), _path3803 || (_path3803 = /*#__PURE__*/React.createElement("path", {
    d: "M77 65h-1v-1h1z",
    fill: "#c0c3ba"
  })), _path3804 || (_path3804 = /*#__PURE__*/React.createElement("path", {
    d: "M79 64v1h-1v-1z",
    fill: "#bdc0bb"
  })), _path3805 || (_path3805 = /*#__PURE__*/React.createElement("path", {
    d: "M82 64v1h-1v-1z",
    fill: "#c68f91"
  })), _path3806 || (_path3806 = /*#__PURE__*/React.createElement("path", {
    d: "M83 65h-1v-1h1z",
    fill: "#b71d24"
  })), _path3807 || (_path3807 = /*#__PURE__*/React.createElement("path", {
    d: "M84 64v1h-1v-1z",
    fill: "#c11d20"
  })), _path3808 || (_path3808 = /*#__PURE__*/React.createElement("path", {
    d: "M91 65v-1h1v1z",
    fill: "#b82c34"
  })), _path3809 || (_path3809 = /*#__PURE__*/React.createElement("path", {
    d: "M92 65v-1h1v1z",
    fill: "#c98d8e"
  })), _path3810 || (_path3810 = /*#__PURE__*/React.createElement("path", {
    d: "M94 64v1h-1v-1z",
    fill: "#c47e82"
  })), _path3811 || (_path3811 = /*#__PURE__*/React.createElement("path", {
    d: "M95 65h-1v-1h1z",
    fill: "#ab3f41"
  })), _path3812 || (_path3812 = /*#__PURE__*/React.createElement("path", {
    d: "M95 64h1v1h-1z",
    fill: "#b36967"
  })), _path3813 || (_path3813 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64v1h-1v-1z",
    fill: "#debebb",
    fillOpacity: 0.639
  })), _path3814 || (_path3814 = /*#__PURE__*/React.createElement("path", {
    d: "M32 66h-1v-1h1z",
    fill: "#e5e5e1",
    fillOpacity: 0.51
  })), _path3815 || (_path3815 = /*#__PURE__*/React.createElement("path", {
    d: "M32 65h1v1h-1z",
    fill: "#dcddd9"
  })), _path3816 || (_path3816 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h-1v-1h1z",
    fill: "#c8c8c3"
  })), _path3817 || (_path3817 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66v-1h1v1z",
    fill: "#ceb8b0"
  })), _path3818 || (_path3818 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v1h-1v-1z",
    fill: "#bb6a66"
  })), _path3819 || (_path3819 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65h1v1h-1z",
    fill: "#a8181b"
  })), _path3820 || (_path3820 = /*#__PURE__*/React.createElement("path", {
    d: "M38 66v-1h1v1z",
    fill: "#ae3037"
  })), _path3821 || (_path3821 = /*#__PURE__*/React.createElement("path", {
    d: "M39 66v-1h1v1z",
    fill: "#c06c74"
  })), _path3822 || (_path3822 = /*#__PURE__*/React.createElement("path", {
    d: "M40 66v-1h1v1z",
    fill: "#ba6669"
  })), _path3823 || (_path3823 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66h-1v-1h1z",
    fill: "#a82f2f"
  })), _path3824 || (_path3824 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66h-1v-1h1z",
    fill: "#a30c0d"
  })), _path3825 || (_path3825 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66h-1v-1h1z",
    fill: "#a90f13"
  })), _path3826 || (_path3826 = /*#__PURE__*/React.createElement("path", {
    d: "M59 65v1h-1v-1z",
    fill: "#a4080e"
  })), _path3827 || (_path3827 = /*#__PURE__*/React.createElement("path", {
    d: "M60 65v1h-1v-1z",
    fill: "#a1272d"
  })), _path3828 || (_path3828 = /*#__PURE__*/React.createElement("path", {
    d: "M60 66v-1h1v1z",
    fill: "#bd857f"
  })), _path3829 || (_path3829 = /*#__PURE__*/React.createElement("path", {
    d: "M62 65v1h-1v-1z",
    fill: "#b95050"
  })), _path3830 || (_path3830 = /*#__PURE__*/React.createElement("path", {
    d: "M64 66v-1h1v1z",
    fill: "#a60f14"
  })), _path3831 || (_path3831 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65h1v1h-1z",
    fill: "#a20b14"
  })), _path3832 || (_path3832 = /*#__PURE__*/React.createElement("path", {
    d: "M67 65h1v1h-1z",
    fill: "#a4222d"
  })), _path3833 || (_path3833 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v1h-1v-1z",
    fill: "#b8666a"
  })), _path3834 || (_path3834 = /*#__PURE__*/React.createElement("path", {
    d: "M70 65v1h-1v-1z",
    fill: "#c6a9aa"
  })), _path3835 || (_path3835 = /*#__PURE__*/React.createElement("path", {
    d: "M71 66h-1v-1h1z",
    fill: "#c5c3be"
  })), _path3836 || (_path3836 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65v1h-1v-1z",
    fill: "#bfbfb8"
  })), _path3837 || (_path3837 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66h-1v-1h1z",
    fill: "#bebfb8"
  })), _path3838 || (_path3838 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66h-1v-1h1z",
    fill: "#bebfb9"
  })), _path3839 || (_path3839 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65v1h-1v-1z",
    fill: "#c3c5c4"
  })), _path3840 || (_path3840 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65v1h-1v-1z",
    fill: "#cbc1bd"
  })), _path3841 || (_path3841 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65h1v1h-1z",
    fill: "#bb4a54"
  })), _path3842 || (_path3842 = /*#__PURE__*/React.createElement("path", {
    d: "M82 65h1v1h-1z",
    fill: "#bf1820"
  })), _path3843 || (_path3843 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66h-1v-1h1z",
    fill: "#b82c32"
  })), _path3844 || (_path3844 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65v1h-1v-1z",
    fill: "#ca8c8b"
  })), _path3845 || (_path3845 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65h1v1h-1z",
    fill: "#c48688"
  })), _path3846 || (_path3846 = /*#__PURE__*/React.createElement("path", {
    d: "M94 65h1v1h-1z",
    fill: "#aa3f43"
  })), _path3847 || (_path3847 = /*#__PURE__*/React.createElement("path", {
    d: "M96 65v1h-1v-1z",
    fill: "#b76c6b"
  })), _path3848 || (_path3848 = /*#__PURE__*/React.createElement("path", {
    d: "M96 65h1v1h-1z",
    fill: "#dfc0bf",
    fillOpacity: 0.627
  })), _path3849 || (_path3849 = /*#__PURE__*/React.createElement("path", {
    d: "M31 66h1v1h-1z",
    fill: "#e3e3e1",
    fillOpacity: 0.514
  })), _path3850 || (_path3850 = /*#__PURE__*/React.createElement("path", {
    d: "M32 67v-1h1v1z",
    fill: "#dddddb"
  })), _path3851 || (_path3851 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66v1h-1v-1z",
    fill: "#ccc9bf"
  })), _path3852 || (_path3852 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h1v1h-1z",
    fill: "#b87570"
  })), _path3853 || (_path3853 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66h1v1h-1z",
    fill: "#b13c40"
  })), _path3854 || (_path3854 = /*#__PURE__*/React.createElement("path", {
    d: "M37 66v1h-1v-1z",
    fill: "#b12124"
  })), _path3855 || (_path3855 = /*#__PURE__*/React.createElement("path", {
    d: "M37 67v-1h1v1z",
    fill: "#b21d1d"
  })), _path3856 || (_path3856 = /*#__PURE__*/React.createElement("path", {
    d: "M39 66v1h-1v-1z",
    fill: "#b01619"
  })), _path3857 || (_path3857 = /*#__PURE__*/React.createElement("path", {
    d: "M40 67h-1v-1h1z",
    fill: "#aa1317"
  })), _path3858 || (_path3858 = /*#__PURE__*/React.createElement("path", {
    d: "M40 66h1v1h-1z",
    fill: "#aa1218"
  })), _path3859 || (_path3859 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h-1v-1h1z",
    fill: "#a90e11"
  })), _path3860 || (_path3860 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66v1h-1v-1z",
    fill: "#a40c0d"
  })), _path3861 || (_path3861 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67v-1h1v1z",
    fill: "#a2090c"
  })), _path3862 || (_path3862 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67v-1h1v1z",
    fill: "#af1318"
  })), _path3863 || (_path3863 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66v1h-1v-1z",
    fill: "#aa1014"
  })), _path3864 || (_path3864 = /*#__PURE__*/React.createElement("path", {
    d: "M55 67v-1h1v1z",
    fill: "#a30a0e"
  })), _path3865 || (_path3865 = /*#__PURE__*/React.createElement("path", {
    d: "M57 67h-1v-1h1z",
    fill: "#a50b10"
  })), _path3866 || (_path3866 = /*#__PURE__*/React.createElement("path", {
    d: "M59 66v1h-1v-1z",
    fill: "#ab2629"
  })), _path3867 || (_path3867 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67v-1h1v1z",
    fill: "#a21219"
  })), _path3868 || (_path3868 = /*#__PURE__*/React.createElement("path", {
    d: "M60 67v-1h1v1z",
    fill: "#a41016"
  })), _path3869 || (_path3869 = /*#__PURE__*/React.createElement("path", {
    d: "M62 67h-1v-1h1z",
    fill: "#a91922"
  })), _path3870 || (_path3870 = /*#__PURE__*/React.createElement("path", {
    d: "M62 66h1v1h-1z",
    fill: "#a80e17"
  })), _path3871 || (_path3871 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67h-1v-1h1z",
    fill: "#a60f15"
  })), _path3872 || (_path3872 = /*#__PURE__*/React.createElement("path", {
    d: "M65 67v-1h1v1z",
    fill: "#ab0d13"
  })), _path3873 || (_path3873 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67v-1h1v1z",
    fill: "#a70c0f"
  })), _path3874 || (_path3874 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v-1h1v1z",
    fill: "#a20e15"
  })), _path3875 || (_path3875 = /*#__PURE__*/React.createElement("path", {
    d: "M69 66h1v1h-1z",
    fill: "#a5222a"
  })), _path3876 || (_path3876 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67h-1v-1h1z",
    fill: "#b05c5d"
  })), _path3877 || (_path3877 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67v-1h1v1z",
    fill: "#c09995"
  })), _path3878 || (_path3878 = /*#__PURE__*/React.createElement("path", {
    d: "M74 67h-1v-1h1z",
    fill: "#c6c4be"
  })), _path3879 || (_path3879 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67h-1v-1h1z",
    fill: "#c5c4c0"
  })), _path3880 || (_path3880 = /*#__PURE__*/React.createElement("path", {
    d: "M76 67h-1v-1h1z",
    fill: "#c0c4c1"
  })), _path3881 || (_path3881 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66v1h-1v-1z",
    fill: "#bfc3c2"
  })), _path3882 || (_path3882 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h1v1h-1z",
    fill: "#c2c3c1"
  })), _path3883 || (_path3883 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v-1h1v1z",
    fill: "#c5c3c3"
  })), _path3884 || (_path3884 = /*#__PURE__*/React.createElement("path", {
    d: "M80 66v1h-1v-1z",
    fill: "#cdb4b7"
  })), _path3885 || (_path3885 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h-1v-1h1z",
    fill: "#c1646a"
  })), _path3886 || (_path3886 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v-1h1v1z",
    fill: "#ba1a23"
  })), _path3887 || (_path3887 = /*#__PURE__*/React.createElement("path", {
    d: "M91 67h-1v-1h1z",
    fill: "#bf292e"
  })), _path3888 || (_path3888 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66v1h-1v-1z",
    fill: "#b82d30"
  })), _path3889 || (_path3889 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66h1v1h-1z",
    fill: "#cb8d8a"
  })), _path3890 || (_path3890 = /*#__PURE__*/React.createElement("path", {
    d: "M94 66v1h-1v-1z",
    fill: "#c39290"
  })), _path3891 || (_path3891 = /*#__PURE__*/React.createElement("path", {
    d: "M95 66v1h-1v-1z",
    fill: "#a94044"
  })), _path3892 || (_path3892 = /*#__PURE__*/React.createElement("path", {
    d: "M96 67h-1v-1h1z",
    fill: "#b96c6d"
  })), _path3893 || (_path3893 = /*#__PURE__*/React.createElement("path", {
    d: "M97 66v1h-1v-1z",
    fill: "#dcbebc",
    fillOpacity: 0.616
  })), _path3894 || (_path3894 = /*#__PURE__*/React.createElement("path", {
    d: "M32 68h-1v-1h1z",
    fill: "#e5e3e1",
    fillOpacity: 0.514
  })), _path3895 || (_path3895 = /*#__PURE__*/React.createElement("path", {
    d: "M33 67v1h-1v-1z",
    fill: "#dedddb"
  })), _path3896 || (_path3896 = /*#__PURE__*/React.createElement("path", {
    d: "M33 68v-1h1v1z",
    fill: "#cfc5ba"
  })), _path3897 || (_path3897 = /*#__PURE__*/React.createElement("path", {
    d: "M34 67h1v1h-1z",
    fill: "#b05b4e"
  })), _path3898 || (_path3898 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v-1h1v1z",
    fill: "#b22825"
  })), _path3899 || (_path3899 = /*#__PURE__*/React.createElement("path", {
    d: "M36 67h1v1h-1z",
    fill: "#b12323"
  })), _path3900 || (_path3900 = /*#__PURE__*/React.createElement("path", {
    d: "M38 67v1h-1v-1z",
    fill: "#b21e1f"
  })), _path3901 || (_path3901 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v-1h1v1z",
    fill: "#b3181b"
  })), _path3902 || (_path3902 = /*#__PURE__*/React.createElement("path", {
    d: "M40 68v-1h1v1z",
    fill: "#b31618"
  })), _path3903 || (_path3903 = /*#__PURE__*/React.createElement("path", {
    d: "M45 68h-1v-1h1z",
    fill: "#ae0f13"
  })), _path3904 || (_path3904 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67h1v1h-1z",
    fill: "#9f090b"
  })), _path3905 || (_path3905 = /*#__PURE__*/React.createElement("path", {
    d: "M53 68h-1v-1h1z",
    fill: "#b11318"
  })), _path3906 || (_path3906 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67h1v1h-1z",
    fill: "#ae1317"
  })), _path3907 || (_path3907 = /*#__PURE__*/React.createElement("path", {
    d: "M54 67h1v1h-1z",
    fill: "#a90f12"
  })), _path3908 || (_path3908 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h-1v-1h1z",
    fill: "#a30c10"
  })), _path3909 || (_path3909 = /*#__PURE__*/React.createElement("path", {
    d: "M58 67h1v1h-1z",
    fill: "#bc7e7a"
  })), _path3910 || (_path3910 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67h1v1h-1z",
    fill: "#bf8f8a"
  })), _path3911 || (_path3911 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67v1h-1v-1z",
    fill: "#a53031"
  })), _path3912 || (_path3912 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67h1v1h-1z",
    fill: "#9f0e0f"
  })), _path3913 || (_path3913 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h-1v-1h1z",
    fill: "#a60f17"
  })), _path3914 || (_path3914 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v-1h1v1z",
    fill: "#a31215"
  })), _path3915 || (_path3915 = /*#__PURE__*/React.createElement("path", {
    d: "M65 68v-1h1v1z",
    fill: "#a20f10"
  })), _path3916 || (_path3916 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67h1v1h-1z",
    fill: "#ab3430"
  })), _path3917 || (_path3917 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v1h-1v-1z",
    fill: "#a52324"
  })), _path3918 || (_path3918 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67h1v1h-1z",
    fill: "#ad0b10"
  })), _path3919 || (_path3919 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68h-1v-1h1z",
    fill: "#a80b10"
  })), _path3920 || (_path3920 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67v1h-1v-1z",
    fill: "#a4141b"
  })), _path3921 || (_path3921 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67h1v1h-1z",
    fill: "#a93439"
  })), _path3922 || (_path3922 = /*#__PURE__*/React.createElement("path", {
    d: "M73 67h1v1h-1z",
    fill: "#af5d5d"
  })), _path3923 || (_path3923 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67v1h-1v-1z",
    fill: "#b67d7c"
  })), _path3924 || (_path3924 = /*#__PURE__*/React.createElement("path", {
    d: "M75 68v-1h1v1z",
    fill: "#bb8f8e"
  })), _path3925 || (_path3925 = /*#__PURE__*/React.createElement("path", {
    d: "M77 67v1h-1v-1z",
    fill: "#be9494"
  })), _path3926 || (_path3926 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v1h-1v-1z",
    fill: "#be8a8d"
  })), _path3927 || (_path3927 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67h1v1h-1z",
    fill: "#b5676d"
  })), _path3928 || (_path3928 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68h-1v-1h1z",
    fill: "#b73641"
  })), _path3929 || (_path3929 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h1v1h-1z",
    fill: "#bc1e1e"
  })), _path3930 || (_path3930 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68v-1h1v1z",
    fill: "#c01d21"
  })), _path3931 || (_path3931 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68v-1h1v1z",
    fill: "#b92d2f"
  })), _path3932 || (_path3932 = /*#__PURE__*/React.createElement("path", {
    d: "M93 67v1h-1v-1z",
    fill: "#ca8d8b"
  })), _path3933 || (_path3933 = /*#__PURE__*/React.createElement("path", {
    d: "M93 68v-1h1v1z",
    fill: "#c7999a"
  })), _path3934 || (_path3934 = /*#__PURE__*/React.createElement("path", {
    d: "M95 68h-1v-1h1z",
    fill: "#a84044"
  })), _path3935 || (_path3935 = /*#__PURE__*/React.createElement("path", {
    d: "M95 67h1v1h-1z",
    fill: "#b86c6c"
  })), _path3936 || (_path3936 = /*#__PURE__*/React.createElement("path", {
    d: "M97 68h-1v-1h1z",
    fill: "#e4c3c2",
    fillOpacity: 0.608
  })), _path3937 || (_path3937 = /*#__PURE__*/React.createElement("path", {
    d: "M32 68v1h-1v-1z",
    fill: "#e6e4e2",
    fillOpacity: 0.522
  })), _path3938 || (_path3938 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v-1h1v1z",
    fill: "#cfc1b6"
  })), _path3939 || (_path3939 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v1h-1v-1z",
    fill: "#ad4d40"
  })), _path3940 || (_path3940 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68h1v1h-1z",
    fill: "#ad2a25"
  })), _path3941 || (_path3941 = /*#__PURE__*/React.createElement("path", {
    d: "M37 69h-1v-1h1z",
    fill: "#b52025"
  })), _path3942 || (_path3942 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v1h-1v-1z",
    fill: "#b41f21"
  })), _path3943 || (_path3943 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69v-1h1v1z",
    fill: "#af191b"
  })), _path3944 || (_path3944 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69h-1v-1h1z",
    fill: "#af1417"
  })), _path3945 || (_path3945 = /*#__PURE__*/React.createElement("path", {
    d: "M44 69v-1h1v1z",
    fill: "#ad0f12"
  })), _path3946 || (_path3946 = /*#__PURE__*/React.createElement("path", {
    d: "M45 69v-1h1v1z",
    fill: "#aa0d10"
  })), _path3947 || (_path3947 = /*#__PURE__*/React.createElement("path", {
    d: "M52 68h1v1h-1z",
    fill: "#b01418"
  })), _path3948 || (_path3948 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69h-1v-1h1z",
    fill: "#a10e13"
  })), _path3949 || (_path3949 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h1v1h-1z",
    fill: "#b78184"
  })), _path3950 || (_path3950 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v-1h1v1z",
    fill: "#c7c9c6"
  })), _path3951 || (_path3951 = /*#__PURE__*/React.createElement("path", {
    d: "M60 68h1v1h-1z",
    fill: "#c9b1a8"
  })), _path3952 || (_path3952 = /*#__PURE__*/React.createElement("path", {
    d: "M62 68v1h-1v-1z",
    fill: "#af6661"
  })), _path3953 || (_path3953 = /*#__PURE__*/React.createElement("path", {
    d: "M62 68h1v1h-1z",
    fill: "#991d1f"
  })), _path3954 || (_path3954 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69v-1h1v1z",
    fill: "#b75e5e"
  })), _path3955 || (_path3955 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69h-1v-1h1z",
    fill: "#cca09a"
  })), _path3956 || (_path3956 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69v-1h1v1z",
    fill: "#a33834"
  })), _path3957 || (_path3957 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69v-1h1v1z",
    fill: "#a40c13"
  })), _path3958 || (_path3958 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68v1h-1v-1z",
    fill: "#ac1015"
  })), _path3959 || (_path3959 = /*#__PURE__*/React.createElement("path", {
    d: "M71 69v-1h1v1z",
    fill: "#ac0f12"
  })), _path3960 || (_path3960 = /*#__PURE__*/React.createElement("path", {
    d: "M73 68v1h-1v-1z",
    fill: "#a80b0e"
  })), _path3961 || (_path3961 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v-1h1v1z",
    fill: "#a1070b"
  })), _path3962 || (_path3962 = /*#__PURE__*/React.createElement("path", {
    d: "M74 69v-1h1v1z",
    fill: "#9a090d"
  })), _path3963 || (_path3963 = /*#__PURE__*/React.createElement("path", {
    d: "M76 69h-1v-1h1z",
    fill: "#960c10"
  })), _path3964 || (_path3964 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h-1v-1h1z",
    fill: "#970e11"
  })), _path3965 || (_path3965 = /*#__PURE__*/React.createElement("path", {
    d: "M78 68v1h-1v-1z",
    fill: "#990c0e"
  })), _path3966 || (_path3966 = /*#__PURE__*/React.createElement("path", {
    d: "M79 69h-1v-1h1z",
    fill: "#a10a0c"
  })), _path3967 || (_path3967 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68v1h-1v-1z",
    fill: "#b8171b"
  })), _path3968 || (_path3968 = /*#__PURE__*/React.createElement("path", {
    d: "M81 68v1h-1v-1z",
    fill: "#c11b1f"
  })), _path3969 || (_path3969 = /*#__PURE__*/React.createElement("path", {
    d: "M81 69v-1h1v1z",
    fill: "#c21b1f"
  })), _path3970 || (_path3970 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68h1v1h-1z",
    fill: "#ba2c2e"
  })), _path3971 || (_path3971 = /*#__PURE__*/React.createElement("path", {
    d: "M93 69h-1v-1h1z",
    fill: "#c88d8c"
  })), _path3972 || (_path3972 = /*#__PURE__*/React.createElement("path", {
    d: "M94 69h-1v-1h1z",
    fill: "#c9a1a3"
  })), _path3973 || (_path3973 = /*#__PURE__*/React.createElement("path", {
    d: "M95 68v1h-1v-1z",
    fill: "#a84247"
  })), _path3974 || (_path3974 = /*#__PURE__*/React.createElement("path", {
    d: "M96 69h-1v-1h1z",
    fill: "#b26566"
  })), _path3975 || (_path3975 = /*#__PURE__*/React.createElement("path", {
    d: "M97 69h-1v-1h1z",
    fill: "#dbbbbb",
    fillOpacity: 0.62
  })), _path3976 || (_path3976 = /*#__PURE__*/React.createElement("path", {
    d: "M31 70v-1h1v1z",
    fill: "#e6e6e4",
    fillOpacity: 0.525
  })), _path3977 || (_path3977 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v1h-1v-1z",
    fill: "#dbdfda"
  })), _path3978 || (_path3978 = /*#__PURE__*/React.createElement("path", {
    d: "M34 69v1h-1v-1z",
    fill: "#cfbeaf"
  })), _path3979 || (_path3979 = /*#__PURE__*/React.createElement("path", {
    d: "M35 70h-1v-1h1z",
    fill: "#b1453b"
  })), _path3980 || (_path3980 = /*#__PURE__*/React.createElement("path", {
    d: "M36 69v1h-1v-1z",
    fill: "#ae2421"
  })), _path3981 || (_path3981 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70v-1h1v1z",
    fill: "#ad2120"
  })), _path3982 || (_path3982 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70v-1h1v1z",
    fill: "#af1f1c"
  })), _path3983 || (_path3983 = /*#__PURE__*/React.createElement("path", {
    d: "M39 70h-1v-1h1z",
    fill: "#b11a1a"
  })), _path3984 || (_path3984 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70v-1h1v1z",
    fill: "#a80c10"
  })), _path3985 || (_path3985 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h1v1h-1z",
    fill: "#a1090f"
  })), _path3986 || (_path3986 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v1h-1v-1z",
    fill: "#ba7b7d"
  })), _path3987 || (_path3987 = /*#__PURE__*/React.createElement("path", {
    d: "M60 70v-1h1v1z",
    fill: "#bdc1bd"
  })), _path3988 || (_path3988 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69v1h-1v-1z",
    fill: "#be9b98"
  })), _path3989 || (_path3989 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69h1v1h-1z",
    fill: "#a44643"
  })), _path3990 || (_path3990 = /*#__PURE__*/React.createElement("path", {
    d: "M64 69h1v1h-1z",
    fill: "#9c1010"
  })), _path3991 || (_path3991 = /*#__PURE__*/React.createElement("path", {
    d: "M67 69v1h-1v-1z",
    fill: "#a2161f"
  })), _path3992 || (_path3992 = /*#__PURE__*/React.createElement("path", {
    d: "M67 70v-1h1v1z",
    fill: "#bb6b70"
  })), _path3993 || (_path3993 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70h-1v-1h1z",
    fill: "#ccafa5"
  })), _path3994 || (_path3994 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69h1v1h-1z",
    fill: "#a9514f"
  })), _path3995 || (_path3995 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v1h-1v-1z",
    fill: "#ab0e15"
  })), _path3996 || (_path3996 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70v-1h1v1z",
    fill: "#a0090b"
  })), _path3997 || (_path3997 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v-1h1v1z",
    fill: "#9f0809"
  })), _path3998 || (_path3998 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70h-1v-1h1z",
    fill: "#a80f12"
  })), _path3999 || (_path3999 = /*#__PURE__*/React.createElement("path", {
    d: "M82 69v1h-1v-1z",
    fill: "#bc1c20"
  })), _path4000 || (_path4000 = /*#__PURE__*/React.createElement("path", {
    d: "M83 70h-1v-1h1z",
    fill: "#bd1d24"
  })), _path4001 || (_path4001 = /*#__PURE__*/React.createElement("path", {
    d: "M91 70v-1h1v1z",
    fill: "#b82d2e"
  })), _path4002 || (_path4002 = /*#__PURE__*/React.createElement("path", {
    d: "M92 70v-1h1v1z",
    fill: "#c78e8d"
  })), _path4003 || (_path4003 = /*#__PURE__*/React.createElement("path", {
    d: "M93 70v-1h1v1z",
    fill: "#cca8ab"
  })), _path4004 || (_path4004 = /*#__PURE__*/React.createElement("path", {
    d: "M94 70v-1h1v1z",
    fill: "#a84348"
  })), _path4005 || (_path4005 = /*#__PURE__*/React.createElement("path", {
    d: "M95 69h1v1h-1z",
    fill: "#b76b6c"
  })), _path4006 || (_path4006 = /*#__PURE__*/React.createElement("path", {
    d: "M96 70v-1h1v1z",
    fill: "#e2c3c3",
    fillOpacity: 0.604
  })), _path4007 || (_path4007 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h-1v-1h1z",
    fill: "#e6e6e4",
    fillOpacity: 0.529
  })), _path4008 || (_path4008 = /*#__PURE__*/React.createElement("path", {
    d: "M33 71v-1h1v1z",
    fill: "#ccb3a6"
  })), _path4009 || (_path4009 = /*#__PURE__*/React.createElement("path", {
    d: "M35 70v1h-1v-1z",
    fill: "#af4337"
  })), _path4010 || (_path4010 = /*#__PURE__*/React.createElement("path", {
    d: "M35 71v-1h1v1z",
    fill: "#ad2321"
  })), _path4011 || (_path4011 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70h1v1h-1z",
    fill: "#ae1e1e"
  })), _path4012 || (_path4012 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70h1v1h-1z",
    fill: "#af1d1d"
  })), _path4013 || (_path4013 = /*#__PURE__*/React.createElement("path", {
    d: "M38 71v-1h1v1z",
    fill: "#b1191b"
  })), _path4014 || (_path4014 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71v-1h1v1z",
    fill: "#a60c10"
  })), _path4015 || (_path4015 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71v-1h1v1z",
    fill: "#ab1013"
  })), _path4016 || (_path4016 = /*#__PURE__*/React.createElement("path", {
    d: "M58 70h1v1h-1z",
    fill: "#a6575e"
  })), _path4017 || (_path4017 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70h1v1h-1z",
    fill: "#c6bebc"
  })), _path4018 || (_path4018 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v-1h1v1z",
    fill: "#c3c1bc"
  })), _path4019 || (_path4019 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70v1h-1v-1z",
    fill: "#bdc2be"
  })), _path4020 || (_path4020 = /*#__PURE__*/React.createElement("path", {
    d: "M64 70v1h-1v-1z",
    fill: "#c7bcb3"
  })), _path4021 || (_path4021 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71v-1h1v1z",
    fill: "#b88078"
  })), _path4022 || (_path4022 = /*#__PURE__*/React.createElement("path", {
    d: "M66 71h-1v-1h1z",
    fill: "#9c2f2c"
  })), _path4023 || (_path4023 = /*#__PURE__*/React.createElement("path", {
    d: "M67 71v-1h1v1z",
    fill: "#a20913"
  })), _path4024 || (_path4024 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70v1h-1v-1z",
    fill: "#ae5358"
  })), _path4025 || (_path4025 = /*#__PURE__*/React.createElement("path", {
    d: "M69 71v-1h1v1z",
    fill: "#d4b0ad"
  })), _path4026 || (_path4026 = /*#__PURE__*/React.createElement("path", {
    d: "M70 70h1v1h-1z",
    fill: "#b06461"
  })), _path4027 || (_path4027 = /*#__PURE__*/React.createElement("path", {
    d: "M73 71h-1v-1h1z",
    fill: "#a90e12"
  })), _path4028 || (_path4028 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70v1h-1v-1z",
    fill: "#a50c12"
  })), _path4029 || (_path4029 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v1h-1v-1z",
    fill: "#a00a0c"
  })), _path4030 || (_path4030 = /*#__PURE__*/React.createElement("path", {
    d: "M79 71v-1h1v1z",
    fill: "#ba191f"
  })), _path4031 || (_path4031 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70v1h-1v-1z",
    fill: "#bd1b1f"
  })), _path4032 || (_path4032 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70h1v1h-1z",
    fill: "#ba262c"
  })), _path4033 || (_path4033 = /*#__PURE__*/React.createElement("path", {
    d: "M83 70v1h-1v-1z",
    fill: "#c73f46"
  })), _path4034 || (_path4034 = /*#__PURE__*/React.createElement("path", {
    d: "M85 70v1h-1v-1z",
    fill: "#c21c24"
  })), _path4035 || (_path4035 = /*#__PURE__*/React.createElement("path", {
    d: "M87 71h-1v-1h1z",
    fill: "#c11f26"
  })), _path4036 || (_path4036 = /*#__PURE__*/React.createElement("path", {
    d: "M93 70v1h-1v-1z",
    fill: "#c78f8e"
  })), _path4037 || (_path4037 = /*#__PURE__*/React.createElement("path", {
    d: "M93 71v-1h1v1z",
    fill: "#cdadb0"
  })), _path4038 || (_path4038 = /*#__PURE__*/React.createElement("path", {
    d: "M94 70h1v1h-1z",
    fill: "#a8444a"
  })), _path4039 || (_path4039 = /*#__PURE__*/React.createElement("path", {
    d: "M95 70h1v1h-1z",
    fill: "#b56e6e"
  })), _path4040 || (_path4040 = /*#__PURE__*/React.createElement("path", {
    d: "M97 71h-1v-1h1z",
    fill: "#e2c7c5",
    fillOpacity: 0.596
  })), _path4041 || (_path4041 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71v1h-1v-1z",
    fill: "#e6e6e2",
    fillOpacity: 0.525
  })), _path4042 || (_path4042 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h1v1h-1z",
    fill: "#ddded9"
  })), _path4043 || (_path4043 = /*#__PURE__*/React.createElement("path", {
    d: "M33 71h1v1h-1z",
    fill: "#cba89c"
  })), _path4044 || (_path4044 = /*#__PURE__*/React.createElement("path", {
    d: "M35 72h-1v-1h1z",
    fill: "#b24238"
  })), _path4045 || (_path4045 = /*#__PURE__*/React.createElement("path", {
    d: "M35 71h1v1h-1z",
    fill: "#ad2522"
  })), _path4046 || (_path4046 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72v-1h1v1z",
    fill: "#a80d0f"
  })), _path4047 || (_path4047 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71v1h-1v-1z",
    fill: "#a1161c"
  })), _path4048 || (_path4048 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h1v1h-1z",
    fill: "#c1999d"
  })), _path4049 || (_path4049 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v1h-1v-1z",
    fill: "#b6928d"
  })), _path4050 || (_path4050 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72v-1h1v1z",
    fill: "#a35755"
  })), _path4051 || (_path4051 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72h-1v-1h1z",
    fill: "#c4a6a7"
  })), _path4052 || (_path4052 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71h1v1h-1z",
    fill: "#bcc2bd"
  })), _path4053 || (_path4053 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71h1v1h-1z",
    fill: "#c4c4bd"
  })), _path4054 || (_path4054 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72v-1h1v1z",
    fill: "#c4b1a8"
  })), _path4055 || (_path4055 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72v-1h1v1z",
    fill: "#ac645e"
  })), _path4056 || (_path4056 = /*#__PURE__*/React.createElement("path", {
    d: "M68 72h-1v-1h1z",
    fill: "#9c1c1c"
  })), _path4057 || (_path4057 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72h-1v-1h1z",
    fill: "#9d060c"
  })), _path4058 || (_path4058 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72h-1v-1h1z",
    fill: "#aa4948"
  })), _path4059 || (_path4059 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72h-1v-1h1z",
    fill: "#d0b3ac"
  })), _path4060 || (_path4060 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72v-1h1v1z",
    fill: "#b46d67"
  })), _path4061 || (_path4061 = /*#__PURE__*/React.createElement("path", {
    d: "M72 71h1v1h-1z",
    fill: "#9d1210"
  })), _path4062 || (_path4062 = /*#__PURE__*/React.createElement("path", {
    d: "M75 71h1v1h-1z",
    fill: "#a00b0d"
  })), _path4063 || (_path4063 = /*#__PURE__*/React.createElement("path", {
    d: "M77 71h1v1h-1z",
    fill: "#9f0b0c"
  })), _path4064 || (_path4064 = /*#__PURE__*/React.createElement("path", {
    d: "M79 72v-1h1v1z",
    fill: "#ba1920"
  })), _path4065 || (_path4065 = /*#__PURE__*/React.createElement("path", {
    d: "M81 71h1v1h-1z",
    fill: "#ca6069"
  })), _path4066 || (_path4066 = /*#__PURE__*/React.createElement("path", {
    d: "M82 71h1v1h-1z",
    fill: "#bc383f"
  })), _path4067 || (_path4067 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72h-1v-1h1z",
    fill: "#be1c22"
  })), _path4068 || (_path4068 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72v-1h1v1z",
    fill: "#c51c25"
  })), _path4069 || (_path4069 = /*#__PURE__*/React.createElement("path", {
    d: "M93 72h-1v-1h1z",
    fill: "#c89190"
  })), _path4070 || (_path4070 = /*#__PURE__*/React.createElement("path", {
    d: "M94 72h-1v-1h1z",
    fill: "#cfb4b5"
  })), _path4071 || (_path4071 = /*#__PURE__*/React.createElement("path", {
    d: "M94 72v-1h1v1z",
    fill: "#a7484b"
  })), _path4072 || (_path4072 = /*#__PURE__*/React.createElement("path", {
    d: "M95 71h1v1h-1z",
    fill: "#c48180"
  })), _path4073 || (_path4073 = /*#__PURE__*/React.createElement("path", {
    d: "M96 72v-1h1v1z",
    fill: "#e4cbc9",
    fillOpacity: 0.6
  })), _path4074 || (_path4074 = /*#__PURE__*/React.createElement("path", {
    d: "M32 73h-1v-1h1z",
    fill: "#e0dcd8",
    fillOpacity: 0.518
  })), _path4075 || (_path4075 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73h-1v-1h1z",
    fill: "#deded5"
  })), _path4076 || (_path4076 = /*#__PURE__*/React.createElement("path", {
    d: "M34 72v1h-1v-1z",
    fill: "#c99a8f"
  })), _path4077 || (_path4077 = /*#__PURE__*/React.createElement("path", {
    d: "M35 73h-1v-1h1z",
    fill: "#b8433b"
  })), _path4078 || (_path4078 = /*#__PURE__*/React.createElement("path", {
    d: "M36 72v1h-1v-1z",
    fill: "#b02826"
  })), _path4079 || (_path4079 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72v1h-1v-1z",
    fill: "#b01316"
  })), _path4080 || (_path4080 = /*#__PURE__*/React.createElement("path", {
    d: "M56 72h1v1h-1z",
    fill: "#a60c0d"
  })), _path4081 || (_path4081 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v-1h1v1z",
    fill: "#a0202a"
  })), _path4082 || (_path4082 = /*#__PURE__*/React.createElement("path", {
    d: "M59 73h-1v-1h1z",
    fill: "#c6aeb3"
  })), _path4083 || (_path4083 = /*#__PURE__*/React.createElement("path", {
    d: "M59 72h1v1h-1z",
    fill: "#c19896"
  })), _path4084 || (_path4084 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72h1v1h-1z",
    fill: "#981619"
  })), _path4085 || (_path4085 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72v1h-1v-1z",
    fill: "#9e2029"
  })), _path4086 || (_path4086 = /*#__PURE__*/React.createElement("path", {
    d: "M63 72v1h-1v-1z",
    fill: "#b57476"
  })), _path4087 || (_path4087 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72h1v1h-1z",
    fill: "#c5c3bb"
  })), _path4088 || (_path4088 = /*#__PURE__*/React.createElement("path", {
    d: "M67 73v-1h1v1z",
    fill: "#be9f94"
  })), _path4089 || (_path4089 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72v1h-1v-1z",
    fill: "#a64b45"
  })), _path4090 || (_path4090 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72v1h-1v-1z",
    fill: "#9b0b0e"
  })), _path4091 || (_path4091 = /*#__PURE__*/React.createElement("path", {
    d: "M71 73h-1v-1h1z",
    fill: "#a9464a"
  })), _path4092 || (_path4092 = /*#__PURE__*/React.createElement("path", {
    d: "M72 72v1h-1v-1z",
    fill: "#d0b9b4"
  })), _path4093 || (_path4093 = /*#__PURE__*/React.createElement("path", {
    d: "M72 73v-1h1v1z",
    fill: "#b16b66"
  })), _path4094 || (_path4094 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72v1h-1v-1z",
    fill: "#9a0f0f"
  })), _path4095 || (_path4095 = /*#__PURE__*/React.createElement("path", {
    d: "M79 73v-1h1v1z",
    fill: "#b5161d"
  })), _path4096 || (_path4096 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72h1v1h-1z",
    fill: "#bb4e53"
  })), _path4097 || (_path4097 = /*#__PURE__*/React.createElement("path", {
    d: "M82 72v1h-1v-1z",
    fill: "#ce8284"
  })), _path4098 || (_path4098 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73h-1v-1h1z",
    fill: "#b91c25"
  })), _path4099 || (_path4099 = /*#__PURE__*/React.createElement("path", {
    d: "M84 73h-1v-1h1z",
    fill: "#c51b21"
  })), _path4100 || (_path4100 = /*#__PURE__*/React.createElement("path", {
    d: "M92 72v1h-1v-1z",
    fill: "#b72f30"
  })), _path4101 || (_path4101 = /*#__PURE__*/React.createElement("path", {
    d: "M93 72v1h-1v-1z",
    fill: "#c99492"
  })), _path4102 || (_path4102 = /*#__PURE__*/React.createElement("path", {
    d: "M93 72h1v1h-1z",
    fill: "#cfb9b8"
  })), _path4103 || (_path4103 = /*#__PURE__*/React.createElement("path", {
    d: "M94 72h1v1h-1z",
    fill: "#a64549"
  })), _path4104 || (_path4104 = /*#__PURE__*/React.createElement("path", {
    d: "M96 72v1h-1v-1z",
    fill: "#b47170"
  })), _path4105 || (_path4105 = /*#__PURE__*/React.createElement("path", {
    d: "M96 73v-1h1v1z",
    fill: "#dec9c5",
    fillOpacity: 0.612
  })), _path4106 || (_path4106 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74h-1v-1h1z",
    fill: "#dad6d2",
    fillOpacity: 0.522
  })), _path4107 || (_path4107 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73v1h-1v-1z",
    fill: "#e0dbd3"
  })), _path4108 || (_path4108 = /*#__PURE__*/React.createElement("path", {
    d: "M33 74v-1h1v1z",
    fill: "#c48c82"
  })), _path4109 || (_path4109 = /*#__PURE__*/React.createElement("path", {
    d: "M35 73v1h-1v-1z",
    fill: "#bb443d"
  })), _path4110 || (_path4110 = /*#__PURE__*/React.createElement("path", {
    d: "M35 74v-1h1v1z",
    fill: "#b32b28"
  })), _path4111 || (_path4111 = /*#__PURE__*/React.createElement("path", {
    d: "M36 73h1v1h-1z",
    fill: "#b01e1d"
  })), _path4112 || (_path4112 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v1h-1v-1z",
    fill: "#af1c1c"
  })), _path4113 || (_path4113 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74h-1v-1h1z",
    fill: "#af1114"
  })), _path4114 || (_path4114 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74h-1v-1h1z",
    fill: "#a60b0e"
  })), _path4115 || (_path4115 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73h1v1h-1z",
    fill: "#9f1119"
  })), _path4116 || (_path4116 = /*#__PURE__*/React.createElement("path", {
    d: "M59 74h-1v-1h1z",
    fill: "#c08b8d"
  })), _path4117 || (_path4117 = /*#__PURE__*/React.createElement("path", {
    d: "M60 74h-1v-1h1z",
    fill: "#c8c4be"
  })), _path4118 || (_path4118 = /*#__PURE__*/React.createElement("path", {
    d: "M61 74h-1v-1h1z",
    fill: "#b67c73"
  })), _path4119 || (_path4119 = /*#__PURE__*/React.createElement("path", {
    d: "M62 73v1h-1v-1z",
    fill: "#971110"
  })), _path4120 || (_path4120 = /*#__PURE__*/React.createElement("path", {
    d: "M63 74h-1v-1h1z",
    fill: "#9c070f"
  })), _path4121 || (_path4121 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v1h-1v-1z",
    fill: "#a6353f"
  })), _path4122 || (_path4122 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h-1v-1h1z",
    fill: "#c08f91"
  })), _path4123 || (_path4123 = /*#__PURE__*/React.createElement("path", {
    d: "M66 73v1h-1v-1z",
    fill: "#c7c1b9"
  })), _path4124 || (_path4124 = /*#__PURE__*/React.createElement("path", {
    d: "M67 74h-1v-1h1z",
    fill: "#bec4bd"
  })), _path4125 || (_path4125 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74h-1v-1h1z",
    fill: "#c1c2c1"
  })), _path4126 || (_path4126 = /*#__PURE__*/React.createElement("path", {
    d: "M68 73h1v1h-1z",
    fill: "#c7bfb6"
  })), _path4127 || (_path4127 = /*#__PURE__*/React.createElement("path", {
    d: "M69 73h1v1h-1z",
    fill: "#bb857e"
  })), _path4128 || (_path4128 = /*#__PURE__*/React.createElement("path", {
    d: "M70 73h1v1h-1z",
    fill: "#973439"
  })), _path4129 || (_path4129 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v-1h1v1z",
    fill: "#b78b8b"
  })), _path4130 || (_path4130 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74h-1v-1h1z",
    fill: "#cbc2be"
  })), _path4131 || (_path4131 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74v-1h1v1z",
    fill: "#a65252"
  })), _path4132 || (_path4132 = /*#__PURE__*/React.createElement("path", {
    d: "M75 74h-1v-1h1z",
    fill: "#9a0a0b"
  })), _path4133 || (_path4133 = /*#__PURE__*/React.createElement("path", {
    d: "M75 73h1v1h-1z",
    fill: "#9f0b0d"
  })), _path4134 || (_path4134 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h-1v-1h1z",
    fill: "#9c080b"
  })), _path4135 || (_path4135 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v-1h1v1z",
    fill: "#9e0a0d"
  })), _path4136 || (_path4136 = /*#__PURE__*/React.createElement("path", {
    d: "M80 73v1h-1v-1z",
    fill: "#ad262a"
  })), _path4137 || (_path4137 = /*#__PURE__*/React.createElement("path", {
    d: "M80 74v-1h1v1z",
    fill: "#d1a4a2"
  })), _path4138 || (_path4138 = /*#__PURE__*/React.createElement("path", {
    d: "M82 73v1h-1v-1z",
    fill: "#c0585e"
  })), _path4139 || (_path4139 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73v1h-1v-1z",
    fill: "#bf171d"
  })), _path4140 || (_path4140 = /*#__PURE__*/React.createElement("path", {
    d: "M84 73v1h-1v-1z",
    fill: "#c11d1f"
  })), _path4141 || (_path4141 = /*#__PURE__*/React.createElement("path", {
    d: "M91 74v-1h1v1z",
    fill: "#b73030"
  })), _path4142 || (_path4142 = /*#__PURE__*/React.createElement("path", {
    d: "M93 74h-1v-1h1z",
    fill: "#cb9796"
  })), _path4143 || (_path4143 = /*#__PURE__*/React.createElement("path", {
    d: "M94 74h-1v-1h1z",
    fill: "#d0bebb"
  })), _path4144 || (_path4144 = /*#__PURE__*/React.createElement("path", {
    d: "M94 73h1v1h-1z",
    fill: "#a9464b"
  })), _path4145 || (_path4145 = /*#__PURE__*/React.createElement("path", {
    d: "M95 74v-1h1v1z",
    fill: "#be7373"
  })), _path4146 || (_path4146 = /*#__PURE__*/React.createElement("path", {
    d: "M97 73v1h-1v-1z",
    fill: "#e4cac9",
    fillOpacity: 0.612
  })), _path4147 || (_path4147 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74v1h-1v-1z",
    fill: "#d8d4d0",
    fillOpacity: 0.522
  })), _path4148 || (_path4148 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74h1v1h-1z",
    fill: "#e0d6d1"
  })), _path4149 || (_path4149 = /*#__PURE__*/React.createElement("path", {
    d: "M34 74v1h-1v-1z",
    fill: "#bd7d70"
  })), _path4150 || (_path4150 = /*#__PURE__*/React.createElement("path", {
    d: "M34 74h1v1h-1z",
    fill: "#bc453e"
  })), _path4151 || (_path4151 = /*#__PURE__*/React.createElement("path", {
    d: "M35 74h1v1h-1z",
    fill: "#b52c27"
  })), _path4152 || (_path4152 = /*#__PURE__*/React.createElement("path", {
    d: "M36 75v-1h1v1z",
    fill: "#b12020"
  })), _path4153 || (_path4153 = /*#__PURE__*/React.createElement("path", {
    d: "M38 75h-1v-1h1z",
    fill: "#b11b1c"
  })), _path4154 || (_path4154 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74v1h-1v-1z",
    fill: "#a60b0f"
  })), _path4155 || (_path4155 = /*#__PURE__*/React.createElement("path", {
    d: "M57 74h1v1h-1z",
    fill: "#a90b11"
  })), _path4156 || (_path4156 = /*#__PURE__*/React.createElement("path", {
    d: "M58 75v-1h1v1z",
    fill: "#a9454d"
  })), _path4157 || (_path4157 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h-1v-1h1z",
    fill: "#c6bdba"
  })), _path4158 || (_path4158 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75v-1h1v1z",
    fill: "#c4c5b8"
  })), _path4159 || (_path4159 = /*#__PURE__*/React.createElement("path", {
    d: "M62 75h-1v-1h1z",
    fill: "#b78174"
  })), _path4160 || (_path4160 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75h-1v-1h1z",
    fill: "#9b1d1d"
  })), _path4161 || (_path4161 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75v-1h1v1z",
    fill: "#9d060d"
  })), _path4162 || (_path4162 = /*#__PURE__*/React.createElement("path", {
    d: "M64 74h1v1h-1z",
    fill: "#9b0f1a"
  })), _path4163 || (_path4163 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h1v1h-1z",
    fill: "#ad4e57"
  })), _path4164 || (_path4164 = /*#__PURE__*/React.createElement("path", {
    d: "M69 75h-1v-1h1z",
    fill: "#bdc3be"
  })), _path4165 || (_path4165 = /*#__PURE__*/React.createElement("path", {
    d: "M70 74v1h-1v-1z",
    fill: "#c4c3bc"
  })), _path4166 || (_path4166 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v1h-1v-1z",
    fill: "#c6b8b1"
  })), _path4167 || (_path4167 = /*#__PURE__*/React.createElement("path", {
    d: "M72 74v1h-1v-1z",
    fill: "#c0b8b2"
  })), _path4168 || (_path4168 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75v-1h1v1z",
    fill: "#c9aaa5"
  })), _path4169 || (_path4169 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v-1h1v1z",
    fill: "#9d2428"
  })), _path4170 || (_path4170 = /*#__PURE__*/React.createElement("path", {
    d: "M75 75v-1h1v1z",
    fill: "#a2060a"
  })), _path4171 || (_path4171 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v1h-1v-1z",
    fill: "#9c080c"
  })), _path4172 || (_path4172 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74h1v1h-1z",
    fill: "#9f090d"
  })), _path4173 || (_path4173 = /*#__PURE__*/React.createElement("path", {
    d: "M79 75v-1h1v1z",
    fill: "#bc6c6d"
  })), _path4174 || (_path4174 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74v1h-1v-1z",
    fill: "#d5b8b4"
  })), _path4175 || (_path4175 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74h1v1h-1z",
    fill: "#b9333a"
  })), _path4176 || (_path4176 = /*#__PURE__*/React.createElement("path", {
    d: "M82 75v-1h1v1z",
    fill: "#c1191f"
  })), _path4177 || (_path4177 = /*#__PURE__*/React.createElement("path", {
    d: "M89 75v-1h1v1z",
    fill: "#bf262a"
  })), _path4178 || (_path4178 = /*#__PURE__*/React.createElement("path", {
    d: "M92 75h-1v-1h1z",
    fill: "#b53232"
  })), _path4179 || (_path4179 = /*#__PURE__*/React.createElement("path", {
    d: "M92 75v-1h1v1z",
    fill: "#cd9c9d"
  })), _path4180 || (_path4180 = /*#__PURE__*/React.createElement("path", {
    d: "M94 75h-1v-1h1z",
    fill: "#d2c1be"
  })), _path4181 || (_path4181 = /*#__PURE__*/React.createElement("path", {
    d: "M94 75v-1h1v1z",
    fill: "#a94a4e"
  })), _path4182 || (_path4182 = /*#__PURE__*/React.createElement("path", {
    d: "M96 74v1h-1v-1z",
    fill: "#b66563"
  })), _path4183 || (_path4183 = /*#__PURE__*/React.createElement("path", {
    d: "M96 75v-1h1v1z",
    fill: "#e2c1c0",
    fillOpacity: 0.588
  })), _path4184 || (_path4184 = /*#__PURE__*/React.createElement("path", {
    d: "M31 75h1v1h-1z",
    fill: "#dcdad6",
    fillOpacity: 0.522
  })), _path4185 || (_path4185 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76h-1v-1h1z",
    fill: "#ded2ca"
  })), _path4186 || (_path4186 = /*#__PURE__*/React.createElement("path", {
    d: "M34 76h-1v-1h1z",
    fill: "#b56b5e"
  })), _path4187 || (_path4187 = /*#__PURE__*/React.createElement("path", {
    d: "M35 75v1h-1v-1z",
    fill: "#bc4540"
  })), _path4188 || (_path4188 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v-1h1v1z",
    fill: "#b42f2b"
  })), _path4189 || (_path4189 = /*#__PURE__*/React.createElement("path", {
    d: "M36 76v-1h1v1z",
    fill: "#b22220"
  })), _path4190 || (_path4190 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76v-1h1v1z",
    fill: "#af1015"
  })), _path4191 || (_path4191 = /*#__PURE__*/React.createElement("path", {
    d: "M53 76v-1h1v1z",
    fill: "#b31418"
  })), _path4192 || (_path4192 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h-1v-1h1z",
    fill: "#ab0f11"
  })), _path4193 || (_path4193 = /*#__PURE__*/React.createElement("path", {
    d: "M59 75v1h-1v-1z",
    fill: "#9f0e19"
  })), _path4194 || (_path4194 = /*#__PURE__*/React.createElement("path", {
    d: "M60 76h-1v-1h1z",
    fill: "#b5777c"
  })), _path4195 || (_path4195 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h1v1h-1z",
    fill: "#c5c4bf"
  })), _path4196 || (_path4196 = /*#__PURE__*/React.createElement("path", {
    d: "M61 75h1v1h-1z",
    fill: "#c2c6bb"
  })), _path4197 || (_path4197 = /*#__PURE__*/React.createElement("path", {
    d: "M62 76v-1h1v1z",
    fill: "#bf9a92"
  })), _path4198 || (_path4198 = /*#__PURE__*/React.createElement("path", {
    d: "M64 75v1h-1v-1z",
    fill: "#9c3334"
  })), _path4199 || (_path4199 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76v-1h1v1z",
    fill: "#9d090d"
  })), _path4200 || (_path4200 = /*#__PURE__*/React.createElement("path", {
    d: "M66 76h-1v-1h1z",
    fill: "#a2080e"
  })), _path4201 || (_path4201 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75v1h-1v-1z",
    fill: "#9e222a"
  })), _path4202 || (_path4202 = /*#__PURE__*/React.createElement("path", {
    d: "M67 76v-1h1v1z",
    fill: "#b57376"
  })), _path4203 || (_path4203 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v-1h1v1z",
    fill: "#c9bbba"
  })), _path4204 || (_path4204 = /*#__PURE__*/React.createElement("path", {
    d: "M70 76h-1v-1h1z",
    fill: "#c4c2c0"
  })), _path4205 || (_path4205 = /*#__PURE__*/React.createElement("path", {
    d: "M71 76h-1v-1h1z",
    fill: "#c0c1ba"
  })), _path4206 || (_path4206 = /*#__PURE__*/React.createElement("path", {
    d: "M72 76h-1v-1h1z",
    fill: "#c1c1bc"
  })), _path4207 || (_path4207 = /*#__PURE__*/React.createElement("path", {
    d: "M74 76v-1h1v1z",
    fill: "#ae6163"
  })), _path4208 || (_path4208 = /*#__PURE__*/React.createElement("path", {
    d: "M75 76v-1h1v1z",
    fill: "#9c0506"
  })), _path4209 || (_path4209 = /*#__PURE__*/React.createElement("path", {
    d: "M76 76v-1h1v1z",
    fill: "#9b0909"
  })), _path4210 || (_path4210 = /*#__PURE__*/React.createElement("path", {
    d: "M78 75v1h-1v-1z",
    fill: "#9e0709"
  })), _path4211 || (_path4211 = /*#__PURE__*/React.createElement("path", {
    d: "M79 76h-1v-1h1z",
    fill: "#9e2728"
  })), _path4212 || (_path4212 = /*#__PURE__*/React.createElement("path", {
    d: "M80 76h-1v-1h1z",
    fill: "#d0b5b1"
  })), _path4213 || (_path4213 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h-1v-1h1z",
    fill: "#caa0a1"
  })), _path4214 || (_path4214 = /*#__PURE__*/React.createElement("path", {
    d: "M82 75v1h-1v-1z",
    fill: "#bb2229"
  })), _path4215 || (_path4215 = /*#__PURE__*/React.createElement("path", {
    d: "M83 75v1h-1v-1z",
    fill: "#c31c21"
  })), _path4216 || (_path4216 = /*#__PURE__*/React.createElement("path", {
    d: "M90 75v1h-1v-1z",
    fill: "#c0252a"
  })), _path4217 || (_path4217 = /*#__PURE__*/React.createElement("path", {
    d: "M91 76h-1v-1h1z",
    fill: "#c0292d"
  })), _path4218 || (_path4218 = /*#__PURE__*/React.createElement("path", {
    d: "M91 75h1v1h-1z",
    fill: "#b53233"
  })), _path4219 || (_path4219 = /*#__PURE__*/React.createElement("path", {
    d: "M93 75v1h-1v-1z",
    fill: "#cda0a0"
  })), _path4220 || (_path4220 = /*#__PURE__*/React.createElement("path", {
    d: "M93 76v-1h1v1z",
    fill: "#d3c5c3"
  })), _path4221 || (_path4221 = /*#__PURE__*/React.createElement("path", {
    d: "M94 75h1v1h-1z",
    fill: "#a94c52"
  })), _path4222 || (_path4222 = /*#__PURE__*/React.createElement("path", {
    d: "M96 75v1h-1v-1z",
    fill: "#af5d5b"
  })), _path4223 || (_path4223 = /*#__PURE__*/React.createElement("path", {
    d: "M97 76h-1v-1h1z",
    fill: "#e4c2be",
    fillOpacity: 0.561
  })), _path4224 || (_path4224 = /*#__PURE__*/React.createElement("path", {
    d: "M32 76v1h-1v-1z",
    fill: "#eaece6",
    fillOpacity: 0.541
  })), _path4225 || (_path4225 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76v1h-1v-1z",
    fill: "#ded0c6"
  })), _path4226 || (_path4226 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76h1v1h-1z",
    fill: "#b35f50"
  })), _path4227 || (_path4227 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v1h-1v-1z",
    fill: "#ba433f"
  })), _path4228 || (_path4228 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76h1v1h-1z",
    fill: "#b42f2d"
  })), _path4229 || (_path4229 = /*#__PURE__*/React.createElement("path", {
    d: "M56 76v1h-1v-1z",
    fill: "#a3090b"
  })), _path4230 || (_path4230 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76v1h-1v-1z",
    fill: "#aa0f10"
  })), _path4231 || (_path4231 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h1v1h-1z",
    fill: "#ab0c11"
  })), _path4232 || (_path4232 = /*#__PURE__*/React.createElement("path", {
    d: "M59 77v-1h1v1z",
    fill: "#a11624"
  })), _path4233 || (_path4233 = /*#__PURE__*/React.createElement("path", {
    d: "M61 76v1h-1v-1z",
    fill: "#bd8d92"
  })), _path4234 || (_path4234 = /*#__PURE__*/React.createElement("path", {
    d: "M63 77h-1v-1h1z",
    fill: "#c5c3bd"
  })), _path4235 || (_path4235 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77h-1v-1h1z",
    fill: "#c8aca5"
  })), _path4236 || (_path4236 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76h1v1h-1z",
    fill: "#a54f4b"
  })), _path4237 || (_path4237 = /*#__PURE__*/React.createElement("path", {
    d: "M65 77v-1h1v1z",
    fill: "#9b0e0e"
  })), _path4238 || (_path4238 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77h-1v-1h1z",
    fill: "#a30a0a"
  })), _path4239 || (_path4239 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v1h-1v-1z",
    fill: "#9e0a12"
  })), _path4240 || (_path4240 = /*#__PURE__*/React.createElement("path", {
    d: "M69 77h-1v-1h1z",
    fill: "#a94049"
  })), _path4241 || (_path4241 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77h-1v-1h1z",
    fill: "#c4a7a2"
  })), _path4242 || (_path4242 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77v-1h1v1z",
    fill: "#c1c1bb"
  })), _path4243 || (_path4243 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77h-1v-1h1z",
    fill: "#b87a7a"
  })), _path4244 || (_path4244 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77v-1h1v1z",
    fill: "#990708"
  })), _path4245 || (_path4245 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76h1v1h-1z",
    fill: "#970709"
  })), _path4246 || (_path4246 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h-1v-1h1z",
    fill: "#b1726c"
  })), _path4247 || (_path4247 = /*#__PURE__*/React.createElement("path", {
    d: "M80 76v1h-1v-1z",
    fill: "#cccdc8"
  })), _path4248 || (_path4248 = /*#__PURE__*/React.createElement("path", {
    d: "M80 77v-1h1v1z",
    fill: "#c58b8e"
  })), _path4249 || (_path4249 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h1v1h-1z",
    fill: "#bc1b23"
  })), _path4250 || (_path4250 = /*#__PURE__*/React.createElement("path", {
    d: "M88 76h1v1h-1z",
    fill: "#c22428"
  })), _path4251 || (_path4251 = /*#__PURE__*/React.createElement("path", {
    d: "M90 76v1h-1v-1z",
    fill: "#c1252a"
  })), _path4252 || (_path4252 = /*#__PURE__*/React.createElement("path", {
    d: "M92 76v1h-1v-1z",
    fill: "#b73334"
  })), _path4253 || (_path4253 = /*#__PURE__*/React.createElement("path", {
    d: "M93 77h-1v-1h1z",
    fill: "#cda5a5"
  })), _path4254 || (_path4254 = /*#__PURE__*/React.createElement("path", {
    d: "M94 77h-1v-1h1z",
    fill: "#d4c8c7"
  })), _path4255 || (_path4255 = /*#__PURE__*/React.createElement("path", {
    d: "M94 77v-1h1v1z",
    fill: "#a94f55"
  })), _path4256 || (_path4256 = /*#__PURE__*/React.createElement("path", {
    d: "M96 76v1h-1v-1z",
    fill: "#af5c5a"
  })), _path4257 || (_path4257 = /*#__PURE__*/React.createElement("path", {
    d: "M97 77h-1v-1h1z",
    fill: "#e6c0bc",
    fillOpacity: 0.525
  })), _path4258 || (_path4258 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78h-1v-1h1z",
    fill: "#e8ece6",
    fillOpacity: 0.541
  })), _path4259 || (_path4259 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v-1h1v1z",
    fill: "#ded2c6"
  })), _path4260 || (_path4260 = /*#__PURE__*/React.createElement("path", {
    d: "M34 77v1h-1v-1z",
    fill: "#b35d4d"
  })), _path4261 || (_path4261 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78h-1v-1h1z",
    fill: "#b9413d"
  })), _path4262 || (_path4262 = /*#__PURE__*/React.createElement("path", {
    d: "M37 77v1h-1v-1z",
    fill: "#b72322"
  })), _path4263 || (_path4263 = /*#__PURE__*/React.createElement("path", {
    d: "M38 77v1h-1v-1z",
    fill: "#b52020"
  })), _path4264 || (_path4264 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v-1h1v1z",
    fill: "#b31d1e"
  })), _path4265 || (_path4265 = /*#__PURE__*/React.createElement("path", {
    d: "M49 78h-1v-1h1z",
    fill: "#9f090a"
  })), _path4266 || (_path4266 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h-1v-1h1z",
    fill: "#ab1011"
  })), _path4267 || (_path4267 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78v-1h1v1z",
    fill: "#a80c0f"
  })), _path4268 || (_path4268 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78h-1v-1h1z",
    fill: "#a11f2f"
  })), _path4269 || (_path4269 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78h-1v-1h1z",
    fill: "#c29197"
  })), _path4270 || (_path4270 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78v-1h1v1z",
    fill: "#cabcb5"
  })), _path4271 || (_path4271 = /*#__PURE__*/React.createElement("path", {
    d: "M66 78h-1v-1h1z",
    fill: "#b47a72"
  })), _path4272 || (_path4272 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77v1h-1v-1z",
    fill: "#9e2321"
  })), _path4273 || (_path4273 = /*#__PURE__*/React.createElement("path", {
    d: "M68 77h1v1h-1z",
    fill: "#a70710"
  })), _path4274 || (_path4274 = /*#__PURE__*/React.createElement("path", {
    d: "M69 78v-1h1v1z",
    fill: "#a5222e"
  })), _path4275 || (_path4275 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77h1v1h-1z",
    fill: "#c58b91"
  })), _path4276 || (_path4276 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77h1v1h-1z",
    fill: "#beb7b2"
  })), _path4277 || (_path4277 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77v1h-1v-1z",
    fill: "#c7a3a5"
  })), _path4278 || (_path4278 = /*#__PURE__*/React.createElement("path", {
    d: "M74 78v-1h1v1z",
    fill: "#a73e43"
  })), _path4279 || (_path4279 = /*#__PURE__*/React.createElement("path", {
    d: "M76 77v1h-1v-1z",
    fill: "#9f070e"
  })), _path4280 || (_path4280 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78v-1h1v1z",
    fill: "#9f060b"
  })), _path4281 || (_path4281 = /*#__PURE__*/React.createElement("path", {
    d: "M77 77h1v1h-1z",
    fill: "#991e1d"
  })), _path4282 || (_path4282 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77v1h-1v-1z",
    fill: "#c7aea5"
  })), _path4283 || (_path4283 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h1v1h-1z",
    fill: "#c5cbc5"
  })), _path4284 || (_path4284 = /*#__PURE__*/React.createElement("path", {
    d: "M81 77v1h-1v-1z",
    fill: "#c78084"
  })), _path4285 || (_path4285 = /*#__PURE__*/React.createElement("path", {
    d: "M82 78h-1v-1h1z",
    fill: "#bc1923"
  })), _path4286 || (_path4286 = /*#__PURE__*/React.createElement("path", {
    d: "M83 78h-1v-1h1z",
    fill: "#c21c22"
  })), _path4287 || (_path4287 = /*#__PURE__*/React.createElement("path", {
    d: "M89 77v1h-1v-1z",
    fill: "#c22328"
  })), _path4288 || (_path4288 = /*#__PURE__*/React.createElement("path", {
    d: "M90 78h-1v-1h1z",
    fill: "#c2252a"
  })), _path4289 || (_path4289 = /*#__PURE__*/React.createElement("path", {
    d: "M91 78v-1h1v1z",
    fill: "#b83637"
  })), _path4290 || (_path4290 = /*#__PURE__*/React.createElement("path", {
    d: "M93 77v1h-1v-1z",
    fill: "#ceabab"
  })), _path4291 || (_path4291 = /*#__PURE__*/React.createElement("path", {
    d: "M93 78v-1h1v1z",
    fill: "#d4c8c9"
  })), _path4292 || (_path4292 = /*#__PURE__*/React.createElement("path", {
    d: "M95 77v1h-1v-1z",
    fill: "#aa5158"
  })), _path4293 || (_path4293 = /*#__PURE__*/React.createElement("path", {
    d: "M96 77v1h-1v-1z",
    fill: "#b25e5c"
  })), _path4294 || (_path4294 = /*#__PURE__*/React.createElement("path", {
    d: "M96 78v-1h1v1z",
    fill: "#e1bbb7",
    fillOpacity: 0.533
  })), _path4295 || (_path4295 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v1h-1v-1z",
    fill: "#e8ece8",
    fillOpacity: 0.529
  })), _path4296 || (_path4296 = /*#__PURE__*/React.createElement("path", {
    d: "M33 78v1h-1v-1z",
    fill: "#e0d4cb"
  })), _path4297 || (_path4297 = /*#__PURE__*/React.createElement("path", {
    d: "M33 79v-1h1v1z",
    fill: "#b25c51"
  })), _path4298 || (_path4298 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78v1h-1v-1z",
    fill: "#b93f39"
  })), _path4299 || (_path4299 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78v1h-1v-1z",
    fill: "#b11c1d"
  })), _path4300 || (_path4300 = /*#__PURE__*/React.createElement("path", {
    d: "M48 79v-1h1v1z",
    fill: "#9e0a0a"
  })), _path4301 || (_path4301 = /*#__PURE__*/React.createElement("path", {
    d: "M50 79h-1v-1h1z",
    fill: "#a50d0f"
  })), _path4302 || (_path4302 = /*#__PURE__*/React.createElement("path", {
    d: "M52 79h-1v-1h1z",
    fill: "#aa0d11"
  })), _path4303 || (_path4303 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79h-1v-1h1z",
    fill: "#ae0e14"
  })), _path4304 || (_path4304 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78v1h-1v-1z",
    fill: "#aa0b11"
  })), _path4305 || (_path4305 = /*#__PURE__*/React.createElement("path", {
    d: "M61 79v-1h1v1z",
    fill: "#9e1d2a"
  })), _path4306 || (_path4306 = /*#__PURE__*/React.createElement("path", {
    d: "M62 79v-1h1v1z",
    fill: "#bf888d"
  })), _path4307 || (_path4307 = /*#__PURE__*/React.createElement("path", {
    d: "M63 78h1v1h-1z",
    fill: "#c6c3c3"
  })), _path4308 || (_path4308 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78h1v1h-1z",
    fill: "#c0bfbe"
  })), _path4309 || (_path4309 = /*#__PURE__*/React.createElement("path", {
    d: "M66 79v-1h1v1z",
    fill: "#c3a89c"
  })), _path4310 || (_path4310 = /*#__PURE__*/React.createElement("path", {
    d: "M68 78v1h-1v-1z",
    fill: "#a8564e"
  })), _path4311 || (_path4311 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v-1h1v1z",
    fill: "#a11917"
  })), _path4312 || (_path4312 = /*#__PURE__*/React.createElement("path", {
    d: "M70 79h-1v-1h1z",
    fill: "#a6060b"
  })), _path4313 || (_path4313 = /*#__PURE__*/React.createElement("path", {
    d: "M71 79h-1v-1h1z",
    fill: "#9f1921"
  })), _path4314 || (_path4314 = /*#__PURE__*/React.createElement("path", {
    d: "M71 79v-1h1v1z",
    fill: "#c59999"
  })), _path4315 || (_path4315 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79h-1v-1h1z",
    fill: "#b5999a"
  })), _path4316 || (_path4316 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79h-1v-1h1z",
    fill: "#90242a"
  })), _path4317 || (_path4317 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78h1v1h-1z",
    fill: "#a20a12"
  })), _path4318 || (_path4318 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78h1v1h-1z",
    fill: "#9d0509"
  })), _path4319 || (_path4319 = /*#__PURE__*/React.createElement("path", {
    d: "M78 78v1h-1v-1z",
    fill: "#a74a4a"
  })), _path4320 || (_path4320 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79h-1v-1h1z",
    fill: "#cac4bc"
  })), _path4321 || (_path4321 = /*#__PURE__*/React.createElement("path", {
    d: "M80 79v-1h1v1z",
    fill: "#c27e83"
  })), _path4322 || (_path4322 = /*#__PURE__*/React.createElement("path", {
    d: "M82 79h-1v-1h1z",
    fill: "#ba1821"
  })), _path4323 || (_path4323 = /*#__PURE__*/React.createElement("path", {
    d: "M90 79v-1h1v1z",
    fill: "#c1292c"
  })), _path4324 || (_path4324 = /*#__PURE__*/React.createElement("path", {
    d: "M91 78h1v1h-1z",
    fill: "#b83a3c"
  })), _path4325 || (_path4325 = /*#__PURE__*/React.createElement("path", {
    d: "M93 79h-1v-1h1z",
    fill: "#d0b2af"
  })), _path4326 || (_path4326 = /*#__PURE__*/React.createElement("path", {
    d: "M93 78h1v1h-1z",
    fill: "#d3c8ca"
  })), _path4327 || (_path4327 = /*#__PURE__*/React.createElement("path", {
    d: "M95 78v1h-1v-1z",
    fill: "#aa545a"
  })), _path4328 || (_path4328 = /*#__PURE__*/React.createElement("path", {
    d: "M96 79h-1v-1h1z",
    fill: "#b8605c"
  })), _path4329 || (_path4329 = /*#__PURE__*/React.createElement("path", {
    d: "M97 79h-1v-1h1z",
    fill: "#dbbdb2",
    fillOpacity: 0.533
  })), _path4330 || (_path4330 = /*#__PURE__*/React.createElement("path", {
    d: "M31 80v-1h1v1z",
    fill: "#e8eae6",
    fillOpacity: 0.533
  })), _path4331 || (_path4331 = /*#__PURE__*/React.createElement("path", {
    d: "M32 79h1v1h-1z",
    fill: "#e2d5cb"
  })), _path4332 || (_path4332 = /*#__PURE__*/React.createElement("path", {
    d: "M33 79h1v1h-1z",
    fill: "#b35c51"
  })), _path4333 || (_path4333 = /*#__PURE__*/React.createElement("path", {
    d: "M34 80v-1h1v1z",
    fill: "#b53732"
  })), _path4334 || (_path4334 = /*#__PURE__*/React.createElement("path", {
    d: "M36 80h-1v-1h1z",
    fill: "#b7302f"
  })), _path4335 || (_path4335 = /*#__PURE__*/React.createElement("path", {
    d: "M39 79h1v1h-1z",
    fill: "#b41a1c"
  })), _path4336 || (_path4336 = /*#__PURE__*/React.createElement("path", {
    d: "M54 80h-1v-1h1z",
    fill: "#ac1014"
  })), _path4337 || (_path4337 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79v1h-1v-1z",
    fill: "#a91115"
  })), _path4338 || (_path4338 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h1v1h-1z",
    fill: "#ac0d0c"
  })), _path4339 || (_path4339 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80v-1h1v1z",
    fill: "#a31513"
  })), _path4340 || (_path4340 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80h-1v-1h1z",
    fill: "#a00b09"
  })), _path4341 || (_path4341 = /*#__PURE__*/React.createElement("path", {
    d: "M63 79v1h-1v-1z",
    fill: "#9a141d"
  })), _path4342 || (_path4342 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80v-1h1v1z",
    fill: "#b9757d"
  })), _path4343 || (_path4343 = /*#__PURE__*/React.createElement("path", {
    d: "M64 80v-1h1v1z",
    fill: "#c9bfbf"
  })), _path4344 || (_path4344 = /*#__PURE__*/React.createElement("path", {
    d: "M67 80h-1v-1h1z",
    fill: "#c3c2be"
  })), _path4345 || (_path4345 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v1h-1v-1z",
    fill: "#c3c2b6"
  })), _path4346 || (_path4346 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80h-1v-1h1z",
    fill: "#c09d92"
  })), _path4347 || (_path4347 = /*#__PURE__*/React.createElement("path", {
    d: "M70 80h-1v-1h1z",
    fill: "#ae5752"
  })), _path4348 || (_path4348 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h-1v-1h1z",
    fill: "#992b28"
  })), _path4349 || (_path4349 = /*#__PURE__*/React.createElement("path", {
    d: "M72 79v1h-1v-1z",
    fill: "#af7979"
  })), _path4350 || (_path4350 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79v1h-1v-1z",
    fill: "#cbc5be"
  })), _path4351 || (_path4351 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79v1h-1v-1z",
    fill: "#b16d68"
  })), _path4352 || (_path4352 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v-1h1v1z",
    fill: "#9f0b0e"
  })), _path4353 || (_path4353 = /*#__PURE__*/React.createElement("path", {
    d: "M76 79h1v1h-1z",
    fill: "#9c070b"
  })), _path4354 || (_path4354 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80v-1h1v1z",
    fill: "#b27776"
  })), _path4355 || (_path4355 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v-1h1v1z",
    fill: "#c8c5c5"
  })), _path4356 || (_path4356 = /*#__PURE__*/React.createElement("path", {
    d: "M81 79v1h-1v-1z",
    fill: "#c48a8d"
  })), _path4357 || (_path4357 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80h-1v-1h1z",
    fill: "#b81a22"
  })), _path4358 || (_path4358 = /*#__PURE__*/React.createElement("path", {
    d: "M89 80v-1h1v1z",
    fill: "#c4282c"
  })), _path4359 || (_path4359 = /*#__PURE__*/React.createElement("path", {
    d: "M90 79h1v1h-1z",
    fill: "#c42d30"
  })), _path4360 || (_path4360 = /*#__PURE__*/React.createElement("path", {
    d: "M92 79v1h-1v-1z",
    fill: "#bc4245"
  })), _path4361 || (_path4361 = /*#__PURE__*/React.createElement("path", {
    d: "M92 80v-1h1v1z",
    fill: "#d2bab7"
  })), _path4362 || (_path4362 = /*#__PURE__*/React.createElement("path", {
    d: "M93 79h1v1h-1z",
    fill: "#d2c9cb"
  })), _path4363 || (_path4363 = /*#__PURE__*/React.createElement("path", {
    d: "M96 80h-1v-1h1z",
    fill: "#b45e59"
  })), _path4364 || (_path4364 = /*#__PURE__*/React.createElement("path", {
    d: "M96 80v-1h1v1z",
    fill: "#dec0b4",
    fillOpacity: 0.498
  })), _path4365 || (_path4365 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80v1h-1v-1z",
    fill: "#eaeae4",
    fillOpacity: 0.533
  })), _path4366 || (_path4366 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80h1v1h-1z",
    fill: "#e3d4c8"
  })), _path4367 || (_path4367 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81h-1v-1h1z",
    fill: "#b45a4f"
  })), _path4368 || (_path4368 = /*#__PURE__*/React.createElement("path", {
    d: "M35 80v1h-1v-1z",
    fill: "#b2312c"
  })), _path4369 || (_path4369 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v-1h1v1z",
    fill: "#ba302e"
  })), _path4370 || (_path4370 = /*#__PURE__*/React.createElement("path", {
    d: "M37 81h-1v-1h1z",
    fill: "#b52623"
  })), _path4371 || (_path4371 = /*#__PURE__*/React.createElement("path", {
    d: "M38 80v1h-1v-1z",
    fill: "#b42121"
  })), _path4372 || (_path4372 = /*#__PURE__*/React.createElement("path", {
    d: "M38 81v-1h1v1z",
    fill: "#b21d1e"
  })), _path4373 || (_path4373 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81v-1h1v1z",
    fill: "#b5181b"
  })), _path4374 || (_path4374 = /*#__PURE__*/React.createElement("path", {
    d: "M49 81h-1v-1h1z",
    fill: "#a20a0b"
  })), _path4375 || (_path4375 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81v-1h1v1z",
    fill: "#ab1114"
  })), _path4376 || (_path4376 = /*#__PURE__*/React.createElement("path", {
    d: "M54 80h1v1h-1z",
    fill: "#a80d10"
  })), _path4377 || (_path4377 = /*#__PURE__*/React.createElement("path", {
    d: "M57 81v-1h1v1z",
    fill: "#ab0c12"
  })), _path4378 || (_path4378 = /*#__PURE__*/React.createElement("path", {
    d: "M58 80h1v1h-1z",
    fill: "#a53536"
  })), _path4379 || (_path4379 = /*#__PURE__*/React.createElement("path", {
    d: "M60 81h-1v-1h1z",
    fill: "#bd9188"
  })), _path4380 || (_path4380 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80h1v1h-1z",
    fill: "#c69e97"
  })), _path4381 || (_path4381 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80v1h-1v-1z",
    fill: "#b07870"
  })), _path4382 || (_path4382 = /*#__PURE__*/React.createElement("path", {
    d: "M63 81h-1v-1h1z",
    fill: "#9e2c2a"
  })), _path4383 || (_path4383 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81h-1v-1h1z",
    fill: "#ab565e"
  })), _path4384 || (_path4384 = /*#__PURE__*/React.createElement("path", {
    d: "M65 80h1v1h-1z",
    fill: "#c8b2b4"
  })), _path4385 || (_path4385 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81v-1h1v1z",
    fill: "#bec2c0"
  })), _path4386 || (_path4386 = /*#__PURE__*/React.createElement("path", {
    d: "M69 81h-1v-1h1z",
    fill: "#c4c4bf"
  })), _path4387 || (_path4387 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80h1v1h-1z",
    fill: "#c7c4bb"
  })), _path4388 || (_path4388 = /*#__PURE__*/React.createElement("path", {
    d: "M70 80h1v1h-1z",
    fill: "#c4b8b0"
  })), _path4389 || (_path4389 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h1v1h-1z",
    fill: "#c4bcba"
  })), _path4390 || (_path4390 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v1h-1v-1z",
    fill: "#c8b8ad"
  })), _path4391 || (_path4391 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80h1v1h-1z",
    fill: "#a33635"
  })), _path4392 || (_path4392 = /*#__PURE__*/React.createElement("path", {
    d: "M76 80v1h-1v-1z",
    fill: "#a0080b"
  })), _path4393 || (_path4393 = /*#__PURE__*/React.createElement("path", {
    d: "M76 81v-1h1v1z",
    fill: "#9c0d12"
  })), _path4394 || (_path4394 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80h1v1h-1z",
    fill: "#be9395"
  })), _path4395 || (_path4395 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v1h-1v-1z",
    fill: "#c2c5c3"
  })), _path4396 || (_path4396 = /*#__PURE__*/React.createElement("path", {
    d: "M79 81v-1h1v1z",
    fill: "#c2c5c4"
  })), _path4397 || (_path4397 = /*#__PURE__*/React.createElement("path", {
    d: "M81 80v1h-1v-1z",
    fill: "#ccadac"
  })), _path4398 || (_path4398 = /*#__PURE__*/React.createElement("path", {
    d: "M82 81h-1v-1h1z",
    fill: "#b82933"
  })), _path4399 || (_path4399 = /*#__PURE__*/React.createElement("path", {
    d: "M88 80v1h-1v-1z",
    fill: "#c7242b"
  })), _path4400 || (_path4400 = /*#__PURE__*/React.createElement("path", {
    d: "M88 81v-1h1v1z",
    fill: "#c6292d"
  })), _path4401 || (_path4401 = /*#__PURE__*/React.createElement("path", {
    d: "M89 80h1v1h-1z",
    fill: "#c5292e"
  })), _path4402 || (_path4402 = /*#__PURE__*/React.createElement("path", {
    d: "M91 80v1h-1v-1z",
    fill: "#c32c2f"
  })), _path4403 || (_path4403 = /*#__PURE__*/React.createElement("path", {
    d: "M91 80h1v1h-1z",
    fill: "#bb4548"
  })), _path4404 || (_path4404 = /*#__PURE__*/React.createElement("path", {
    d: "M92 80h1v1h-1z",
    fill: "#d0bfbd"
  })), _path4405 || (_path4405 = /*#__PURE__*/React.createElement("path", {
    d: "M94 81h-1v-1h1z",
    fill: "#d0cbcb"
  })), _path4406 || (_path4406 = /*#__PURE__*/React.createElement("path", {
    d: "M94 80h1v1h-1z",
    fill: "#ad595e"
  })), _path4407 || (_path4407 = /*#__PURE__*/React.createElement("path", {
    d: "M95 81v-1h1v1z",
    fill: "#b15c57"
  })), _path4408 || (_path4408 = /*#__PURE__*/React.createElement("path", {
    d: "M97 80v1h-1v-1z",
    fill: "#e4c8bc",
    fillOpacity: 0.529
  })), _path4409 || (_path4409 = /*#__PURE__*/React.createElement("path", {
    d: "M32 82h-1v-1h1z",
    fill: "#e4e2da",
    fillOpacity: 0.525
  })), _path4410 || (_path4410 = /*#__PURE__*/React.createElement("path", {
    d: "M33 81v1h-1v-1z",
    fill: "#e1cfc3"
  })), _path4411 || (_path4411 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81v1h-1v-1z",
    fill: "#b4584d"
  })), _path4412 || (_path4412 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v1h-1v-1z",
    fill: "#b22e2a"
  })), _path4413 || (_path4413 = /*#__PURE__*/React.createElement("path", {
    d: "M36 81v1h-1v-1z",
    fill: "#bb302e"
  })), _path4414 || (_path4414 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82h-1v-1h1z",
    fill: "#b62723"
  })), _path4415 || (_path4415 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82h-1v-1h1z",
    fill: "#b42222"
  })), _path4416 || (_path4416 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h-1v-1h1z",
    fill: "#b41e1f"
  })), _path4417 || (_path4417 = /*#__PURE__*/React.createElement("path", {
    d: "M51 81v1h-1v-1z",
    fill: "#ae1015"
  })), _path4418 || (_path4418 = /*#__PURE__*/React.createElement("path", {
    d: "M57 82h-1v-1h1z",
    fill: "#ac0e13"
  })), _path4419 || (_path4419 = /*#__PURE__*/React.createElement("path", {
    d: "M58 81v1h-1v-1z",
    fill: "#a31619"
  })), _path4420 || (_path4420 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82v-1h1v1z",
    fill: "#c39699"
  })), _path4421 || (_path4421 = /*#__PURE__*/React.createElement("path", {
    d: "M59 82v-1h1v1z",
    fill: "#c49f9f"
  })), _path4422 || (_path4422 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v-1h1v1z",
    fill: "#a86b70"
  })), _path4423 || (_path4423 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h-1v-1h1z",
    fill: "#cac3bd"
  })), _path4424 || (_path4424 = /*#__PURE__*/React.createElement("path", {
    d: "M63 82h-1v-1h1z",
    fill: "#c4b5a4"
  })), _path4425 || (_path4425 = /*#__PURE__*/React.createElement("path", {
    d: "M64 82h-1v-1h1z",
    fill: "#a9504a"
  })), _path4426 || (_path4426 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81v1h-1v-1z",
    fill: "#9a070f"
  })), _path4427 || (_path4427 = /*#__PURE__*/React.createElement("path", {
    d: "M66 81v1h-1v-1z",
    fill: "#a8353d"
  })), _path4428 || (_path4428 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h-1v-1h1z",
    fill: "#c79b9d"
  })), _path4429 || (_path4429 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81h1v1h-1z",
    fill: "#c5c4c3"
  })), _path4430 || (_path4430 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82v-1h1v1z",
    fill: "#c0c5bc"
  })), _path4431 || (_path4431 = /*#__PURE__*/React.createElement("path", {
    d: "M72 81v1h-1v-1z",
    fill: "#c2c2bc"
  })), _path4432 || (_path4432 = /*#__PURE__*/React.createElement("path", {
    d: "M73 81v1h-1v-1z",
    fill: "#c4bec0"
  })), _path4433 || (_path4433 = /*#__PURE__*/React.createElement("path", {
    d: "M74 82h-1v-1h1z",
    fill: "#c2c7be"
  })), _path4434 || (_path4434 = /*#__PURE__*/React.createElement("path", {
    d: "M75 81v1h-1v-1z",
    fill: "#b66b6a"
  })), _path4435 || (_path4435 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82v-1h1v1z",
    fill: "#9e030a"
  })), _path4436 || (_path4436 = /*#__PURE__*/React.createElement("path", {
    d: "M77 81v1h-1v-1z",
    fill: "#9b1a1b"
  })), _path4437 || (_path4437 = /*#__PURE__*/React.createElement("path", {
    d: "M78 81v1h-1v-1z",
    fill: "#c3a7a5"
  })), _path4438 || (_path4438 = /*#__PURE__*/React.createElement("path", {
    d: "M80 81v1h-1v-1z",
    fill: "#c5c1c2"
  })), _path4439 || (_path4439 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h-1v-1h1z",
    fill: "#c8c6c2"
  })), _path4440 || (_path4440 = /*#__PURE__*/React.createElement("path", {
    d: "M81 81h1v1h-1z",
    fill: "#be7272"
  })), _path4441 || (_path4441 = /*#__PURE__*/React.createElement("path", {
    d: "M82 82v-1h1v1z",
    fill: "#b51e22"
  })), _path4442 || (_path4442 = /*#__PURE__*/React.createElement("path", {
    d: "M88 81v1h-1v-1z",
    fill: "#c52229"
  })), _path4443 || (_path4443 = /*#__PURE__*/React.createElement("path", {
    d: "M91 82v-1h1v1z",
    fill: "#b9484b"
  })), _path4444 || (_path4444 = /*#__PURE__*/React.createElement("path", {
    d: "M92 82v-1h1v1z",
    fill: "#cfc3c1"
  })), _path4445 || (_path4445 = /*#__PURE__*/React.createElement("path", {
    d: "M93 81h1v1h-1z",
    fill: "#cfcdcd"
  })), _path4446 || (_path4446 = /*#__PURE__*/React.createElement("path", {
    d: "M94 81h1v1h-1z",
    fill: "#af5d61"
  })), _path4447 || (_path4447 = /*#__PURE__*/React.createElement("path", {
    d: "M96 82h-1v-1h1z",
    fill: "#b45f59"
  })), _path4448 || (_path4448 = /*#__PURE__*/React.createElement("path", {
    d: "M97 82h-1v-1h1z",
    fill: "#eacec3",
    fillOpacity: 0.537
  })), _path4449 || (_path4449 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82h1v1h-1z",
    fill: "#e1ddd6",
    fillOpacity: 0.514
  })), _path4450 || (_path4450 = /*#__PURE__*/React.createElement("path", {
    d: "M33 82v1h-1v-1z",
    fill: "#e2cabd"
  })), _path4451 || (_path4451 = /*#__PURE__*/React.createElement("path", {
    d: "M33 83v-1h1v1z",
    fill: "#b6574c"
  })), _path4452 || (_path4452 = /*#__PURE__*/React.createElement("path", {
    d: "M35 83h-1v-1h1z",
    fill: "#b32d2b"
  })), _path4453 || (_path4453 = /*#__PURE__*/React.createElement("path", {
    d: "M36 82v1h-1v-1z",
    fill: "#ba3131"
  })), _path4454 || (_path4454 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82v1h-1v-1z",
    fill: "#b62825"
  })), _path4455 || (_path4455 = /*#__PURE__*/React.createElement("path", {
    d: "M38 83v-1h1v1z",
    fill: "#b61e20"
  })), _path4456 || (_path4456 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v1h-1v-1z",
    fill: "#b4181b"
  })), _path4457 || (_path4457 = /*#__PURE__*/React.createElement("path", {
    d: "M44 83h-1v-1h1z",
    fill: "#af1416"
  })), _path4458 || (_path4458 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82v1h-1v-1z",
    fill: "#af1016"
  })), _path4459 || (_path4459 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83v-1h1v1z",
    fill: "#b11119"
  })), _path4460 || (_path4460 = /*#__PURE__*/React.createElement("path", {
    d: "M52 82v1h-1v-1z",
    fill: "#ae0e16"
  })), _path4461 || (_path4461 = /*#__PURE__*/React.createElement("path", {
    d: "M52 83v-1h1v1z",
    fill: "#af0f17"
  })), _path4462 || (_path4462 = /*#__PURE__*/React.createElement("path", {
    d: "M53 83v-1h1v1z",
    fill: "#af1116"
  })), _path4463 || (_path4463 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83h-1v-1h1z",
    fill: "#aa242a"
  })), _path4464 || (_path4464 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82h1v1h-1z",
    fill: "#cdb4b2"
  })), _path4465 || (_path4465 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v1h-1v-1z",
    fill: "#bc8883"
  })), _path4466 || (_path4466 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82h1v1h-1z",
    fill: "#981a22"
  })), _path4467 || (_path4467 = /*#__PURE__*/React.createElement("path", {
    d: "M61 82h1v1h-1z",
    fill: "#ca9b9d"
  })), _path4468 || (_path4468 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h1v1h-1z",
    fill: "#c4cbc9"
  })), _path4469 || (_path4469 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83v-1h1v1z",
    fill: "#cdb3ae"
  })), _path4470 || (_path4470 = /*#__PURE__*/React.createElement("path", {
    d: "M64 83v-1h1v1z",
    fill: "#a62528"
  })), _path4471 || (_path4471 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83h-1v-1h1z",
    fill: "#a7060f"
  })), _path4472 || (_path4472 = /*#__PURE__*/React.createElement("path", {
    d: "M66 82h1v1h-1z",
    fill: "#a21e28"
  })), _path4473 || (_path4473 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h1v1h-1z",
    fill: "#c1818a"
  })), _path4474 || (_path4474 = /*#__PURE__*/React.createElement("path", {
    d: "M69 82v1h-1v-1z",
    fill: "#cbc2c3"
  })), _path4475 || (_path4475 = /*#__PURE__*/React.createElement("path", {
    d: "M72 83h-1v-1h1z",
    fill: "#bfc4bd"
  })), _path4476 || (_path4476 = /*#__PURE__*/React.createElement("path", {
    d: "M72 82h1v1h-1z",
    fill: "#c2c0c0"
  })), _path4477 || (_path4477 = /*#__PURE__*/React.createElement("path", {
    d: "M73 82h1v1h-1z",
    fill: "#c4c9c5"
  })), _path4478 || (_path4478 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83v-1h1v1z",
    fill: "#bc7976"
  })), _path4479 || (_path4479 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82h1v1h-1z",
    fill: "#9c0608"
  })), _path4480 || (_path4480 = /*#__PURE__*/React.createElement("path", {
    d: "M76 82h1v1h-1z",
    fill: "#a11e24"
  })), _path4481 || (_path4481 = /*#__PURE__*/React.createElement("path", {
    d: "M78 83h-1v-1h1z",
    fill: "#c6afac"
  })), _path4482 || (_path4482 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82v1h-1v-1z",
    fill: "#c1c3c1"
  })), _path4483 || (_path4483 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h1v1h-1z",
    fill: "#c5c2c3"
  })), _path4484 || (_path4484 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h1v1h-1z",
    fill: "#d5bdba"
  })), _path4485 || (_path4485 = /*#__PURE__*/React.createElement("path", {
    d: "M83 83h-1v-1h1z",
    fill: "#c2494e"
  })), _path4486 || (_path4486 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82v1h-1v-1z",
    fill: "#bf1c23"
  })), _path4487 || (_path4487 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82h1v1h-1z",
    fill: "#c41f27"
  })), _path4488 || (_path4488 = /*#__PURE__*/React.createElement("path", {
    d: "M89 83h-1v-1h1z",
    fill: "#bf2128"
  })), _path4489 || (_path4489 = /*#__PURE__*/React.createElement("path", {
    d: "M89 82h1v1h-1z",
    fill: "#c1252b"
  })), _path4490 || (_path4490 = /*#__PURE__*/React.createElement("path", {
    d: "M92 82v1h-1v-1z",
    fill: "#bd5154"
  })), _path4491 || (_path4491 = /*#__PURE__*/React.createElement("path", {
    d: "M92 83v-1h1v1z",
    fill: "#d0c8c3"
  })), _path4492 || (_path4492 = /*#__PURE__*/React.createElement("path", {
    d: "M93 83v-1h1v1z",
    fill: "#d1cdce"
  })), _path4493 || (_path4493 = /*#__PURE__*/React.createElement("path", {
    d: "M94 82h1v1h-1z",
    fill: "#ae6165"
  })), _path4494 || (_path4494 = /*#__PURE__*/React.createElement("path", {
    d: "M96 83h-1v-1h1z",
    fill: "#b76359"
  })), _path4495 || (_path4495 = /*#__PURE__*/React.createElement("path", {
    d: "M97 83h-1v-1h1z",
    fill: "#eccfc2",
    fillOpacity: 0.529
  })), _path4496 || (_path4496 = /*#__PURE__*/React.createElement("path", {
    d: "M32 83v1h-1v-1z",
    fill: "#e3dfd7",
    fillOpacity: 0.506
  })), _path4497 || (_path4497 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84v-1h1v1z",
    fill: "#dfc4b8"
  })), _path4498 || (_path4498 = /*#__PURE__*/React.createElement("path", {
    d: "M33 84v-1h1v1z",
    fill: "#b8564e"
  })), _path4499 || (_path4499 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h-1v-1h1z",
    fill: "#b43231"
  })), _path4500 || (_path4500 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84v-1h1v1z",
    fill: "#b93334"
  })), _path4501 || (_path4501 = /*#__PURE__*/React.createElement("path", {
    d: "M37 84h-1v-1h1z",
    fill: "#b72a29"
  })), _path4502 || (_path4502 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84v-1h1v1z",
    fill: "#b71f22"
  })), _path4503 || (_path4503 = /*#__PURE__*/React.createElement("path", {
    d: "M45 84h-1v-1h1z",
    fill: "#b31519"
  })), _path4504 || (_path4504 = /*#__PURE__*/React.createElement("path", {
    d: "M45 83h1v1h-1z",
    fill: "#b11317"
  })), _path4505 || (_path4505 = /*#__PURE__*/React.createElement("path", {
    d: "M46 84v-1h1v1z",
    fill: "#af1115"
  })), _path4506 || (_path4506 = /*#__PURE__*/React.createElement("path", {
    d: "M47 84v-1h1v1z",
    fill: "#ad0f13"
  })), _path4507 || (_path4507 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84v-1h1v1z",
    fill: "#ac0f13"
  })), _path4508 || (_path4508 = /*#__PURE__*/React.createElement("path", {
    d: "M51 83h1v1h-1z",
    fill: "#b21218"
  })), _path4509 || (_path4509 = /*#__PURE__*/React.createElement("path", {
    d: "M56 84v-1h1v1z",
    fill: "#b61219"
  })), _path4510 || (_path4510 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83v1h-1v-1z",
    fill: "#ae1f27"
  })), _path4511 || (_path4511 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83v1h-1v-1z",
    fill: "#c6a8a5"
  })), _path4512 || (_path4512 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83h1v1h-1z",
    fill: "#cabdb0"
  })), _path4513 || (_path4513 = /*#__PURE__*/React.createElement("path", {
    d: "M60 84v-1h1v1z",
    fill: "#af4742"
  })), _path4514 || (_path4514 = /*#__PURE__*/React.createElement("path", {
    d: "M62 84h-1v-1h1z",
    fill: "#a52734"
  })), _path4515 || (_path4515 = /*#__PURE__*/React.createElement("path", {
    d: "M62 83h1v1h-1z",
    fill: "#c0848d"
  })), _path4516 || (_path4516 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83h1v1h-1z",
    fill: "#c68a8c"
  })), _path4517 || (_path4517 = /*#__PURE__*/React.createElement("path", {
    d: "M65 84h-1v-1h1z",
    fill: "#ab1d25"
  })), _path4518 || (_path4518 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83v1h-1v-1z",
    fill: "#af0e14"
  })), _path4519 || (_path4519 = /*#__PURE__*/React.createElement("path", {
    d: "M68 83v1h-1v-1z",
    fill: "#a7111c"
  })), _path4520 || (_path4520 = /*#__PURE__*/React.createElement("path", {
    d: "M69 84h-1v-1h1z",
    fill: "#bc6873"
  })), _path4521 || (_path4521 = /*#__PURE__*/React.createElement("path", {
    d: "M69 83h1v1h-1z",
    fill: "#cbbfbd"
  })), _path4522 || (_path4522 = /*#__PURE__*/React.createElement("path", {
    d: "M71 83v1h-1v-1z",
    fill: "#c0bab6"
  })), _path4523 || (_path4523 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84v-1h1v1z",
    fill: "#c0afb2"
  })), _path4524 || (_path4524 = /*#__PURE__*/React.createElement("path", {
    d: "M72 84v-1h1v1z",
    fill: "#c8bdbd"
  })), _path4525 || (_path4525 = /*#__PURE__*/React.createElement("path", {
    d: "M73 84v-1h1v1z",
    fill: "#ceaeb0"
  })), _path4526 || (_path4526 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83h1v1h-1z",
    fill: "#ad4344"
  })), _path4527 || (_path4527 = /*#__PURE__*/React.createElement("path", {
    d: "M76 84v-1h1v1z",
    fill: "#a42528"
  })), _path4528 || (_path4528 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v-1h1v1z",
    fill: "#cab1af"
  })), _path4529 || (_path4529 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84h-1v-1h1z",
    fill: "#bec4c0"
  })), _path4530 || (_path4530 = /*#__PURE__*/React.createElement("path", {
    d: "M79 83h1v1h-1z",
    fill: "#c1c4c3"
  })), _path4531 || (_path4531 = /*#__PURE__*/React.createElement("path", {
    d: "M80 84v-1h1v1z",
    fill: "#cbc7c3"
  })), _path4532 || (_path4532 = /*#__PURE__*/React.createElement("path", {
    d: "M81 83h1v1h-1z",
    fill: "#c88a8e"
  })), _path4533 || (_path4533 = /*#__PURE__*/React.createElement("path", {
    d: "M83 83v1h-1v-1z",
    fill: "#bd2934"
  })), _path4534 || (_path4534 = /*#__PURE__*/React.createElement("path", {
    d: "M88 83h1v1h-1z",
    fill: "#c12229"
  })), _path4535 || (_path4535 = /*#__PURE__*/React.createElement("path", {
    d: "M90 83v1h-1v-1z",
    fill: "#c3272d"
  })), _path4536 || (_path4536 = /*#__PURE__*/React.createElement("path", {
    d: "M90 84v-1h1v1z",
    fill: "#c2262b"
  })), _path4537 || (_path4537 = /*#__PURE__*/React.createElement("path", {
    d: "M91 83h1v1h-1z",
    fill: "#c05d60"
  })), _path4538 || (_path4538 = /*#__PURE__*/React.createElement("path", {
    d: "M92 84v-1h1v1z",
    fill: "#d1ccc8"
  })), _path4539 || (_path4539 = /*#__PURE__*/React.createElement("path", {
    d: "M93 83h1v1h-1z",
    fill: "#d0cdcd"
  })), _path4540 || (_path4540 = /*#__PURE__*/React.createElement("path", {
    d: "M94 84v-1h1v1z",
    fill: "#b06166"
  })), _path4541 || (_path4541 = /*#__PURE__*/React.createElement("path", {
    d: "M96 84h-1v-1h1z",
    fill: "#bd6a64"
  })), _path4542 || (_path4542 = /*#__PURE__*/React.createElement("path", {
    d: "M97 83v1h-1v-1z",
    fill: "#e7ccc2",
    fillOpacity: 0.514
  })), _path4543 || (_path4543 = /*#__PURE__*/React.createElement("path", {
    d: "M32 85h-1v-1h1z",
    fill: "#e3dfd5",
    fillOpacity: 0.506
  })), _path4544 || (_path4544 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84h1v1h-1z",
    fill: "#dfc1b6"
  })), _path4545 || (_path4545 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84v1h-1v-1z",
    fill: "#be5d56"
  })), _path4546 || (_path4546 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84h1v1h-1z",
    fill: "#b93d3c"
  })), _path4547 || (_path4547 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h1v1h-1z",
    fill: "#bd383a"
  })), _path4548 || (_path4548 = /*#__PURE__*/React.createElement("path", {
    d: "M36 85v-1h1v1z",
    fill: "#ba2f2e"
  })), _path4549 || (_path4549 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84v1h-1v-1z",
    fill: "#ba2829"
  })), _path4550 || (_path4550 = /*#__PURE__*/React.createElement("path", {
    d: "M39 84h1v1h-1z",
    fill: "#bb1f22"
  })), _path4551 || (_path4551 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84v1h-1v-1z",
    fill: "#ba1d21"
  })), _path4552 || (_path4552 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84v1h-1v-1z",
    fill: "#b91a1e"
  })), _path4553 || (_path4553 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84h1v1h-1z",
    fill: "#b9181d"
  })), _path4554 || (_path4554 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85h-1v-1h1z",
    fill: "#b9171c"
  })), _path4555 || (_path4555 = /*#__PURE__*/React.createElement("path", {
    d: "M47 85h-1v-1h1z",
    fill: "#b61318"
  })), _path4556 || (_path4556 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85v-1h1v1z",
    fill: "#b11216"
  })), _path4557 || (_path4557 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84h1v1h-1z",
    fill: "#b41419"
  })), _path4558 || (_path4558 = /*#__PURE__*/React.createElement("path", {
    d: "M55 84h1v1h-1z",
    fill: "#b7151c"
  })), _path4559 || (_path4559 = /*#__PURE__*/React.createElement("path", {
    d: "M58 84v1h-1v-1z",
    fill: "#b5131f"
  })), _path4560 || (_path4560 = /*#__PURE__*/React.createElement("path", {
    d: "M59 85h-1v-1h1z",
    fill: "#c4757d"
  })), _path4561 || (_path4561 = /*#__PURE__*/React.createElement("path", {
    d: "M61 85h-1v-1h1z",
    fill: "#c6b1a2"
  })), _path4562 || (_path4562 = /*#__PURE__*/React.createElement("path", {
    d: "M62 84v1h-1v-1z",
    fill: "#a83935"
  })), _path4563 || (_path4563 = /*#__PURE__*/React.createElement("path", {
    d: "M62 85v-1h1v1z",
    fill: "#a40b13"
  })), _path4564 || (_path4564 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v-1h1v1z",
    fill: "#ae1017"
  })), _path4565 || (_path4565 = /*#__PURE__*/React.createElement("path", {
    d: "M66 85h-1v-1h1z",
    fill: "#b0121a"
  })), _path4566 || (_path4566 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v-1h1v1z",
    fill: "#b80f13"
  })), _path4567 || (_path4567 = /*#__PURE__*/React.createElement("path", {
    d: "M68 84h1v1h-1z",
    fill: "#ac121b"
  })), _path4568 || (_path4568 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v-1h1v1z",
    fill: "#b8636a"
  })), _path4569 || (_path4569 = /*#__PURE__*/React.createElement("path", {
    d: "M71 85h-1v-1h1z",
    fill: "#cbb4b6"
  })), _path4570 || (_path4570 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84h1v1h-1z",
    fill: "#a95d63"
  })), _path4571 || (_path4571 = /*#__PURE__*/React.createElement("path", {
    d: "M72 85v-1h1v1z",
    fill: "#aa343a"
  })), _path4572 || (_path4572 = /*#__PURE__*/React.createElement("path", {
    d: "M73 84h1v1h-1z",
    fill: "#ad2936"
  })), _path4573 || (_path4573 = /*#__PURE__*/React.createElement("path", {
    d: "M75 84v1h-1v-1z",
    fill: "#ac1219"
  })), _path4574 || (_path4574 = /*#__PURE__*/React.createElement("path", {
    d: "M75 85v-1h1v1z",
    fill: "#af0c13"
  })), _path4575 || (_path4575 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v1h-1v-1z",
    fill: "#a62628"
  })), _path4576 || (_path4576 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v-1h1v1z",
    fill: "#c7b2af"
  })), _path4577 || (_path4577 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84v1h-1v-1z",
    fill: "#c1c4c0"
  })), _path4578 || (_path4578 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85v-1h1v1z",
    fill: "#c4c7c5"
  })), _path4579 || (_path4579 = /*#__PURE__*/React.createElement("path", {
    d: "M81 85h-1v-1h1z",
    fill: "#cca3a4"
  })), _path4580 || (_path4580 = /*#__PURE__*/React.createElement("path", {
    d: "M81 85v-1h1v1z",
    fill: "#bb2939"
  })), _path4581 || (_path4581 = /*#__PURE__*/React.createElement("path", {
    d: "M82 85v-1h1v1z",
    fill: "#c61a26"
  })), _path4582 || (_path4582 = /*#__PURE__*/React.createElement("path", {
    d: "M84 84v1h-1v-1z",
    fill: "#c71e25"
  })), _path4583 || (_path4583 = /*#__PURE__*/React.createElement("path", {
    d: "M89 84v1h-1v-1z",
    fill: "#c2232a"
  })), _path4584 || (_path4584 = /*#__PURE__*/React.createElement("path", {
    d: "M90 85h-1v-1h1z",
    fill: "#c4282e"
  })), _path4585 || (_path4585 = /*#__PURE__*/React.createElement("path", {
    d: "M91 84v1h-1v-1z",
    fill: "#c2282d"
  })), _path4586 || (_path4586 = /*#__PURE__*/React.createElement("path", {
    d: "M91 84h1v1h-1z",
    fill: "#c06969"
  })), _path4587 || (_path4587 = /*#__PURE__*/React.createElement("path", {
    d: "M93 85v-1h1v1z",
    fill: "#d1cdcc"
  })), _path4588 || (_path4588 = /*#__PURE__*/React.createElement("path", {
    d: "M94 84h1v1h-1z",
    fill: "#b2676a"
  })), _path4589 || (_path4589 = /*#__PURE__*/React.createElement("path", {
    d: "M95 84h1v1h-1z",
    fill: "#c57d7a"
  })), _path4590 || (_path4590 = /*#__PURE__*/React.createElement("path", {
    d: "M96 84h1v1h-1z",
    fill: "#ebd6ce",
    fillOpacity: 0.514
  })), _path4591 || (_path4591 = /*#__PURE__*/React.createElement("path", {
    d: "M32 85v1h-1v-1z",
    fill: "#e3dfd5",
    fillOpacity: 0.502
  })), _path4592 || (_path4592 = /*#__PURE__*/React.createElement("path", {
    d: "M33 85v1h-1v-1z",
    fill: "#dfbfb5"
  })), _path4593 || (_path4593 = /*#__PURE__*/React.createElement("path", {
    d: "M34 86h-1v-1h1z",
    fill: "#c3655f"
  })), _path4594 || (_path4594 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86h-1v-1h1z",
    fill: "#be4847"
  })), _path4595 || (_path4595 = /*#__PURE__*/React.createElement("path", {
    d: "M35 85h1v1h-1z",
    fill: "#c23b40"
  })), _path4596 || (_path4596 = /*#__PURE__*/React.createElement("path", {
    d: "M37 86h-1v-1h1z",
    fill: "#c03334"
  })), _path4597 || (_path4597 = /*#__PURE__*/React.createElement("path", {
    d: "M38 85v1h-1v-1z",
    fill: "#be2c2d"
  })), _path4598 || (_path4598 = /*#__PURE__*/React.createElement("path", {
    d: "M38 86v-1h1v1z",
    fill: "#be2628"
  })), _path4599 || (_path4599 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86h-1v-1h1z",
    fill: "#bf2326"
  })), _path4600 || (_path4600 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v-1h1v1z",
    fill: "#bd2023"
  })), _path4601 || (_path4601 = /*#__PURE__*/React.createElement("path", {
    d: "M41 85h1v1h-1z",
    fill: "#bb1d20"
  })), _path4602 || (_path4602 = /*#__PURE__*/React.createElement("path", {
    d: "M43 86h-1v-1h1z",
    fill: "#bb1b1f"
  })), _path4603 || (_path4603 = /*#__PURE__*/React.createElement("path", {
    d: "M44 86h-1v-1h1z",
    fill: "#bb191e"
  })), _path4604 || (_path4604 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85v1h-1v-1z",
    fill: "#bb181d"
  })), _path4605 || (_path4605 = /*#__PURE__*/React.createElement("path", {
    d: "M47 86h-1v-1h1z",
    fill: "#b8151a"
  })), _path4606 || (_path4606 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85h1v1h-1z",
    fill: "#b41519"
  })), _path4607 || (_path4607 = /*#__PURE__*/React.createElement("path", {
    d: "M55 85h1v1h-1z",
    fill: "#b7141b"
  })), _path4608 || (_path4608 = /*#__PURE__*/React.createElement("path", {
    d: "M57 86v-1h1v1z",
    fill: "#b9141c"
  })), _path4609 || (_path4609 = /*#__PURE__*/React.createElement("path", {
    d: "M58 85h1v1h-1z",
    fill: "#b42e38"
  })), _path4610 || (_path4610 = /*#__PURE__*/React.createElement("path", {
    d: "M59 86v-1h1v1z",
    fill: "#cfabb1"
  })), _path4611 || (_path4611 = /*#__PURE__*/React.createElement("path", {
    d: "M61 86h-1v-1h1z",
    fill: "#bfc9c2"
  })), _path4612 || (_path4612 = /*#__PURE__*/React.createElement("path", {
    d: "M62 86h-1v-1h1z",
    fill: "#c6afa2"
  })), _path4613 || (_path4613 = /*#__PURE__*/React.createElement("path", {
    d: "M62 85h1v1h-1z",
    fill: "#ab3e3d"
  })), _path4614 || (_path4614 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v1h-1v-1z",
    fill: "#ac0d11"
  })), _path4615 || (_path4615 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v1h-1v-1z",
    fill: "#b8141a"
  })), _path4616 || (_path4616 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85h1v1h-1z",
    fill: "#b1141c"
  })), _path4617 || (_path4617 = /*#__PURE__*/React.createElement("path", {
    d: "M70 85h1v1h-1z",
    fill: "#be6971"
  })), _path4618 || (_path4618 = /*#__PURE__*/React.createElement("path", {
    d: "M71 86v-1h1v1z",
    fill: "#d0b0ae"
  })), _path4619 || (_path4619 = /*#__PURE__*/React.createElement("path", {
    d: "M73 85v1h-1v-1z",
    fill: "#ae3a3a"
  })), _path4620 || (_path4620 = /*#__PURE__*/React.createElement("path", {
    d: "M73 86v-1h1v1z",
    fill: "#ad0c0f"
  })), _path4621 || (_path4621 = /*#__PURE__*/React.createElement("path", {
    d: "M75 85h1v1h-1z",
    fill: "#b21017"
  })), _path4622 || (_path4622 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v1h-1v-1z",
    fill: "#a82325"
  })), _path4623 || (_path4623 = /*#__PURE__*/React.createElement("path", {
    d: "M78 86h-1v-1h1z",
    fill: "#c6adac"
  })), _path4624 || (_path4624 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85v1h-1v-1z",
    fill: "#c0c5c1"
  })), _path4625 || (_path4625 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85h1v1h-1z",
    fill: "#cac4c2"
  })), _path4626 || (_path4626 = /*#__PURE__*/React.createElement("path", {
    d: "M80 85h1v1h-1z",
    fill: "#bd5760"
  })), _path4627 || (_path4627 = /*#__PURE__*/React.createElement("path", {
    d: "M81 86v-1h1v1z",
    fill: "#c21821"
  })), _path4628 || (_path4628 = /*#__PURE__*/React.createElement("path", {
    d: "M83 86h-1v-1h1z",
    fill: "#c71e24"
  })), _path4629 || (_path4629 = /*#__PURE__*/React.createElement("path", {
    d: "M84 85h1v1h-1z",
    fill: "#c72029"
  })), _path4630 || (_path4630 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86v-1h1v1z",
    fill: "#c52227"
  })), _path4631 || (_path4631 = /*#__PURE__*/React.createElement("path", {
    d: "M87 85h1v1h-1z",
    fill: "#c42128"
  })), _path4632 || (_path4632 = /*#__PURE__*/React.createElement("path", {
    d: "M88 86v-1h1v1z",
    fill: "#c2232b"
  })), _path4633 || (_path4633 = /*#__PURE__*/React.createElement("path", {
    d: "M90 85v1h-1v-1z",
    fill: "#c4292f"
  })), _path4634 || (_path4634 = /*#__PURE__*/React.createElement("path", {
    d: "M90 86v-1h1v1z",
    fill: "#c2282e"
  })), _path4635 || (_path4635 = /*#__PURE__*/React.createElement("path", {
    d: "M91 85h1v1h-1z",
    fill: "#c57878"
  })), _path4636 || (_path4636 = /*#__PURE__*/React.createElement("path", {
    d: "M93 86h-1v-1h1z",
    fill: "#ced0cd"
  })), _path4637 || (_path4637 = /*#__PURE__*/React.createElement("path", {
    d: "M94 85h1v1h-1z",
    fill: "#b97576"
  })), _path4638 || (_path4638 = /*#__PURE__*/React.createElement("path", {
    d: "M96 86h-1v-1h1z",
    fill: "#cc8f8d"
  })), _path4639 || (_path4639 = /*#__PURE__*/React.createElement("path", {
    d: "M97 86h-1v-1h1z",
    fill: "#e1d0ca",
    fillOpacity: 0.514
  })), _path4640 || (_path4640 = /*#__PURE__*/React.createElement("path", {
    d: "M31 87v-1h1v1z",
    fill: "#e1dfd3",
    fillOpacity: 0.506
  })), _path4641 || (_path4641 = /*#__PURE__*/React.createElement("path", {
    d: "M33 86v1h-1v-1z",
    fill: "#e0b9b0"
  })), _path4642 || (_path4642 = /*#__PURE__*/React.createElement("path", {
    d: "M33 86h1v1h-1z",
    fill: "#c46661"
  })), _path4643 || (_path4643 = /*#__PURE__*/React.createElement("path", {
    d: "M34 87v-1h1v1z",
    fill: "#c04a4b"
  })), _path4644 || (_path4644 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86h1v1h-1z",
    fill: "#c23d40"
  })), _path4645 || (_path4645 = /*#__PURE__*/React.createElement("path", {
    d: "M38 87h-1v-1h1z",
    fill: "#bf2d31"
  })), _path4646 || (_path4646 = /*#__PURE__*/React.createElement("path", {
    d: "M39 87h-1v-1h1z",
    fill: "#bf272c"
  })), _path4647 || (_path4647 = /*#__PURE__*/React.createElement("path", {
    d: "M41 86v1h-1v-1z",
    fill: "#be2223"
  })), _path4648 || (_path4648 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v-1h1v1z",
    fill: "#be1c21"
  })), _path4649 || (_path4649 = /*#__PURE__*/React.createElement("path", {
    d: "M44 87v-1h1v1z",
    fill: "#bb1820"
  })), _path4650 || (_path4650 = /*#__PURE__*/React.createElement("path", {
    d: "M46 87v-1h1v1z",
    fill: "#b9161c"
  })), _path4651 || (_path4651 = /*#__PURE__*/React.createElement("path", {
    d: "M49 86v1h-1v-1z",
    fill: "#b8141b"
  })), _path4652 || (_path4652 = /*#__PURE__*/React.createElement("path", {
    d: "M55 86v1h-1v-1z",
    fill: "#b81319"
  })), _path4653 || (_path4653 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86h1v1h-1z",
    fill: "#b6141a"
  })), _path4654 || (_path4654 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87v-1h1v1z",
    fill: "#b85260"
  })), _path4655 || (_path4655 = /*#__PURE__*/React.createElement("path", {
    d: "M60 87v-1h1v1z",
    fill: "#cbbdc0"
  })), _path4656 || (_path4656 = /*#__PURE__*/React.createElement("path", {
    d: "M62 87h-1v-1h1z",
    fill: "#c3c5bd"
  })), _path4657 || (_path4657 = /*#__PURE__*/React.createElement("path", {
    d: "M63 86v1h-1v-1z",
    fill: "#c6b5ac"
  })), _path4658 || (_path4658 = /*#__PURE__*/React.createElement("path", {
    d: "M63 87v-1h1v1z",
    fill: "#b05652"
  })), _path4659 || (_path4659 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86v1h-1v-1z",
    fill: "#a71415"
  })), _path4660 || (_path4660 = /*#__PURE__*/React.createElement("path", {
    d: "M65 87v-1h1v1z",
    fill: "#b41015"
  })), _path4661 || (_path4661 = /*#__PURE__*/React.createElement("path", {
    d: "M68 86v1h-1v-1z",
    fill: "#b7151e"
  })), _path4662 || (_path4662 = /*#__PURE__*/React.createElement("path", {
    d: "M68 87v-1h1v1z",
    fill: "#ba161e"
  })), _path4663 || (_path4663 = /*#__PURE__*/React.createElement("path", {
    d: "M70 86v1h-1v-1z",
    fill: "#bf171c"
  })), _path4664 || (_path4664 = /*#__PURE__*/React.createElement("path", {
    d: "M71 86v1h-1v-1z",
    fill: "#b11822"
  })), _path4665 || (_path4665 = /*#__PURE__*/React.createElement("path", {
    d: "M72 86v1h-1v-1z",
    fill: "#c0868b"
  })), _path4666 || (_path4666 = /*#__PURE__*/React.createElement("path", {
    d: "M73 86v1h-1v-1z",
    fill: "#cba8a1"
  })), _path4667 || (_path4667 = /*#__PURE__*/React.createElement("path", {
    d: "M74 87h-1v-1h1z",
    fill: "#ae2526"
  })), _path4668 || (_path4668 = /*#__PURE__*/React.createElement("path", {
    d: "M75 87v-1h1v1z",
    fill: "#b31017"
  })), _path4669 || (_path4669 = /*#__PURE__*/React.createElement("path", {
    d: "M76 87v-1h1v1z",
    fill: "#a81d1f"
  })), _path4670 || (_path4670 = /*#__PURE__*/React.createElement("path", {
    d: "M77 86h1v1h-1z",
    fill: "#c4a5a5"
  })), _path4671 || (_path4671 = /*#__PURE__*/React.createElement("path", {
    d: "M79 87h-1v-1h1z",
    fill: "#bfc8c6"
  })), _path4672 || (_path4672 = /*#__PURE__*/React.createElement("path", {
    d: "M80 86h1v1h-1z",
    fill: "#bc2b34"
  })), _path4673 || (_path4673 = /*#__PURE__*/React.createElement("path", {
    d: "M87 87v-1h1v1z",
    fill: "#c6232a"
  })), _path4674 || (_path4674 = /*#__PURE__*/React.createElement("path", {
    d: "M88 86h1v1h-1z",
    fill: "#c4252d"
  })), _path4675 || (_path4675 = /*#__PURE__*/React.createElement("path", {
    d: "M89 87v-1h1v1z",
    fill: "#c62b30"
  })), _path4676 || (_path4676 = /*#__PURE__*/React.createElement("path", {
    d: "M90 86h1v1h-1z",
    fill: "#bf2b30"
  })), _path4677 || (_path4677 = /*#__PURE__*/React.createElement("path", {
    d: "M91 86h1v1h-1z",
    fill: "#c78985"
  })), _path4678 || (_path4678 = /*#__PURE__*/React.createElement("path", {
    d: "M92 87v-1h1v1z",
    fill: "#cdd2ce"
  })), _path4679 || (_path4679 = /*#__PURE__*/React.createElement("path", {
    d: "M94 87v-1h1v1z",
    fill: "#bf8586"
  })), _path4680 || (_path4680 = /*#__PURE__*/React.createElement("path", {
    d: "M96 86v1h-1v-1z",
    fill: "#d79c9d"
  })), _path4681 || (_path4681 = /*#__PURE__*/React.createElement("path", {
    d: "M96 87v-1h1v1z",
    fill: "#dfcdcc",
    fillOpacity: 0.51
  })), _path4682 || (_path4682 = /*#__PURE__*/React.createElement("path", {
    d: "M32 88h-1v-1h1z",
    fill: "#e1ddd1",
    fillOpacity: 0.506
  })), _path4683 || (_path4683 = /*#__PURE__*/React.createElement("path", {
    d: "M33 88h-1v-1h1z",
    fill: "#ddb4ac"
  })), _path4684 || (_path4684 = /*#__PURE__*/React.createElement("path", {
    d: "M33 88v-1h1v1z",
    fill: "#c46963"
  })), _path4685 || (_path4685 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88h-1v-1h1z",
    fill: "#c14d4e"
  })), _path4686 || (_path4686 = /*#__PURE__*/React.createElement("path", {
    d: "M36 88v-1h1v1z",
    fill: "#c13639"
  })), _path4687 || (_path4687 = /*#__PURE__*/React.createElement("path", {
    d: "M37 87h1v1h-1z",
    fill: "#c02e30"
  })), _path4688 || (_path4688 = /*#__PURE__*/React.createElement("path", {
    d: "M38 88v-1h1v1z",
    fill: "#be292b"
  })), _path4689 || (_path4689 = /*#__PURE__*/React.createElement("path", {
    d: "M40 88h-1v-1h1z",
    fill: "#c0262a"
  })), _path4690 || (_path4690 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v1h-1v-1z",
    fill: "#bc1a1f"
  })), _path4691 || (_path4691 = /*#__PURE__*/React.createElement("path", {
    d: "M50 88v-1h1v1z",
    fill: "#bc181e"
  })), _path4692 || (_path4692 = /*#__PURE__*/React.createElement("path", {
    d: "M55 88h-1v-1h1z",
    fill: "#b9141a"
  })), _path4693 || (_path4693 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87h1v1h-1z",
    fill: "#b41723"
  })), _path4694 || (_path4694 = /*#__PURE__*/React.createElement("path", {
    d: "M60 88v-1h1v1z",
    fill: "#c1666f"
  })), _path4695 || (_path4695 = /*#__PURE__*/React.createElement("path", {
    d: "M61 87h1v1h-1z",
    fill: "#c8c2bb"
  })), _path4696 || (_path4696 = /*#__PURE__*/React.createElement("path", {
    d: "M64 87v1h-1v-1z",
    fill: "#c8c1b9"
  })), _path4697 || (_path4697 = /*#__PURE__*/React.createElement("path", {
    d: "M64 88v-1h1v1z",
    fill: "#bc8277"
  })), _path4698 || (_path4698 = /*#__PURE__*/React.createElement("path", {
    d: "M65 88v-1h1v1z",
    fill: "#ae2e2e"
  })), _path4699 || (_path4699 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87v1h-1v-1z",
    fill: "#b01214"
  })), _path4700 || (_path4700 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h1v1h-1z",
    fill: "#b81416"
  })), _path4701 || (_path4701 = /*#__PURE__*/React.createElement("path", {
    d: "M71 87v1h-1v-1z",
    fill: "#c0141d"
  })), _path4702 || (_path4702 = /*#__PURE__*/React.createElement("path", {
    d: "M71 87h1v1h-1z",
    fill: "#af3139"
  })), _path4703 || (_path4703 = /*#__PURE__*/React.createElement("path", {
    d: "M72 87h1v1h-1z",
    fill: "#cbb7b0"
  })), _path4704 || (_path4704 = /*#__PURE__*/React.createElement("path", {
    d: "M74 87v1h-1v-1z",
    fill: "#bf7c7d"
  })), _path4705 || (_path4705 = /*#__PURE__*/React.createElement("path", {
    d: "M74 88v-1h1v1z",
    fill: "#ae1519"
  })), _path4706 || (_path4706 = /*#__PURE__*/React.createElement("path", {
    d: "M75 88v-1h1v1z",
    fill: "#b71118"
  })), _path4707 || (_path4707 = /*#__PURE__*/React.createElement("path", {
    d: "M76 87h1v1h-1z",
    fill: "#aa171c"
  })), _path4708 || (_path4708 = /*#__PURE__*/React.createElement("path", {
    d: "M78 88h-1v-1h1z",
    fill: "#c19699"
  })), _path4709 || (_path4709 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88v-1h1v1z",
    fill: "#c68c90"
  })), _path4710 || (_path4710 = /*#__PURE__*/React.createElement("path", {
    d: "M80 87h1v1h-1z",
    fill: "#bf1b26"
  })), _path4711 || (_path4711 = /*#__PURE__*/React.createElement("path", {
    d: "M89 87h1v1h-1z",
    fill: "#c82c32"
  })), _path4712 || (_path4712 = /*#__PURE__*/React.createElement("path", {
    d: "M91 87v1h-1v-1z",
    fill: "#bf3034"
  })), _path4713 || (_path4713 = /*#__PURE__*/React.createElement("path", {
    d: "M91 88v-1h1v1z",
    fill: "#cc9995"
  })), _path4714 || (_path4714 = /*#__PURE__*/React.createElement("path", {
    d: "M93 87v1h-1v-1z",
    fill: "#cdd1ce"
  })), _path4715 || (_path4715 = /*#__PURE__*/React.createElement("path", {
    d: "M93 87h1v1h-1z",
    fill: "#d1d0ce"
  })), _path4716 || (_path4716 = /*#__PURE__*/React.createElement("path", {
    d: "M94 87h1v1h-1z",
    fill: "#c68f90"
  })), _path4717 || (_path4717 = /*#__PURE__*/React.createElement("path", {
    d: "M96 87v1h-1v-1z",
    fill: "#daa1a1"
  })), _path4718 || (_path4718 = /*#__PURE__*/React.createElement("path", {
    d: "M96 87h1v1h-1z",
    fill: "#efddd9",
    fillOpacity: 0.506
  })), _path4719 || (_path4719 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89v-1h1v1z",
    fill: "#e9e3d9",
    fillOpacity: 0.502
  })), _path4720 || (_path4720 = /*#__PURE__*/React.createElement("path", {
    d: "M32 89v-1h1v1z",
    fill: "#dcb1a8"
  })), _path4721 || (_path4721 = /*#__PURE__*/React.createElement("path", {
    d: "M34 88v1h-1v-1z",
    fill: "#c46a64"
  })), _path4722 || (_path4722 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88v1h-1v-1z",
    fill: "#c14f4f"
  })), _path4723 || (_path4723 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89h-1v-1h1z",
    fill: "#c04042"
  })), _path4724 || (_path4724 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89v-1h1v1z",
    fill: "#c1373a"
  })), _path4725 || (_path4725 = /*#__PURE__*/React.createElement("path", {
    d: "M37 89v-1h1v1z",
    fill: "#c02e33"
  })), _path4726 || (_path4726 = /*#__PURE__*/React.createElement("path", {
    d: "M39 88v1h-1v-1z",
    fill: "#bf2a2a"
  })), _path4727 || (_path4727 = /*#__PURE__*/React.createElement("path", {
    d: "M39 88h1v1h-1z",
    fill: "#bc2522"
  })), _path4728 || (_path4728 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h-1v-1h1z",
    fill: "#b81f1d"
  })), _path4729 || (_path4729 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89h-1v-1h1z",
    fill: "#ba1c1d"
  })), _path4730 || (_path4730 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89v-1h1v1z",
    fill: "#b71a1c"
  })), _path4731 || (_path4731 = /*#__PURE__*/React.createElement("path", {
    d: "M44 88v1h-1v-1z",
    fill: "#b9191d"
  })), _path4732 || (_path4732 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88v1h-1v-1z",
    fill: "#be1a23"
  })), _path4733 || (_path4733 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v-1h1v1z",
    fill: "#c0191c"
  })), _path4734 || (_path4734 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v-1h1v1z",
    fill: "#b51721"
  })), _path4735 || (_path4735 = /*#__PURE__*/React.createElement("path", {
    d: "M62 89h-1v-1h1z",
    fill: "#bf727f"
  })), _path4736 || (_path4736 = /*#__PURE__*/React.createElement("path", {
    d: "M63 89h-1v-1h1z",
    fill: "#cac3c5"
  })), _path4737 || (_path4737 = /*#__PURE__*/React.createElement("path", {
    d: "M63 88h1v1h-1z",
    fill: "#c5c2be"
  })), _path4738 || (_path4738 = /*#__PURE__*/React.createElement("path", {
    d: "M66 88v1h-1v-1z",
    fill: "#c9b3ab"
  })), _path4739 || (_path4739 = /*#__PURE__*/React.createElement("path", {
    d: "M67 89h-1v-1h1z",
    fill: "#bc7067"
  })), _path4740 || (_path4740 = /*#__PURE__*/React.createElement("path", {
    d: "M68 88v1h-1v-1z",
    fill: "#b32e2c"
  })), _path4741 || (_path4741 = /*#__PURE__*/React.createElement("path", {
    d: "M69 89h-1v-1h1z",
    fill: "#b51817"
  })), _path4742 || (_path4742 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89h-1v-1h1z",
    fill: "#ba161a"
  })), _path4743 || (_path4743 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89v-1h1v1z",
    fill: "#bf1719"
  })), _path4744 || (_path4744 = /*#__PURE__*/React.createElement("path", {
    d: "M71 88h1v1h-1z",
    fill: "#b1181c"
  })), _path4745 || (_path4745 = /*#__PURE__*/React.createElement("path", {
    d: "M73 88v1h-1v-1z",
    fill: "#bf9694"
  })), _path4746 || (_path4746 = /*#__PURE__*/React.createElement("path", {
    d: "M74 88h1v1h-1z",
    fill: "#b33a3c"
  })), _path4747 || (_path4747 = /*#__PURE__*/React.createElement("path", {
    d: "M76 88v1h-1v-1z",
    fill: "#b71217"
  })), _path4748 || (_path4748 = /*#__PURE__*/React.createElement("path", {
    d: "M76 88h1v1h-1z",
    fill: "#af121a"
  })), _path4749 || (_path4749 = /*#__PURE__*/React.createElement("path", {
    d: "M77 89v-1h1v1z",
    fill: "#bf8287"
  })), _path4750 || (_path4750 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88h1v1h-1z",
    fill: "#c4747a"
  })), _path4751 || (_path4751 = /*#__PURE__*/React.createElement("path", {
    d: "M80 89v-1h1v1z",
    fill: "#c11822"
  })), _path4752 || (_path4752 = /*#__PURE__*/React.createElement("path", {
    d: "M89 88h1v1h-1z",
    fill: "#c72b31"
  })), _path4753 || (_path4753 = /*#__PURE__*/React.createElement("path", {
    d: "M91 89h-1v-1h1z",
    fill: "#be3638"
  })), _path4754 || (_path4754 = /*#__PURE__*/React.createElement("path", {
    d: "M91 88h1v1h-1z",
    fill: "#cea7a7"
  })), _path4755 || (_path4755 = /*#__PURE__*/React.createElement("path", {
    d: "M92 89v-1h1v1z",
    fill: "#cbd1cf"
  })), _path4756 || (_path4756 = /*#__PURE__*/React.createElement("path", {
    d: "M94 89h-1v-1h1z",
    fill: "#d0d0ce"
  })), _path4757 || (_path4757 = /*#__PURE__*/React.createElement("path", {
    d: "M94 89v-1h1v1z",
    fill: "#c78f93"
  })), _path4758 || (_path4758 = /*#__PURE__*/React.createElement("path", {
    d: "M95 88h1v1h-1z",
    fill: "#d29898"
  })), _path4759 || (_path4759 = /*#__PURE__*/React.createElement("path", {
    d: "M97 88v1h-1v-1z",
    fill: "#e4d3cd",
    fillOpacity: 0.525
  })), _path4760 || (_path4760 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89h1v1h-1z",
    fill: "#efe7db",
    fillOpacity: 0.514
  })), _path4761 || (_path4761 = /*#__PURE__*/React.createElement("path", {
    d: "M33 90h-1v-1h1z",
    fill: "#ddaea6"
  })), _path4762 || (_path4762 = /*#__PURE__*/React.createElement("path", {
    d: "M34 90h-1v-1h1z",
    fill: "#c66a64"
  })), _path4763 || (_path4763 = /*#__PURE__*/React.createElement("path", {
    d: "M34 89h1v1h-1z",
    fill: "#c24e4f"
  })), _path4764 || (_path4764 = /*#__PURE__*/React.createElement("path", {
    d: "M37 89v1h-1v-1z",
    fill: "#c23739"
  })), _path4765 || (_path4765 = /*#__PURE__*/React.createElement("path", {
    d: "M38 90h-1v-1h1z",
    fill: "#c12f31"
  })), _path4766 || (_path4766 = /*#__PURE__*/React.createElement("path", {
    d: "M40 89v1h-1v-1z",
    fill: "#b64543"
  })), _path4767 || (_path4767 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90v-1h1v1z",
    fill: "#c5706e"
  })), _path4768 || (_path4768 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h1v1h-1z",
    fill: "#ce8280"
  })), _path4769 || (_path4769 = /*#__PURE__*/React.createElement("path", {
    d: "M43 90h-1v-1h1z",
    fill: "#c87c74"
  })), _path4770 || (_path4770 = /*#__PURE__*/React.createElement("path", {
    d: "M44 89v1h-1v-1z",
    fill: "#bd5a51"
  })), _path4771 || (_path4771 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h-1v-1h1z",
    fill: "#b32d29"
  })), _path4772 || (_path4772 = /*#__PURE__*/React.createElement("path", {
    d: "M47 89v1h-1v-1z",
    fill: "#bd181f"
  })), _path4773 || (_path4773 = /*#__PURE__*/React.createElement("path", {
    d: "M48 90v-1h1v1z",
    fill: "#bb181f"
  })), _path4774 || (_path4774 = /*#__PURE__*/React.createElement("path", {
    d: "M49 89h1v1h-1z",
    fill: "#bd191f"
  })), _path4775 || (_path4775 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89v1h-1v-1z",
    fill: "#c31b24"
  })), _path4776 || (_path4776 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v1h-1v-1z",
    fill: "#bf1d25"
  })), _path4777 || (_path4777 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90v-1h1v1z",
    fill: "#bb1a1f"
  })), _path4778 || (_path4778 = /*#__PURE__*/React.createElement("path", {
    d: "M61 89h1v1h-1z",
    fill: "#b31825"
  })), _path4779 || (_path4779 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90h-1v-1h1z",
    fill: "#c08086"
  })), _path4780 || (_path4780 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90v-1h1v1z",
    fill: "#cbc3c2"
  })), _path4781 || (_path4781 = /*#__PURE__*/React.createElement("path", {
    d: "M66 89v1h-1v-1z",
    fill: "#c2c4bd"
  })), _path4782 || (_path4782 = /*#__PURE__*/React.createElement("path", {
    d: "M66 89h1v1h-1z",
    fill: "#c7c7bd"
  })), _path4783 || (_path4783 = /*#__PURE__*/React.createElement("path", {
    d: "M67 90v-1h1v1z",
    fill: "#c9b2a8"
  })), _path4784 || (_path4784 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90h-1v-1h1z",
    fill: "#c27e77"
  })), _path4785 || (_path4785 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90v-1h1v1z",
    fill: "#b64d4b"
  })), _path4786 || (_path4786 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89h1v1h-1z",
    fill: "#b33635"
  })), _path4787 || (_path4787 = /*#__PURE__*/React.createElement("path", {
    d: "M71 89h1v1h-1z",
    fill: "#b15050"
  })), _path4788 || (_path4788 = /*#__PURE__*/React.createElement("path", {
    d: "M72 90v-1h1v1z",
    fill: "#c9b2b0"
  })), _path4789 || (_path4789 = /*#__PURE__*/React.createElement("path", {
    d: "M74 90v-1h1v1z",
    fill: "#bd706e"
  })), _path4790 || (_path4790 = /*#__PURE__*/React.createElement("path", {
    d: "M76 89v1h-1v-1z",
    fill: "#b41216"
  })), _path4791 || (_path4791 = /*#__PURE__*/React.createElement("path", {
    d: "M77 89v1h-1v-1z",
    fill: "#b31118"
  })), _path4792 || (_path4792 = /*#__PURE__*/React.createElement("path", {
    d: "M77 90v-1h1v1z",
    fill: "#bc6b71"
  })), _path4793 || (_path4793 = /*#__PURE__*/React.createElement("path", {
    d: "M79 89v1h-1v-1z",
    fill: "#cdcac8"
  })), _path4794 || (_path4794 = /*#__PURE__*/React.createElement("path", {
    d: "M79 90v-1h1v1z",
    fill: "#c1656c"
  })), _path4795 || (_path4795 = /*#__PURE__*/React.createElement("path", {
    d: "M88 89h1v1h-1z",
    fill: "#c6272f"
  })), _path4796 || (_path4796 = /*#__PURE__*/React.createElement("path", {
    d: "M89 90v-1h1v1z",
    fill: "#c6292f"
  })), _path4797 || (_path4797 = /*#__PURE__*/React.createElement("path", {
    d: "M91 89v1h-1v-1z",
    fill: "#bf3c3d"
  })), _path4798 || (_path4798 = /*#__PURE__*/React.createElement("path", {
    d: "M92 89v1h-1v-1z",
    fill: "#d1b5b5"
  })), _path4799 || (_path4799 = /*#__PURE__*/React.createElement("path", {
    d: "M93 89v1h-1v-1z",
    fill: "#cad1cd"
  })), _path4800 || (_path4800 = /*#__PURE__*/React.createElement("path", {
    d: "M93 90v-1h1v1z",
    fill: "#d0d1cd"
  })), _path4801 || (_path4801 = /*#__PURE__*/React.createElement("path", {
    d: "M94 89h1v1h-1z",
    fill: "#c78f94"
  })), _path4802 || (_path4802 = /*#__PURE__*/React.createElement("path", {
    d: "M96 89v1h-1v-1z",
    fill: "#d39798"
  })), _path4803 || (_path4803 = /*#__PURE__*/React.createElement("path", {
    d: "M96 90v-1h1v1z",
    fill: "#e4cfc9",
    fillOpacity: 0.525
  })), _path4804 || (_path4804 = /*#__PURE__*/React.createElement("path", {
    d: "M31 90h1v1h-1z",
    fill: "#ebe9df",
    fillOpacity: 0.514
  })), _path4805 || (_path4805 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91v-1h1v1z",
    fill: "#dbafa5"
  })), _path4806 || (_path4806 = /*#__PURE__*/React.createElement("path", {
    d: "M37 90v1h-1v-1z",
    fill: "#c43539"
  })), _path4807 || (_path4807 = /*#__PURE__*/React.createElement("path", {
    d: "M38 90v1h-1v-1z",
    fill: "#c02c2b"
  })), _path4808 || (_path4808 = /*#__PURE__*/React.createElement("path", {
    d: "M38 91v-1h1v1z",
    fill: "#c05460"
  })), _path4809 || (_path4809 = /*#__PURE__*/React.createElement("path", {
    d: "M39 90h1v1h-1z",
    fill: "#e6ccca"
  })), _path4810 || (_path4810 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90h1v1h-1z",
    fill: "#e4dbd8"
  })), _path4811 || (_path4811 = /*#__PURE__*/React.createElement("path", {
    d: "M42 91h-1v-1h1z",
    fill: "#e0dcd7"
  })), _path4812 || (_path4812 = /*#__PURE__*/React.createElement("path", {
    d: "M42 90h1v1h-1z",
    fill: "#e3dcd7"
  })), _path4813 || (_path4813 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v-1h1v1z",
    fill: "#e3dcd3"
  })), _path4814 || (_path4814 = /*#__PURE__*/React.createElement("path", {
    d: "M44 90h1v1h-1z",
    fill: "#e0c2b3"
  })), _path4815 || (_path4815 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h1v1h-1z",
    fill: "#c76e61"
  })), _path4816 || (_path4816 = /*#__PURE__*/React.createElement("path", {
    d: "M47 90v1h-1v-1z",
    fill: "#b12520"
  })), _path4817 || (_path4817 = /*#__PURE__*/React.createElement("path", {
    d: "M49 91v-1h1v1z",
    fill: "#bb1b1d"
  })), _path4818 || (_path4818 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91v-1h1v1z",
    fill: "#c1171c"
  })), _path4819 || (_path4819 = /*#__PURE__*/React.createElement("path", {
    d: "M53 90v1h-1v-1z",
    fill: "#be151a"
  })), _path4820 || (_path4820 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90h1v1h-1z",
    fill: "#bf171e"
  })), _path4821 || (_path4821 = /*#__PURE__*/React.createElement("path", {
    d: "M62 90v1h-1v-1z",
    fill: "#bb1114"
  })), _path4822 || (_path4822 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90v1h-1v-1z",
    fill: "#ae1d2a"
  })), _path4823 || (_path4823 = /*#__PURE__*/React.createElement("path", {
    d: "M64 91h-1v-1h1z",
    fill: "#c5989e"
  })), _path4824 || (_path4824 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91v-1h1v1z",
    fill: "#c0c4bb"
  })), _path4825 || (_path4825 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90h1v1h-1z",
    fill: "#cbc1bb"
  })), _path4826 || (_path4826 = /*#__PURE__*/React.createElement("path", {
    d: "M71 90v1h-1v-1z",
    fill: "#c7bbb3"
  })), _path4827 || (_path4827 = /*#__PURE__*/React.createElement("path", {
    d: "M71 91v-1h1v1z",
    fill: "#c7c0ba"
  })), _path4828 || (_path4828 = /*#__PURE__*/React.createElement("path", {
    d: "M75 91h-1v-1h1z",
    fill: "#c38d8b"
  })), _path4829 || (_path4829 = /*#__PURE__*/React.createElement("path", {
    d: "M77 91h-1v-1h1z",
    fill: "#b51119"
  })), _path4830 || (_path4830 = /*#__PURE__*/React.createElement("path", {
    d: "M78 90v1h-1v-1z",
    fill: "#b65055"
  })), _path4831 || (_path4831 = /*#__PURE__*/React.createElement("path", {
    d: "M79 91h-1v-1h1z",
    fill: "#d0c6c4"
  })), _path4832 || (_path4832 = /*#__PURE__*/React.createElement("path", {
    d: "M80 90v1h-1v-1z",
    fill: "#c3626a"
  })), _path4833 || (_path4833 = /*#__PURE__*/React.createElement("path", {
    d: "M81 90h1v1h-1z",
    fill: "#c81e29"
  })), _path4834 || (_path4834 = /*#__PURE__*/React.createElement("path", {
    d: "M89 90h1v1h-1z",
    fill: "#c62b2d"
  })), _path4835 || (_path4835 = /*#__PURE__*/React.createElement("path", {
    d: "M90 91v-1h1v1z",
    fill: "#bb4847"
  })), _path4836 || (_path4836 = /*#__PURE__*/React.createElement("path", {
    d: "M92 91h-1v-1h1z",
    fill: "#cfc1bf"
  })), _path4837 || (_path4837 = /*#__PURE__*/React.createElement("path", {
    d: "M92 90h1v1h-1z",
    fill: "#cccfcd"
  })), _path4838 || (_path4838 = /*#__PURE__*/React.createElement("path", {
    d: "M95 90v1h-1v-1z",
    fill: "#c49092"
  })), _path4839 || (_path4839 = /*#__PURE__*/React.createElement("path", {
    d: "M96 91h-1v-1h1z",
    fill: "#d89b9c"
  })), _path4840 || (_path4840 = /*#__PURE__*/React.createElement("path", {
    d: "M96 90h1v1h-1z",
    fill: "#e9d2d0",
    fillOpacity: 0.514
  })), _path4841 || (_path4841 = /*#__PURE__*/React.createElement("path", {
    d: "M31 92v-1h1v1z",
    fill: "#ebebe2",
    fillOpacity: 0.522
  })), _path4842 || (_path4842 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91h1v1h-1z",
    fill: "#dcb1a7"
  })), _path4843 || (_path4843 = /*#__PURE__*/React.createElement("path", {
    d: "M37 91v1h-1v-1z",
    fill: "#c63439"
  })), _path4844 || (_path4844 = /*#__PURE__*/React.createElement("path", {
    d: "M39 92h-1v-1h1z",
    fill: "#c86c79"
  })), _path4845 || (_path4845 = /*#__PURE__*/React.createElement("path", {
    d: "M39 91h1v1h-1z",
    fill: "#ddc1bf"
  })), _path4846 || (_path4846 = /*#__PURE__*/React.createElement("path", {
    d: "M40 91h1v1h-1z",
    fill: "#bf8087"
  })), _path4847 || (_path4847 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92v-1h1v1z",
    fill: "#dfb1b4"
  })), _path4848 || (_path4848 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v1h-1v-1z",
    fill: "#c7808d"
  })), _path4849 || (_path4849 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92h-1v-1h1z",
    fill: "#cf9fa5"
  })), _path4850 || (_path4850 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92v-1h1v1z",
    fill: "#c4868e"
  })), _path4851 || (_path4851 = /*#__PURE__*/React.createElement("path", {
    d: "M45 91h1v1h-1z",
    fill: "#e7ceca"
  })), _path4852 || (_path4852 = /*#__PURE__*/React.createElement("path", {
    d: "M46 92v-1h1v1z",
    fill: "#c15953"
  })), _path4853 || (_path4853 = /*#__PURE__*/React.createElement("path", {
    d: "M49 91v1h-1v-1z",
    fill: "#bc1c1f"
  })), _path4854 || (_path4854 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92h-1v-1h1z",
    fill: "#bb1b1e"
  })), _path4855 || (_path4855 = /*#__PURE__*/React.createElement("path", {
    d: "M51 92h-1v-1h1z",
    fill: "#ba1918"
  })), _path4856 || (_path4856 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91h1v1h-1z",
    fill: "#b72627"
  })), _path4857 || (_path4857 = /*#__PURE__*/React.createElement("path", {
    d: "M53 91v1h-1v-1z",
    fill: "#be3d3e"
  })), _path4858 || (_path4858 = /*#__PURE__*/React.createElement("path", {
    d: "M53 92v-1h1v1z",
    fill: "#b52e2c"
  })), _path4859 || (_path4859 = /*#__PURE__*/React.createElement("path", {
    d: "M55 91v1h-1v-1z",
    fill: "#b71518"
  })), _path4860 || (_path4860 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91v1h-1v-1z",
    fill: "#bf181c"
  })), _path4861 || (_path4861 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92v-1h1v1z",
    fill: "#c01c24"
  })), _path4862 || (_path4862 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v1h-1v-1z",
    fill: "#c71923"
  })), _path4863 || (_path4863 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92v-1h1v1z",
    fill: "#bc2227"
  })), _path4864 || (_path4864 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91v1h-1v-1z",
    fill: "#bd4c49"
  })), _path4865 || (_path4865 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91h1v1h-1z",
    fill: "#bf5e58"
  })), _path4866 || (_path4866 = /*#__PURE__*/React.createElement("path", {
    d: "M61 92v-1h1v1z",
    fill: "#b74b46"
  })), _path4867 || (_path4867 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92h-1v-1h1z",
    fill: "#ab2221"
  })), _path4868 || (_path4868 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92v-1h1v1z",
    fill: "#a4404a"
  })), _path4869 || (_path4869 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91v1h-1v-1z",
    fill: "#c9b9bd"
  })), _path4870 || (_path4870 = /*#__PURE__*/React.createElement("path", {
    d: "M66 91v1h-1v-1z",
    fill: "#c6babb"
  })), _path4871 || (_path4871 = /*#__PURE__*/React.createElement("path", {
    d: "M67 92h-1v-1h1z",
    fill: "#cac3c2"
  })), _path4872 || (_path4872 = /*#__PURE__*/React.createElement("path", {
    d: "M67 91h1v1h-1z",
    fill: "#c3c4bd"
  })), _path4873 || (_path4873 = /*#__PURE__*/React.createElement("path", {
    d: "M75 91v1h-1v-1z",
    fill: "#c38081"
  })), _path4874 || (_path4874 = /*#__PURE__*/React.createElement("path", {
    d: "M76 92h-1v-1h1z",
    fill: "#b5121b"
  })), _path4875 || (_path4875 = /*#__PURE__*/React.createElement("path", {
    d: "M77 92h-1v-1h1z",
    fill: "#b5141b"
  })), _path4876 || (_path4876 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h-1v-1h1z",
    fill: "#af363d"
  })), _path4877 || (_path4877 = /*#__PURE__*/React.createElement("path", {
    d: "M78 91h1v1h-1z",
    fill: "#d0bebe"
  })), _path4878 || (_path4878 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92v-1h1v1z",
    fill: "#c2646d"
  })), _path4879 || (_path4879 = /*#__PURE__*/React.createElement("path", {
    d: "M90 91h1v1h-1z",
    fill: "#c05756"
  })), _path4880 || (_path4880 = /*#__PURE__*/React.createElement("path", {
    d: "M92 92h-1v-1h1z",
    fill: "#d4c9c8"
  })), _path4881 || (_path4881 = /*#__PURE__*/React.createElement("path", {
    d: "M92 92v-1h1v1z",
    fill: "#cbcecc"
  })), _path4882 || (_path4882 = /*#__PURE__*/React.createElement("path", {
    d: "M94 92v-1h1v1z",
    fill: "#c49091"
  })), _path4883 || (_path4883 = /*#__PURE__*/React.createElement("path", {
    d: "M95 91h1v1h-1z",
    fill: "#d6989a"
  })), _path4884 || (_path4884 = /*#__PURE__*/React.createElement("path", {
    d: "M96 92v-1h1v1z",
    fill: "#e1c9c5",
    fillOpacity: 0.506
  })), _path4885 || (_path4885 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93h-1v-1h1z",
    fill: "#eceae1",
    fillOpacity: 0.549
  })), _path4886 || (_path4886 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93h-1v-1h1z",
    fill: "#e1b7ac"
  })), _path4887 || (_path4887 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93v-1h1v1z",
    fill: "#c66b65"
  })), _path4888 || (_path4888 = /*#__PURE__*/React.createElement("path", {
    d: "M35 93v-1h1v1z",
    fill: "#c23f42"
  })), _path4889 || (_path4889 = /*#__PURE__*/React.createElement("path", {
    d: "M36 93v-1h1v1z",
    fill: "#c5343a"
  })), _path4890 || (_path4890 = /*#__PURE__*/React.createElement("path", {
    d: "M37 92h1v1h-1z",
    fill: "#c2272f"
  })), _path4891 || (_path4891 = /*#__PURE__*/React.createElement("path", {
    d: "M38 93v-1h1v1z",
    fill: "#cd6b7c"
  })), _path4892 || (_path4892 = /*#__PURE__*/React.createElement("path", {
    d: "M40 92v1h-1v-1z",
    fill: "#debcb9"
  })), _path4893 || (_path4893 = /*#__PURE__*/React.createElement("path", {
    d: "M40 93v-1h1v1z",
    fill: "#c27275"
  })), _path4894 || (_path4894 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92h1v1h-1z",
    fill: "#d38886"
  })), _path4895 || (_path4895 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h-1v-1h1z",
    fill: "#c55e67"
  })), _path4896 || (_path4896 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93v-1h1v1z",
    fill: "#c57277"
  })), _path4897 || (_path4897 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92v1h-1v-1z",
    fill: "#bd656e"
  })), _path4898 || (_path4898 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92h1v1h-1z",
    fill: "#d7a8af"
  })), _path4899 || (_path4899 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93h-1v-1h1z",
    fill: "#c66259"
  })), _path4900 || (_path4900 = /*#__PURE__*/React.createElement("path", {
    d: "M48 93h-1v-1h1z",
    fill: "#b81618"
  })), _path4901 || (_path4901 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93h-1v-1h1z",
    fill: "#bd1b21"
  })), _path4902 || (_path4902 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92v1h-1v-1z",
    fill: "#bb1821"
  })), _path4903 || (_path4903 = /*#__PURE__*/React.createElement("path", {
    d: "M50 93v-1h1v1z",
    fill: "#b5373b"
  })), _path4904 || (_path4904 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h-1v-1h1z",
    fill: "#d0a19b"
  })), _path4905 || (_path4905 = /*#__PURE__*/React.createElement("path", {
    d: "M52 92h1v1h-1z",
    fill: "#d3bdb8"
  })), _path4906 || (_path4906 = /*#__PURE__*/React.createElement("path", {
    d: "M54 93h-1v-1h1z",
    fill: "#d2b0a9"
  })), _path4907 || (_path4907 = /*#__PURE__*/React.createElement("path", {
    d: "M55 93h-1v-1h1z",
    fill: "#bd7169"
  })), _path4908 || (_path4908 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93h-1v-1h1z",
    fill: "#bd1c26"
  })), _path4909 || (_path4909 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92h1v1h-1z",
    fill: "#c67e7f"
  })), _path4910 || (_path4910 = /*#__PURE__*/React.createElement("path", {
    d: "M59 92h1v1h-1z",
    fill: "#cfc4bb"
  })), _path4911 || (_path4911 = /*#__PURE__*/React.createElement("path", {
    d: "M61 92v1h-1v-1z",
    fill: "#cfb8b4"
  })), _path4912 || (_path4912 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h-1v-1h1z",
    fill: "#d1b1b2"
  })), _path4913 || (_path4913 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93v-1h1v1z",
    fill: "#d1aba9"
  })), _path4914 || (_path4914 = /*#__PURE__*/React.createElement("path", {
    d: "M64 92v1h-1v-1z",
    fill: "#b98381"
  })), _path4915 || (_path4915 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93h-1v-1h1z",
    fill: "#c1ada6"
  })), _path4916 || (_path4916 = /*#__PURE__*/React.createElement("path", {
    d: "M65 92h1v1h-1z",
    fill: "#b36e75"
  })), _path4917 || (_path4917 = /*#__PURE__*/React.createElement("path", {
    d: "M66 92h1v1h-1z",
    fill: "#b86970"
  })), _path4918 || (_path4918 = /*#__PURE__*/React.createElement("path", {
    d: "M67 93v-1h1v1z",
    fill: "#ceb0b2"
  })), _path4919 || (_path4919 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92v1h-1v-1z",
    fill: "#ccc5c1"
  })), _path4920 || (_path4920 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92h1v1h-1z",
    fill: "#c5c7bf"
  })), _path4921 || (_path4921 = /*#__PURE__*/React.createElement("path", {
    d: "M71 92h1v1h-1z",
    fill: "#bfc5c2"
  })), _path4922 || (_path4922 = /*#__PURE__*/React.createElement("path", {
    d: "M73 92v1h-1v-1z",
    fill: "#c3c7c5"
  })), _path4923 || (_path4923 = /*#__PURE__*/React.createElement("path", {
    d: "M73 92h1v1h-1z",
    fill: "#d1bcba"
  })), _path4924 || (_path4924 = /*#__PURE__*/React.createElement("path", {
    d: "M74 92h1v1h-1z",
    fill: "#b4474c"
  })), _path4925 || (_path4925 = /*#__PURE__*/React.createElement("path", {
    d: "M75 93v-1h1v1z",
    fill: "#b8131b"
  })), _path4926 || (_path4926 = /*#__PURE__*/React.createElement("path", {
    d: "M76 93v-1h1v1z",
    fill: "#b8161d"
  })), _path4927 || (_path4927 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93h-1v-1h1z",
    fill: "#b02129"
  })), _path4928 || (_path4928 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h1v1h-1z",
    fill: "#cfabad"
  })), _path4929 || (_path4929 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92h1v1h-1z",
    fill: "#c37076"
  })), _path4930 || (_path4930 = /*#__PURE__*/React.createElement("path", {
    d: "M81 92v1h-1v-1z",
    fill: "#c21922"
  })), _path4931 || (_path4931 = /*#__PURE__*/React.createElement("path", {
    d: "M86 92v1h-1v-1z",
    fill: "#c9232a"
  })), _path4932 || (_path4932 = /*#__PURE__*/React.createElement("path", {
    d: "M86 92h1v1h-1z",
    fill: "#cb262d"
  })), _path4933 || (_path4933 = /*#__PURE__*/React.createElement("path", {
    d: "M89 92h1v1h-1z",
    fill: "#c32a2b"
  })), _path4934 || (_path4934 = /*#__PURE__*/React.createElement("path", {
    d: "M90 92h1v1h-1z",
    fill: "#c36a67"
  })), _path4935 || (_path4935 = /*#__PURE__*/React.createElement("path", {
    d: "M91 93v-1h1v1z",
    fill: "#d4cdcc"
  })), _path4936 || (_path4936 = /*#__PURE__*/React.createElement("path", {
    d: "M93 93h-1v-1h1z",
    fill: "#cacecb"
  })), _path4937 || (_path4937 = /*#__PURE__*/React.createElement("path", {
    d: "M94 92h1v1h-1z",
    fill: "#c48e90"
  })), _path4938 || (_path4938 = /*#__PURE__*/React.createElement("path", {
    d: "M96 92v1h-1v-1z",
    fill: "#db9c9e"
  })), _path4939 || (_path4939 = /*#__PURE__*/React.createElement("path", {
    d: "M97 93h-1v-1h1z",
    fill: "#e9d1cd",
    fillOpacity: 0.51
  })), _path4940 || (_path4940 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93v1h-1v-1z",
    fill: "#eaeae2",
    fillOpacity: 0.592
  })), _path4941 || (_path4941 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93h1v1h-1z",
    fill: "#e2b8ad"
  })), _path4942 || (_path4942 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93h1v1h-1z",
    fill: "#c56a64"
  })), _path4943 || (_path4943 = /*#__PURE__*/React.createElement("path", {
    d: "M38 94h-1v-1h1z",
    fill: "#c1292f"
  })), _path4944 || (_path4944 = /*#__PURE__*/React.createElement("path", {
    d: "M39 93v1h-1v-1z",
    fill: "#c86b7e"
  })), _path4945 || (_path4945 = /*#__PURE__*/React.createElement("path", {
    d: "M39 93h1v1h-1z",
    fill: "#e7d5d0"
  })), _path4946 || (_path4946 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94h-1v-1h1z",
    fill: "#c47c7b"
  })), _path4947 || (_path4947 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94v-1h1v1z",
    fill: "#cc7a80"
  })), _path4948 || (_path4948 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94v-1h1v1z",
    fill: "#cc7884"
  })), _path4949 || (_path4949 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h1v1h-1z",
    fill: "#c87a86"
  })), _path4950 || (_path4950 = /*#__PURE__*/React.createElement("path", {
    d: "M45 94h-1v-1h1z",
    fill: "#cb7981"
  })), _path4951 || (_path4951 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h-1v-1h1z",
    fill: "#d7a7a8"
  })), _path4952 || (_path4952 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93v1h-1v-1z",
    fill: "#c4635a"
  })), _path4953 || (_path4953 = /*#__PURE__*/React.createElement("path", {
    d: "M48 94h-1v-1h1z",
    fill: "#b9181b"
  })), _path4954 || (_path4954 = /*#__PURE__*/React.createElement("path", {
    d: "M50 94h-1v-1h1z",
    fill: "#b51d22"
  })), _path4955 || (_path4955 = /*#__PURE__*/React.createElement("path", {
    d: "M51 93v1h-1v-1z",
    fill: "#c68a90"
  })), _path4956 || (_path4956 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h1v1h-1z",
    fill: "#af4a58"
  })), _path4957 || (_path4957 = /*#__PURE__*/React.createElement("path", {
    d: "M54 94h-1v-1h1z",
    fill: "#cbacb2"
  })), _path4958 || (_path4958 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h-1v-1h1z",
    fill: "#c7ccbf"
  })), _path4959 || (_path4959 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94h-1v-1h1z",
    fill: "#cb978a"
  })), _path4960 || (_path4960 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94v-1h1v1z",
    fill: "#b72c2b"
  })), _path4961 || (_path4961 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93v1h-1v-1z",
    fill: "#ba3039"
  })), _path4962 || (_path4962 = /*#__PURE__*/React.createElement("path", {
    d: "M59 93v1h-1v-1z",
    fill: "#d4b8b7"
  })), _path4963 || (_path4963 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94h-1v-1h1z",
    fill: "#c09090"
  })), _path4964 || (_path4964 = /*#__PURE__*/React.createElement("path", {
    d: "M60 93h1v1h-1z",
    fill: "#b22b3a"
  })), _path4965 || (_path4965 = /*#__PURE__*/React.createElement("path", {
    d: "M61 93h1v1h-1z",
    fill: "#b42e3e"
  })), _path4966 || (_path4966 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h1v1h-1z",
    fill: "#b65061"
  })), _path4967 || (_path4967 = /*#__PURE__*/React.createElement("path", {
    d: "M64 93v1h-1v-1z",
    fill: "#c78b9e"
  })), _path4968 || (_path4968 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93v1h-1v-1z",
    fill: "#c7bebe"
  })), _path4969 || (_path4969 = /*#__PURE__*/React.createElement("path", {
    d: "M65 94v-1h1v1z",
    fill: "#c1998e"
  })), _path4970 || (_path4970 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94h-1v-1h1z",
    fill: "#a93031"
  })), _path4971 || (_path4971 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94h-1v-1h1z",
    fill: "#b62934"
  })), _path4972 || (_path4972 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94v-1h1v1z",
    fill: "#bf646f"
  })), _path4973 || (_path4973 = /*#__PURE__*/React.createElement("path", {
    d: "M70 93v1h-1v-1z",
    fill: "#ca939d"
  })), _path4974 || (_path4974 = /*#__PURE__*/React.createElement("path", {
    d: "M71 93v1h-1v-1z",
    fill: "#d1abb0"
  })), _path4975 || (_path4975 = /*#__PURE__*/React.createElement("path", {
    d: "M72 93v1h-1v-1z",
    fill: "#cdb3b6"
  })), _path4976 || (_path4976 = /*#__PURE__*/React.createElement("path", {
    d: "M72 93h1v1h-1z",
    fill: "#cca4a7"
  })), _path4977 || (_path4977 = /*#__PURE__*/React.createElement("path", {
    d: "M74 94h-1v-1h1z",
    fill: "#b85862"
  })), _path4978 || (_path4978 = /*#__PURE__*/React.createElement("path", {
    d: "M75 94h-1v-1h1z",
    fill: "#b5161f"
  })), _path4979 || (_path4979 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93v1h-1v-1z",
    fill: "#b3161f"
  })), _path4980 || (_path4980 = /*#__PURE__*/React.createElement("path", {
    d: "M78 94v-1h1v1z",
    fill: "#c99193"
  })), _path4981 || (_path4981 = /*#__PURE__*/React.createElement("path", {
    d: "M80 93v1h-1v-1z",
    fill: "#c88284"
  })), _path4982 || (_path4982 = /*#__PURE__*/React.createElement("path", {
    d: "M81 94v-1h1v1z",
    fill: "#c42127"
  })), _path4983 || (_path4983 = /*#__PURE__*/React.createElement("path", {
    d: "M82 93h1v1h-1z",
    fill: "#c72227"
  })), _path4984 || (_path4984 = /*#__PURE__*/React.createElement("path", {
    d: "M88 93v1h-1v-1z",
    fill: "#ca272d"
  })), _path4985 || (_path4985 = /*#__PURE__*/React.createElement("path", {
    d: "M90 93v1h-1v-1z",
    fill: "#c12a2b"
  })), _path4986 || (_path4986 = /*#__PURE__*/React.createElement("path", {
    d: "M91 94h-1v-1h1z",
    fill: "#c9807b"
  })), _path4987 || (_path4987 = /*#__PURE__*/React.createElement("path", {
    d: "M93 94h-1v-1h1z",
    fill: "#caceca"
  })), _path4988 || (_path4988 = /*#__PURE__*/React.createElement("path", {
    d: "M94 94h-1v-1h1z",
    fill: "#d3cecd"
  })), _path4989 || (_path4989 = /*#__PURE__*/React.createElement("path", {
    d: "M95 93v1h-1v-1z",
    fill: "#c48b8e"
  })), _path4990 || (_path4990 = /*#__PURE__*/React.createElement("path", {
    d: "M96 94h-1v-1h1z",
    fill: "#d8979a"
  })), _path4991 || (_path4991 = /*#__PURE__*/React.createElement("path", {
    d: "M97 93v1h-1v-1z",
    fill: "#e1cac6",
    fillOpacity: 0.51
  })), _path4992 || (_path4992 = /*#__PURE__*/React.createElement("path", {
    d: "M31 95v-1h1v1z",
    fill: "#e3d4cd",
    fillOpacity: 0.608
  })), _path4993 || (_path4993 = /*#__PURE__*/React.createElement("path", {
    d: "M33 94v1h-1v-1z",
    fill: "#e1b0a8"
  })), _path4994 || (_path4994 = /*#__PURE__*/React.createElement("path", {
    d: "M34 94v1h-1v-1z",
    fill: "#c76a66"
  })), _path4995 || (_path4995 = /*#__PURE__*/React.createElement("path", {
    d: "M35 94v1h-1v-1z",
    fill: "#c24e4e"
  })), _path4996 || (_path4996 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94v1h-1v-1z",
    fill: "#c24041"
  })), _path4997 || (_path4997 = /*#__PURE__*/React.createElement("path", {
    d: "M36 95v-1h1v1z",
    fill: "#c63739"
  })), _path4998 || (_path4998 = /*#__PURE__*/React.createElement("path", {
    d: "M37 94h1v1h-1z",
    fill: "#c42930"
  })), _path4999 || (_path4999 = /*#__PURE__*/React.createElement("path", {
    d: "M39 95h-1v-1h1z",
    fill: "#c86d7e"
  })), _path5000 || (_path5000 = /*#__PURE__*/React.createElement("path", {
    d: "M39 94h1v1h-1z",
    fill: "#e7d2d1"
  })), _path5001 || (_path5001 = /*#__PURE__*/React.createElement("path", {
    d: "M40 95v-1h1v1z",
    fill: "#c76e74"
  })), _path5002 || (_path5002 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95v-1h1v1z",
    fill: "#c2646a"
  })), _path5003 || (_path5003 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94h1v1h-1z",
    fill: "#c2616c"
  })), _path5004 || (_path5004 = /*#__PURE__*/React.createElement("path", {
    d: "M44 95h-1v-1h1z",
    fill: "#c87781"
  })), _path5005 || (_path5005 = /*#__PURE__*/React.createElement("path", {
    d: "M44 94h1v1h-1z",
    fill: "#ce7a83"
  })), _path5006 || (_path5006 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v-1h1v1z",
    fill: "#d9a8ad"
  })), _path5007 || (_path5007 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h1v1h-1z",
    fill: "#c8625e"
  })), _path5008 || (_path5008 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95h-1v-1h1z",
    fill: "#bd181b"
  })), _path5009 || (_path5009 = /*#__PURE__*/React.createElement("path", {
    d: "M49 94h1v1h-1z",
    fill: "#b8262c"
  })), _path5010 || (_path5010 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h-1v-1h1z",
    fill: "#d0a5ae"
  })), _path5011 || (_path5011 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v-1h1v1z",
    fill: "#c38782"
  })), _path5012 || (_path5012 = /*#__PURE__*/React.createElement("path", {
    d: "M53 94v1h-1v-1z",
    fill: "#b01620"
  })), _path5013 || (_path5013 = /*#__PURE__*/React.createElement("path", {
    d: "M53 95v-1h1v1z",
    fill: "#c67985"
  })), _path5014 || (_path5014 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h1v1h-1z",
    fill: "#cacec2"
  })), _path5015 || (_path5015 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94h1v1h-1z",
    fill: "#c7736d"
  })), _path5016 || (_path5016 = /*#__PURE__*/React.createElement("path", {
    d: "M58 94v1h-1v-1z",
    fill: "#b92e3a"
  })), _path5017 || (_path5017 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h-1v-1h1z",
    fill: "#d1b9b6"
  })), _path5018 || (_path5018 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94v1h-1v-1z",
    fill: "#c18b86"
  })), _path5019 || (_path5019 = /*#__PURE__*/React.createElement("path", {
    d: "M60 95v-1h1v1z",
    fill: "#b21716"
  })), _path5020 || (_path5020 = /*#__PURE__*/React.createElement("path", {
    d: "M63 94v1h-1v-1z",
    fill: "#ba0f14"
  })), _path5021 || (_path5021 = /*#__PURE__*/React.createElement("path", {
    d: "M63 95v-1h1v1z",
    fill: "#a81422"
  })), _path5022 || (_path5022 = /*#__PURE__*/React.createElement("path", {
    d: "M64 94h1v1h-1z",
    fill: "#bf9897"
  })), _path5023 || (_path5023 = /*#__PURE__*/React.createElement("path", {
    d: "M66 94v1h-1v-1z",
    fill: "#cbb9b8"
  })), _path5024 || (_path5024 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94v1h-1v-1z",
    fill: "#d4aeae"
  })), _path5025 || (_path5025 = /*#__PURE__*/React.createElement("path", {
    d: "M67 95v-1h1v1z",
    fill: "#be6661"
  })), _path5026 || (_path5026 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94h1v1h-1z",
    fill: "#b22021"
  })), _path5027 || (_path5027 = /*#__PURE__*/React.createElement("path", {
    d: "M69 94h1v1h-1z",
    fill: "#b61c25"
  })), _path5028 || (_path5028 = /*#__PURE__*/React.createElement("path", {
    d: "M71 95h-1v-1h1z",
    fill: "#bb2b39"
  })), _path5029 || (_path5029 = /*#__PURE__*/React.createElement("path", {
    d: "M71 94h1v1h-1z",
    fill: "#bb303d"
  })), _path5030 || (_path5030 = /*#__PURE__*/React.createElement("path", {
    d: "M72 94h1v1h-1z",
    fill: "#b62330"
  })), _path5031 || (_path5031 = /*#__PURE__*/React.createElement("path", {
    d: "M74 94v1h-1v-1z",
    fill: "#b61422"
  })), _path5032 || (_path5032 = /*#__PURE__*/React.createElement("path", {
    d: "M74 95v-1h1v1z",
    fill: "#be151f"
  })), _path5033 || (_path5033 = /*#__PURE__*/React.createElement("path", {
    d: "M76 94v1h-1v-1z",
    fill: "#ba181d"
  })), _path5034 || (_path5034 = /*#__PURE__*/React.createElement("path", {
    d: "M79 94v1h-1v-1z",
    fill: "#c27175"
  })), _path5035 || (_path5035 = /*#__PURE__*/React.createElement("path", {
    d: "M80 95h-1v-1h1z",
    fill: "#cf9596"
  })), _path5036 || (_path5036 = /*#__PURE__*/React.createElement("path", {
    d: "M80 94h1v1h-1z",
    fill: "#b92127"
  })), _path5037 || (_path5037 = /*#__PURE__*/React.createElement("path", {
    d: "M87 95v-1h1v1z",
    fill: "#c9272e"
  })), _path5038 || (_path5038 = /*#__PURE__*/React.createElement("path", {
    d: "M89 94v1h-1v-1z",
    fill: "#c92a2d"
  })), _path5039 || (_path5039 = /*#__PURE__*/React.createElement("path", {
    d: "M89 95v-1h1v1z",
    fill: "#be2d2e"
  })), _path5040 || (_path5040 = /*#__PURE__*/React.createElement("path", {
    d: "M90 94h1v1h-1z",
    fill: "#cd9793"
  })), _path5041 || (_path5041 = /*#__PURE__*/React.createElement("path", {
    d: "M92 94v1h-1v-1z",
    fill: "#cfd0cf"
  })), _path5042 || (_path5042 = /*#__PURE__*/React.createElement("path", {
    d: "M93 95v-1h1v1z",
    fill: "#d2cccb"
  })), _path5043 || (_path5043 = /*#__PURE__*/React.createElement("path", {
    d: "M94 95v-1h1v1z",
    fill: "#c7898f"
  })), _path5044 || (_path5044 = /*#__PURE__*/React.createElement("path", {
    d: "M96 94v1h-1v-1z",
    fill: "#d79799"
  })), _path5045 || (_path5045 = /*#__PURE__*/React.createElement("path", {
    d: "M96 95v-1h1v1z",
    fill: "#ddc0c0",
    fillOpacity: 0.51
  })), _path5046 || (_path5046 = /*#__PURE__*/React.createElement("path", {
    d: "M31 95h1v1h-1z",
    fill: "#dfc4bf",
    fillOpacity: 0.631
  })), _path5047 || (_path5047 = /*#__PURE__*/React.createElement("path", {
    d: "M32 96v-1h1v1z",
    fill: "#da9e98"
  })), _path5048 || (_path5048 = /*#__PURE__*/React.createElement("path", {
    d: "M34 96h-1v-1h1z",
    fill: "#ca6a67"
  })), _path5049 || (_path5049 = /*#__PURE__*/React.createElement("path", {
    d: "M35 95v1h-1v-1z",
    fill: "#c44d4f"
  })), _path5050 || (_path5050 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h-1v-1h1z",
    fill: "#c34042"
  })), _path5051 || (_path5051 = /*#__PURE__*/React.createElement("path", {
    d: "M36 95h1v1h-1z",
    fill: "#c53939"
  })), _path5052 || (_path5052 = /*#__PURE__*/React.createElement("path", {
    d: "M38 95v1h-1v-1z",
    fill: "#c12c30"
  })), _path5053 || (_path5053 = /*#__PURE__*/React.createElement("path", {
    d: "M38 96v-1h1v1z",
    fill: "#cc6d7d"
  })), _path5054 || (_path5054 = /*#__PURE__*/React.createElement("path", {
    d: "M39 95h1v1h-1z",
    fill: "#edd5d7"
  })), _path5055 || (_path5055 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h-1v-1h1z",
    fill: "#c68f93"
  })), _path5056 || (_path5056 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95h1v1h-1z",
    fill: "#ddb7ac"
  })), _path5057 || (_path5057 = /*#__PURE__*/React.createElement("path", {
    d: "M43 96h-1v-1h1z",
    fill: "#c57879"
  })), _path5058 || (_path5058 = /*#__PURE__*/React.createElement("path", {
    d: "M44 95v1h-1v-1z",
    fill: "#c8787e"
  })), _path5059 || (_path5059 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v1h-1v-1z",
    fill: "#b85c66"
  })), _path5060 || (_path5060 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95h1v1h-1z",
    fill: "#d7b4b3"
  })), _path5061 || (_path5061 = /*#__PURE__*/React.createElement("path", {
    d: "M47 95v1h-1v-1z",
    fill: "#c6645e"
  })), _path5062 || (_path5062 = /*#__PURE__*/React.createElement("path", {
    d: "M50 95v1h-1v-1z",
    fill: "#b61f2a"
  })), _path5063 || (_path5063 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v1h-1v-1z",
    fill: "#cca3a9"
  })), _path5064 || (_path5064 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h1v1h-1z",
    fill: "#c7a198"
  })), _path5065 || (_path5065 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96h-1v-1h1z",
    fill: "#b72227"
  })), _path5066 || (_path5066 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95v1h-1v-1z",
    fill: "#b72534"
  })), _path5067 || (_path5067 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95h1v1h-1z",
    fill: "#c77886"
  })), _path5068 || (_path5068 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96h-1v-1h1z",
    fill: "#d4a9b0"
  })), _path5069 || (_path5069 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96v-1h1v1z",
    fill: "#ca6465"
  })), _path5070 || (_path5070 = /*#__PURE__*/React.createElement("path", {
    d: "M57 95h1v1h-1z",
    fill: "#b91f29"
  })), _path5071 || (_path5071 = /*#__PURE__*/React.createElement("path", {
    d: "M58 95h1v1h-1z",
    fill: "#ca989b"
  })), _path5072 || (_path5072 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h1v1h-1z",
    fill: "#cec1b9"
  })), _path5073 || (_path5073 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h-1v-1h1z",
    fill: "#b96058"
  })), _path5074 || (_path5074 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95v1h-1v-1z",
    fill: "#ac1d19"
  })), _path5075 || (_path5075 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95h1v1h-1z",
    fill: "#b1110b"
  })), _path5076 || (_path5076 = /*#__PURE__*/React.createElement("path", {
    d: "M64 96h-1v-1h1z",
    fill: "#ad3a3d"
  })), _path5077 || (_path5077 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96h-1v-1h1z",
    fill: "#cfafaa"
  })), _path5078 || (_path5078 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h-1v-1h1z",
    fill: "#b44352"
  })), _path5079 || (_path5079 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96v-1h1v1z",
    fill: "#b9586b"
  })), _path5080 || (_path5080 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96h-1v-1h1z",
    fill: "#d1b2b3"
  })), _path5081 || (_path5081 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96v-1h1v1z",
    fill: "#d19a92"
  })), _path5082 || (_path5082 = /*#__PURE__*/React.createElement("path", {
    d: "M69 95h1v1h-1z",
    fill: "#bb3f3f"
  })), _path5083 || (_path5083 = /*#__PURE__*/React.createElement("path", {
    d: "M71 95v1h-1v-1z",
    fill: "#bc171f"
  })), _path5084 || (_path5084 = /*#__PURE__*/React.createElement("path", {
    d: "M73 96h-1v-1h1z",
    fill: "#c11821"
  })), _path5085 || (_path5085 = /*#__PURE__*/React.createElement("path", {
    d: "M74 96h-1v-1h1z",
    fill: "#be1721"
  })), _path5086 || (_path5086 = /*#__PURE__*/React.createElement("path", {
    d: "M78 96v-1h1v1z",
    fill: "#b74e54"
  })), _path5087 || (_path5087 = /*#__PURE__*/React.createElement("path", {
    d: "M80 96h-1v-1h1z",
    fill: "#d3a4a2"
  })), _path5088 || (_path5088 = /*#__PURE__*/React.createElement("path", {
    d: "M80 96v-1h1v1z",
    fill: "#bd2830"
  })), _path5089 || (_path5089 = /*#__PURE__*/React.createElement("path", {
    d: "M89 95h1v1h-1z",
    fill: "#bd3537"
  })), _path5090 || (_path5090 = /*#__PURE__*/React.createElement("path", {
    d: "M91 96h-1v-1h1z",
    fill: "#d1aba8"
  })), _path5091 || (_path5091 = /*#__PURE__*/React.createElement("path", {
    d: "M91 95h1v1h-1z",
    fill: "#cccecd"
  })), _path5092 || (_path5092 = /*#__PURE__*/React.createElement("path", {
    d: "M93 95v1h-1v-1z",
    fill: "#cbccca"
  })), _path5093 || (_path5093 = /*#__PURE__*/React.createElement("path", {
    d: "M93 95h1v1h-1z",
    fill: "#d3cbca"
  })), _path5094 || (_path5094 = /*#__PURE__*/React.createElement("path", {
    d: "M94 95h1v1h-1z",
    fill: "#c8868d"
  })), _path5095 || (_path5095 = /*#__PURE__*/React.createElement("path", {
    d: "M95 96v-1h1v1z",
    fill: "#d89799"
  })), _path5096 || (_path5096 = /*#__PURE__*/React.createElement("path", {
    d: "M96 95h1v1h-1z",
    fill: "#e1c2c2",
    fillOpacity: 0.51
  })), _path5097 || (_path5097 = /*#__PURE__*/React.createElement("path", {
    d: "M31 97v-1h1v1z",
    fill: "#e4c4be",
    fillOpacity: 0.647
  })), _path5098 || (_path5098 = /*#__PURE__*/React.createElement("path", {
    d: "M32 97v-1h1v1z",
    fill: "#d79490"
  })), _path5099 || (_path5099 = /*#__PURE__*/React.createElement("path", {
    d: "M34 96v1h-1v-1z",
    fill: "#c96867"
  })), _path5100 || (_path5100 = /*#__PURE__*/React.createElement("path", {
    d: "M34 97v-1h1v1z",
    fill: "#c44d50"
  })), _path5101 || (_path5101 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96v1h-1v-1z",
    fill: "#c44043"
  })), _path5102 || (_path5102 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h1v1h-1z",
    fill: "#c5383b"
  })), _path5103 || (_path5103 = /*#__PURE__*/React.createElement("path", {
    d: "M38 97h-1v-1h1z",
    fill: "#c22c31"
  })), _path5104 || (_path5104 = /*#__PURE__*/React.createElement("path", {
    d: "M39 97h-1v-1h1z",
    fill: "#ca6b79"
  })), _path5105 || (_path5105 = /*#__PURE__*/React.createElement("path", {
    d: "M39 96h1v1h-1z",
    fill: "#d6b6bb"
  })), _path5106 || (_path5106 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96v1h-1v-1z",
    fill: "#dcb7bc"
  })), _path5107 || (_path5107 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h1v1h-1z",
    fill: "#e0c1c9"
  })), _path5108 || (_path5108 = /*#__PURE__*/React.createElement("path", {
    d: "M42 97v-1h1v1z",
    fill: "#e3b8bc"
  })), _path5109 || (_path5109 = /*#__PURE__*/React.createElement("path", {
    d: "M43 97v-1h1v1z",
    fill: "#e2b7b8"
  })), _path5110 || (_path5110 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97h-1v-1h1z",
    fill: "#d79d9f"
  })), _path5111 || (_path5111 = /*#__PURE__*/React.createElement("path", {
    d: "M46 96v1h-1v-1z",
    fill: "#ead0ca"
  })), _path5112 || (_path5112 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v1h-1v-1z",
    fill: "#c5605c"
  })), _path5113 || (_path5113 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v1h-1v-1z",
    fill: "#c1161d"
  })), _path5114 || (_path5114 = /*#__PURE__*/React.createElement("path", {
    d: "M49 97v-1h1v1z",
    fill: "#b71a25"
  })), _path5115 || (_path5115 = /*#__PURE__*/React.createElement("path", {
    d: "M51 96v1h-1v-1z",
    fill: "#c68e94"
  })), _path5116 || (_path5116 = /*#__PURE__*/React.createElement("path", {
    d: "M52 97h-1v-1h1z",
    fill: "#cdc1b9"
  })), _path5117 || (_path5117 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96v1h-1v-1z",
    fill: "#b94b4a"
  })), _path5118 || (_path5118 = /*#__PURE__*/React.createElement("path", {
    d: "M54 96v1h-1v-1z",
    fill: "#be1722"
  })), _path5119 || (_path5119 = /*#__PURE__*/React.createElement("path", {
    d: "M55 96v1h-1v-1z",
    fill: "#bb1926"
  })), _path5120 || (_path5120 = /*#__PURE__*/React.createElement("path", {
    d: "M55 97v-1h1v1z",
    fill: "#bd2732"
  })), _path5121 || (_path5121 = /*#__PURE__*/React.createElement("path", {
    d: "M57 96v1h-1v-1z",
    fill: "#c21f2e"
  })), _path5122 || (_path5122 = /*#__PURE__*/React.createElement("path", {
    d: "M58 96v1h-1v-1z",
    fill: "#c21b29"
  })), _path5123 || (_path5123 = /*#__PURE__*/React.createElement("path", {
    d: "M58 97v-1h1v1z",
    fill: "#c55667"
  })), _path5124 || (_path5124 = /*#__PURE__*/React.createElement("path", {
    d: "M60 96v1h-1v-1z",
    fill: "#cac5c5"
  })), _path5125 || (_path5125 = /*#__PURE__*/React.createElement("path", {
    d: "M60 97v-1h1v1z",
    fill: "#cabfb7"
  })), _path5126 || (_path5126 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h1v1h-1z",
    fill: "#c18a85"
  })), _path5127 || (_path5127 = /*#__PURE__*/React.createElement("path", {
    d: "M63 96v1h-1v-1z",
    fill: "#ba7470"
  })), _path5128 || (_path5128 = /*#__PURE__*/React.createElement("path", {
    d: "M63 97v-1h1v1z",
    fill: "#ccaca7"
  })), _path5129 || (_path5129 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96v1h-1v-1z",
    fill: "#c27f83"
  })), _path5130 || (_path5130 = /*#__PURE__*/React.createElement("path", {
    d: "M65 97v-1h1v1z",
    fill: "#b2171e"
  })), _path5131 || (_path5131 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h1v1h-1z",
    fill: "#b7121f"
  })), _path5132 || (_path5132 = /*#__PURE__*/React.createElement("path", {
    d: "M67 96h1v1h-1z",
    fill: "#b53141"
  })), _path5133 || (_path5133 = /*#__PURE__*/React.createElement("path", {
    d: "M69 97h-1v-1h1z",
    fill: "#cb9297"
  })), _path5134 || (_path5134 = /*#__PURE__*/React.createElement("path", {
    d: "M70 96v1h-1v-1z",
    fill: "#d3b9b3"
  })), _path5135 || (_path5135 = /*#__PURE__*/React.createElement("path", {
    d: "M70 97v-1h1v1z",
    fill: "#bf5855"
  })), _path5136 || (_path5136 = /*#__PURE__*/React.createElement("path", {
    d: "M72 96v1h-1v-1z",
    fill: "#b81c22"
  })), _path5137 || (_path5137 = /*#__PURE__*/React.createElement("path", {
    d: "M73 96h1v1h-1z",
    fill: "#bb1921"
  })), _path5138 || (_path5138 = /*#__PURE__*/React.createElement("path", {
    d: "M77 96v1h-1v-1z",
    fill: "#bc191f"
  })), _path5139 || (_path5139 = /*#__PURE__*/React.createElement("path", {
    d: "M78 96h1v1h-1z",
    fill: "#b4323b"
  })), _path5140 || (_path5140 = /*#__PURE__*/React.createElement("path", {
    d: "M79 97v-1h1v1z",
    fill: "#d4a7a6"
  })), _path5141 || (_path5141 = /*#__PURE__*/React.createElement("path", {
    d: "M80 97v-1h1v1z",
    fill: "#bf3941"
  })), _path5142 || (_path5142 = /*#__PURE__*/React.createElement("path", {
    d: "M81 96h1v1h-1z",
    fill: "#c32126"
  })), _path5143 || (_path5143 = /*#__PURE__*/React.createElement("path", {
    d: "M87 96v1h-1v-1z",
    fill: "#c9262c"
  })), _path5144 || (_path5144 = /*#__PURE__*/React.createElement("path", {
    d: "M87 97v-1h1v1z",
    fill: "#cd272f"
  })), _path5145 || (_path5145 = /*#__PURE__*/React.createElement("path", {
    d: "M88 96h1v1h-1z",
    fill: "#c8282d"
  })), _path5146 || (_path5146 = /*#__PURE__*/React.createElement("path", {
    d: "M89 97v-1h1v1z",
    fill: "#bc4346"
  })), _path5147 || (_path5147 = /*#__PURE__*/React.createElement("path", {
    d: "M90 96h1v1h-1z",
    fill: "#d1bebb"
  })), _path5148 || (_path5148 = /*#__PURE__*/React.createElement("path", {
    d: "M92 97h-1v-1h1z",
    fill: "#caccca"
  })), _path5149 || (_path5149 = /*#__PURE__*/React.createElement("path", {
    d: "M92 97v-1h1v1z",
    fill: "#cdcccd"
  })), _path5150 || (_path5150 = /*#__PURE__*/React.createElement("path", {
    d: "M94 97h-1v-1h1z",
    fill: "#d5caca"
  })), _path5151 || (_path5151 = /*#__PURE__*/React.createElement("path", {
    d: "M94 97v-1h1v1z",
    fill: "#c88388"
  })), _path5152 || (_path5152 = /*#__PURE__*/React.createElement("path", {
    d: "M95 96h1v1h-1z",
    fill: "#d89797"
  })), _path5153 || (_path5153 = /*#__PURE__*/React.createElement("path", {
    d: "M96 97v-1h1v1z",
    fill: "#e3c3c1",
    fillOpacity: 0.502
  })), _path5154 || (_path5154 = /*#__PURE__*/React.createElement("path", {
    d: "M31 97h1v1h-1z",
    fill: "#e3c1b9",
    fillOpacity: 0.651
  })), _path5155 || (_path5155 = /*#__PURE__*/React.createElement("path", {
    d: "M33 97v1h-1v-1z",
    fill: "#d7918d"
  })), _path5156 || (_path5156 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98h-1v-1h1z",
    fill: "#c96767"
  })), _path5157 || (_path5157 = /*#__PURE__*/React.createElement("path", {
    d: "M35 97v1h-1v-1z",
    fill: "#c54d50"
  })), _path5158 || (_path5158 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v-1h1v1z",
    fill: "#c54045"
  })), _path5159 || (_path5159 = /*#__PURE__*/React.createElement("path", {
    d: "M38 97v1h-1v-1z",
    fill: "#c22c35"
  })), _path5160 || (_path5160 = /*#__PURE__*/React.createElement("path", {
    d: "M38 98v-1h1v1z",
    fill: "#c96874"
  })), _path5161 || (_path5161 = /*#__PURE__*/React.createElement("path", {
    d: "M39 98v-1h1v1z",
    fill: "#d38d9a"
  })), _path5162 || (_path5162 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v-1h1v1z",
    fill: "#c46d7c"
  })), _path5163 || (_path5163 = /*#__PURE__*/React.createElement("path", {
    d: "M41 98v-1h1v1z",
    fill: "#cd8b95"
  })), _path5164 || (_path5164 = /*#__PURE__*/React.createElement("path", {
    d: "M42 97h1v1h-1z",
    fill: "#c56474"
  })), _path5165 || (_path5165 = /*#__PURE__*/React.createElement("path", {
    d: "M43 97h1v1h-1z",
    fill: "#c5697c"
  })), _path5166 || (_path5166 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97v1h-1v-1z",
    fill: "#c78390"
  })), _path5167 || (_path5167 = /*#__PURE__*/React.createElement("path", {
    d: "M46 98h-1v-1h1z",
    fill: "#cd9c9e"
  })), _path5168 || (_path5168 = /*#__PURE__*/React.createElement("path", {
    d: "M47 97v1h-1v-1z",
    fill: "#cb5e5c"
  })), _path5169 || (_path5169 = /*#__PURE__*/React.createElement("path", {
    d: "M49 97h1v1h-1z",
    fill: "#bc1720"
  })), _path5170 || (_path5170 = /*#__PURE__*/React.createElement("path", {
    d: "M50 97h1v1h-1z",
    fill: "#c26c76"
  })), _path5171 || (_path5171 = /*#__PURE__*/React.createElement("path", {
    d: "M51 98v-1h1v1z",
    fill: "#cac9cb"
  })), _path5172 || (_path5172 = /*#__PURE__*/React.createElement("path", {
    d: "M53 97v1h-1v-1z",
    fill: "#c1928a"
  })), _path5173 || (_path5173 = /*#__PURE__*/React.createElement("path", {
    d: "M53 97h1v1h-1z",
    fill: "#b62023"
  })), _path5174 || (_path5174 = /*#__PURE__*/React.createElement("path", {
    d: "M57 97v1h-1v-1z",
    fill: "#c21e28"
  })), _path5175 || (_path5175 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98h-1v-1h1z",
    fill: "#c91d29"
  })), _path5176 || (_path5176 = /*#__PURE__*/React.createElement("path", {
    d: "M59 97v1h-1v-1z",
    fill: "#bd2234"
  })), _path5177 || (_path5177 = /*#__PURE__*/React.createElement("path", {
    d: "M60 98h-1v-1h1z",
    fill: "#c88c96"
  })), _path5178 || (_path5178 = /*#__PURE__*/React.createElement("path", {
    d: "M61 98h-1v-1h1z",
    fill: "#c3c8c3"
  })), _path5179 || (_path5179 = /*#__PURE__*/React.createElement("path", {
    d: "M62 97v1h-1v-1z",
    fill: "#c3c6be"
  })), _path5180 || (_path5180 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98h-1v-1h1z",
    fill: "#b01e27"
  })), _path5181 || (_path5181 = /*#__PURE__*/React.createElement("path", {
    d: "M66 97v1h-1v-1z",
    fill: "#bb141b"
  })), _path5182 || (_path5182 = /*#__PURE__*/React.createElement("path", {
    d: "M69 97v1h-1v-1z",
    fill: "#b42231"
  })), _path5183 || (_path5183 = /*#__PURE__*/React.createElement("path", {
    d: "M70 98h-1v-1h1z",
    fill: "#c67788"
  })), _path5184 || (_path5184 = /*#__PURE__*/React.createElement("path", {
    d: "M70 97h1v1h-1z",
    fill: "#d5bfbb"
  })), _path5185 || (_path5185 = /*#__PURE__*/React.createElement("path", {
    d: "M71 97h1v1h-1z",
    fill: "#c0605e"
  })), _path5186 || (_path5186 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98h-1v-1h1z",
    fill: "#b81b22"
  })), _path5187 || (_path5187 = /*#__PURE__*/React.createElement("path", {
    d: "M79 97v1h-1v-1z",
    fill: "#b61f28"
  })), _path5188 || (_path5188 = /*#__PURE__*/React.createElement("path", {
    d: "M80 98h-1v-1h1z",
    fill: "#d19c9d"
  })), _path5189 || (_path5189 = /*#__PURE__*/React.createElement("path", {
    d: "M80 98v-1h1v1z",
    fill: "#c25358"
  })), _path5190 || (_path5190 = /*#__PURE__*/React.createElement("path", {
    d: "M86 97h1v1h-1z",
    fill: "#c9262e"
  })), _path5191 || (_path5191 = /*#__PURE__*/React.createElement("path", {
    d: "M88 97v1h-1v-1z",
    fill: "#cf2630"
  })), _path5192 || (_path5192 = /*#__PURE__*/React.createElement("path", {
    d: "M89 97v1h-1v-1z",
    fill: "#c3282d"
  })), _path5193 || (_path5193 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98h-1v-1h1z",
    fill: "#bf595b"
  })), _path5194 || (_path5194 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98v-1h1v1z",
    fill: "#d0cbc9"
  })), _path5195 || (_path5195 = /*#__PURE__*/React.createElement("path", {
    d: "M91 97h1v1h-1z",
    fill: "#cbcbc8"
  })), _path5196 || (_path5196 = /*#__PURE__*/React.createElement("path", {
    d: "M93 98h-1v-1h1z",
    fill: "#ceccd0"
  })), _path5197 || (_path5197 = /*#__PURE__*/React.createElement("path", {
    d: "M93 97h1v1h-1z",
    fill: "#d4c9ca"
  })), _path5198 || (_path5198 = /*#__PURE__*/React.createElement("path", {
    d: "M94 97h1v1h-1z",
    fill: "#c58183"
  })), _path5199 || (_path5199 = /*#__PURE__*/React.createElement("path", {
    d: "M95 98v-1h1v1z",
    fill: "#d79997"
  })), _path5200 || (_path5200 = /*#__PURE__*/React.createElement("path", {
    d: "M97 97v1h-1v-1z",
    fill: "#e6cbc4",
    fillOpacity: 0.482
  })), _path5201 || (_path5201 = /*#__PURE__*/React.createElement("path", {
    d: "M31 98h1v1h-1z",
    fill: "#e1c1b7",
    fillOpacity: 0.655
  })), _path5202 || (_path5202 = /*#__PURE__*/React.createElement("path", {
    d: "M32 98h1v1h-1z",
    fill: "#d8908c"
  })), _path5203 || (_path5203 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98v1h-1v-1z",
    fill: "#c86668"
  })), _path5204 || (_path5204 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99h-1v-1h1z",
    fill: "#c74047"
  })), _path5205 || (_path5205 = /*#__PURE__*/React.createElement("path", {
    d: "M38 99h-1v-1h1z",
    fill: "#c22c33"
  })), _path5206 || (_path5206 = /*#__PURE__*/React.createElement("path", {
    d: "M39 99h-1v-1h1z",
    fill: "#ca6f7e"
  })), _path5207 || (_path5207 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v1h-1v-1z",
    fill: "#daaaaa"
  })), _path5208 || (_path5208 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98h1v1h-1z",
    fill: "#d09191"
  })), _path5209 || (_path5209 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v-1h1v1z",
    fill: "#ce9293"
  })), _path5210 || (_path5210 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99v-1h1v1z",
    fill: "#ce7f86"
  })), _path5211 || (_path5211 = /*#__PURE__*/React.createElement("path", {
    d: "M43 99v-1h1v1z",
    fill: "#c76f75"
  })), _path5212 || (_path5212 = /*#__PURE__*/React.createElement("path", {
    d: "M44 99v-1h1v1z",
    fill: "#c78386"
  })), _path5213 || (_path5213 = /*#__PURE__*/React.createElement("path", {
    d: "M45 98h1v1h-1z",
    fill: "#c88b90"
  })), _path5214 || (_path5214 = /*#__PURE__*/React.createElement("path", {
    d: "M46 99v-1h1v1z",
    fill: "#cd5a5b"
  })), _path5215 || (_path5215 = /*#__PURE__*/React.createElement("path", {
    d: "M51 98v1h-1v-1z",
    fill: "#b9444e"
  })), _path5216 || (_path5216 = /*#__PURE__*/React.createElement("path", {
    d: "M51 99v-1h1v1z",
    fill: "#c9bec2"
  })), _path5217 || (_path5217 = /*#__PURE__*/React.createElement("path", {
    d: "M53 99h-1v-1h1z",
    fill: "#c8c4bb"
  })), _path5218 || (_path5218 = /*#__PURE__*/React.createElement("path", {
    d: "M54 99h-1v-1h1z",
    fill: "#bc5d56"
  })), _path5219 || (_path5219 = /*#__PURE__*/React.createElement("path", {
    d: "M54 99v-1h1v1z",
    fill: "#b8191d"
  })), _path5220 || (_path5220 = /*#__PURE__*/React.createElement("path", {
    d: "M55 99v-1h1v1z",
    fill: "#c51d27"
  })), _path5221 || (_path5221 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99v-1h1v1z",
    fill: "#c52029"
  })), _path5222 || (_path5222 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98h1v1h-1z",
    fill: "#c51c27"
  })), _path5223 || (_path5223 = /*#__PURE__*/React.createElement("path", {
    d: "M59 99v-1h1v1z",
    fill: "#c13041"
  })), _path5224 || (_path5224 = /*#__PURE__*/React.createElement("path", {
    d: "M60 99v-1h1v1z",
    fill: "#caa7a9"
  })), _path5225 || (_path5225 = /*#__PURE__*/React.createElement("path", {
    d: "M64 99h-1v-1h1z",
    fill: "#c3aea4"
  })), _path5226 || (_path5226 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98v1h-1v-1z",
    fill: "#b9594e"
  })), _path5227 || (_path5227 = /*#__PURE__*/React.createElement("path", {
    d: "M66 98v1h-1v-1z",
    fill: "#b11c1f"
  })), _path5228 || (_path5228 = /*#__PURE__*/React.createElement("path", {
    d: "M67 99h-1v-1h1z",
    fill: "#bb171f"
  })), _path5229 || (_path5229 = /*#__PURE__*/React.createElement("path", {
    d: "M68 99v-1h1v1z",
    fill: "#c01d23"
  })), _path5230 || (_path5230 = /*#__PURE__*/React.createElement("path", {
    d: "M69 98h1v1h-1z",
    fill: "#b71d2e"
  })), _path5231 || (_path5231 = /*#__PURE__*/React.createElement("path", {
    d: "M70 98h1v1h-1z",
    fill: "#c27a8a"
  })), _path5232 || (_path5232 = /*#__PURE__*/React.createElement("path", {
    d: "M72 98v1h-1v-1z",
    fill: "#d4c0bd"
  })), _path5233 || (_path5233 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98v1h-1v-1z",
    fill: "#bc5a55"
  })), _path5234 || (_path5234 = /*#__PURE__*/React.createElement("path", {
    d: "M74 99h-1v-1h1z",
    fill: "#b81620"
  })), _path5235 || (_path5235 = /*#__PURE__*/React.createElement("path", {
    d: "M75 99h-1v-1h1z",
    fill: "#bf1921"
  })), _path5236 || (_path5236 = /*#__PURE__*/React.createElement("path", {
    d: "M77 98v1h-1v-1z",
    fill: "#bc1a22"
  })), _path5237 || (_path5237 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99h-1v-1h1z",
    fill: "#b9181f"
  })), _path5238 || (_path5238 = /*#__PURE__*/React.createElement("path", {
    d: "M80 99h-1v-1h1z",
    fill: "#cb8387"
  })), _path5239 || (_path5239 = /*#__PURE__*/React.createElement("path", {
    d: "M80 99v-1h1v1z",
    fill: "#ca7174"
  })), _path5240 || (_path5240 = /*#__PURE__*/React.createElement("path", {
    d: "M88 98v1h-1v-1z",
    fill: "#cc282f"
  })), _path5241 || (_path5241 = /*#__PURE__*/React.createElement("path", {
    d: "M88 99v-1h1v1z",
    fill: "#c1272a"
  })), _path5242 || (_path5242 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98v1h-1v-1z",
    fill: "#c57577"
  })), _path5243 || (_path5243 = /*#__PURE__*/React.createElement("path", {
    d: "M91 99h-1v-1h1z",
    fill: "#cfcece"
  })), _path5244 || (_path5244 = /*#__PURE__*/React.createElement("path", {
    d: "M91 98h1v1h-1z",
    fill: "#cbcaca"
  })), _path5245 || (_path5245 = /*#__PURE__*/React.createElement("path", {
    d: "M93 99h-1v-1h1z",
    fill: "#cccdd0"
  })), _path5246 || (_path5246 = /*#__PURE__*/React.createElement("path", {
    d: "M93 98h1v1h-1z",
    fill: "#d3c7c7"
  })), _path5247 || (_path5247 = /*#__PURE__*/React.createElement("path", {
    d: "M95 98v1h-1v-1z",
    fill: "#c47c7f"
  })), _path5248 || (_path5248 = /*#__PURE__*/React.createElement("path", {
    d: "M95 98h1v1h-1z",
    fill: "#d79c9a"
  })), _path5249 || (_path5249 = /*#__PURE__*/React.createElement("path", {
    d: "M97 99h-1v-1h1z",
    fill: "#e5cec8",
    fillOpacity: 0.478
  })), _path5250 || (_path5250 = /*#__PURE__*/React.createElement("path", {
    d: "M32 100h-1v-1h1z",
    fill: "#e2c1b6",
    fillOpacity: 0.663
  })), _path5251 || (_path5251 = /*#__PURE__*/React.createElement("path", {
    d: "M33 100h-1v-1h1z",
    fill: "#d78e8b"
  })), _path5252 || (_path5252 = /*#__PURE__*/React.createElement("path", {
    d: "M34 99v1h-1v-1z",
    fill: "#c96567"
  })), _path5253 || (_path5253 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99v1h-1v-1z",
    fill: "#c74146"
  })), _path5254 || (_path5254 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99h1v1h-1z",
    fill: "#c6383e"
  })), _path5255 || (_path5255 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h1v1h-1z",
    fill: "#c52935"
  })), _path5256 || (_path5256 = /*#__PURE__*/React.createElement("path", {
    d: "M39 100h-1v-1h1z",
    fill: "#cd7381"
  })), _path5257 || (_path5257 = /*#__PURE__*/React.createElement("path", {
    d: "M39 99h1v1h-1z",
    fill: "#e5c9c6"
  })), _path5258 || (_path5258 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v1h-1v-1z",
    fill: "#cc8692"
  })), _path5259 || (_path5259 = /*#__PURE__*/React.createElement("path", {
    d: "M41 100v-1h1v1z",
    fill: "#d99da5"
  })), _path5260 || (_path5260 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99h1v1h-1z",
    fill: "#dcb3b7"
  })), _path5261 || (_path5261 = /*#__PURE__*/React.createElement("path", {
    d: "M44 100h-1v-1h1z",
    fill: "#dea7ae"
  })), _path5262 || (_path5262 = /*#__PURE__*/React.createElement("path", {
    d: "M45 100h-1v-1h1z",
    fill: "#daa6b0"
  })), _path5263 || (_path5263 = /*#__PURE__*/React.createElement("path", {
    d: "M46 100h-1v-1h1z",
    fill: "#e5c5c4"
  })), _path5264 || (_path5264 = /*#__PURE__*/React.createElement("path", {
    d: "M47 100h-1v-1h1z",
    fill: "#c65e5b"
  })), _path5265 || (_path5265 = /*#__PURE__*/React.createElement("path", {
    d: "M48 99v1h-1v-1z",
    fill: "#c1171f"
  })), _path5266 || (_path5266 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100v-1h1v1z",
    fill: "#b7212d"
  })), _path5267 || (_path5267 = /*#__PURE__*/React.createElement("path", {
    d: "M52 99v1h-1v-1z",
    fill: "#ca9aa0"
  })), _path5268 || (_path5268 = /*#__PURE__*/React.createElement("path", {
    d: "M53 99v1h-1v-1z",
    fill: "#c5cac3"
  })), _path5269 || (_path5269 = /*#__PURE__*/React.createElement("path", {
    d: "M53 100v-1h1v1z",
    fill: "#cbb3a4"
  })), _path5270 || (_path5270 = /*#__PURE__*/React.createElement("path", {
    d: "M55 99v1h-1v-1z",
    fill: "#b53d39"
  })), _path5271 || (_path5271 = /*#__PURE__*/React.createElement("path", {
    d: "M55 100v-1h1v1z",
    fill: "#c4191f"
  })), _path5272 || (_path5272 = /*#__PURE__*/React.createElement("path", {
    d: "M58 100v-1h1v1z",
    fill: "#c52028"
  })), _path5273 || (_path5273 = /*#__PURE__*/React.createElement("path", {
    d: "M60 99v1h-1v-1z",
    fill: "#c31a26"
  })), _path5274 || (_path5274 = /*#__PURE__*/React.createElement("path", {
    d: "M60 100v-1h1v1z",
    fill: "#bd3f4f"
  })), _path5275 || (_path5275 = /*#__PURE__*/React.createElement("path", {
    d: "M61 99h1v1h-1z",
    fill: "#ccaeb0"
  })), _path5276 || (_path5276 = /*#__PURE__*/React.createElement("path", {
    d: "M63 99v1h-1v-1z",
    fill: "#c6c4bd"
  })), _path5277 || (_path5277 = /*#__PURE__*/React.createElement("path", {
    d: "M63 100v-1h1v1z",
    fill: "#c2c6c0"
  })), _path5278 || (_path5278 = /*#__PURE__*/React.createElement("path", {
    d: "M65 99v1h-1v-1z",
    fill: "#cdc6bb"
  })), _path5279 || (_path5279 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99v1h-1v-1z",
    fill: "#c3917e"
  })), _path5280 || (_path5280 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99h1v1h-1z",
    fill: "#b13e37"
  })), _path5281 || (_path5281 = /*#__PURE__*/React.createElement("path", {
    d: "M67 99h1v1h-1z",
    fill: "#ba191e"
  })), _path5282 || (_path5282 = /*#__PURE__*/React.createElement("path", {
    d: "M69 99v1h-1v-1z",
    fill: "#c11920"
  })), _path5283 || (_path5283 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100v-1h1v1z",
    fill: "#c51921"
  })), _path5284 || (_path5284 = /*#__PURE__*/React.createElement("path", {
    d: "M70 100v-1h1v1z",
    fill: "#b32635"
  })), _path5285 || (_path5285 = /*#__PURE__*/React.createElement("path", {
    d: "M71 99h1v1h-1z",
    fill: "#c6a2a7"
  })), _path5286 || (_path5286 = /*#__PURE__*/React.createElement("path", {
    d: "M73 100h-1v-1h1z",
    fill: "#cebbb2"
  })), _path5287 || (_path5287 = /*#__PURE__*/React.createElement("path", {
    d: "M74 99v1h-1v-1z",
    fill: "#b54143"
  })), _path5288 || (_path5288 = /*#__PURE__*/React.createElement("path", {
    d: "M76 100v-1h1v1z",
    fill: "#bb1b24"
  })), _path5289 || (_path5289 = /*#__PURE__*/React.createElement("path", {
    d: "M77 99h1v1h-1z",
    fill: "#bf1b22"
  })), _path5290 || (_path5290 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99v1h-1v-1z",
    fill: "#bd171f"
  })), _path5291 || (_path5291 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99h1v1h-1z",
    fill: "#c3656b"
  })), _path5292 || (_path5292 = /*#__PURE__*/React.createElement("path", {
    d: "M81 99v1h-1v-1z",
    fill: "#d1908f"
  })), _path5293 || (_path5293 = /*#__PURE__*/React.createElement("path", {
    d: "M82 100v-1h1v1z",
    fill: "#c82228"
  })), _path5294 || (_path5294 = /*#__PURE__*/React.createElement("path", {
    d: "M87 100v-1h1v1z",
    fill: "#cd272e"
  })), _path5295 || (_path5295 = /*#__PURE__*/React.createElement("path", {
    d: "M89 99v1h-1v-1z",
    fill: "#bf2a2d"
  })), _path5296 || (_path5296 = /*#__PURE__*/React.createElement("path", {
    d: "M90 100h-1v-1h1z",
    fill: "#cb9292"
  })), _path5297 || (_path5297 = /*#__PURE__*/React.createElement("path", {
    d: "M91 99v1h-1v-1z",
    fill: "#cdcdcd"
  })), _path5298 || (_path5298 = /*#__PURE__*/React.createElement("path", {
    d: "M92 100v-1h1v1z",
    fill: "#cbcdce"
  })), _path5299 || (_path5299 = /*#__PURE__*/React.createElement("path", {
    d: "M93 100v-1h1v1z",
    fill: "#d4c4c4"
  })), _path5300 || (_path5300 = /*#__PURE__*/React.createElement("path", {
    d: "M95 100h-1v-1h1z",
    fill: "#c5787c"
  })), _path5301 || (_path5301 = /*#__PURE__*/React.createElement("path", {
    d: "M95 99h1v1h-1z",
    fill: "#d69999"
  })), _path5302 || (_path5302 = /*#__PURE__*/React.createElement("path", {
    d: "M97 100h-1v-1h1z",
    fill: "#e0c6c5",
    fillOpacity: 0.518
  })), _path5303 || (_path5303 = /*#__PURE__*/React.createElement("path", {
    d: "M31 100h1v1h-1z",
    fill: "#e1c1b5",
    fillOpacity: 0.682
  })), _path5304 || (_path5304 = /*#__PURE__*/React.createElement("path", {
    d: "M32 101v-1h1v1z",
    fill: "#d68d8a"
  })), _path5305 || (_path5305 = /*#__PURE__*/React.createElement("path", {
    d: "M33 101v-1h1v1z",
    fill: "#c96566"
  })), _path5306 || (_path5306 = /*#__PURE__*/React.createElement("path", {
    d: "M35 100v1h-1v-1z",
    fill: "#c64c51"
  })), _path5307 || (_path5307 = /*#__PURE__*/React.createElement("path", {
    d: "M36 101h-1v-1h1z",
    fill: "#c64146"
  })), _path5308 || (_path5308 = /*#__PURE__*/React.createElement("path", {
    d: "M38 100v1h-1v-1z",
    fill: "#c22b32"
  })), _path5309 || (_path5309 = /*#__PURE__*/React.createElement("path", {
    d: "M38 101v-1h1v1z",
    fill: "#d07484"
  })), _path5310 || (_path5310 = /*#__PURE__*/React.createElement("path", {
    d: "M40 100v1h-1v-1z",
    fill: "#e0c9c7"
  })), _path5311 || (_path5311 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101h-1v-1h1z",
    fill: "#c08380"
  })), _path5312 || (_path5312 = /*#__PURE__*/React.createElement("path", {
    d: "M42 101h-1v-1h1z",
    fill: "#be7d7f"
  })), _path5313 || (_path5313 = /*#__PURE__*/React.createElement("path", {
    d: "M42 100h1v1h-1z",
    fill: "#ce9093"
  })), _path5314 || (_path5314 = /*#__PURE__*/React.createElement("path", {
    d: "M44 101h-1v-1h1z",
    fill: "#bc5867"
  })), _path5315 || (_path5315 = /*#__PURE__*/React.createElement("path", {
    d: "M44 101v-1h1v1z",
    fill: "#b86173"
  })), _path5316 || (_path5316 = /*#__PURE__*/React.createElement("path", {
    d: "M45 101v-1h1v1z",
    fill: "#eed5d4"
  })), _path5317 || (_path5317 = /*#__PURE__*/React.createElement("path", {
    d: "M46 101v-1h1v1z",
    fill: "#c85c5b"
  })), _path5318 || (_path5318 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101v-1h1v1z",
    fill: "#c2171d"
  })), _path5319 || (_path5319 = /*#__PURE__*/React.createElement("path", {
    d: "M49 101v-1h1v1z",
    fill: "#c01c20"
  })), _path5320 || (_path5320 = /*#__PURE__*/React.createElement("path", {
    d: "M51 100v1h-1v-1z",
    fill: "#bf1621"
  })), _path5321 || (_path5321 = /*#__PURE__*/React.createElement("path", {
    d: "M52 100v1h-1v-1z",
    fill: "#c05b64"
  })), _path5322 || (_path5322 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101h-1v-1h1z",
    fill: "#ccc5c2"
  })), _path5323 || (_path5323 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101h-1v-1h1z",
    fill: "#c9a094"
  })), _path5324 || (_path5324 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101h-1v-1h1z",
    fill: "#cb1e29"
  })), _path5325 || (_path5325 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101v-1h1v1z",
    fill: "#c91f24"
  })), _path5326 || (_path5326 = /*#__PURE__*/React.createElement("path", {
    d: "M61 101v-1h1v1z",
    fill: "#b7404e"
  })), _path5327 || (_path5327 = /*#__PURE__*/React.createElement("path", {
    d: "M62 101v-1h1v1z",
    fill: "#d0a6ae"
  })), _path5328 || (_path5328 = /*#__PURE__*/React.createElement("path", {
    d: "M64 101h-1v-1h1z",
    fill: "#c2c6c4"
  })), _path5329 || (_path5329 = /*#__PURE__*/React.createElement("path", {
    d: "M64 100h1v1h-1z",
    fill: "#bec2bb"
  })), _path5330 || (_path5330 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101h-1v-1h1z",
    fill: "#cccbc0"
  })), _path5331 || (_path5331 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101v-1h1v1z",
    fill: "#ccbbae"
  })), _path5332 || (_path5332 = /*#__PURE__*/React.createElement("path", {
    d: "M68 100v1h-1v-1z",
    fill: "#c0877e"
  })), _path5333 || (_path5333 = /*#__PURE__*/React.createElement("path", {
    d: "M69 101h-1v-1h1z",
    fill: "#b74d4a"
  })), _path5334 || (_path5334 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100h1v1h-1z",
    fill: "#b92d2b"
  })), _path5335 || (_path5335 = /*#__PURE__*/React.createElement("path", {
    d: "M70 100h1v1h-1z",
    fill: "#b12825"
  })), _path5336 || (_path5336 = /*#__PURE__*/React.createElement("path", {
    d: "M71 100h1v1h-1z",
    fill: "#c29090"
  })), _path5337 || (_path5337 = /*#__PURE__*/React.createElement("path", {
    d: "M73 100v1h-1v-1z",
    fill: "#c5ccc9"
  })), _path5338 || (_path5338 = /*#__PURE__*/React.createElement("path", {
    d: "M73 101v-1h1v1z",
    fill: "#ce9891"
  })), _path5339 || (_path5339 = /*#__PURE__*/React.createElement("path", {
    d: "M74 101v-1h1v1z",
    fill: "#b42226"
  })), _path5340 || (_path5340 = /*#__PURE__*/React.createElement("path", {
    d: "M76 101h-1v-1h1z",
    fill: "#c0181e"
  })), _path5341 || (_path5341 = /*#__PURE__*/React.createElement("path", {
    d: "M77 100h1v1h-1z",
    fill: "#c01b24"
  })), _path5342 || (_path5342 = /*#__PURE__*/React.createElement("path", {
    d: "M79 100h1v1h-1z",
    fill: "#c14952"
  })), _path5343 || (_path5343 = /*#__PURE__*/React.createElement("path", {
    d: "M80 101v-1h1v1z",
    fill: "#d3a6a3"
  })), _path5344 || (_path5344 = /*#__PURE__*/React.createElement("path", {
    d: "M81 100h1v1h-1z",
    fill: "#c02b34"
  })), _path5345 || (_path5345 = /*#__PURE__*/React.createElement("path", {
    d: "M86 100h1v1h-1z",
    fill: "#c8262d"
  })), _path5346 || (_path5346 = /*#__PURE__*/React.createElement("path", {
    d: "M88 100v1h-1v-1z",
    fill: "#cd252e"
  })), _path5347 || (_path5347 = /*#__PURE__*/React.createElement("path", {
    d: "M88 100h1v1h-1z",
    fill: "#b93637"
  })), _path5348 || (_path5348 = /*#__PURE__*/React.createElement("path", {
    d: "M89 100h1v1h-1z",
    fill: "#ceafac"
  })), _path5349 || (_path5349 = /*#__PURE__*/React.createElement("path", {
    d: "M90 101v-1h1v1z",
    fill: "#cacbcd"
  })), _path5350 || (_path5350 = /*#__PURE__*/React.createElement("path", {
    d: "M92 100h1v1h-1z",
    fill: "#cdcece"
  })), _path5351 || (_path5351 = /*#__PURE__*/React.createElement("path", {
    d: "M94 101h-1v-1h1z",
    fill: "#d4c0bf"
  })), _path5352 || (_path5352 = /*#__PURE__*/React.createElement("path", {
    d: "M95 100v1h-1v-1z",
    fill: "#c47478"
  })), _path5353 || (_path5353 = /*#__PURE__*/React.createElement("path", {
    d: "M95 101v-1h1v1z",
    fill: "#d6999b"
  })), _path5354 || (_path5354 = /*#__PURE__*/React.createElement("path", {
    d: "M97 100v1h-1v-1z",
    fill: "#e0c7c7",
    fillOpacity: 0.522
  })), _path5355 || (_path5355 = /*#__PURE__*/React.createElement("path", {
    d: "M31 102v-1h1v1z",
    fill: "#debdb3",
    fillOpacity: 0.702
  })), _path5356 || (_path5356 = /*#__PURE__*/React.createElement("path", {
    d: "M32 101h1v1h-1z",
    fill: "#d58b88"
  })), _path5357 || (_path5357 = /*#__PURE__*/React.createElement("path", {
    d: "M34 101v1h-1v-1z",
    fill: "#ca6464"
  })), _path5358 || (_path5358 = /*#__PURE__*/React.createElement("path", {
    d: "M34 102v-1h1v1z",
    fill: "#c44c4f"
  })), _path5359 || (_path5359 = /*#__PURE__*/React.createElement("path", {
    d: "M36 102v-1h1v1z",
    fill: "#c7383d"
  })), _path5360 || (_path5360 = /*#__PURE__*/React.createElement("path", {
    d: "M37 101h1v1h-1z",
    fill: "#c42e37"
  })), _path5361 || (_path5361 = /*#__PURE__*/React.createElement("path", {
    d: "M39 102h-1v-1h1z",
    fill: "#c0485e"
  })), _path5362 || (_path5362 = /*#__PURE__*/React.createElement("path", {
    d: "M39 101h1v1h-1z",
    fill: "#e7b7c5"
  })), _path5363 || (_path5363 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101v1h-1v-1z",
    fill: "#e6dad5"
  })), _path5364 || (_path5364 = /*#__PURE__*/React.createElement("path", {
    d: "M41 102v-1h1v1z",
    fill: "#dfd1ca"
  })), _path5365 || (_path5365 = /*#__PURE__*/React.createElement("path", {
    d: "M43 101v1h-1v-1z",
    fill: "#dec6c0"
  })), _path5366 || (_path5366 = /*#__PURE__*/React.createElement("path", {
    d: "M43 102v-1h1v1z",
    fill: "#dcafad"
  })), _path5367 || (_path5367 = /*#__PURE__*/React.createElement("path", {
    d: "M45 102h-1v-1h1z",
    fill: "#d7b2b6"
  })), _path5368 || (_path5368 = /*#__PURE__*/React.createElement("path", {
    d: "M46 102h-1v-1h1z",
    fill: "#ebd8d9"
  })), _path5369 || (_path5369 = /*#__PURE__*/React.createElement("path", {
    d: "M46 102v-1h1v1z",
    fill: "#c65658"
  })), _path5370 || (_path5370 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101h1v1h-1z",
    fill: "#c0181d"
  })), _path5371 || (_path5371 = /*#__PURE__*/React.createElement("path", {
    d: "M51 101h1v1h-1z",
    fill: "#b72530"
  })), _path5372 || (_path5372 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101v1h-1v-1z",
    fill: "#d09da7"
  })), _path5373 || (_path5373 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101v1h-1v-1z",
    fill: "#c8c5c6"
  })), _path5374 || (_path5374 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101v1h-1v-1z",
    fill: "#c8c7c1"
  })), _path5375 || (_path5375 = /*#__PURE__*/React.createElement("path", {
    d: "M55 102v-1h1v1z",
    fill: "#c49286"
  })), _path5376 || (_path5376 = /*#__PURE__*/React.createElement("path", {
    d: "M58 102h-1v-1h1z",
    fill: "#c81d25"
  })), _path5377 || (_path5377 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101v1h-1v-1z",
    fill: "#c62029"
  })), _path5378 || (_path5378 = /*#__PURE__*/React.createElement("path", {
    d: "M60 102v-1h1v1z",
    fill: "#c31d22"
  })), _path5379 || (_path5379 = /*#__PURE__*/React.createElement("path", {
    d: "M61 101h1v1h-1z",
    fill: "#bd1622"
  })), _path5380 || (_path5380 = /*#__PURE__*/React.createElement("path", {
    d: "M63 101v1h-1v-1z",
    fill: "#b63446"
  })), _path5381 || (_path5381 = /*#__PURE__*/React.createElement("path", {
    d: "M63 102v-1h1v1z",
    fill: "#c89ba0"
  })), _path5382 || (_path5382 = /*#__PURE__*/React.createElement("path", {
    d: "M68 102h-1v-1h1z",
    fill: "#c4c7be"
  })), _path5383 || (_path5383 = /*#__PURE__*/React.createElement("path", {
    d: "M68 101h1v1h-1z",
    fill: "#c8c2b6"
  })), _path5384 || (_path5384 = /*#__PURE__*/React.createElement("path", {
    d: "M69 101h1v1h-1z",
    fill: "#ceafa5"
  })), _path5385 || (_path5385 = /*#__PURE__*/React.createElement("path", {
    d: "M71 102h-1v-1h1z",
    fill: "#c9aa9f"
  })), _path5386 || (_path5386 = /*#__PURE__*/React.createElement("path", {
    d: "M72 101v1h-1v-1z",
    fill: "#cabfb9"
  })), _path5387 || (_path5387 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102h-1v-1h1z",
    fill: "#cdc4bd"
  })), _path5388 || (_path5388 = /*#__PURE__*/React.createElement("path", {
    d: "M75 101v1h-1v-1z",
    fill: "#bd5559"
  })), _path5389 || (_path5389 = /*#__PURE__*/React.createElement("path", {
    d: "M75 102v-1h1v1z",
    fill: "#bb161f"
  })), _path5390 || (_path5390 = /*#__PURE__*/React.createElement("path", {
    d: "M77 102v-1h1v1z",
    fill: "#c11b24"
  })), _path5391 || (_path5391 = /*#__PURE__*/React.createElement("path", {
    d: "M80 102h-1v-1h1z",
    fill: "#bd323b"
  })), _path5392 || (_path5392 = /*#__PURE__*/React.createElement("path", {
    d: "M80 101h1v1h-1z",
    fill: "#d7abad"
  })), _path5393 || (_path5393 = /*#__PURE__*/React.createElement("path", {
    d: "M82 102h-1v-1h1z",
    fill: "#bf4247"
  })), _path5394 || (_path5394 = /*#__PURE__*/React.createElement("path", {
    d: "M88 102h-1v-1h1z",
    fill: "#c7252e"
  })), _path5395 || (_path5395 = /*#__PURE__*/React.createElement("path", {
    d: "M89 101v1h-1v-1z",
    fill: "#bb4b49"
  })), _path5396 || (_path5396 = /*#__PURE__*/React.createElement("path", {
    d: "M90 101v1h-1v-1z",
    fill: "#d1c2c0"
  })), _path5397 || (_path5397 = /*#__PURE__*/React.createElement("path", {
    d: "M91 102h-1v-1h1z",
    fill: "#cac9cc"
  })), _path5398 || (_path5398 = /*#__PURE__*/React.createElement("path", {
    d: "M92 102v-1h1v1z",
    fill: "#cfcecd"
  })), _path5399 || (_path5399 = /*#__PURE__*/React.createElement("path", {
    d: "M93 102v-1h1v1z",
    fill: "#d4bbb9"
  })), _path5400 || (_path5400 = /*#__PURE__*/React.createElement("path", {
    d: "M94 102v-1h1v1z",
    fill: "#c27173"
  })), _path5401 || (_path5401 = /*#__PURE__*/React.createElement("path", {
    d: "M95 101h1v1h-1z",
    fill: "#dca2a3"
  })), _path5402 || (_path5402 = /*#__PURE__*/React.createElement("path", {
    d: "M97 102h-1v-1h1z",
    fill: "#e8d2d0",
    fillOpacity: 0.494
  })), _path5403 || (_path5403 = /*#__PURE__*/React.createElement("path", {
    d: "M32 102v1h-1v-1z",
    fill: "#dcbab0",
    fillOpacity: 0.718
  })), _path5404 || (_path5404 = /*#__PURE__*/React.createElement("path", {
    d: "M33 102v1h-1v-1z",
    fill: "#d58a86"
  })), _path5405 || (_path5405 = /*#__PURE__*/React.createElement("path", {
    d: "M33 103v-1h1v1z",
    fill: "#c96363"
  })), _path5406 || (_path5406 = /*#__PURE__*/React.createElement("path", {
    d: "M37 102h1v1h-1z",
    fill: "#c63034"
  })), _path5407 || (_path5407 = /*#__PURE__*/React.createElement("path", {
    d: "M38 103v-1h1v1z",
    fill: "#c22932"
  })), _path5408 || (_path5408 = /*#__PURE__*/React.createElement("path", {
    d: "M39 103v-1h1v1z",
    fill: "#bc3b4e"
  })), _path5409 || (_path5409 = /*#__PURE__*/React.createElement("path", {
    d: "M40 103v-1h1v1z",
    fill: "#d37d90"
  })), _path5410 || (_path5410 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v-1h1v1z",
    fill: "#deadbc"
  })), _path5411 || (_path5411 = /*#__PURE__*/React.createElement("path", {
    d: "M42 102h1v1h-1z",
    fill: "#e2bdc9"
  })), _path5412 || (_path5412 = /*#__PURE__*/React.createElement("path", {
    d: "M44 102v1h-1v-1z",
    fill: "#e5bcc6"
  })), _path5413 || (_path5413 = /*#__PURE__*/React.createElement("path", {
    d: "M45 102v1h-1v-1z",
    fill: "#dfa1af"
  })), _path5414 || (_path5414 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h-1v-1h1z",
    fill: "#cd616f"
  })), _path5415 || (_path5415 = /*#__PURE__*/React.createElement("path", {
    d: "M47 103h-1v-1h1z",
    fill: "#be252e"
  })), _path5416 || (_path5416 = /*#__PURE__*/React.createElement("path", {
    d: "M48 102v1h-1v-1z",
    fill: "#c51c21"
  })), _path5417 || (_path5417 = /*#__PURE__*/React.createElement("path", {
    d: "M53 103h-1v-1h1z",
    fill: "#bc5164"
  })), _path5418 || (_path5418 = /*#__PURE__*/React.createElement("path", {
    d: "M53 102h1v1h-1z",
    fill: "#cfbfc5"
  })), _path5419 || (_path5419 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103h-1v-1h1z",
    fill: "#cac5bf"
  })), _path5420 || (_path5420 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103v-1h1v1z",
    fill: "#cc8b82"
  })), _path5421 || (_path5421 = /*#__PURE__*/React.createElement("path", {
    d: "M57 103v-1h1v1z",
    fill: "#bb2a2b"
  })), _path5422 || (_path5422 = /*#__PURE__*/React.createElement("path", {
    d: "M60 103h-1v-1h1z",
    fill: "#c62025"
  })), _path5423 || (_path5423 = /*#__PURE__*/React.createElement("path", {
    d: "M60 102h1v1h-1z",
    fill: "#c51d22"
  })), _path5424 || (_path5424 = /*#__PURE__*/React.createElement("path", {
    d: "M62 102v1h-1v-1z",
    fill: "#c41a21"
  })), _path5425 || (_path5425 = /*#__PURE__*/React.createElement("path", {
    d: "M63 102v1h-1v-1z",
    fill: "#bc151c"
  })), _path5426 || (_path5426 = /*#__PURE__*/React.createElement("path", {
    d: "M64 102v1h-1v-1z",
    fill: "#ae2635"
  })), _path5427 || (_path5427 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103h-1v-1h1z",
    fill: "#c27a88"
  })), _path5428 || (_path5428 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h-1v-1h1z",
    fill: "#ccbfbe"
  })), _path5429 || (_path5429 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103v-1h1v1z",
    fill: "#c3c6bf"
  })), _path5430 || (_path5430 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103h-1v-1h1z",
    fill: "#c2c2bb"
  })), _path5431 || (_path5431 = /*#__PURE__*/React.createElement("path", {
    d: "M69 102h1v1h-1z",
    fill: "#c0c6c3"
  })), _path5432 || (_path5432 = /*#__PURE__*/React.createElement("path", {
    d: "M70 102h1v1h-1z",
    fill: "#c3c6c4"
  })), _path5433 || (_path5433 = /*#__PURE__*/React.createElement("path", {
    d: "M71 103v-1h1v1z",
    fill: "#c3c3bf"
  })), _path5434 || (_path5434 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102h1v1h-1z",
    fill: "#c88286"
  })), _path5435 || (_path5435 = /*#__PURE__*/React.createElement("path", {
    d: "M76 103h-1v-1h1z",
    fill: "#b81720"
  })), _path5436 || (_path5436 = /*#__PURE__*/React.createElement("path", {
    d: "M78 103v-1h1v1z",
    fill: "#c31b23"
  })), _path5437 || (_path5437 = /*#__PURE__*/React.createElement("path", {
    d: "M79 102h1v1h-1z",
    fill: "#bb272f"
  })), _path5438 || (_path5438 = /*#__PURE__*/React.createElement("path", {
    d: "M80 103v-1h1v1z",
    fill: "#d6a8a9"
  })), _path5439 || (_path5439 = /*#__PURE__*/React.createElement("path", {
    d: "M81 102h1v1h-1z",
    fill: "#c55d63"
  })), _path5440 || (_path5440 = /*#__PURE__*/React.createElement("path", {
    d: "M84 102v1h-1v-1z",
    fill: "#c7242a"
  })), _path5441 || (_path5441 = /*#__PURE__*/React.createElement("path", {
    d: "M85 103v-1h1v1z",
    fill: "#ca242d"
  })), _path5442 || (_path5442 = /*#__PURE__*/React.createElement("path", {
    d: "M87 102h1v1h-1z",
    fill: "#c12527"
  })), _path5443 || (_path5443 = /*#__PURE__*/React.createElement("path", {
    d: "M88 103v-1h1v1z",
    fill: "#c46868"
  })), _path5444 || (_path5444 = /*#__PURE__*/React.createElement("path", {
    d: "M90 103h-1v-1h1z",
    fill: "#cfcac9"
  })), _path5445 || (_path5445 = /*#__PURE__*/React.createElement("path", {
    d: "M90 102h1v1h-1z",
    fill: "#cac8cb"
  })), _path5446 || (_path5446 = /*#__PURE__*/React.createElement("path", {
    d: "M91 102h1v1h-1z",
    fill: "#ccc9c9"
  })), _path5447 || (_path5447 = /*#__PURE__*/React.createElement("path", {
    d: "M93 102v1h-1v-1z",
    fill: "#cecfd0"
  })), _path5448 || (_path5448 = /*#__PURE__*/React.createElement("path", {
    d: "M93 102h1v1h-1z",
    fill: "#d2b5b6"
  })), _path5449 || (_path5449 = /*#__PURE__*/React.createElement("path", {
    d: "M95 102v1h-1v-1z",
    fill: "#c16e70"
  })), _path5450 || (_path5450 = /*#__PURE__*/React.createElement("path", {
    d: "M95 103v-1h1v1z",
    fill: "#dc9ea0"
  })), _path5451 || (_path5451 = /*#__PURE__*/React.createElement("path", {
    d: "M97 103h-1v-1h1z",
    fill: "#e6cecc",
    fillOpacity: 0.494
  })), _path5452 || (_path5452 = /*#__PURE__*/React.createElement("path", {
    d: "M32 103v1h-1v-1z",
    fill: "#dbb7ac",
    fillOpacity: 0.729
  })), _path5453 || (_path5453 = /*#__PURE__*/React.createElement("path", {
    d: "M33 103v1h-1v-1z",
    fill: "#d48884"
  })), _path5454 || (_path5454 = /*#__PURE__*/React.createElement("path", {
    d: "M34 104h-1v-1h1z",
    fill: "#c86363"
  })), _path5455 || (_path5455 = /*#__PURE__*/React.createElement("path", {
    d: "M35 103h1v1h-1z",
    fill: "#c53f43"
  })), _path5456 || (_path5456 = /*#__PURE__*/React.createElement("path", {
    d: "M37 103v1h-1v-1z",
    fill: "#c7373c"
  })), _path5457 || (_path5457 = /*#__PURE__*/React.createElement("path", {
    d: "M37 104v-1h1v1z",
    fill: "#c52f38"
  })), _path5458 || (_path5458 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h-1v-1h1z",
    fill: "#c52c30"
  })), _path5459 || (_path5459 = /*#__PURE__*/React.createElement("path", {
    d: "M40 104h-1v-1h1z",
    fill: "#c2292d"
  })), _path5460 || (_path5460 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v1h-1v-1z",
    fill: "#b9242c"
  })), _path5461 || (_path5461 = /*#__PURE__*/React.createElement("path", {
    d: "M42 103v1h-1v-1z",
    fill: "#b92733"
  })), _path5462 || (_path5462 = /*#__PURE__*/React.createElement("path", {
    d: "M43 104h-1v-1h1z",
    fill: "#b92e3b"
  })), _path5463 || (_path5463 = /*#__PURE__*/React.createElement("path", {
    d: "M44 103v1h-1v-1z",
    fill: "#bc2c38"
  })), _path5464 || (_path5464 = /*#__PURE__*/React.createElement("path", {
    d: "M44 103h1v1h-1z",
    fill: "#be212c"
  })), _path5465 || (_path5465 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103v1h-1v-1z",
    fill: "#be1c26"
  })), _path5466 || (_path5466 = /*#__PURE__*/React.createElement("path", {
    d: "M52 104h-1v-1h1z",
    fill: "#c41c1f"
  })), _path5467 || (_path5467 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h1v1h-1z",
    fill: "#b82131"
  })), _path5468 || (_path5468 = /*#__PURE__*/React.createElement("path", {
    d: "M54 103v1h-1v-1z",
    fill: "#c78594"
  })), _path5469 || (_path5469 = /*#__PURE__*/React.createElement("path", {
    d: "M54 104v-1h1v1z",
    fill: "#c5c8c5"
  })), _path5470 || (_path5470 = /*#__PURE__*/React.createElement("path", {
    d: "M55 104v-1h1v1z",
    fill: "#c1c4bd"
  })), _path5471 || (_path5471 = /*#__PURE__*/React.createElement("path", {
    d: "M56 104v-1h1v1z",
    fill: "#c8c7be"
  })), _path5472 || (_path5472 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103v1h-1v-1z",
    fill: "#d08e88"
  })), _path5473 || (_path5473 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103h1v1h-1z",
    fill: "#bb2f31"
  })), _path5474 || (_path5474 = /*#__PURE__*/React.createElement("path", {
    d: "M59 104v-1h1v1z",
    fill: "#c11e22"
  })), _path5475 || (_path5475 = /*#__PURE__*/React.createElement("path", {
    d: "M63 103h1v1h-1z",
    fill: "#bf141c"
  })), _path5476 || (_path5476 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103v1h-1v-1z",
    fill: "#b01626"
  })), _path5477 || (_path5477 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104v-1h1v1z",
    fill: "#b9505e"
  })), _path5478 || (_path5478 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h1v1h-1z",
    fill: "#cf9fa8"
  })), _path5479 || (_path5479 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103v1h-1v-1z",
    fill: "#cac3cb"
  })), _path5480 || (_path5480 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103h1v1h-1z",
    fill: "#c3c6c7"
  })), _path5481 || (_path5481 = /*#__PURE__*/React.createElement("path", {
    d: "M70 104h-1v-1h1z",
    fill: "#c1c5bf"
  })), _path5482 || (_path5482 = /*#__PURE__*/React.createElement("path", {
    d: "M72 103v1h-1v-1z",
    fill: "#c4c3bf"
  })), _path5483 || (_path5483 = /*#__PURE__*/React.createElement("path", {
    d: "M72 103h1v1h-1z",
    fill: "#bfc2bd"
  })), _path5484 || (_path5484 = /*#__PURE__*/React.createElement("path", {
    d: "M73 103h1v1h-1z",
    fill: "#c5c6c2"
  })), _path5485 || (_path5485 = /*#__PURE__*/React.createElement("path", {
    d: "M75 104h-1v-1h1z",
    fill: "#c77d82"
  })), _path5486 || (_path5486 = /*#__PURE__*/React.createElement("path", {
    d: "M75 104v-1h1v1z",
    fill: "#b91721"
  })), _path5487 || (_path5487 = /*#__PURE__*/React.createElement("path", {
    d: "M77 103v1h-1v-1z",
    fill: "#bf1b21"
  })), _path5488 || (_path5488 = /*#__PURE__*/React.createElement("path", {
    d: "M80 103v1h-1v-1z",
    fill: "#bd2229"
  })), _path5489 || (_path5489 = /*#__PURE__*/React.createElement("path", {
    d: "M80 104v-1h1v1z",
    fill: "#ce9e9d"
  })), _path5490 || (_path5490 = /*#__PURE__*/React.createElement("path", {
    d: "M81 103h1v1h-1z",
    fill: "#ca787d"
  })), _path5491 || (_path5491 = /*#__PURE__*/React.createElement("path", {
    d: "M83 104h-1v-1h1z",
    fill: "#c41d28"
  })), _path5492 || (_path5492 = /*#__PURE__*/React.createElement("path", {
    d: "M84 104h-1v-1h1z",
    fill: "#c8242a"
  })), _path5493 || (_path5493 = /*#__PURE__*/React.createElement("path", {
    d: "M86 104h-1v-1h1z",
    fill: "#ca242e"
  })), _path5494 || (_path5494 = /*#__PURE__*/React.createElement("path", {
    d: "M87 104v-1h1v1z",
    fill: "#bf2828"
  })), _path5495 || (_path5495 = /*#__PURE__*/React.createElement("path", {
    d: "M89 103v1h-1v-1z",
    fill: "#ca908d"
  })), _path5496 || (_path5496 = /*#__PURE__*/React.createElement("path", {
    d: "M89 104v-1h1v1z",
    fill: "#c9ccca"
  })), _path5497 || (_path5497 = /*#__PURE__*/React.createElement("path", {
    d: "M91 104h-1v-1h1z",
    fill: "#cac9ca"
  })), _path5498 || (_path5498 = /*#__PURE__*/React.createElement("path", {
    d: "M91 103h1v1h-1z",
    fill: "#cccac8"
  })), _path5499 || (_path5499 = /*#__PURE__*/React.createElement("path", {
    d: "M94 103v1h-1v-1z",
    fill: "#d1afb1"
  })), _path5500 || (_path5500 = /*#__PURE__*/React.createElement("path", {
    d: "M95 103v1h-1v-1z",
    fill: "#c16c6f"
  })), _path5501 || (_path5501 = /*#__PURE__*/React.createElement("path", {
    d: "M96 103v1h-1v-1z",
    fill: "#d99799"
  })), _path5502 || (_path5502 = /*#__PURE__*/React.createElement("path", {
    d: "M97 103v1h-1v-1z",
    fill: "#dfc3c1",
    fillOpacity: 0.502
  })), _path5503 || (_path5503 = /*#__PURE__*/React.createElement("path", {
    d: "M31 105v-1h1v1z",
    fill: "#dab5aa",
    fillOpacity: 0.737
  })), _path5504 || (_path5504 = /*#__PURE__*/React.createElement("path", {
    d: "M32 105v-1h1v1z",
    fill: "#d48784"
  })), _path5505 || (_path5505 = /*#__PURE__*/React.createElement("path", {
    d: "M34 104h1v1h-1z",
    fill: "#c44a4d"
  })), _path5506 || (_path5506 = /*#__PURE__*/React.createElement("path", {
    d: "M35 105v-1h1v1z",
    fill: "#c63f43"
  })), _path5507 || (_path5507 = /*#__PURE__*/React.createElement("path", {
    d: "M36 105v-1h1v1z",
    fill: "#c7373b"
  })), _path5508 || (_path5508 = /*#__PURE__*/React.createElement("path", {
    d: "M38 105h-1v-1h1z",
    fill: "#c53033"
  })), _path5509 || (_path5509 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h1v1h-1z",
    fill: "#c5282c"
  })), _path5510 || (_path5510 = /*#__PURE__*/React.createElement("path", {
    d: "M41 104v1h-1v-1z",
    fill: "#c8222b"
  })), _path5511 || (_path5511 = /*#__PURE__*/React.createElement("path", {
    d: "M42 105h-1v-1h1z",
    fill: "#c4212a"
  })), _path5512 || (_path5512 = /*#__PURE__*/React.createElement("path", {
    d: "M42 105v-1h1v1z",
    fill: "#c41e29"
  })), _path5513 || (_path5513 = /*#__PURE__*/React.createElement("path", {
    d: "M43 105v-1h1v1z",
    fill: "#c51e28"
  })), _path5514 || (_path5514 = /*#__PURE__*/React.createElement("path", {
    d: "M45 104h1v1h-1z",
    fill: "#c41f24"
  })), _path5515 || (_path5515 = /*#__PURE__*/React.createElement("path", {
    d: "M46 104h1v1h-1z",
    fill: "#c51f23"
  })), _path5516 || (_path5516 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105v-1h1v1z",
    fill: "#c41d26"
  })), _path5517 || (_path5517 = /*#__PURE__*/React.createElement("path", {
    d: "M53 104v1h-1v-1z",
    fill: "#c01e24"
  })), _path5518 || (_path5518 = /*#__PURE__*/React.createElement("path", {
    d: "M53 104h1v1h-1z",
    fill: "#b8333f"
  })), _path5519 || (_path5519 = /*#__PURE__*/React.createElement("path", {
    d: "M55 105h-1v-1h1z",
    fill: "#cda6b0"
  })), _path5520 || (_path5520 = /*#__PURE__*/React.createElement("path", {
    d: "M56 105h-1v-1h1z",
    fill: "#c6c4c6"
  })), _path5521 || (_path5521 = /*#__PURE__*/React.createElement("path", {
    d: "M58 104v1h-1v-1z",
    fill: "#c8c6c4"
  })), _path5522 || (_path5522 = /*#__PURE__*/React.createElement("path", {
    d: "M58 105v-1h1v1z",
    fill: "#ca9b96"
  })), _path5523 || (_path5523 = /*#__PURE__*/React.createElement("path", {
    d: "M59 104h1v1h-1z",
    fill: "#be3639"
  })), _path5524 || (_path5524 = /*#__PURE__*/React.createElement("path", {
    d: "M60 104h1v1h-1z",
    fill: "#c2191e"
  })), _path5525 || (_path5525 = /*#__PURE__*/React.createElement("path", {
    d: "M61 104h1v1h-1z",
    fill: "#c31923"
  })), _path5526 || (_path5526 = /*#__PURE__*/React.createElement("path", {
    d: "M64 105h-1v-1h1z",
    fill: "#b9191c"
  })), _path5527 || (_path5527 = /*#__PURE__*/React.createElement("path", {
    d: "M65 105h-1v-1h1z",
    fill: "#bd161d"
  })), _path5528 || (_path5528 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104h1v1h-1z",
    fill: "#b9141d"
  })), _path5529 || (_path5529 = /*#__PURE__*/React.createElement("path", {
    d: "M66 104h1v1h-1z",
    fill: "#b92434"
  })), _path5530 || (_path5530 = /*#__PURE__*/React.createElement("path", {
    d: "M68 105h-1v-1h1z",
    fill: "#c55f75"
  })), _path5531 || (_path5531 = /*#__PURE__*/React.createElement("path", {
    d: "M68 104h1v1h-1z",
    fill: "#ce9cac"
  })), _path5532 || (_path5532 = /*#__PURE__*/React.createElement("path", {
    d: "M70 104v1h-1v-1z",
    fill: "#cdbbc2"
  })), _path5533 || (_path5533 = /*#__PURE__*/React.createElement("path", {
    d: "M71 105h-1v-1h1z",
    fill: "#c9c6c8"
  })), _path5534 || (_path5534 = /*#__PURE__*/React.createElement("path", {
    d: "M71 104h1v1h-1z",
    fill: "#c5c7c9"
  })), _path5535 || (_path5535 = /*#__PURE__*/React.createElement("path", {
    d: "M73 104v1h-1v-1z",
    fill: "#c8c6c7"
  })), _path5536 || (_path5536 = /*#__PURE__*/React.createElement("path", {
    d: "M74 104v1h-1v-1z",
    fill: "#cdafb3"
  })), _path5537 || (_path5537 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105h-1v-1h1z",
    fill: "#bb3e4b"
  })), _path5538 || (_path5538 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105v-1h1v1z",
    fill: "#c11521"
  })), _path5539 || (_path5539 = /*#__PURE__*/React.createElement("path", {
    d: "M76 105v-1h1v1z",
    fill: "#be1b22"
  })), _path5540 || (_path5540 = /*#__PURE__*/React.createElement("path", {
    d: "M81 104v1h-1v-1z",
    fill: "#c89596"
  })), _path5541 || (_path5541 = /*#__PURE__*/React.createElement("path", {
    d: "M82 104v1h-1v-1z",
    fill: "#cb9495"
  })), _path5542 || (_path5542 = /*#__PURE__*/React.createElement("path", {
    d: "M82 105v-1h1v1z",
    fill: "#c2222c"
  })), _path5543 || (_path5543 = /*#__PURE__*/React.createElement("path", {
    d: "M84 104v1h-1v-1z",
    fill: "#cb232c"
  })), _path5544 || (_path5544 = /*#__PURE__*/React.createElement("path", {
    d: "M86 104v1h-1v-1z",
    fill: "#ca252d"
  })), _path5545 || (_path5545 = /*#__PURE__*/React.createElement("path", {
    d: "M86 105v-1h1v1z",
    fill: "#cc242c"
  })), _path5546 || (_path5546 = /*#__PURE__*/React.createElement("path", {
    d: "M88 105h-1v-1h1z",
    fill: "#c23439"
  })), _path5547 || (_path5547 = /*#__PURE__*/React.createElement("path", {
    d: "M89 104v1h-1v-1z",
    fill: "#ceb2ad"
  })), _path5548 || (_path5548 = /*#__PURE__*/React.createElement("path", {
    d: "M90 105h-1v-1h1z",
    fill: "#c8cac9"
  })), _path5549 || (_path5549 = /*#__PURE__*/React.createElement("path", {
    d: "M90 105v-1h1v1z",
    fill: "#cbc9c9"
  })), _path5550 || (_path5550 = /*#__PURE__*/React.createElement("path", {
    d: "M93 104h1v1h-1z",
    fill: "#d1a9aa"
  })), _path5551 || (_path5551 = /*#__PURE__*/React.createElement("path", {
    d: "M95 105h-1v-1h1z",
    fill: "#c26a6e"
  })), _path5552 || (_path5552 = /*#__PURE__*/React.createElement("path", {
    d: "M96 104v1h-1v-1z",
    fill: "#d89698"
  })), _path5553 || (_path5553 = /*#__PURE__*/React.createElement("path", {
    d: "M97 105h-1v-1h1z",
    fill: "#ddc1bd",
    fillOpacity: 0.506
  })), _path5554 || (_path5554 = /*#__PURE__*/React.createElement("path", {
    d: "M31 105h1v1h-1z",
    fill: "#d8b2a9",
    fillOpacity: 0.745
  })), _path5555 || (_path5555 = /*#__PURE__*/React.createElement("path", {
    d: "M32 106v-1h1v1z",
    fill: "#d48683"
  })), _path5556 || (_path5556 = /*#__PURE__*/React.createElement("path", {
    d: "M35 106h-1v-1h1z",
    fill: "#c4494c"
  })), _path5557 || (_path5557 = /*#__PURE__*/React.createElement("path", {
    d: "M36 106h-1v-1h1z",
    fill: "#c63e42"
  })), _path5558 || (_path5558 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106h-1v-1h1z",
    fill: "#c7363a"
  })), _path5559 || (_path5559 = /*#__PURE__*/React.createElement("path", {
    d: "M38 106h-1v-1h1z",
    fill: "#c53134"
  })), _path5560 || (_path5560 = /*#__PURE__*/React.createElement("path", {
    d: "M39 105v1h-1v-1z",
    fill: "#c32b2f"
  })), _path5561 || (_path5561 = /*#__PURE__*/React.createElement("path", {
    d: "M39 106v-1h1v1z",
    fill: "#c3232a"
  })), _path5562 || (_path5562 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106h-1v-1h1z",
    fill: "#c6212b"
  })), _path5563 || (_path5563 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105h1v1h-1z",
    fill: "#c01f22"
  })), _path5564 || (_path5564 = /*#__PURE__*/React.createElement("path", {
    d: "M53 106h-1v-1h1z",
    fill: "#c02023"
  })), _path5565 || (_path5565 = /*#__PURE__*/React.createElement("path", {
    d: "M54 105v1h-1v-1z",
    fill: "#bd1e22"
  })), _path5566 || (_path5566 = /*#__PURE__*/React.createElement("path", {
    d: "M54 106v-1h1v1z",
    fill: "#b54a57"
  })), _path5567 || (_path5567 = /*#__PURE__*/React.createElement("path", {
    d: "M56 106h-1v-1h1z",
    fill: "#ceb7c2"
  })), _path5568 || (_path5568 = /*#__PURE__*/React.createElement("path", {
    d: "M57 105v1h-1v-1z",
    fill: "#c3c4c4"
  })), _path5569 || (_path5569 = /*#__PURE__*/React.createElement("path", {
    d: "M59 106v-1h1v1z",
    fill: "#ceaba0"
  })), _path5570 || (_path5570 = /*#__PURE__*/React.createElement("path", {
    d: "M60 106v-1h1v1z",
    fill: "#b94b46"
  })), _path5571 || (_path5571 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105v1h-1v-1z",
    fill: "#c1151f"
  })), _path5572 || (_path5572 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105h1v1h-1z",
    fill: "#bc161e"
  })), _path5573 || (_path5573 = /*#__PURE__*/React.createElement("path", {
    d: "M64 105h1v1h-1z",
    fill: "#bb171d"
  })), _path5574 || (_path5574 = /*#__PURE__*/React.createElement("path", {
    d: "M67 105v1h-1v-1z",
    fill: "#c01b1e"
  })), _path5575 || (_path5575 = /*#__PURE__*/React.createElement("path", {
    d: "M67 105h1v1h-1z",
    fill: "#c11923"
  })), _path5576 || (_path5576 = /*#__PURE__*/React.createElement("path", {
    d: "M69 105v1h-1v-1z",
    fill: "#be2538"
  })), _path5577 || (_path5577 = /*#__PURE__*/React.createElement("path", {
    d: "M70 106h-1v-1h1z",
    fill: "#bd4457"
  })), _path5578 || (_path5578 = /*#__PURE__*/React.createElement("path", {
    d: "M70 105h1v1h-1z",
    fill: "#c76073"
  })), _path5579 || (_path5579 = /*#__PURE__*/React.createElement("path", {
    d: "M71 106v-1h1v1z",
    fill: "#c77383"
  })), _path5580 || (_path5580 = /*#__PURE__*/React.createElement("path", {
    d: "M72 105h1v1h-1z",
    fill: "#c66474"
  })), _path5581 || (_path5581 = /*#__PURE__*/React.createElement("path", {
    d: "M73 106v-1h1v1z",
    fill: "#bb3646"
  })), _path5582 || (_path5582 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105v1h-1v-1z",
    fill: "#bd1723"
  })), _path5583 || (_path5583 = /*#__PURE__*/React.createElement("path", {
    d: "M76 106h-1v-1h1z",
    fill: "#c31921"
  })), _path5584 || (_path5584 = /*#__PURE__*/React.createElement("path", {
    d: "M80 105v1h-1v-1z",
    fill: "#c02024"
  })), _path5585 || (_path5585 = /*#__PURE__*/React.createElement("path", {
    d: "M81 106h-1v-1h1z",
    fill: "#c89395"
  })), _path5586 || (_path5586 = /*#__PURE__*/React.createElement("path", {
    d: "M82 106h-1v-1h1z",
    fill: "#cca7a6"
  })), _path5587 || (_path5587 = /*#__PURE__*/React.createElement("path", {
    d: "M82 105h1v1h-1z",
    fill: "#c02931"
  })), _path5588 || (_path5588 = /*#__PURE__*/React.createElement("path", {
    d: "M83 106v-1h1v1z",
    fill: "#cc212b"
  })), _path5589 || (_path5589 = /*#__PURE__*/React.createElement("path", {
    d: "M88 105v1h-1v-1z",
    fill: "#c35456"
  })), _path5590 || (_path5590 = /*#__PURE__*/React.createElement("path", {
    d: "M88 106v-1h1v1z",
    fill: "#d1c5c3"
  })), _path5591 || (_path5591 = /*#__PURE__*/React.createElement("path", {
    d: "M91 106h-1v-1h1z",
    fill: "#cbc9c7"
  })), _path5592 || (_path5592 = /*#__PURE__*/React.createElement("path", {
    d: "M91 105h1v1h-1z",
    fill: "#cbcbca"
  })), _path5593 || (_path5593 = /*#__PURE__*/React.createElement("path", {
    d: "M92 105h1v1h-1z",
    fill: "#cfcfd2"
  })), _path5594 || (_path5594 = /*#__PURE__*/React.createElement("path", {
    d: "M94 106h-1v-1h1z",
    fill: "#cd9e9f"
  })), _path5595 || (_path5595 = /*#__PURE__*/React.createElement("path", {
    d: "M95 105v1h-1v-1z",
    fill: "#c3686c"
  })), _path5596 || (_path5596 = /*#__PURE__*/React.createElement("path", {
    d: "M96 106h-1v-1h1z",
    fill: "#d99598"
  })), _path5597 || (_path5597 = /*#__PURE__*/React.createElement("path", {
    d: "M97 105v1h-1v-1z",
    fill: "#dfbfbd",
    fillOpacity: 0.506
  })), _path5598 || (_path5598 = /*#__PURE__*/React.createElement("path", {
    d: "M33 107h-1v-1h1z",
    fill: "#d38582"
  })), _path5599 || (_path5599 = /*#__PURE__*/React.createElement("path", {
    d: "M34 106v1h-1v-1z",
    fill: "#c86162"
  })), _path5600 || (_path5600 = /*#__PURE__*/React.createElement("path", {
    d: "M35 107h-1v-1h1z",
    fill: "#c3484c"
  })), _path5601 || (_path5601 = /*#__PURE__*/React.createElement("path", {
    d: "M35 106h1v1h-1z",
    fill: "#c53e42"
  })), _path5602 || (_path5602 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106h1v1h-1z",
    fill: "#c42e36"
  })), _path5603 || (_path5603 = /*#__PURE__*/React.createElement("path", {
    d: "M39 107h-1v-1h1z",
    fill: "#c43c41"
  })), _path5604 || (_path5604 = /*#__PURE__*/React.createElement("path", {
    d: "M40 107h-1v-1h1z",
    fill: "#c95250"
  })), _path5605 || (_path5605 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106v1h-1v-1z",
    fill: "#c03232"
  })), _path5606 || (_path5606 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106h1v1h-1z",
    fill: "#c13939"
  })), _path5607 || (_path5607 = /*#__PURE__*/React.createElement("path", {
    d: "M43 106v1h-1v-1z",
    fill: "#bf2a2b"
  })), _path5608 || (_path5608 = /*#__PURE__*/React.createElement("path", {
    d: "M44 106v1h-1v-1z",
    fill: "#bf2126"
  })), _path5609 || (_path5609 = /*#__PURE__*/React.createElement("path", {
    d: "M45 107h-1v-1h1z",
    fill: "#bf2025"
  })), _path5610 || (_path5610 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h1v1h-1z",
    fill: "#c01f21"
  })), _path5611 || (_path5611 = /*#__PURE__*/React.createElement("path", {
    d: "M51 106v1h-1v-1z",
    fill: "#c02022"
  })), _path5612 || (_path5612 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107v-1h1v1z",
    fill: "#bc1924"
  })), _path5613 || (_path5613 = /*#__PURE__*/React.createElement("path", {
    d: "M55 107v-1h1v1z",
    fill: "#bf636e"
  })), _path5614 || (_path5614 = /*#__PURE__*/React.createElement("path", {
    d: "M57 107h-1v-1h1z",
    fill: "#ccc1c6"
  })), _path5615 || (_path5615 = /*#__PURE__*/React.createElement("path", {
    d: "M58 106v1h-1v-1z",
    fill: "#c7c3c2"
  })), _path5616 || (_path5616 = /*#__PURE__*/React.createElement("path", {
    d: "M60 106v1h-1v-1z",
    fill: "#c7c6c1"
  })), _path5617 || (_path5617 = /*#__PURE__*/React.createElement("path", {
    d: "M60 107v-1h1v1z",
    fill: "#ceb9b0"
  })), _path5618 || (_path5618 = /*#__PURE__*/React.createElement("path", {
    d: "M61 106h1v1h-1z",
    fill: "#be6861"
  })), _path5619 || (_path5619 = /*#__PURE__*/React.createElement("path", {
    d: "M62 106h1v1h-1z",
    fill: "#ae1f1d"
  })), _path5620 || (_path5620 = /*#__PURE__*/React.createElement("path", {
    d: "M65 106v1h-1v-1z",
    fill: "#ba171e"
  })), _path5621 || (_path5621 = /*#__PURE__*/React.createElement("path", {
    d: "M70 107v-1h1v1z",
    fill: "#c31a27"
  })), _path5622 || (_path5622 = /*#__PURE__*/React.createElement("path", {
    d: "M71 106h1v1h-1z",
    fill: "#c21a29"
  })), _path5623 || (_path5623 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107h-1v-1h1z",
    fill: "#c01820"
  })), _path5624 || (_path5624 = /*#__PURE__*/React.createElement("path", {
    d: "M75 107v-1h1v1z",
    fill: "#bf1d20"
  })), _path5625 || (_path5625 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107h-1v-1h1z",
    fill: "#c51e24"
  })), _path5626 || (_path5626 = /*#__PURE__*/React.createElement("path", {
    d: "M79 106h1v1h-1z",
    fill: "#bc2427"
  })), _path5627 || (_path5627 = /*#__PURE__*/React.createElement("path", {
    d: "M80 106h1v1h-1z",
    fill: "#c79d9e"
  })), _path5628 || (_path5628 = /*#__PURE__*/React.createElement("path", {
    d: "M82 106v1h-1v-1z",
    fill: "#ceb1b0"
  })), _path5629 || (_path5629 = /*#__PURE__*/React.createElement("path", {
    d: "M82 107v-1h1v1z",
    fill: "#bf2f38"
  })), _path5630 || (_path5630 = /*#__PURE__*/React.createElement("path", {
    d: "M83 106h1v1h-1z",
    fill: "#cc202a"
  })), _path5631 || (_path5631 = /*#__PURE__*/React.createElement("path", {
    d: "M87 107v-1h1v1z",
    fill: "#c9817c"
  })), _path5632 || (_path5632 = /*#__PURE__*/React.createElement("path", {
    d: "M89 106v1h-1v-1z",
    fill: "#cbcccb"
  })), _path5633 || (_path5633 = /*#__PURE__*/React.createElement("path", {
    d: "M90 106v1h-1v-1z",
    fill: "#c8cac6"
  })), _path5634 || (_path5634 = /*#__PURE__*/React.createElement("path", {
    d: "M92 107h-1v-1h1z",
    fill: "#cbcacb"
  })), _path5635 || (_path5635 = /*#__PURE__*/React.createElement("path", {
    d: "M92 107v-1h1v1z",
    fill: "#d0cfd2"
  })), _path5636 || (_path5636 = /*#__PURE__*/React.createElement("path", {
    d: "M93 107v-1h1v1z",
    fill: "#c79394"
  })), _path5637 || (_path5637 = /*#__PURE__*/React.createElement("path", {
    d: "M95 107h-1v-1h1z",
    fill: "#c4676a"
  })), _path5638 || (_path5638 = /*#__PURE__*/React.createElement("path", {
    d: "M95 106h1v1h-1z",
    fill: "#d69698"
  })), _path5639 || (_path5639 = /*#__PURE__*/React.createElement("path", {
    d: "M97 106v1h-1v-1z",
    fill: "#dfbfbf",
    fillOpacity: 0.506
  })), _path5640 || (_path5640 = /*#__PURE__*/React.createElement("path", {
    d: "M31 107h1v1h-1z",
    fill: "#d9b1a8",
    fillOpacity: 0.737
  })), _path5641 || (_path5641 = /*#__PURE__*/React.createElement("path", {
    d: "M33 108h-1v-1h1z",
    fill: "#d28582"
  })), _path5642 || (_path5642 = /*#__PURE__*/React.createElement("path", {
    d: "M34 108h-1v-1h1z",
    fill: "#c75f62"
  })), _path5643 || (_path5643 = /*#__PURE__*/React.createElement("path", {
    d: "M35 107v1h-1v-1z",
    fill: "#c2484d"
  })), _path5644 || (_path5644 = /*#__PURE__*/React.createElement("path", {
    d: "M35 108v-1h1v1z",
    fill: "#c43e42"
  })), _path5645 || (_path5645 = /*#__PURE__*/React.createElement("path", {
    d: "M37 108h-1v-1h1z",
    fill: "#c43538"
  })), _path5646 || (_path5646 = /*#__PURE__*/React.createElement("path", {
    d: "M38 107v1h-1v-1z",
    fill: "#c22b31"
  })), _path5647 || (_path5647 = /*#__PURE__*/React.createElement("path", {
    d: "M38 108v-1h1v1z",
    fill: "#c84b54"
  })), _path5648 || (_path5648 = /*#__PURE__*/React.createElement("path", {
    d: "M39 108v-1h1v1z",
    fill: "#d07e81"
  })), _path5649 || (_path5649 = /*#__PURE__*/React.createElement("path", {
    d: "M40 108v-1h1v1z",
    fill: "#c45d60"
  })), _path5650 || (_path5650 = /*#__PURE__*/React.createElement("path", {
    d: "M42 108h-1v-1h1z",
    fill: "#cd7b7b"
  })), _path5651 || (_path5651 = /*#__PURE__*/React.createElement("path", {
    d: "M42 107h1v1h-1z",
    fill: "#cc5253"
  })), _path5652 || (_path5652 = /*#__PURE__*/React.createElement("path", {
    d: "M43 107h1v1h-1z",
    fill: "#bb353a"
  })), _path5653 || (_path5653 = /*#__PURE__*/React.createElement("path", {
    d: "M45 107v1h-1v-1z",
    fill: "#d2706d"
  })), _path5654 || (_path5654 = /*#__PURE__*/React.createElement("path", {
    d: "M46 108h-1v-1h1z",
    fill: "#cc6b6a"
  })), _path5655 || (_path5655 = /*#__PURE__*/React.createElement("path", {
    d: "M47 107v1h-1v-1z",
    fill: "#c74041"
  })), _path5656 || (_path5656 = /*#__PURE__*/React.createElement("path", {
    d: "M47 108v-1h1v1z",
    fill: "#c31a23"
  })), _path5657 || (_path5657 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107h1v1h-1z",
    fill: "#c61d25"
  })), _path5658 || (_path5658 = /*#__PURE__*/React.createElement("path", {
    d: "M56 108h-1v-1h1z",
    fill: "#b8202d"
  })), _path5659 || (_path5659 = /*#__PURE__*/React.createElement("path", {
    d: "M56 108v-1h1v1z",
    fill: "#c3737f"
  })), _path5660 || (_path5660 = /*#__PURE__*/React.createElement("path", {
    d: "M57 108v-1h1v1z",
    fill: "#cdc2c5"
  })), _path5661 || (_path5661 = /*#__PURE__*/React.createElement("path", {
    d: "M62 107v1h-1v-1z",
    fill: "#cdc2bb"
  })), _path5662 || (_path5662 = /*#__PURE__*/React.createElement("path", {
    d: "M62 107h1v1h-1z",
    fill: "#c49287"
  })), _path5663 || (_path5663 = /*#__PURE__*/React.createElement("path", {
    d: "M64 107v1h-1v-1z",
    fill: "#b03835"
  })), _path5664 || (_path5664 = /*#__PURE__*/React.createElement("path", {
    d: "M64 108v-1h1v1z",
    fill: "#b51219"
  })), _path5665 || (_path5665 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107v1h-1v-1z",
    fill: "#c31d1f"
  })), _path5666 || (_path5666 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107h1v1h-1z",
    fill: "#bb2d31"
  })), _path5667 || (_path5667 = /*#__PURE__*/React.createElement("path", {
    d: "M81 107v1h-1v-1z",
    fill: "#c7b0af"
  })), _path5668 || (_path5668 = /*#__PURE__*/React.createElement("path", {
    d: "M81 107h1v1h-1z",
    fill: "#ceb6b6"
  })), _path5669 || (_path5669 = /*#__PURE__*/React.createElement("path", {
    d: "M83 107v1h-1v-1z",
    fill: "#c1343d"
  })), _path5670 || (_path5670 = /*#__PURE__*/React.createElement("path", {
    d: "M83 108v-1h1v1z",
    fill: "#cb2129"
  })), _path5671 || (_path5671 = /*#__PURE__*/React.createElement("path", {
    d: "M86 107h1v1h-1z",
    fill: "#bd3030"
  })), _path5672 || (_path5672 = /*#__PURE__*/React.createElement("path", {
    d: "M88 107v1h-1v-1z",
    fill: "#cfaaa2"
  })), _path5673 || (_path5673 = /*#__PURE__*/React.createElement("path", {
    d: "M89 108h-1v-1h1z",
    fill: "#c6cbca"
  })), _path5674 || (_path5674 = /*#__PURE__*/React.createElement("path", {
    d: "M90 108h-1v-1h1z",
    fill: "#c6c9c7"
  })), _path5675 || (_path5675 = /*#__PURE__*/React.createElement("path", {
    d: "M90 108v-1h1v1z",
    fill: "#c9c9c8"
  })), _path5676 || (_path5676 = /*#__PURE__*/React.createElement("path", {
    d: "M91 107h1v1h-1z",
    fill: "#cbcacc"
  })), _path5677 || (_path5677 = /*#__PURE__*/React.createElement("path", {
    d: "M93 108h-1v-1h1z",
    fill: "#d0cece"
  })), _path5678 || (_path5678 = /*#__PURE__*/React.createElement("path", {
    d: "M93 107h1v1h-1z",
    fill: "#c48889"
  })), _path5679 || (_path5679 = /*#__PURE__*/React.createElement("path", {
    d: "M94 107h1v1h-1z",
    fill: "#c2686a"
  })), _path5680 || (_path5680 = /*#__PURE__*/React.createElement("path", {
    d: "M95 108v-1h1v1z",
    fill: "#dea9a8"
  })), _path5681 || (_path5681 = /*#__PURE__*/React.createElement("path", {
    d: "M96 107h1v1h-1z",
    fill: "#e2c6c6",
    fillOpacity: 0.494
  })), _path5682 || (_path5682 = /*#__PURE__*/React.createElement("path", {
    d: "M32 108h1v1h-1z",
    fill: "#d18380"
  })), _path5683 || (_path5683 = /*#__PURE__*/React.createElement("path", {
    d: "M33 108h1v1h-1z",
    fill: "#c55d60"
  })), _path5684 || (_path5684 = /*#__PURE__*/React.createElement("path", {
    d: "M35 108h1v1h-1z",
    fill: "#c43e40"
  })), _path5685 || (_path5685 = /*#__PURE__*/React.createElement("path", {
    d: "M37 108v1h-1v-1z",
    fill: "#c43436"
  })), _path5686 || (_path5686 = /*#__PURE__*/React.createElement("path", {
    d: "M38 109h-1v-1h1z",
    fill: "#c22a30"
  })), _path5687 || (_path5687 = /*#__PURE__*/React.createElement("path", {
    d: "M39 108v1h-1v-1z",
    fill: "#c2434e"
  })), _path5688 || (_path5688 = /*#__PURE__*/React.createElement("path", {
    d: "M39 109v-1h1v1z",
    fill: "#c6676d"
  })), _path5689 || (_path5689 = /*#__PURE__*/React.createElement("path", {
    d: "M41 108v1h-1v-1z",
    fill: "#bc4d51"
  })), _path5690 || (_path5690 = /*#__PURE__*/React.createElement("path", {
    d: "M41 109v-1h1v1z",
    fill: "#cf8287"
  })), _path5691 || (_path5691 = /*#__PURE__*/React.createElement("path", {
    d: "M42 109v-1h1v1z",
    fill: "#c85758"
  })), _path5692 || (_path5692 = /*#__PURE__*/React.createElement("path", {
    d: "M44 108v1h-1v-1z",
    fill: "#c14a52"
  })), _path5693 || (_path5693 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109v-1h1v1z",
    fill: "#c6727a"
  })), _path5694 || (_path5694 = /*#__PURE__*/React.createElement("path", {
    d: "M46 108v1h-1v-1z",
    fill: "#c16e71"
  })), _path5695 || (_path5695 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109v-1h1v1z",
    fill: "#c83f42"
  })), _path5696 || (_path5696 = /*#__PURE__*/React.createElement("path", {
    d: "M55 109h-1v-1h1z",
    fill: "#c21f22"
  })), _path5697 || (_path5697 = /*#__PURE__*/React.createElement("path", {
    d: "M57 109h-1v-1h1z",
    fill: "#bf212f"
  })), _path5698 || (_path5698 = /*#__PURE__*/React.createElement("path", {
    d: "M57 108h1v1h-1z",
    fill: "#c87484"
  })), _path5699 || (_path5699 = /*#__PURE__*/React.createElement("path", {
    d: "M58 109v-1h1v1z",
    fill: "#cfc1c6"
  })), _path5700 || (_path5700 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109v-1h1v1z",
    fill: "#bec7c2"
  })), _path5701 || (_path5701 = /*#__PURE__*/React.createElement("path", {
    d: "M63 109v-1h1v1z",
    fill: "#c8b5aa"
  })), _path5702 || (_path5702 = /*#__PURE__*/React.createElement("path", {
    d: "M64 108h1v1h-1z",
    fill: "#bb6c67"
  })), _path5703 || (_path5703 = /*#__PURE__*/React.createElement("path", {
    d: "M65 108h1v1h-1z",
    fill: "#b32628"
  })), _path5704 || (_path5704 = /*#__PURE__*/React.createElement("path", {
    d: "M66 108h1v1h-1z",
    fill: "#b8181c"
  })), _path5705 || (_path5705 = /*#__PURE__*/React.createElement("path", {
    d: "M78 108h1v1h-1z",
    fill: "#c1191b"
  })), _path5706 || (_path5706 = /*#__PURE__*/React.createElement("path", {
    d: "M80 108v1h-1v-1z",
    fill: "#b94a4d"
  })), _path5707 || (_path5707 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109h-1v-1h1z",
    fill: "#cac2c1"
  })), _path5708 || (_path5708 = /*#__PURE__*/React.createElement("path", {
    d: "M81 108h1v1h-1z",
    fill: "#cab3b4"
  })), _path5709 || (_path5709 = /*#__PURE__*/React.createElement("path", {
    d: "M82 109v-1h1v1z",
    fill: "#c0323c"
  })), _path5710 || (_path5710 = /*#__PURE__*/React.createElement("path", {
    d: "M85 108v1h-1v-1z",
    fill: "#ca232b"
  })), _path5711 || (_path5711 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109h-1v-1h1z",
    fill: "#bd504d"
  })), _path5712 || (_path5712 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109v-1h1v1z",
    fill: "#cec4bb"
  })), _path5713 || (_path5713 = /*#__PURE__*/React.createElement("path", {
    d: "M89 109h-1v-1h1z",
    fill: "#c8c7c8"
  })), _path5714 || (_path5714 = /*#__PURE__*/React.createElement("path", {
    d: "M89 108h1v1h-1z",
    fill: "#c5c9c8"
  })), _path5715 || (_path5715 = /*#__PURE__*/React.createElement("path", {
    d: "M90 108h1v1h-1z",
    fill: "#c9c8c9"
  })), _path5716 || (_path5716 = /*#__PURE__*/React.createElement("path", {
    d: "M92 109h-1v-1h1z",
    fill: "#c9cacb"
  })), _path5717 || (_path5717 = /*#__PURE__*/React.createElement("path", {
    d: "M92 109v-1h1v1z",
    fill: "#d1cbcc"
  })), _path5718 || (_path5718 = /*#__PURE__*/React.createElement("path", {
    d: "M94 108v1h-1v-1z",
    fill: "#c17a7d"
  })), _path5719 || (_path5719 = /*#__PURE__*/React.createElement("path", {
    d: "M94 109v-1h1v1z",
    fill: "#c26f70"
  })), _path5720 || (_path5720 = /*#__PURE__*/React.createElement("path", {
    d: "M95 109v-1h1v1z",
    fill: "#deb6b3"
  })), _path5721 || (_path5721 = /*#__PURE__*/React.createElement("path", {
    d: "M96 108h1v1h-1z",
    fill: "#e0cccc",
    fillOpacity: 0.494
  })), _path5722 || (_path5722 = /*#__PURE__*/React.createElement("path", {
    d: "M32 109v1h-1v-1z",
    fill: "#dab3aa",
    fillOpacity: 0.757
  })), _path5723 || (_path5723 = /*#__PURE__*/React.createElement("path", {
    d: "M33 109v1h-1v-1z",
    fill: "#d0827f"
  })), _path5724 || (_path5724 = /*#__PURE__*/React.createElement("path", {
    d: "M33 110v-1h1v1z",
    fill: "#c55d5f"
  })), _path5725 || (_path5725 = /*#__PURE__*/React.createElement("path", {
    d: "M34 110v-1h1v1z",
    fill: "#c2484b"
  })), _path5726 || (_path5726 = /*#__PURE__*/React.createElement("path", {
    d: "M36 110h-1v-1h1z",
    fill: "#c23d3e"
  })), _path5727 || (_path5727 = /*#__PURE__*/React.createElement("path", {
    d: "M37 109h1v1h-1z",
    fill: "#c32a30"
  })), _path5728 || (_path5728 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110h-1v-1h1z",
    fill: "#c43f4c"
  })), _path5729 || (_path5729 = /*#__PURE__*/React.createElement("path", {
    d: "M39 109h1v1h-1z",
    fill: "#db8c8c"
  })), _path5730 || (_path5730 = /*#__PURE__*/React.createElement("path", {
    d: "M41 109v1h-1v-1z",
    fill: "#c25252"
  })), _path5731 || (_path5731 = /*#__PURE__*/React.createElement("path", {
    d: "M42 109v1h-1v-1z",
    fill: "#c7676b"
  })), _path5732 || (_path5732 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110h-1v-1h1z",
    fill: "#cd6264"
  })), _path5733 || (_path5733 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109v1h-1v-1z",
    fill: "#c34c59"
  })), _path5734 || (_path5734 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109h1v1h-1z",
    fill: "#c67680"
  })), _path5735 || (_path5735 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109v1h-1v-1z",
    fill: "#cb797a"
  })), _path5736 || (_path5736 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110v-1h1v1z",
    fill: "#c51c20"
  })), _path5737 || (_path5737 = /*#__PURE__*/React.createElement("path", {
    d: "M48 109h1v1h-1z",
    fill: "#c61c25"
  })), _path5738 || (_path5738 = /*#__PURE__*/React.createElement("path", {
    d: "M54 109h1v1h-1z",
    fill: "#c11f23"
  })), _path5739 || (_path5739 = /*#__PURE__*/React.createElement("path", {
    d: "M55 109h1v1h-1z",
    fill: "#c32124"
  })), _path5740 || (_path5740 = /*#__PURE__*/React.createElement("path", {
    d: "M56 109h1v1h-1z",
    fill: "#c61e25"
  })), _path5741 || (_path5741 = /*#__PURE__*/React.createElement("path", {
    d: "M57 110v-1h1v1z",
    fill: "#be2030"
  })), _path5742 || (_path5742 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109v1h-1v-1z",
    fill: "#c5747e"
  })), _path5743 || (_path5743 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109h1v1h-1z",
    fill: "#d1bec2"
  })), _path5744 || (_path5744 = /*#__PURE__*/React.createElement("path", {
    d: "M60 109h1v1h-1z",
    fill: "#c5c3c1"
  })), _path5745 || (_path5745 = /*#__PURE__*/React.createElement("path", {
    d: "M62 109h1v1h-1z",
    fill: "#c5c0bb"
  })), _path5746 || (_path5746 = /*#__PURE__*/React.createElement("path", {
    d: "M65 109h1v1h-1z",
    fill: "#c9a79e"
  })), _path5747 || (_path5747 = /*#__PURE__*/React.createElement("path", {
    d: "M66 109h1v1h-1z",
    fill: "#b96760"
  })), _path5748 || (_path5748 = /*#__PURE__*/React.createElement("path", {
    d: "M69 109v1h-1v-1z",
    fill: "#c0191f"
  })), _path5749 || (_path5749 = /*#__PURE__*/React.createElement("path", {
    d: "M69 109h1v1h-1z",
    fill: "#c51b22"
  })), _path5750 || (_path5750 = /*#__PURE__*/React.createElement("path", {
    d: "M77 109h1v1h-1z",
    fill: "#c21a1f"
  })), _path5751 || (_path5751 = /*#__PURE__*/React.createElement("path", {
    d: "M79 109v1h-1v-1z",
    fill: "#b22224"
  })), _path5752 || (_path5752 = /*#__PURE__*/React.createElement("path", {
    d: "M79 109h1v1h-1z",
    fill: "#c49190"
  })), _path5753 || (_path5753 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109v1h-1v-1z",
    fill: "#c9c9c9"
  })), _path5754 || (_path5754 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109h1v1h-1z",
    fill: "#cba7aa"
  })), _path5755 || (_path5755 = /*#__PURE__*/React.createElement("path", {
    d: "M83 110h-1v-1h1z",
    fill: "#c12b37"
  })), _path5756 || (_path5756 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109v1h-1v-1z",
    fill: "#c5817b"
  })), _path5757 || (_path5757 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109h1v1h-1z",
    fill: "#cacbc8"
  })), _path5758 || (_path5758 = /*#__PURE__*/React.createElement("path", {
    d: "M89 109v1h-1v-1z",
    fill: "#c9c7c5"
  })), _path5759 || (_path5759 = /*#__PURE__*/React.createElement("path", {
    d: "M89 110v-1h1v1z",
    fill: "#c8c8c7"
  })), _path5760 || (_path5760 = /*#__PURE__*/React.createElement("path", {
    d: "M90 110v-1h1v1z",
    fill: "#cac8c9"
  })), _path5761 || (_path5761 = /*#__PURE__*/React.createElement("path", {
    d: "M93 109v1h-1v-1z",
    fill: "#d1c6c7"
  })), _path5762 || (_path5762 = /*#__PURE__*/React.createElement("path", {
    d: "M93 109h1v1h-1z",
    fill: "#be6c71"
  })), _path5763 || (_path5763 = /*#__PURE__*/React.createElement("path", {
    d: "M95 110h-1v-1h1z",
    fill: "#c67475"
  })), _path5764 || (_path5764 = /*#__PURE__*/React.createElement("path", {
    d: "M95 110v-1h1v1z",
    fill: "#d8b8b4"
  })), _path5765 || (_path5765 = /*#__PURE__*/React.createElement("path", {
    d: "M97 110h-1v-1h1z",
    fill: "#e0d1cf",
    fillOpacity: 0.486
  })), _path5766 || (_path5766 = /*#__PURE__*/React.createElement("path", {
    d: "M32 111h-1v-1h1z",
    fill: "#d8b2aa",
    fillOpacity: 0.761
  })), _path5767 || (_path5767 = /*#__PURE__*/React.createElement("path", {
    d: "M33 110v1h-1v-1z",
    fill: "#ce827e"
  })), _path5768 || (_path5768 = /*#__PURE__*/React.createElement("path", {
    d: "M34 111h-1v-1h1z",
    fill: "#c55d5e"
  })), _path5769 || (_path5769 = /*#__PURE__*/React.createElement("path", {
    d: "M34 110h1v1h-1z",
    fill: "#c1474a"
  })), _path5770 || (_path5770 = /*#__PURE__*/React.createElement("path", {
    d: "M37 110h1v1h-1z",
    fill: "#c42c2f"
  })), _path5771 || (_path5771 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110v1h-1v-1z",
    fill: "#bd2d39"
  })), _path5772 || (_path5772 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110h1v1h-1z",
    fill: "#be3a49"
  })), _path5773 || (_path5773 = /*#__PURE__*/React.createElement("path", {
    d: "M41 111h-1v-1h1z",
    fill: "#be333c"
  })), _path5774 || (_path5774 = /*#__PURE__*/React.createElement("path", {
    d: "M41 111v-1h1v1z",
    fill: "#bd3039"
  })), _path5775 || (_path5775 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110v1h-1v-1z",
    fill: "#c95054"
  })), _path5776 || (_path5776 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110h1v1h-1z",
    fill: "#bd3748"
  })), _path5777 || (_path5777 = /*#__PURE__*/React.createElement("path", {
    d: "M45 110v1h-1v-1z",
    fill: "#cf626d"
  })), _path5778 || (_path5778 = /*#__PURE__*/React.createElement("path", {
    d: "M46 111h-1v-1h1z",
    fill: "#d37581"
  })), _path5779 || (_path5779 = /*#__PURE__*/React.createElement("path", {
    d: "M47 111h-1v-1h1z",
    fill: "#c3373f"
  })), _path5780 || (_path5780 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110h1v1h-1z",
    fill: "#c31b20"
  })), _path5781 || (_path5781 = /*#__PURE__*/React.createElement("path", {
    d: "M49 111h-1v-1h1z",
    fill: "#c11f22"
  })), _path5782 || (_path5782 = /*#__PURE__*/React.createElement("path", {
    d: "M54 111v-1h1v1z",
    fill: "#c31d25"
  })), _path5783 || (_path5783 = /*#__PURE__*/React.createElement("path", {
    d: "M56 111v-1h1v1z",
    fill: "#c42126"
  })), _path5784 || (_path5784 = /*#__PURE__*/React.createElement("path", {
    d: "M59 111h-1v-1h1z",
    fill: "#bd212f"
  })), _path5785 || (_path5785 = /*#__PURE__*/React.createElement("path", {
    d: "M59 111v-1h1v1z",
    fill: "#c16273"
  })), _path5786 || (_path5786 = /*#__PURE__*/React.createElement("path", {
    d: "M60 110h1v1h-1z",
    fill: "#cfb6bc"
  })), _path5787 || (_path5787 = /*#__PURE__*/React.createElement("path", {
    d: "M66 111v-1h1v1z",
    fill: "#c8c5be"
  })), _path5788 || (_path5788 = /*#__PURE__*/React.createElement("path", {
    d: "M68 110v1h-1v-1z",
    fill: "#ccada1"
  })), _path5789 || (_path5789 = /*#__PURE__*/React.createElement("path", {
    d: "M69 111h-1v-1h1z",
    fill: "#c4776d"
  })), _path5790 || (_path5790 = /*#__PURE__*/React.createElement("path", {
    d: "M70 110v1h-1v-1z",
    fill: "#be4440"
  })), _path5791 || (_path5791 = /*#__PURE__*/React.createElement("path", {
    d: "M71 110v1h-1v-1z",
    fill: "#bb2826"
  })), _path5792 || (_path5792 = /*#__PURE__*/React.createElement("path", {
    d: "M71 111v-1h1v1z",
    fill: "#bd1d1d"
  })), _path5793 || (_path5793 = /*#__PURE__*/React.createElement("path", {
    d: "M72 110h1v1h-1z",
    fill: "#c1181c"
  })), _path5794 || (_path5794 = /*#__PURE__*/React.createElement("path", {
    d: "M74 111h-1v-1h1z",
    fill: "#c0171f"
  })), _path5795 || (_path5795 = /*#__PURE__*/React.createElement("path", {
    d: "M74 111v-1h1v1z",
    fill: "#bf181d"
  })), _path5796 || (_path5796 = /*#__PURE__*/React.createElement("path", {
    d: "M76 110h1v1h-1z",
    fill: "#ba1719"
  })), _path5797 || (_path5797 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111h-1v-1h1z",
    fill: "#b32525"
  })), _path5798 || (_path5798 = /*#__PURE__*/React.createElement("path", {
    d: "M79 111h-1v-1h1z",
    fill: "#c37876"
  })), _path5799 || (_path5799 = /*#__PURE__*/React.createElement("path", {
    d: "M80 110v1h-1v-1z",
    fill: "#ccc2c1"
  })), _path5800 || (_path5800 = /*#__PURE__*/React.createElement("path", {
    d: "M80 111v-1h1v1z",
    fill: "#c4cac8"
  })), _path5801 || (_path5801 = /*#__PURE__*/React.createElement("path", {
    d: "M82 111h-1v-1h1z",
    fill: "#cf9198"
  })), _path5802 || (_path5802 = /*#__PURE__*/React.createElement("path", {
    d: "M82 110h1v1h-1z",
    fill: "#c42330"
  })), _path5803 || (_path5803 = /*#__PURE__*/React.createElement("path", {
    d: "M86 111h-1v-1h1z",
    fill: "#b83233"
  })), _path5804 || (_path5804 = /*#__PURE__*/React.createElement("path", {
    d: "M86 110h1v1h-1z",
    fill: "#cbaea9"
  })), _path5805 || (_path5805 = /*#__PURE__*/React.createElement("path", {
    d: "M88 110v1h-1v-1z",
    fill: "#c6cac9"
  })), _path5806 || (_path5806 = /*#__PURE__*/React.createElement("path", {
    d: "M90 110v1h-1v-1z",
    fill: "#c6c8c5"
  })), _path5807 || (_path5807 = /*#__PURE__*/React.createElement("path", {
    d: "M93 111h-1v-1h1z",
    fill: "#cfbfbf"
  })), _path5808 || (_path5808 = /*#__PURE__*/React.createElement("path", {
    d: "M93 110h1v1h-1z",
    fill: "#bb5f64"
  })), _path5809 || (_path5809 = /*#__PURE__*/React.createElement("path", {
    d: "M94 110h1v1h-1z",
    fill: "#c77476"
  })), _path5810 || (_path5810 = /*#__PURE__*/React.createElement("path", {
    d: "M96 111h-1v-1h1z",
    fill: "#d9bab8"
  })), _path5811 || (_path5811 = /*#__PURE__*/React.createElement("path", {
    d: "M97 110v1h-1v-1z",
    fill: "#e1d2d2",
    fillOpacity: 0.471
  })), _path5812 || (_path5812 = /*#__PURE__*/React.createElement("path", {
    d: "M32 111v1h-1v-1z",
    fill: "#d5b2aa",
    fillOpacity: 0.749
  })), _path5813 || (_path5813 = /*#__PURE__*/React.createElement("path", {
    d: "M33 111v1h-1v-1z",
    fill: "#cd847d"
  })), _path5814 || (_path5814 = /*#__PURE__*/React.createElement("path", {
    d: "M34 111v1h-1v-1z",
    fill: "#c45e5e"
  })), _path5815 || (_path5815 = /*#__PURE__*/React.createElement("path", {
    d: "M36 111v1h-1v-1z",
    fill: "#c23c40"
  })), _path5816 || (_path5816 = /*#__PURE__*/React.createElement("path", {
    d: "M37 112h-1v-1h1z",
    fill: "#c03538"
  })), _path5817 || (_path5817 = /*#__PURE__*/React.createElement("path", {
    d: "M37 111h1v1h-1z",
    fill: "#bd2d32"
  })), _path5818 || (_path5818 = /*#__PURE__*/React.createElement("path", {
    d: "M39 112h-1v-1h1z",
    fill: "#c85458"
  })), _path5819 || (_path5819 = /*#__PURE__*/React.createElement("path", {
    d: "M40 112h-1v-1h1z",
    fill: "#ce7571"
  })), _path5820 || (_path5820 = /*#__PURE__*/React.createElement("path", {
    d: "M40 111h1v1h-1z",
    fill: "#c7605c"
  })), _path5821 || (_path5821 = /*#__PURE__*/React.createElement("path", {
    d: "M42 112h-1v-1h1z",
    fill: "#ca4d4e"
  })), _path5822 || (_path5822 = /*#__PURE__*/React.createElement("path", {
    d: "M44 111v1h-1v-1z",
    fill: "#bb1c23"
  })), _path5823 || (_path5823 = /*#__PURE__*/React.createElement("path", {
    d: "M44 112v-1h1v1z",
    fill: "#b91e22"
  })), _path5824 || (_path5824 = /*#__PURE__*/React.createElement("path", {
    d: "M45 112v-1h1v1z",
    fill: "#bc2633"
  })), _path5825 || (_path5825 = /*#__PURE__*/React.createElement("path", {
    d: "M46 111h1v1h-1z",
    fill: "#bd232c"
  })), _path5826 || (_path5826 = /*#__PURE__*/React.createElement("path", {
    d: "M48 111h1v1h-1z",
    fill: "#c11e21"
  })), _path5827 || (_path5827 = /*#__PURE__*/React.createElement("path", {
    d: "M58 112h-1v-1h1z",
    fill: "#c82127"
  })), _path5828 || (_path5828 = /*#__PURE__*/React.createElement("path", {
    d: "M59 111v1h-1v-1z",
    fill: "#c52225"
  })), _path5829 || (_path5829 = /*#__PURE__*/React.createElement("path", {
    d: "M60 111v1h-1v-1z",
    fill: "#bc1c28"
  })), _path5830 || (_path5830 = /*#__PURE__*/React.createElement("path", {
    d: "M61 111v1h-1v-1z",
    fill: "#b94c5c"
  })), _path5831 || (_path5831 = /*#__PURE__*/React.createElement("path", {
    d: "M61 111h1v1h-1z",
    fill: "#cba6b1"
  })), _path5832 || (_path5832 = /*#__PURE__*/React.createElement("path", {
    d: "M63 111v1h-1v-1z",
    fill: "#c7c5c7"
  })), _path5833 || (_path5833 = /*#__PURE__*/React.createElement("path", {
    d: "M63 112v-1h1v1z",
    fill: "#bec2bd"
  })), _path5834 || (_path5834 = /*#__PURE__*/React.createElement("path", {
    d: "M65 111v1h-1v-1z",
    fill: "#c2bfbc"
  })), _path5835 || (_path5835 = /*#__PURE__*/React.createElement("path", {
    d: "M66 111h1v1h-1z",
    fill: "#c0c1bf"
  })), _path5836 || (_path5836 = /*#__PURE__*/React.createElement("path", {
    d: "M68 111h1v1h-1z",
    fill: "#c6c8bf"
  })), _path5837 || (_path5837 = /*#__PURE__*/React.createElement("path", {
    d: "M70 112h-1v-1h1z",
    fill: "#cbc0b5"
  })), _path5838 || (_path5838 = /*#__PURE__*/React.createElement("path", {
    d: "M71 112h-1v-1h1z",
    fill: "#caa79c"
  })), _path5839 || (_path5839 = /*#__PURE__*/React.createElement("path", {
    d: "M71 111h1v1h-1z",
    fill: "#c78176"
  })), _path5840 || (_path5840 = /*#__PURE__*/React.createElement("path", {
    d: "M73 111v1h-1v-1z",
    fill: "#c05e52"
  })), _path5841 || (_path5841 = /*#__PURE__*/React.createElement("path", {
    d: "M73 111h1v1h-1z",
    fill: "#b7493f"
  })), _path5842 || (_path5842 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112v-1h1v1z",
    fill: "#b34139"
  })), _path5843 || (_path5843 = /*#__PURE__*/React.createElement("path", {
    d: "M76 111v1h-1v-1z",
    fill: "#b8463f"
  })), _path5844 || (_path5844 = /*#__PURE__*/React.createElement("path", {
    d: "M77 112h-1v-1h1z",
    fill: "#bd655e"
  })), _path5845 || (_path5845 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111v1h-1v-1z",
    fill: "#c3a193"
  })), _path5846 || (_path5846 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111h1v1h-1z",
    fill: "#c5c6bd"
  })), _path5847 || (_path5847 = /*#__PURE__*/React.createElement("path", {
    d: "M79 111h1v1h-1z",
    fill: "#bfc3c5"
  })), _path5848 || (_path5848 = /*#__PURE__*/React.createElement("path", {
    d: "M80 111h1v1h-1z",
    fill: "#c9c7c4"
  })), _path5849 || (_path5849 = /*#__PURE__*/React.createElement("path", {
    d: "M81 112v-1h1v1z",
    fill: "#cb6a76"
  })), _path5850 || (_path5850 = /*#__PURE__*/React.createElement("path", {
    d: "M83 112h-1v-1h1z",
    fill: "#c11f2a"
  })), _path5851 || (_path5851 = /*#__PURE__*/React.createElement("path", {
    d: "M84 112v-1h1v1z",
    fill: "#c12024"
  })), _path5852 || (_path5852 = /*#__PURE__*/React.createElement("path", {
    d: "M85 111h1v1h-1z",
    fill: "#bd5e5b"
  })), _path5853 || (_path5853 = /*#__PURE__*/React.createElement("path", {
    d: "M86 112v-1h1v1z",
    fill: "#cdc6c2"
  })), _path5854 || (_path5854 = /*#__PURE__*/React.createElement("path", {
    d: "M89 111v1h-1v-1z",
    fill: "#c5c7c3"
  })), _path5855 || (_path5855 = /*#__PURE__*/React.createElement("path", {
    d: "M90 112h-1v-1h1z",
    fill: "#c6c8c4"
  })), _path5856 || (_path5856 = /*#__PURE__*/React.createElement("path", {
    d: "M90 111h1v1h-1z",
    fill: "#c7c9c7"
  })), _path5857 || (_path5857 = /*#__PURE__*/React.createElement("path", {
    d: "M91 112v-1h1v1z",
    fill: "#c9ccd0"
  })), _path5858 || (_path5858 = /*#__PURE__*/React.createElement("path", {
    d: "M93 111v1h-1v-1z",
    fill: "#ccb2b2"
  })), _path5859 || (_path5859 = /*#__PURE__*/React.createElement("path", {
    d: "M94 111v1h-1v-1z",
    fill: "#b8555a"
  })), _path5860 || (_path5860 = /*#__PURE__*/React.createElement("path", {
    d: "M95 112h-1v-1h1z",
    fill: "#c56d6e"
  })), _path5861 || (_path5861 = /*#__PURE__*/React.createElement("path", {
    d: "M96 111v1h-1v-1z",
    fill: "#e1bdbe"
  })), _path5862 || (_path5862 = /*#__PURE__*/React.createElement("path", {
    d: "M97 112h-1v-1h1z",
    fill: "#decdcf",
    fillOpacity: 0.486
  })), _path5863 || (_path5863 = /*#__PURE__*/React.createElement("path", {
    d: "M32 113h-1v-1h1z",
    fill: "#d4b3ab",
    fillOpacity: 0.753
  })), _path5864 || (_path5864 = /*#__PURE__*/React.createElement("path", {
    d: "M32 113v-1h1v1z",
    fill: "#ca847d"
  })), _path5865 || (_path5865 = /*#__PURE__*/React.createElement("path", {
    d: "M34 113h-1v-1h1z",
    fill: "#c25f5d"
  })), _path5866 || (_path5866 = /*#__PURE__*/React.createElement("path", {
    d: "M35 112v1h-1v-1z",
    fill: "#c0474a"
  })), _path5867 || (_path5867 = /*#__PURE__*/React.createElement("path", {
    d: "M36 113h-1v-1h1z",
    fill: "#c13d40"
  })), _path5868 || (_path5868 = /*#__PURE__*/React.createElement("path", {
    d: "M38 112v1h-1v-1z",
    fill: "#bf323a"
  })), _path5869 || (_path5869 = /*#__PURE__*/React.createElement("path", {
    d: "M39 112v1h-1v-1z",
    fill: "#cd5f68"
  })), _path5870 || (_path5870 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113h-1v-1h1z",
    fill: "#ca7c80"
  })), _path5871 || (_path5871 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113v-1h1v1z",
    fill: "#ce7f83"
  })), _path5872 || (_path5872 = /*#__PURE__*/React.createElement("path", {
    d: "M42 113h-1v-1h1z",
    fill: "#cb7174"
  })), _path5873 || (_path5873 = /*#__PURE__*/React.createElement("path", {
    d: "M43 113h-1v-1h1z",
    fill: "#bd3337"
  })), _path5874 || (_path5874 = /*#__PURE__*/React.createElement("path", {
    d: "M43 112h1v1h-1z",
    fill: "#cc5451"
  })), _path5875 || (_path5875 = /*#__PURE__*/React.createElement("path", {
    d: "M45 112v1h-1v-1z",
    fill: "#c24c4b"
  })), _path5876 || (_path5876 = /*#__PURE__*/React.createElement("path", {
    d: "M46 113h-1v-1h1z",
    fill: "#c55458"
  })), _path5877 || (_path5877 = /*#__PURE__*/React.createElement("path", {
    d: "M46 112h1v1h-1z",
    fill: "#cb5254"
  })), _path5878 || (_path5878 = /*#__PURE__*/React.createElement("path", {
    d: "M48 113h-1v-1h1z",
    fill: "#ba2223"
  })), _path5879 || (_path5879 = /*#__PURE__*/React.createElement("path", {
    d: "M57 113v-1h1v1z",
    fill: "#c42226"
  })), _path5880 || (_path5880 = /*#__PURE__*/React.createElement("path", {
    d: "M59 113h-1v-1h1z",
    fill: "#c72024"
  })), _path5881 || (_path5881 = /*#__PURE__*/React.createElement("path", {
    d: "M59 113v-1h1v1z",
    fill: "#c91e25"
  })), _path5882 || (_path5882 = /*#__PURE__*/React.createElement("path", {
    d: "M61 113h-1v-1h1z",
    fill: "#bc1824"
  })), _path5883 || (_path5883 = /*#__PURE__*/React.createElement("path", {
    d: "M62 112v1h-1v-1z",
    fill: "#b32e41"
  })), _path5884 || (_path5884 = /*#__PURE__*/React.createElement("path", {
    d: "M62 112h1v1h-1z",
    fill: "#c3858f"
  })), _path5885 || (_path5885 = /*#__PURE__*/React.createElement("path", {
    d: "M64 113h-1v-1h1z",
    fill: "#c6bfc1"
  })), _path5886 || (_path5886 = /*#__PURE__*/React.createElement("path", {
    d: "M65 113h-1v-1h1z",
    fill: "#c0c4c5"
  })), _path5887 || (_path5887 = /*#__PURE__*/React.createElement("path", {
    d: "M67 112v1h-1v-1z",
    fill: "#c1bfbe"
  })), _path5888 || (_path5888 = /*#__PURE__*/React.createElement("path", {
    d: "M70 112h1v1h-1z",
    fill: "#c3c6c1"
  })), _path5889 || (_path5889 = /*#__PURE__*/React.createElement("path", {
    d: "M71 113v-1h1v1z",
    fill: "#c7c8c5"
  })), _path5890 || (_path5890 = /*#__PURE__*/React.createElement("path", {
    d: "M73 112v1h-1v-1z",
    fill: "#cac6bd"
  })), _path5891 || (_path5891 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112v1h-1v-1z",
    fill: "#ccc1b3"
  })), _path5892 || (_path5892 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112h1v1h-1z",
    fill: "#c9bfaf"
  })), _path5893 || (_path5893 = /*#__PURE__*/React.createElement("path", {
    d: "M75 112h1v1h-1z",
    fill: "#c6c1b3"
  })), _path5894 || (_path5894 = /*#__PURE__*/React.createElement("path", {
    d: "M79 112v1h-1v-1z",
    fill: "#c3c1c0"
  })), _path5895 || (_path5895 = /*#__PURE__*/React.createElement("path", {
    d: "M80 113h-1v-1h1z",
    fill: "#c1c4c5"
  })), _path5896 || (_path5896 = /*#__PURE__*/React.createElement("path", {
    d: "M80 112h1v1h-1z",
    fill: "#d2b3b1"
  })), _path5897 || (_path5897 = /*#__PURE__*/React.createElement("path", {
    d: "M82 113h-1v-1h1z",
    fill: "#c03947"
  })), _path5898 || (_path5898 = /*#__PURE__*/React.createElement("path", {
    d: "M83 113v-1h1v1z",
    fill: "#c92127"
  })), _path5899 || (_path5899 = /*#__PURE__*/React.createElement("path", {
    d: "M84 112h1v1h-1z",
    fill: "#ba262b"
  })), _path5900 || (_path5900 = /*#__PURE__*/React.createElement("path", {
    d: "M85 113v-1h1v1z",
    fill: "#cb9790"
  })), _path5901 || (_path5901 = /*#__PURE__*/React.createElement("path", {
    d: "M90 112v1h-1v-1z",
    fill: "#c5c7c5"
  })), _path5902 || (_path5902 = /*#__PURE__*/React.createElement("path", {
    d: "M90 113v-1h1v1z",
    fill: "#c8c8c8"
  })), _path5903 || (_path5903 = /*#__PURE__*/React.createElement("path", {
    d: "M91 113v-1h1v1z",
    fill: "#cacdd0"
  })), _path5904 || (_path5904 = /*#__PURE__*/React.createElement("path", {
    d: "M93 113h-1v-1h1z",
    fill: "#c99fa3"
  })), _path5905 || (_path5905 = /*#__PURE__*/React.createElement("path", {
    d: "M93 112h1v1h-1z",
    fill: "#b64f55"
  })), _path5906 || (_path5906 = /*#__PURE__*/React.createElement("path", {
    d: "M95 113h-1v-1h1z",
    fill: "#c26565"
  })), _path5907 || (_path5907 = /*#__PURE__*/React.createElement("path", {
    d: "M96 113h-1v-1h1z",
    fill: "#c69b9a"
  })), _path5908 || (_path5908 = /*#__PURE__*/React.createElement("path", {
    d: "M97 113h-1v-1h1z",
    fill: "#d1bdbf",
    fillOpacity: 0.506
  })), _path5909 || (_path5909 = /*#__PURE__*/React.createElement("path", {
    d: "M31 114v-1h1v1z",
    fill: "#d4b5ad",
    fillOpacity: 0.733
  })), _path5910 || (_path5910 = /*#__PURE__*/React.createElement("path", {
    d: "M32 114v-1h1v1z",
    fill: "#c7847d"
  })), _path5911 || (_path5911 = /*#__PURE__*/React.createElement("path", {
    d: "M34 114v-1h1v1z",
    fill: "#bf474a"
  })), _path5912 || (_path5912 = /*#__PURE__*/React.createElement("path", {
    d: "M35 113h1v1h-1z",
    fill: "#c13c3f"
  })), _path5913 || (_path5913 = /*#__PURE__*/React.createElement("path", {
    d: "M36 114v-1h1v1z",
    fill: "#c03337"
  })), _path5914 || (_path5914 = /*#__PURE__*/React.createElement("path", {
    d: "M38 114h-1v-1h1z",
    fill: "#ba3637"
  })), _path5915 || (_path5915 = /*#__PURE__*/React.createElement("path", {
    d: "M38 113h1v1h-1z",
    fill: "#ca5f65"
  })), _path5916 || (_path5916 = /*#__PURE__*/React.createElement("path", {
    d: "M40 114h-1v-1h1z",
    fill: "#ca6874"
  })), _path5917 || (_path5917 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113h1v1h-1z",
    fill: "#c77279"
  })), _path5918 || (_path5918 = /*#__PURE__*/React.createElement("path", {
    d: "M41 113h1v1h-1z",
    fill: "#c87375"
  })), _path5919 || (_path5919 = /*#__PURE__*/React.createElement("path", {
    d: "M42 114v-1h1v1z",
    fill: "#c0565a"
  })), _path5920 || (_path5920 = /*#__PURE__*/React.createElement("path", {
    d: "M44 114h-1v-1h1z",
    fill: "#d48f90"
  })), _path5921 || (_path5921 = /*#__PURE__*/React.createElement("path", {
    d: "M45 114h-1v-1h1z",
    fill: "#d1898f"
  })), _path5922 || (_path5922 = /*#__PURE__*/React.createElement("path", {
    d: "M46 113v1h-1v-1z",
    fill: "#bc545c"
  })), _path5923 || (_path5923 = /*#__PURE__*/React.createElement("path", {
    d: "M46 114v-1h1v1z",
    fill: "#c8565d"
  })), _path5924 || (_path5924 = /*#__PURE__*/React.createElement("path", {
    d: "M61 113h1v1h-1z",
    fill: "#be161c"
  })), _path5925 || (_path5925 = /*#__PURE__*/React.createElement("path", {
    d: "M63 113v1h-1v-1z",
    fill: "#b11827"
  })), _path5926 || (_path5926 = /*#__PURE__*/React.createElement("path", {
    d: "M63 114v-1h1v1z",
    fill: "#b44f64"
  })), _path5927 || (_path5927 = /*#__PURE__*/React.createElement("path", {
    d: "M64 113h1v1h-1z",
    fill: "#c69da6"
  })), _path5928 || (_path5928 = /*#__PURE__*/React.createElement("path", {
    d: "M67 114h-1v-1h1z",
    fill: "#bdc6c0"
  })), _path5929 || (_path5929 = /*#__PURE__*/React.createElement("path", {
    d: "M68 113v1h-1v-1z",
    fill: "#bfc2bc"
  })), _path5930 || (_path5930 = /*#__PURE__*/React.createElement("path", {
    d: "M70 113v1h-1v-1z",
    fill: "#c0c0bf"
  })), _path5931 || (_path5931 = /*#__PURE__*/React.createElement("path", {
    d: "M71 113v1h-1v-1z",
    fill: "#c4c0c1"
  })), _path5932 || (_path5932 = /*#__PURE__*/React.createElement("path", {
    d: "M71 114v-1h1v1z",
    fill: "#c1c1c2"
  })), _path5933 || (_path5933 = /*#__PURE__*/React.createElement("path", {
    d: "M74 114h-1v-1h1z",
    fill: "#c1c2be"
  })), _path5934 || (_path5934 = /*#__PURE__*/React.createElement("path", {
    d: "M76 114h-1v-1h1z",
    fill: "#c4c1c0"
  })), _path5935 || (_path5935 = /*#__PURE__*/React.createElement("path", {
    d: "M78 114v-1h1v1z",
    fill: "#bdc4c2"
  })), _path5936 || (_path5936 = /*#__PURE__*/React.createElement("path", {
    d: "M80 113v1h-1v-1z",
    fill: "#cdc4c3"
  })), _path5937 || (_path5937 = /*#__PURE__*/React.createElement("path", {
    d: "M80 114v-1h1v1z",
    fill: "#c66e75"
  })), _path5938 || (_path5938 = /*#__PURE__*/React.createElement("path", {
    d: "M82 114h-1v-1h1z",
    fill: "#c11c29"
  })), _path5939 || (_path5939 = /*#__PURE__*/React.createElement("path", {
    d: "M83 114h-1v-1h1z",
    fill: "#cb1f28"
  })), _path5940 || (_path5940 = /*#__PURE__*/React.createElement("path", {
    d: "M85 114h-1v-1h1z",
    fill: "#b84748"
  })), _path5941 || (_path5941 = /*#__PURE__*/React.createElement("path", {
    d: "M85 113h1v1h-1z",
    fill: "#cdbfb7"
  })), _path5942 || (_path5942 = /*#__PURE__*/React.createElement("path", {
    d: "M87 113v1h-1v-1z",
    fill: "#c4c6c3"
  })), _path5943 || (_path5943 = /*#__PURE__*/React.createElement("path", {
    d: "M88 113v1h-1v-1z",
    fill: "#c5c5c3"
  })), _path5944 || (_path5944 = /*#__PURE__*/React.createElement("path", {
    d: "M89 114h-1v-1h1z",
    fill: "#c6c5c4"
  })), _path5945 || (_path5945 = /*#__PURE__*/React.createElement("path", {
    d: "M90 113h1v1h-1z",
    fill: "#c8c6c9"
  })), _path5946 || (_path5946 = /*#__PURE__*/React.createElement("path", {
    d: "M92 114v-1h1v1z",
    fill: "#c58a90"
  })), _path5947 || (_path5947 = /*#__PURE__*/React.createElement("path", {
    d: "M93 114v-1h1v1z",
    fill: "#b74c52"
  })), _path5948 || (_path5948 = /*#__PURE__*/React.createElement("path", {
    d: "M94 114v-1h1v1z",
    fill: "#bf6a69"
  })), _path5949 || (_path5949 = /*#__PURE__*/React.createElement("path", {
    d: "M96 114h-1v-1h1z",
    fill: "#d4b0b0"
  })), _path5950 || (_path5950 = /*#__PURE__*/React.createElement("path", {
    d: "M97 114h-1v-1h1z",
    fill: "#e2d2d4",
    fillOpacity: 0.49
  })), _path5951 || (_path5951 = /*#__PURE__*/React.createElement("path", {
    d: "M31 114h1v1h-1z",
    fill: "#d7b8af",
    fillOpacity: 0.678
  })), _path5952 || (_path5952 = /*#__PURE__*/React.createElement("path", {
    d: "M33 115h-1v-1h1z",
    fill: "#c9857e"
  })), _path5953 || (_path5953 = /*#__PURE__*/React.createElement("path", {
    d: "M35 115h-1v-1h1z",
    fill: "#bc4547"
  })), _path5954 || (_path5954 = /*#__PURE__*/React.createElement("path", {
    d: "M35 115v-1h1v1z",
    fill: "#be3a3e"
  })), _path5955 || (_path5955 = /*#__PURE__*/React.createElement("path", {
    d: "M37 114v1h-1v-1z",
    fill: "#c03336"
  })), _path5956 || (_path5956 = /*#__PURE__*/React.createElement("path", {
    d: "M38 115h-1v-1h1z",
    fill: "#bc2d34"
  })), _path5957 || (_path5957 = /*#__PURE__*/React.createElement("path", {
    d: "M38 115v-1h1v1z",
    fill: "#cc5e65"
  })), _path5958 || (_path5958 = /*#__PURE__*/React.createElement("path", {
    d: "M40 114v1h-1v-1z",
    fill: "#ca6d76"
  })), _path5959 || (_path5959 = /*#__PURE__*/React.createElement("path", {
    d: "M41 115h-1v-1h1z",
    fill: "#ca6b75"
  })), _path5960 || (_path5960 = /*#__PURE__*/React.createElement("path", {
    d: "M41 114h1v1h-1z",
    fill: "#cb6a70"
  })), _path5961 || (_path5961 = /*#__PURE__*/React.createElement("path", {
    d: "M42 114h1v1h-1z",
    fill: "#bf4b57"
  })), _path5962 || (_path5962 = /*#__PURE__*/React.createElement("path", {
    d: "M44 114v1h-1v-1z",
    fill: "#cc737e"
  })), _path5963 || (_path5963 = /*#__PURE__*/React.createElement("path", {
    d: "M45 114v1h-1v-1z",
    fill: "#ca8087"
  })), _path5964 || (_path5964 = /*#__PURE__*/React.createElement("path", {
    d: "M45 115v-1h1v1z",
    fill: "#c36b6b"
  })), _path5965 || (_path5965 = /*#__PURE__*/React.createElement("path", {
    d: "M46 114h1v1h-1z",
    fill: "#c2595a"
  })), _path5966 || (_path5966 = /*#__PURE__*/React.createElement("path", {
    d: "M47 115v-1h1v1z",
    fill: "#bf282b"
  })), _path5967 || (_path5967 = /*#__PURE__*/React.createElement("path", {
    d: "M59 114v1h-1v-1z",
    fill: "#c71f25"
  })), _path5968 || (_path5968 = /*#__PURE__*/React.createElement("path", {
    d: "M61 115h-1v-1h1z",
    fill: "#bf1c22"
  })), _path5969 || (_path5969 = /*#__PURE__*/React.createElement("path", {
    d: "M61 114h1v1h-1z",
    fill: "#bc1921"
  })), _path5970 || (_path5970 = /*#__PURE__*/React.createElement("path", {
    d: "M63 115v-1h1v1z",
    fill: "#b3101d"
  })), _path5971 || (_path5971 = /*#__PURE__*/React.createElement("path", {
    d: "M65 115h-1v-1h1z",
    fill: "#ad2332"
  })), _path5972 || (_path5972 = /*#__PURE__*/React.createElement("path", {
    d: "M65 114h1v1h-1z",
    fill: "#bb5e70"
  })), _path5973 || (_path5973 = /*#__PURE__*/React.createElement("path", {
    d: "M67 114v1h-1v-1z",
    fill: "#cb9dac"
  })), _path5974 || (_path5974 = /*#__PURE__*/React.createElement("path", {
    d: "M67 115v-1h1v1z",
    fill: "#c8bcc1"
  })), _path5975 || (_path5975 = /*#__PURE__*/React.createElement("path", {
    d: "M69 114v1h-1v-1z",
    fill: "#c2c3c5"
  })), _path5976 || (_path5976 = /*#__PURE__*/React.createElement("path", {
    d: "M71 115h-1v-1h1z",
    fill: "#bec2be"
  })), _path5977 || (_path5977 = /*#__PURE__*/React.createElement("path", {
    d: "M73 114v1h-1v-1z",
    fill: "#c2bfbe"
  })), _path5978 || (_path5978 = /*#__PURE__*/React.createElement("path", {
    d: "M74 114h1v1h-1z",
    fill: "#c2c0bb"
  })), _path5979 || (_path5979 = /*#__PURE__*/React.createElement("path", {
    d: "M76 115v-1h1v1z",
    fill: "#c1c1be"
  })), _path5980 || (_path5980 = /*#__PURE__*/React.createElement("path", {
    d: "M77 114h1v1h-1z",
    fill: "#c0c4c0"
  })), _path5981 || (_path5981 = /*#__PURE__*/React.createElement("path", {
    d: "M79 114v1h-1v-1z",
    fill: "#cac4c4"
  })), _path5982 || (_path5982 = /*#__PURE__*/React.createElement("path", {
    d: "M79 114h1v1h-1z",
    fill: "#cb858e"
  })), _path5983 || (_path5983 = /*#__PURE__*/React.createElement("path", {
    d: "M80 114h1v1h-1z",
    fill: "#bd2437"
  })), _path5984 || (_path5984 = /*#__PURE__*/React.createElement("path", {
    d: "M81 115v-1h1v1z",
    fill: "#c61e28"
  })), _path5985 || (_path5985 = /*#__PURE__*/React.createElement("path", {
    d: "M85 115h-1v-1h1z",
    fill: "#c4807b"
  })), _path5986 || (_path5986 = /*#__PURE__*/React.createElement("path", {
    d: "M86 114v1h-1v-1z",
    fill: "#c9c8c6"
  })), _path5987 || (_path5987 = /*#__PURE__*/React.createElement("path", {
    d: "M88 114v1h-1v-1z",
    fill: "#c4c4c2"
  })), _path5988 || (_path5988 = /*#__PURE__*/React.createElement("path", {
    d: "M89 115h-1v-1h1z",
    fill: "#c5c4c4"
  })), _path5989 || (_path5989 = /*#__PURE__*/React.createElement("path", {
    d: "M90 115h-1v-1h1z",
    fill: "#c4c5c5"
  })), _path5990 || (_path5990 = /*#__PURE__*/React.createElement("path", {
    d: "M91 114v1h-1v-1z",
    fill: "#c5c5c8"
  })), _path5991 || (_path5991 = /*#__PURE__*/React.createElement("path", {
    d: "M92 114v1h-1v-1z",
    fill: "#c8c9cb"
  })), _path5992 || (_path5992 = /*#__PURE__*/React.createElement("path", {
    d: "M92 115v-1h1v1z",
    fill: "#bb737a"
  })), _path5993 || (_path5993 = /*#__PURE__*/React.createElement("path", {
    d: "M94 115h-1v-1h1z",
    fill: "#b54b4e"
  })), _path5994 || (_path5994 = /*#__PURE__*/React.createElement("path", {
    d: "M94 114h1v1h-1z",
    fill: "#bf7171"
  })), _path5995 || (_path5995 = /*#__PURE__*/React.createElement("path", {
    d: "M95 115v-1h1v1z",
    fill: "#dbb8b9"
  })), _path5996 || (_path5996 = /*#__PURE__*/React.createElement("path", {
    d: "M96 115v-1h1v1z",
    fill: "#d5c7c7",
    fillOpacity: 0.435
  })), _path5997 || (_path5997 = /*#__PURE__*/React.createElement("path", {
    d: "M32 115v1h-1v-1z",
    fill: "#dbc3b7",
    fillOpacity: 0.506
  })), _path5998 || (_path5998 = /*#__PURE__*/React.createElement("path", {
    d: "M32 116v-1h1v1z",
    fill: "#c98d85"
  })), _path5999 || (_path5999 = /*#__PURE__*/React.createElement("path", {
    d: "M34 116h-1v-1h1z",
    fill: "#b85e5a"
  })), _path6000 || (_path6000 = /*#__PURE__*/React.createElement("path", {
    d: "M35 115v1h-1v-1z",
    fill: "#b64444"
  })), _path6001 || (_path6001 = /*#__PURE__*/React.createElement("path", {
    d: "M36 116h-1v-1h1z",
    fill: "#b83940"
  })), _path6002 || (_path6002 = /*#__PURE__*/React.createElement("path", {
    d: "M37 116h-1v-1h1z",
    fill: "#bb3236"
  })), _path6003 || (_path6003 = /*#__PURE__*/React.createElement("path", {
    d: "M38 116v-1h1v1z",
    fill: "#b92e30"
  })), _path6004 || (_path6004 = /*#__PURE__*/React.createElement("path", {
    d: "M39 115h1v1h-1z",
    fill: "#b82930"
  })), _path6005 || (_path6005 = /*#__PURE__*/React.createElement("path", {
    d: "M40 115h1v1h-1z",
    fill: "#ba2832"
  })), _path6006 || (_path6006 = /*#__PURE__*/React.createElement("path", {
    d: "M41 116v-1h1v1z",
    fill: "#ba2c37"
  })), _path6007 || (_path6007 = /*#__PURE__*/React.createElement("path", {
    d: "M43 115v1h-1v-1z",
    fill: "#bc2631"
  })), _path6008 || (_path6008 = /*#__PURE__*/React.createElement("path", {
    d: "M44 116h-1v-1h1z",
    fill: "#bf303b"
  })), _path6009 || (_path6009 = /*#__PURE__*/React.createElement("path", {
    d: "M45 116h-1v-1h1z",
    fill: "#bb3845"
  })), _path6010 || (_path6010 = /*#__PURE__*/React.createElement("path", {
    d: "M45 115h1v1h-1z",
    fill: "#c55b64"
  })), _path6011 || (_path6011 = /*#__PURE__*/React.createElement("path", {
    d: "M46 115h1v1h-1z",
    fill: "#c75256"
  })), _path6012 || (_path6012 = /*#__PURE__*/React.createElement("path", {
    d: "M49 116h-1v-1h1z",
    fill: "#be1a1e"
  })), _path6013 || (_path6013 = /*#__PURE__*/React.createElement("path", {
    d: "M50 116h-1v-1h1z",
    fill: "#be1a20"
  })), _path6014 || (_path6014 = /*#__PURE__*/React.createElement("path", {
    d: "M61 115h1v1h-1z",
    fill: "#b91820"
  })), _path6015 || (_path6015 = /*#__PURE__*/React.createElement("path", {
    d: "M63 115v1h-1v-1z",
    fill: "#b6161e"
  })), _path6016 || (_path6016 = /*#__PURE__*/React.createElement("path", {
    d: "M65 116v-1h1v1z",
    fill: "#b3151c"
  })), _path6017 || (_path6017 = /*#__PURE__*/React.createElement("path", {
    d: "M66 115h1v1h-1z",
    fill: "#b32431"
  })), _path6018 || (_path6018 = /*#__PURE__*/React.createElement("path", {
    d: "M68 116h-1v-1h1z",
    fill: "#bb4c63"
  })), _path6019 || (_path6019 = /*#__PURE__*/React.createElement("path", {
    d: "M68 116v-1h1v1z",
    fill: "#c18095"
  })), _path6020 || (_path6020 = /*#__PURE__*/React.createElement("path", {
    d: "M69 115h1v1h-1z",
    fill: "#c7a8b3"
  })), _path6021 || (_path6021 = /*#__PURE__*/React.createElement("path", {
    d: "M70 115h1v1h-1z",
    fill: "#c5b8bd"
  })), _path6022 || (_path6022 = /*#__PURE__*/React.createElement("path", {
    d: "M72 115v1h-1v-1z",
    fill: "#c5bfc2"
  })), _path6023 || (_path6023 = /*#__PURE__*/React.createElement("path", {
    d: "M72 116v-1h1v1z",
    fill: "#c1c1c3"
  })), _path6024 || (_path6024 = /*#__PURE__*/React.createElement("path", {
    d: "M73 116v-1h1v1z",
    fill: "#c0c1c4"
  })), _path6025 || (_path6025 = /*#__PURE__*/React.createElement("path", {
    d: "M75 116h-1v-1h1z",
    fill: "#c0c1c2"
  })), _path6026 || (_path6026 = /*#__PURE__*/React.createElement("path", {
    d: "M76 116h-1v-1h1z",
    fill: "#c2c2c4"
  })), _path6027 || (_path6027 = /*#__PURE__*/React.createElement("path", {
    d: "M77 115v1h-1v-1z",
    fill: "#cabfc2"
  })), _path6028 || (_path6028 = /*#__PURE__*/React.createElement("path", {
    d: "M77 115h1v1h-1z",
    fill: "#caacb2"
  })), _path6029 || (_path6029 = /*#__PURE__*/React.createElement("path", {
    d: "M79 116h-1v-1h1z",
    fill: "#bf6a74"
  })), _path6030 || (_path6030 = /*#__PURE__*/React.createElement("path", {
    d: "M80 116h-1v-1h1z",
    fill: "#b82330"
  })), _path6031 || (_path6031 = /*#__PURE__*/React.createElement("path", {
    d: "M81 116h-1v-1h1z",
    fill: "#c21b24"
  })), _path6032 || (_path6032 = /*#__PURE__*/React.createElement("path", {
    d: "M83 116v-1h1v1z",
    fill: "#b63739"
  })), _path6033 || (_path6033 = /*#__PURE__*/React.createElement("path", {
    d: "M85 115v1h-1v-1z",
    fill: "#cbb3ad"
  })), _path6034 || (_path6034 = /*#__PURE__*/React.createElement("path", {
    d: "M85 116v-1h1v1z",
    fill: "#c2c3c2"
  })), _path6035 || (_path6035 = /*#__PURE__*/React.createElement("path", {
    d: "M86 116v-1h1v1z",
    fill: "#c3c3c3"
  })), _path6036 || (_path6036 = /*#__PURE__*/React.createElement("path", {
    d: "M88 115v1h-1v-1z",
    fill: "#c2c2c2"
  })), _path6037 || (_path6037 = /*#__PURE__*/React.createElement("path", {
    d: "M90 116v-1h1v1z",
    fill: "#c1c2c4"
  })), _path6038 || (_path6038 = /*#__PURE__*/React.createElement("path", {
    d: "M92 116h-1v-1h1z",
    fill: "#c5bcc0"
  })), _path6039 || (_path6039 = /*#__PURE__*/React.createElement("path", {
    d: "M93 116h-1v-1h1z",
    fill: "#b35962"
  })), _path6040 || (_path6040 = /*#__PURE__*/React.createElement("path", {
    d: "M94 116h-1v-1h1z",
    fill: "#b74b51"
  })), _path6041 || (_path6041 = /*#__PURE__*/React.createElement("path", {
    d: "M95 115v1h-1v-1z",
    fill: "#be6466"
  })), _path6042 || (_path6042 = /*#__PURE__*/React.createElement("path", {
    d: "M96 116h-1v-1h1z",
    fill: "#c79293"
  })), _path6043 || (_path6043 = /*#__PURE__*/React.createElement("path", {
    d: "M97 116h-1v-1h1z",
    fill: "#d5bdc0",
    fillOpacity: 0.29
  })), _path6044 || (_path6044 = /*#__PURE__*/React.createElement("path", {
    d: "M31 117v-1h1v1z",
    fill: "#f8ebdf",
    fillOpacity: 0.157
  })), _path6045 || (_path6045 = /*#__PURE__*/React.createElement("path", {
    d: "M33 117h-1v-1h1z",
    fill: "#d4b1a7",
    fillOpacity: 0.918
  })), _path6046 || (_path6046 = /*#__PURE__*/React.createElement("path", {
    d: "M34 116v1h-1v-1z",
    fill: "#be796d"
  })), _path6047 || (_path6047 = /*#__PURE__*/React.createElement("path", {
    d: "M34 116h1v1h-1z",
    fill: "#ad4e46"
  })), _path6048 || (_path6048 = /*#__PURE__*/React.createElement("path", {
    d: "M36 116v1h-1v-1z",
    fill: "#b03836"
  })), _path6049 || (_path6049 = /*#__PURE__*/React.createElement("path", {
    d: "M36 116h1v1h-1z",
    fill: "#b72f2b"
  })), _path6050 || (_path6050 = /*#__PURE__*/React.createElement("path", {
    d: "M38 117h-1v-1h1z",
    fill: "#b62a26"
  })), _path6051 || (_path6051 = /*#__PURE__*/React.createElement("path", {
    d: "M38 116h1v1h-1z",
    fill: "#ba2625"
  })), _path6052 || (_path6052 = /*#__PURE__*/React.createElement("path", {
    d: "M39 116h1v1h-1z",
    fill: "#bb2525"
  })), _path6053 || (_path6053 = /*#__PURE__*/React.createElement("path", {
    d: "M41 116v1h-1v-1z",
    fill: "#b82425"
  })), _path6054 || (_path6054 = /*#__PURE__*/React.createElement("path", {
    d: "M42 117h-1v-1h1z",
    fill: "#ba2022"
  })), _path6055 || (_path6055 = /*#__PURE__*/React.createElement("path", {
    d: "M42 117v-1h1v1z",
    fill: "#bc1f1f"
  })), _path6056 || (_path6056 = /*#__PURE__*/React.createElement("path", {
    d: "M44 116v1h-1v-1z",
    fill: "#b91e1c"
  })), _path6057 || (_path6057 = /*#__PURE__*/React.createElement("path", {
    d: "M44 117v-1h1v1z",
    fill: "#bb1a1d"
  })), _path6058 || (_path6058 = /*#__PURE__*/React.createElement("path", {
    d: "M46 116v1h-1v-1z",
    fill: "#b91821"
  })), _path6059 || (_path6059 = /*#__PURE__*/React.createElement("path", {
    d: "M47 117h-1v-1h1z",
    fill: "#b81d24"
  })), _path6060 || (_path6060 = /*#__PURE__*/React.createElement("path", {
    d: "M47 116h1v1h-1z",
    fill: "#bd1b1e"
  })), _path6061 || (_path6061 = /*#__PURE__*/React.createElement("path", {
    d: "M55 117h-1v-1h1z",
    fill: "#bd191e"
  })), _path6062 || (_path6062 = /*#__PURE__*/React.createElement("path", {
    d: "M58 116h1v1h-1z",
    fill: "#bd1d21"
  })), _path6063 || (_path6063 = /*#__PURE__*/React.createElement("path", {
    d: "M62 117h-1v-1h1z",
    fill: "#b7171e"
  })), _path6064 || (_path6064 = /*#__PURE__*/React.createElement("path", {
    d: "M63 116v1h-1v-1z",
    fill: "#b4141d"
  })), _path6065 || (_path6065 = /*#__PURE__*/React.createElement("path", {
    d: "M63 117v-1h1v1z",
    fill: "#b4141c"
  })), _path6066 || (_path6066 = /*#__PURE__*/React.createElement("path", {
    d: "M65 116v1h-1v-1z",
    fill: "#b6151e"
  })), _path6067 || (_path6067 = /*#__PURE__*/React.createElement("path", {
    d: "M65 116h1v1h-1z",
    fill: "#b71920"
  })), _path6068 || (_path6068 = /*#__PURE__*/React.createElement("path", {
    d: "M66 116h1v1h-1z",
    fill: "#b91b1f"
  })), _path6069 || (_path6069 = /*#__PURE__*/React.createElement("path", {
    d: "M67 116h1v1h-1z",
    fill: "#ba1720"
  })), _path6070 || (_path6070 = /*#__PURE__*/React.createElement("path", {
    d: "M69 116v1h-1v-1z",
    fill: "#b71a29"
  })), _path6071 || (_path6071 = /*#__PURE__*/React.createElement("path", {
    d: "M70 116v1h-1v-1z",
    fill: "#b6293c"
  })), _path6072 || (_path6072 = /*#__PURE__*/React.createElement("path", {
    d: "M71 117h-1v-1h1z",
    fill: "#b84055"
  })), _path6073 || (_path6073 = /*#__PURE__*/React.createElement("path", {
    d: "M71 116h1v1h-1z",
    fill: "#c05c6e"
  })), _path6074 || (_path6074 = /*#__PURE__*/React.createElement("path", {
    d: "M73 116v1h-1v-1z",
    fill: "#c06f80"
  })), _path6075 || (_path6075 = /*#__PURE__*/React.createElement("path", {
    d: "M74 116v1h-1v-1z",
    fill: "#c17b8c"
  })), _path6076 || (_path6076 = /*#__PURE__*/React.createElement("path", {
    d: "M75 117h-1v-1h1z",
    fill: "#c17e8e"
  })), _path6077 || (_path6077 = /*#__PURE__*/React.createElement("path", {
    d: "M76 117h-1v-1h1z",
    fill: "#bf7784"
  })), _path6078 || (_path6078 = /*#__PURE__*/React.createElement("path", {
    d: "M77 116v1h-1v-1z",
    fill: "#ba5866"
  })), _path6079 || (_path6079 = /*#__PURE__*/React.createElement("path", {
    d: "M78 116v1h-1v-1z",
    fill: "#b12f3f"
  })), _path6080 || (_path6080 = /*#__PURE__*/React.createElement("path", {
    d: "M79 116v1h-1v-1z",
    fill: "#b41821"
  })), _path6081 || (_path6081 = /*#__PURE__*/React.createElement("path", {
    d: "M79 117v-1h1v1z",
    fill: "#be1a1f"
  })), _path6082 || (_path6082 = /*#__PURE__*/React.createElement("path", {
    d: "M81 116v1h-1v-1z",
    fill: "#bb1e20"
  })), _path6083 || (_path6083 = /*#__PURE__*/React.createElement("path", {
    d: "M82 116v1h-1v-1z",
    fill: "#be1e24"
  })), _path6084 || (_path6084 = /*#__PURE__*/React.createElement("path", {
    d: "M82 117v-1h1v1z",
    fill: "#ba1a22"
  })), _path6085 || (_path6085 = /*#__PURE__*/React.createElement("path", {
    d: "M83 116h1v1h-1z",
    fill: "#bb7474"
  })), _path6086 || (_path6086 = /*#__PURE__*/React.createElement("path", {
    d: "M85 116h1v1h-1z",
    fill: "#bcbfbd"
  })), _path6087 || (_path6087 = /*#__PURE__*/React.createElement("path", {
    d: "M86 117v-1h1v1z",
    fill: "#c0bebf"
  })), _path6088 || (_path6088 = /*#__PURE__*/React.createElement("path", {
    d: "M87 117v-1h1v1z",
    fill: "#c0bfc0"
  })), _path6089 || (_path6089 = /*#__PURE__*/React.createElement("path", {
    d: "M90 117h-1v-1h1z",
    fill: "#c0bfbf"
  })), _path6090 || (_path6090 = /*#__PURE__*/React.createElement("path", {
    d: "M90 116h1v1h-1z",
    fill: "#c0c2c1"
  })), _path6091 || (_path6091 = /*#__PURE__*/React.createElement("path", {
    d: "M91 117v-1h1v1z",
    fill: "#c8a7ac"
  })), _path6092 || (_path6092 = /*#__PURE__*/React.createElement("path", {
    d: "M92 117v-1h1v1z",
    fill: "#b1454a"
  })), _path6093 || (_path6093 = /*#__PURE__*/React.createElement("path", {
    d: "M93 116h1v1h-1z",
    fill: "#af4f4a"
  })), _path6094 || (_path6094 = /*#__PURE__*/React.createElement("path", {
    d: "M95 117h-1v-1h1z",
    fill: "#c07971"
  })), _path6095 || (_path6095 = /*#__PURE__*/React.createElement("path", {
    d: "M95 116h1v1h-1z",
    fill: "#c9a19b",
    fillOpacity: 0.741
  })), _path6096 || (_path6096 = /*#__PURE__*/React.createElement("path", {
    d: "M97 117h-1v-1h1z",
    fill: "#ebebeb",
    fillOpacity: 0.051
  })), _path6097 || (_path6097 = /*#__PURE__*/React.createElement("path", {
    d: "M32 118v-1h1v1z",
    fill: "#f8eee0",
    fillOpacity: 0.294
  })), _path6098 || (_path6098 = /*#__PURE__*/React.createElement("path", {
    d: "M33 117h1v1h-1z",
    fill: "#e4d3c3",
    fillOpacity: 0.902
  })), _path6099 || (_path6099 = /*#__PURE__*/React.createElement("path", {
    d: "M35 117v1h-1v-1z",
    fill: "#d8b6a1"
  })), _path6100 || (_path6100 = /*#__PURE__*/React.createElement("path", {
    d: "M36 118h-1v-1h1z",
    fill: "#c18b76"
  })), _path6101 || (_path6101 = /*#__PURE__*/React.createElement("path", {
    d: "M37 118h-1v-1h1z",
    fill: "#b76b52"
  })), _path6102 || (_path6102 = /*#__PURE__*/React.createElement("path", {
    d: "M38 117v1h-1v-1z",
    fill: "#af4d38"
  })), _path6103 || (_path6103 = /*#__PURE__*/React.createElement("path", {
    d: "M39 117v1h-1v-1z",
    fill: "#ae3a2b"
  })), _path6104 || (_path6104 = /*#__PURE__*/React.createElement("path", {
    d: "M39 117h1v1h-1z",
    fill: "#b02921"
  })), _path6105 || (_path6105 = /*#__PURE__*/React.createElement("path", {
    d: "M41 118h-1v-1h1z",
    fill: "#b2221d"
  })), _path6106 || (_path6106 = /*#__PURE__*/React.createElement("path", {
    d: "M43 118h-1v-1h1z",
    fill: "#b81b1d"
  })), _path6107 || (_path6107 = /*#__PURE__*/React.createElement("path", {
    d: "M43 117h1v1h-1z",
    fill: "#b61b1d"
  })), _path6108 || (_path6108 = /*#__PURE__*/React.createElement("path", {
    d: "M45 117v1h-1v-1z",
    fill: "#b71a1d"
  })), _path6109 || (_path6109 = /*#__PURE__*/React.createElement("path", {
    d: "M45 118v-1h1v1z",
    fill: "#b91a1b"
  })), _path6110 || (_path6110 = /*#__PURE__*/React.createElement("path", {
    d: "M47 117v1h-1v-1z",
    fill: "#b91a1d"
  })), _path6111 || (_path6111 = /*#__PURE__*/React.createElement("path", {
    d: "M47 118v-1h1v1z",
    fill: "#bb1a1b"
  })), _path6112 || (_path6112 = /*#__PURE__*/React.createElement("path", {
    d: "M49 117v1h-1v-1z",
    fill: "#be181d"
  })), _path6113 || (_path6113 = /*#__PURE__*/React.createElement("path", {
    d: "M50 117v1h-1v-1z",
    fill: "#bd181d"
  })), _path6114 || (_path6114 = /*#__PURE__*/React.createElement("path", {
    d: "M51 117v1h-1v-1z",
    fill: "#bc191d"
  })), _path6115 || (_path6115 = /*#__PURE__*/React.createElement("path", {
    d: "M53 117v1h-1v-1z",
    fill: "#bb181c"
  })), _path6116 || (_path6116 = /*#__PURE__*/React.createElement("path", {
    d: "M55 117h1v1h-1z",
    fill: "#bd1a1d"
  })), _path6117 || (_path6117 = /*#__PURE__*/React.createElement("path", {
    d: "M56 117h1v1h-1z",
    fill: "#bd191d"
  })), _path6118 || (_path6118 = /*#__PURE__*/React.createElement("path", {
    d: "M59 118h-1v-1h1z",
    fill: "#ba1b20"
  })), _path6119 || (_path6119 = /*#__PURE__*/React.createElement("path", {
    d: "M59 118v-1h1v1z",
    fill: "#b91a1f"
  })), _path6120 || (_path6120 = /*#__PURE__*/React.createElement("path", {
    d: "M61 118h-1v-1h1z",
    fill: "#b5181e"
  })), _path6121 || (_path6121 = /*#__PURE__*/React.createElement("path", {
    d: "M61 118v-1h1v1z",
    fill: "#b4161c"
  })), _path6122 || (_path6122 = /*#__PURE__*/React.createElement("path", {
    d: "M62 117h1v1h-1z",
    fill: "#b4141a"
  })), _path6123 || (_path6123 = /*#__PURE__*/React.createElement("path", {
    d: "M65 118h-1v-1h1z",
    fill: "#b5151b"
  })), _path6124 || (_path6124 = /*#__PURE__*/React.createElement("path", {
    d: "M66 118h-1v-1h1z",
    fill: "#b91720"
  })), _path6125 || (_path6125 = /*#__PURE__*/React.createElement("path", {
    d: "M66 118v-1h1v1z",
    fill: "#bc1922"
  })), _path6126 || (_path6126 = /*#__PURE__*/React.createElement("path", {
    d: "M68 118h-1v-1h1z",
    fill: "#bb1a21"
  })), _path6127 || (_path6127 = /*#__PURE__*/React.createElement("path", {
    d: "M68 118v-1h1v1z",
    fill: "#ba1b22"
  })), _path6128 || (_path6128 = /*#__PURE__*/React.createElement("path", {
    d: "M71 117h1v1h-1z",
    fill: "#b5181c"
  })), _path6129 || (_path6129 = /*#__PURE__*/React.createElement("path", {
    d: "M72 117h1v1h-1z",
    fill: "#b4171f"
  })), _path6130 || (_path6130 = /*#__PURE__*/React.createElement("path", {
    d: "M73 118v-1h1v1z",
    fill: "#b21721"
  })), _path6131 || (_path6131 = /*#__PURE__*/React.createElement("path", {
    d: "M75 118h-1v-1h1z",
    fill: "#af1722"
  })), _path6132 || (_path6132 = /*#__PURE__*/React.createElement("path", {
    d: "M76 117v1h-1v-1z",
    fill: "#b2151f"
  })), _path6133 || (_path6133 = /*#__PURE__*/React.createElement("path", {
    d: "M78 118h-1v-1h1z",
    fill: "#b5181a"
  })), _path6134 || (_path6134 = /*#__PURE__*/React.createElement("path", {
    d: "M82 117v1h-1v-1z",
    fill: "#be1820"
  })), _path6135 || (_path6135 = /*#__PURE__*/React.createElement("path", {
    d: "M82 117h1v1h-1z",
    fill: "#ae3b3c"
  })), _path6136 || (_path6136 = /*#__PURE__*/React.createElement("path", {
    d: "M84 118h-1v-1h1z",
    fill: "#c1b0ab"
  })), _path6137 || (_path6137 = /*#__PURE__*/React.createElement("path", {
    d: "M85 118v-1h1v1z",
    fill: "#bdbdba"
  })), _path6138 || (_path6138 = /*#__PURE__*/React.createElement("path", {
    d: "M91 117h1v1h-1z",
    fill: "#be9999"
  })), _path6139 || (_path6139 = /*#__PURE__*/React.createElement("path", {
    d: "M93 118h-1v-1h1z",
    fill: "#b97164"
  })), _path6140 || (_path6140 = /*#__PURE__*/React.createElement("path", {
    d: "M93 117h1v1h-1z",
    fill: "#d5aa93"
  })), _path6141 || (_path6141 = /*#__PURE__*/React.createElement("path", {
    d: "M95 117v1h-1v-1z",
    fill: "#dac6b7",
    fillOpacity: 0.8
  })), _path6142 || (_path6142 = /*#__PURE__*/React.createElement("path", {
    d: "M95 118v-1h1v1z",
    fill: "#f6eddb",
    fillOpacity: 0.114
  })), _path6143 || (_path6143 = /*#__PURE__*/React.createElement("path", {
    d: "M34 118v1h-1v-1z",
    fill: "#edf3ed",
    fillOpacity: 0.173
  })), _path6144 || (_path6144 = /*#__PURE__*/React.createElement("path", {
    d: "M34 119v-1h1v1z",
    fill: "#e2e4d9",
    fillOpacity: 0.741
  })), _path6145 || (_path6145 = /*#__PURE__*/React.createElement("path", {
    d: "M36 118v1h-1v-1z",
    fill: "#e0e0d4"
  })), _path6146 || (_path6146 = /*#__PURE__*/React.createElement("path", {
    d: "M36 118h1v1h-1z",
    fill: "#ddd5c6"
  })), _path6147 || (_path6147 = /*#__PURE__*/React.createElement("path", {
    d: "M37 118h1v1h-1z",
    fill: "#d4c9b8"
  })), _path6148 || (_path6148 = /*#__PURE__*/React.createElement("path", {
    d: "M38 118h1v1h-1z",
    fill: "#d4beab"
  })), _path6149 || (_path6149 = /*#__PURE__*/React.createElement("path", {
    d: "M39 119v-1h1v1z",
    fill: "#d1a995"
  })), _path6150 || (_path6150 = /*#__PURE__*/React.createElement("path", {
    d: "M40 118h1v1h-1z",
    fill: "#ca9480"
  })), _path6151 || (_path6151 = /*#__PURE__*/React.createElement("path", {
    d: "M41 119v-1h1v1z",
    fill: "#c47e67"
  })), _path6152 || (_path6152 = /*#__PURE__*/React.createElement("path", {
    d: "M43 118v1h-1v-1z",
    fill: "#c06755"
  })), _path6153 || (_path6153 = /*#__PURE__*/React.createElement("path", {
    d: "M43 118h1v1h-1z",
    fill: "#bd5446"
  })), _path6154 || (_path6154 = /*#__PURE__*/React.createElement("path", {
    d: "M45 119h-1v-1h1z",
    fill: "#b84438"
  })), _path6155 || (_path6155 = /*#__PURE__*/React.createElement("path", {
    d: "M45 118h1v1h-1z",
    fill: "#b4362c"
  })), _path6156 || (_path6156 = /*#__PURE__*/React.createElement("path", {
    d: "M47 118v1h-1v-1z",
    fill: "#b42a25"
  })), _path6157 || (_path6157 = /*#__PURE__*/React.createElement("path", {
    d: "M47 118h1v1h-1z",
    fill: "#b2241a"
  })), _path6158 || (_path6158 = /*#__PURE__*/React.createElement("path", {
    d: "M49 119h-1v-1h1z",
    fill: "#b11e15"
  })), _path6159 || (_path6159 = /*#__PURE__*/React.createElement("path", {
    d: "M50 119h-1v-1h1z",
    fill: "#b21a15"
  })), _path6160 || (_path6160 = /*#__PURE__*/React.createElement("path", {
    d: "M50 118h1v1h-1z",
    fill: "#b21814"
  })), _path6161 || (_path6161 = /*#__PURE__*/React.createElement("path", {
    d: "M52 119h-1v-1h1z",
    fill: "#b21613"
  })), _path6162 || (_path6162 = /*#__PURE__*/React.createElement("path", {
    d: "M53 119h-1v-1h1z",
    fill: "#b21512"
  })), _path6163 || (_path6163 = /*#__PURE__*/React.createElement("path", {
    d: "M54 118v1h-1v-1z",
    fill: "#b41412"
  })), _path6164 || (_path6164 = /*#__PURE__*/React.createElement("path", {
    d: "M54 119v-1h1v1z",
    fill: "#b51313"
  })), _path6165 || (_path6165 = /*#__PURE__*/React.createElement("path", {
    d: "M56 118v1h-1v-1z",
    fill: "#b61313"
  })), _path6166 || (_path6166 = /*#__PURE__*/React.createElement("path", {
    d: "M56 119v-1h1v1z",
    fill: "#b81314"
  })), _path6167 || (_path6167 = /*#__PURE__*/React.createElement("path", {
    d: "M58 118v1h-1v-1z",
    fill: "#b61316"
  })), _path6168 || (_path6168 = /*#__PURE__*/React.createElement("path", {
    d: "M60 118v1h-1v-1z",
    fill: "#b31317"
  })), _path6169 || (_path6169 = /*#__PURE__*/React.createElement("path", {
    d: "M65 118v1h-1v-1z",
    fill: "#b21114"
  })), _path6170 || (_path6170 = /*#__PURE__*/React.createElement("path", {
    d: "M65 119v-1h1v1z",
    fill: "#b31216"
  })), _path6171 || (_path6171 = /*#__PURE__*/React.createElement("path", {
    d: "M68 118v1h-1v-1z",
    fill: "#b7131e"
  })), _path6172 || (_path6172 = /*#__PURE__*/React.createElement("path", {
    d: "M69 119h-1v-1h1z",
    fill: "#b8141e"
  })), _path6173 || (_path6173 = /*#__PURE__*/React.createElement("path", {
    d: "M70 119h-1v-1h1z",
    fill: "#b9151b"
  })), _path6174 || (_path6174 = /*#__PURE__*/React.createElement("path", {
    d: "M71 118v1h-1v-1z",
    fill: "#b81619"
  })), _path6175 || (_path6175 = /*#__PURE__*/React.createElement("path", {
    d: "M72 118v1h-1v-1z",
    fill: "#b6171a"
  })), _path6176 || (_path6176 = /*#__PURE__*/React.createElement("path", {
    d: "M72 119v-1h1v1z",
    fill: "#b41719"
  })), _path6177 || (_path6177 = /*#__PURE__*/React.createElement("path", {
    d: "M74 119h-1v-1h1z",
    fill: "#b41518"
  })), _path6178 || (_path6178 = /*#__PURE__*/React.createElement("path", {
    d: "M80 118v1h-1v-1z",
    fill: "#b3181a"
  })), _path6179 || (_path6179 = /*#__PURE__*/React.createElement("path", {
    d: "M81 119h-1v-1h1z",
    fill: "#b21b1a"
  })), _path6180 || (_path6180 = /*#__PURE__*/React.createElement("path", {
    d: "M82 119h-1v-1h1z",
    fill: "#a9231d"
  })), _path6181 || (_path6181 = /*#__PURE__*/React.createElement("path", {
    d: "M82 119v-1h1v1z",
    fill: "#bd887d"
  })), _path6182 || (_path6182 = /*#__PURE__*/React.createElement("path", {
    d: "M83 119v-1h1v1z",
    fill: "#c1c1b9"
  })), _path6183 || (_path6183 = /*#__PURE__*/React.createElement("path", {
    d: "M86 119h-1v-1h1z",
    fill: "#c0c0bb"
  })), _path6184 || (_path6184 = /*#__PURE__*/React.createElement("path", {
    d: "M88 118h1v1h-1z",
    fill: "#cbcac5"
  })), _path6185 || (_path6185 = /*#__PURE__*/React.createElement("path", {
    d: "M90 118v1h-1v-1z",
    fill: "#cecdc8"
  })), _path6186 || (_path6186 = /*#__PURE__*/React.createElement("path", {
    d: "M90 118h1v1h-1z",
    fill: "#d2d0cd"
  })), _path6187 || (_path6187 = /*#__PURE__*/React.createElement("path", {
    d: "M91 119v-1h1v1z",
    fill: "#d8d0cc"
  })), _path6188 || (_path6188 = /*#__PURE__*/React.createElement("path", {
    d: "M93 119h-1v-1h1z",
    fill: "#e3dfd2"
  })), _path6189 || (_path6189 = /*#__PURE__*/React.createElement("path", {
    d: "M93 118h1v1h-1z",
    fill: "#e4dfd8",
    fillOpacity: 0.706
  })), _path6190 || (_path6190 = /*#__PURE__*/React.createElement("path", {
    d: "M94 119v-1h1v1z",
    fill: "#e2f5ec",
    fillOpacity: 0.106
  })), _path6191 || (_path6191 = /*#__PURE__*/React.createElement("path", {
    d: "M36 119v1h-1v-1z",
    fill: "#ddddd6",
    fillOpacity: 0.471
  })), _path6192 || (_path6192 = /*#__PURE__*/React.createElement("path", {
    d: "M36 119h1v1h-1z",
    fill: "#d1d1ca",
    fillOpacity: 0.949
  })), _path6193 || (_path6193 = /*#__PURE__*/React.createElement("path", {
    d: "M38 120h-1v-1h1z",
    fill: "#c9c9c6"
  })), _path6194 || (_path6194 = /*#__PURE__*/React.createElement("path", {
    d: "M39 120h-1v-1h1z",
    fill: "#c7c8c4"
  })), _path6195 || (_path6195 = /*#__PURE__*/React.createElement("path", {
    d: "M39 120v-1h1v1z",
    fill: "#cacbc6"
  })), _path6196 || (_path6196 = /*#__PURE__*/React.createElement("path", {
    d: "M40 120v-1h1v1z",
    fill: "#cdcec9"
  })), _path6197 || (_path6197 = /*#__PURE__*/React.createElement("path", {
    d: "M41 119h1v1h-1z",
    fill: "#d1cfc9"
  })), _path6198 || (_path6198 = /*#__PURE__*/React.createElement("path", {
    d: "M43 120h-1v-1h1z",
    fill: "#d3d1c5"
  })), _path6199 || (_path6199 = /*#__PURE__*/React.createElement("path", {
    d: "M44 119v1h-1v-1z",
    fill: "#d7cfbe"
  })), _path6200 || (_path6200 = /*#__PURE__*/React.createElement("path", {
    d: "M45 119v1h-1v-1z",
    fill: "#dbcab8"
  })), _path6201 || (_path6201 = /*#__PURE__*/React.createElement("path", {
    d: "M46 119v1h-1v-1z",
    fill: "#dbc4b4"
  })), _path6202 || (_path6202 = /*#__PURE__*/React.createElement("path", {
    d: "M47 120h-1v-1h1z",
    fill: "#d9baaa"
  })), _path6203 || (_path6203 = /*#__PURE__*/React.createElement("path", {
    d: "M47 120v-1h1v1z",
    fill: "#d9b19d"
  })), _path6204 || (_path6204 = /*#__PURE__*/React.createElement("path", {
    d: "M49 119v1h-1v-1z",
    fill: "#d4a690"
  })), _path6205 || (_path6205 = /*#__PURE__*/React.createElement("path", {
    d: "M50 119v1h-1v-1z",
    fill: "#d19c87"
  })), _path6206 || (_path6206 = /*#__PURE__*/React.createElement("path", {
    d: "M50 120v-1h1v1z",
    fill: "#cb907e"
  })), _path6207 || (_path6207 = /*#__PURE__*/React.createElement("path", {
    d: "M52 120h-1v-1h1z",
    fill: "#c98777"
  })), _path6208 || (_path6208 = /*#__PURE__*/React.createElement("path", {
    d: "M52 119h1v1h-1z",
    fill: "#c47e6c"
  })), _path6209 || (_path6209 = /*#__PURE__*/React.createElement("path", {
    d: "M53 119h1v1h-1z",
    fill: "#c47461"
  })), _path6210 || (_path6210 = /*#__PURE__*/React.createElement("path", {
    d: "M54 119h1v1h-1z",
    fill: "#c36e5b"
  })), _path6211 || (_path6211 = /*#__PURE__*/React.createElement("path", {
    d: "M55 119h1v1h-1z",
    fill: "#c26756"
  })), _path6212 || (_path6212 = /*#__PURE__*/React.createElement("path", {
    d: "M56 119h1v1h-1z",
    fill: "#bf604f"
  })), _path6213 || (_path6213 = /*#__PURE__*/React.createElement("path", {
    d: "M57 120v-1h1v1z",
    fill: "#bf5947"
  })), _path6214 || (_path6214 = /*#__PURE__*/React.createElement("path", {
    d: "M58 119h1v1h-1z",
    fill: "#bc5340"
  })), _path6215 || (_path6215 = /*#__PURE__*/React.createElement("path", {
    d: "M59 119h1v1h-1z",
    fill: "#b84d3c"
  })), _path6216 || (_path6216 = /*#__PURE__*/React.createElement("path", {
    d: "M61 120h-1v-1h1z",
    fill: "#b74937"
  })), _path6217 || (_path6217 = /*#__PURE__*/React.createElement("path", {
    d: "M62 119v1h-1v-1z",
    fill: "#b44635"
  })), _path6218 || (_path6218 = /*#__PURE__*/React.createElement("path", {
    d: "M62 119h1v1h-1z",
    fill: "#b14232"
  })), _path6219 || (_path6219 = /*#__PURE__*/React.createElement("path", {
    d: "M63 119h1v1h-1z",
    fill: "#b24032"
  })), _path6220 || (_path6220 = /*#__PURE__*/React.createElement("path", {
    d: "M64 120v-1h1v1z",
    fill: "#b23e30"
  })), _path6221 || (_path6221 = /*#__PURE__*/React.createElement("path", {
    d: "M65 119h1v1h-1z",
    fill: "#b23c2f"
  })), _path6222 || (_path6222 = /*#__PURE__*/React.createElement("path", {
    d: "M66 119h1v1h-1z",
    fill: "#b03a2d"
  })), _path6223 || (_path6223 = /*#__PURE__*/React.createElement("path", {
    d: "M67 120v-1h1v1z",
    fill: "#af3a2b"
  })), _path6224 || (_path6224 = /*#__PURE__*/React.createElement("path", {
    d: "M68 119h1v1h-1z",
    fill: "#b13c2c"
  })), _path6225 || (_path6225 = /*#__PURE__*/React.createElement("path", {
    d: "M70 119v1h-1v-1z",
    fill: "#b43f2e"
  })), _path6226 || (_path6226 = /*#__PURE__*/React.createElement("path", {
    d: "M70 120v-1h1v1z",
    fill: "#b74636"
  })), _path6227 || (_path6227 = /*#__PURE__*/React.createElement("path", {
    d: "M71 120v-1h1v1z",
    fill: "#b84b3c"
  })), _path6228 || (_path6228 = /*#__PURE__*/React.createElement("path", {
    d: "M73 119v1h-1v-1z",
    fill: "#ba5142"
  })), _path6229 || (_path6229 = /*#__PURE__*/React.createElement("path", {
    d: "M74 119v1h-1v-1z",
    fill: "#bc5949"
  })), _path6230 || (_path6230 = /*#__PURE__*/React.createElement("path", {
    d: "M74 119h1v1h-1z",
    fill: "#bc6551"
  })), _path6231 || (_path6231 = /*#__PURE__*/React.createElement("path", {
    d: "M76 120h-1v-1h1z",
    fill: "#bf6c59"
  })), _path6232 || (_path6232 = /*#__PURE__*/React.createElement("path", {
    d: "M77 120h-1v-1h1z",
    fill: "#c47560"
  })), _path6233 || (_path6233 = /*#__PURE__*/React.createElement("path", {
    d: "M78 119v1h-1v-1z",
    fill: "#ca7e6a"
  })), _path6234 || (_path6234 = /*#__PURE__*/React.createElement("path", {
    d: "M79 119v1h-1v-1z",
    fill: "#cc8775"
  })), _path6235 || (_path6235 = /*#__PURE__*/React.createElement("path", {
    d: "M79 119h1v1h-1z",
    fill: "#d09280"
  })), _path6236 || (_path6236 = /*#__PURE__*/React.createElement("path", {
    d: "M81 119v1h-1v-1z",
    fill: "#d09f8a"
  })), _path6237 || (_path6237 = /*#__PURE__*/React.createElement("path", {
    d: "M81 120v-1h1v1z",
    fill: "#d1af99"
  })), _path6238 || (_path6238 = /*#__PURE__*/React.createElement("path", {
    d: "M83 119v1h-1v-1z",
    fill: "#d9cfc1"
  })), _path6239 || (_path6239 = /*#__PURE__*/React.createElement("path", {
    d: "M84 119v1h-1v-1z",
    fill: "#d2d0cb"
  })), _path6240 || (_path6240 = /*#__PURE__*/React.createElement("path", {
    d: "M85 120h-1v-1h1z",
    fill: "#d0d2cb"
  })), _path6241 || (_path6241 = /*#__PURE__*/React.createElement("path", {
    d: "M86 119v1h-1v-1z",
    fill: "#d2d1cc"
  })), _path6242 || (_path6242 = /*#__PURE__*/React.createElement("path", {
    d: "M86 120v-1h1v1z",
    fill: "#d2d1cd"
  })), _path6243 || (_path6243 = /*#__PURE__*/React.createElement("path", {
    d: "M88 120h-1v-1h1z",
    fill: "#d1d0cc"
  })), _path6244 || (_path6244 = /*#__PURE__*/React.createElement("path", {
    d: "M90 119v1h-1v-1z",
    fill: "#cecdc9"
  })), _path6245 || (_path6245 = /*#__PURE__*/React.createElement("path", {
    d: "M90 119h1v1h-1z",
    fill: "#d1d0cd"
  })), _path6246 || (_path6246 = /*#__PURE__*/React.createElement("path", {
    d: "M92 119v1h-1v-1z",
    fill: "#d2d1cf",
    fillOpacity: 0.969
  })), _path6247 || (_path6247 = /*#__PURE__*/React.createElement("path", {
    d: "M93 119v1h-1v-1z",
    fill: "#d8d8d8",
    fillOpacity: 0.498
  })), _path6248 || (_path6248 = /*#__PURE__*/React.createElement("path", {
    d: "M94 119v1h-1v-1z",
    fill: "#e2e2e2",
    fillOpacity: 0.035
  })), _path6249 || (_path6249 = /*#__PURE__*/React.createElement("path", {
    d: "M37 120v1h-1v-1z",
    fill: "#dfdfd8",
    fillOpacity: 0.286
  })), _path6250 || (_path6250 = /*#__PURE__*/React.createElement("path", {
    d: "M38 121h-1v-1h1z",
    fill: "#c9c8c3",
    fillOpacity: 0.933
  })), _path6251 || (_path6251 = /*#__PURE__*/React.createElement("path", {
    d: "M39 120v1h-1v-1z",
    fill: "#bcbbb7"
  })), _path6252 || (_path6252 = /*#__PURE__*/React.createElement("path", {
    d: "M40 121h-1v-1h1z",
    fill: "#b7b6b3"
  })), _path6253 || (_path6253 = /*#__PURE__*/React.createElement("path", {
    d: "M41 120h1v1h-1z",
    fill: "#b8b3b2"
  })), _path6254 || (_path6254 = /*#__PURE__*/React.createElement("path", {
    d: "M43 120h1v1h-1z",
    fill: "#b6b8b4"
  })), _path6255 || (_path6255 = /*#__PURE__*/React.createElement("path", {
    d: "M44 121v-1h1v1z",
    fill: "#bbbab7"
  })), _path6256 || (_path6256 = /*#__PURE__*/React.createElement("path", {
    d: "M46 120v1h-1v-1z",
    fill: "#bfbdbb"
  })), _path6257 || (_path6257 = /*#__PURE__*/React.createElement("path", {
    d: "M49 120v1h-1v-1z",
    fill: "#c4c8c3"
  })), _path6258 || (_path6258 = /*#__PURE__*/React.createElement("path", {
    d: "M49 121v-1h1v1z",
    fill: "#c6cac5"
  })), _path6259 || (_path6259 = /*#__PURE__*/React.createElement("path", {
    d: "M51 120v1h-1v-1z",
    fill: "#c9cdc7"
  })), _path6260 || (_path6260 = /*#__PURE__*/React.createElement("path", {
    d: "M51 121v-1h1v1z",
    fill: "#cbccc6"
  })), _path6261 || (_path6261 = /*#__PURE__*/React.createElement("path", {
    d: "M52 120h1v1h-1z",
    fill: "#cecec7"
  })), _path6262 || (_path6262 = /*#__PURE__*/React.createElement("path", {
    d: "M54 121h-1v-1h1z",
    fill: "#d0d0c9"
  })), _path6263 || (_path6263 = /*#__PURE__*/React.createElement("path", {
    d: "M54 121v-1h1v1z",
    fill: "#d2d2ca"
  })), _path6264 || (_path6264 = /*#__PURE__*/React.createElement("path", {
    d: "M56 121h-1v-1h1z",
    fill: "#d4d3ca"
  })), _path6265 || (_path6265 = /*#__PURE__*/React.createElement("path", {
    d: "M56 121v-1h1v1z",
    fill: "#d5d2ca"
  })), _path6266 || (_path6266 = /*#__PURE__*/React.createElement("path", {
    d: "M57 120h1v1h-1z",
    fill: "#d7d3c8"
  })), _path6267 || (_path6267 = /*#__PURE__*/React.createElement("path", {
    d: "M59 120v1h-1v-1z",
    fill: "#d9d4c6"
  })), _path6268 || (_path6268 = /*#__PURE__*/React.createElement("path", {
    d: "M59 121v-1h1v1z",
    fill: "#d9d2c3"
  })), _path6269 || (_path6269 = /*#__PURE__*/React.createElement("path", {
    d: "M61 120v1h-1v-1z",
    fill: "#d8d1c0"
  })), _path6270 || (_path6270 = /*#__PURE__*/React.createElement("path", {
    d: "M62 121h-1v-1h1z",
    fill: "#d7cebc"
  })), _path6271 || (_path6271 = /*#__PURE__*/React.createElement("path", {
    d: "M62 121v-1h1v1z",
    fill: "#d6cbbb"
  })), _path6272 || (_path6272 = /*#__PURE__*/React.createElement("path", {
    d: "M64 121h-1v-1h1z",
    fill: "#d9cabb"
  })), _path6273 || (_path6273 = /*#__PURE__*/React.createElement("path", {
    d: "M65 121h-1v-1h1z",
    fill: "#dac8ba"
  })), _path6274 || (_path6274 = /*#__PURE__*/React.createElement("path", {
    d: "M65 121v-1h1v1z",
    fill: "#dac8b9"
  })), _path6275 || (_path6275 = /*#__PURE__*/React.createElement("path", {
    d: "M66 121v-1h1v1z",
    fill: "#d8c8b7"
  })), _path6276 || (_path6276 = /*#__PURE__*/React.createElement("path", {
    d: "M68 121h-1v-1h1z",
    fill: "#d8c7b6"
  })), _path6277 || (_path6277 = /*#__PURE__*/React.createElement("path", {
    d: "M68 121v-1h1v1z",
    fill: "#d9c9b7"
  })), _path6278 || (_path6278 = /*#__PURE__*/React.createElement("path", {
    d: "M70 121h-1v-1h1z",
    fill: "#d9caba"
  })), _path6279 || (_path6279 = /*#__PURE__*/React.createElement("path", {
    d: "M71 120v1h-1v-1z",
    fill: "#dacfc2"
  })), _path6280 || (_path6280 = /*#__PURE__*/React.createElement("path", {
    d: "M72 121h-1v-1h1z",
    fill: "#dad2c4"
  })), _path6281 || (_path6281 = /*#__PURE__*/React.createElement("path", {
    d: "M72 120h1v1h-1z",
    fill: "#d8d3c5"
  })), _path6282 || (_path6282 = /*#__PURE__*/React.createElement("path", {
    d: "M74 121h-1v-1h1z",
    fill: "#d7d4c7"
  })), _path6283 || (_path6283 = /*#__PURE__*/React.createElement("path", {
    d: "M77 120v1h-1v-1z",
    fill: "#d5d4cb"
  })), _path6284 || (_path6284 = /*#__PURE__*/React.createElement("path", {
    d: "M78 120v1h-1v-1z",
    fill: "#d4d3cb"
  })), _path6285 || (_path6285 = /*#__PURE__*/React.createElement("path", {
    d: "M78 121v-1h1v1z",
    fill: "#d2d3ca"
  })), _path6286 || (_path6286 = /*#__PURE__*/React.createElement("path", {
    d: "M80 120v1h-1v-1z",
    fill: "#ced0c7"
  })), _path6287 || (_path6287 = /*#__PURE__*/React.createElement("path", {
    d: "M80 121v-1h1v1z",
    fill: "#c9cdc6"
  })), _path6288 || (_path6288 = /*#__PURE__*/React.createElement("path", {
    d: "M81 120h1v1h-1z",
    fill: "#c8ccc5"
  })), _path6289 || (_path6289 = /*#__PURE__*/React.createElement("path", {
    d: "M83 120v1h-1v-1z",
    fill: "#c7c5c2"
  })), _path6290 || (_path6290 = /*#__PURE__*/React.createElement("path", {
    d: "M84 121h-1v-1h1z",
    fill: "#c2c2c3"
  })), _path6291 || (_path6291 = /*#__PURE__*/React.createElement("path", {
    d: "M85 121h-1v-1h1z",
    fill: "#c0c1be"
  })), _path6292 || (_path6292 = /*#__PURE__*/React.createElement("path", {
    d: "M86 121v-1h1v1z",
    fill: "#bdbcba"
  })), _path6293 || (_path6293 = /*#__PURE__*/React.createElement("path", {
    d: "M88 120v1h-1v-1z",
    fill: "#bcbbb8"
  })), _path6294 || (_path6294 = /*#__PURE__*/React.createElement("path", {
    d: "M88 120h1v1h-1z",
    fill: "#bdbcb9"
  })), _path6295 || (_path6295 = /*#__PURE__*/React.createElement("path", {
    d: "M91 121h-1v-1h1z",
    fill: "#cac9c7",
    fillOpacity: 0.929
  })), _path6296 || (_path6296 = /*#__PURE__*/React.createElement("path", {
    d: "M92 121h-1v-1h1z",
    fill: "#d8d8d5",
    fillOpacity: 0.31
  })), _path6297 || (_path6297 = /*#__PURE__*/React.createElement("path", {
    d: "M38 122h-1v-1h1z",
    fill: "#c7c7c5",
    fillOpacity: 0.38
  })), _path6298 || (_path6298 = /*#__PURE__*/React.createElement("path", {
    d: "M38 121h1v1h-1z",
    fill: "#bcbab6",
    fillOpacity: 0.996
  })), _path6299 || (_path6299 = /*#__PURE__*/React.createElement("path", {
    d: "M39 121h1v1h-1z",
    fill: "#b2b1ad"
  })), _path6300 || (_path6300 = /*#__PURE__*/React.createElement("path", {
    d: "M41 121v1h-1v-1z",
    fill: "#afafab"
  })), _path6301 || (_path6301 = /*#__PURE__*/React.createElement("path", {
    d: "M41 122v-1h1v1z",
    fill: "#abaea7"
  })), _path6302 || (_path6302 = /*#__PURE__*/React.createElement("path", {
    d: "M44 122v-1h1v1z",
    fill: "#a8a7a6"
  })), _path6303 || (_path6303 = /*#__PURE__*/React.createElement("path", {
    d: "M48 121v1h-1v-1z",
    fill: "#aaa9a7"
  })), _path6304 || (_path6304 = /*#__PURE__*/React.createElement("path", {
    d: "M48 121h1v1h-1z",
    fill: "#aaa9a8"
  })), _path6305 || (_path6305 = /*#__PURE__*/React.createElement("path", {
    d: "M50 122h-1v-1h1z",
    fill: "#aba9a6"
  })), _path6306 || (_path6306 = /*#__PURE__*/React.createElement("path", {
    d: "M51 122h-1v-1h1z",
    fill: "#abaaa5"
  })), _path6307 || (_path6307 = /*#__PURE__*/React.createElement("path", {
    d: "M52 122h-1v-1h1z",
    fill: "#abaca4"
  })), _path6308 || (_path6308 = /*#__PURE__*/React.createElement("path", {
    d: "M53 121v1h-1v-1z",
    fill: "#acada7"
  })), _path6309 || (_path6309 = /*#__PURE__*/React.createElement("path", {
    d: "M55 122h-1v-1h1z",
    fill: "#b1b1ae"
  })), _path6310 || (_path6310 = /*#__PURE__*/React.createElement("path", {
    d: "M55 121h1v1h-1z",
    fill: "#b2b3ae"
  })), _path6311 || (_path6311 = /*#__PURE__*/React.createElement("path", {
    d: "M56 121h1v1h-1z",
    fill: "#b4b4af"
  })), _path6312 || (_path6312 = /*#__PURE__*/React.createElement("path", {
    d: "M57 122v-1h1v1z",
    fill: "#b4b7b2"
  })), _path6313 || (_path6313 = /*#__PURE__*/React.createElement("path", {
    d: "M58 122v-1h1v1z",
    fill: "#b6b9b4"
  })), _path6314 || (_path6314 = /*#__PURE__*/React.createElement("path", {
    d: "M60 121h1v1h-1z",
    fill: "#b8bab2"
  })), _path6315 || (_path6315 = /*#__PURE__*/React.createElement("path", {
    d: "M61 121h1v1h-1z",
    fill: "#b7bbb3"
  })), _path6316 || (_path6316 = /*#__PURE__*/React.createElement("path", {
    d: "M62 122v-1h1v1z",
    fill: "#b7bbb4"
  })), _path6317 || (_path6317 = /*#__PURE__*/React.createElement("path", {
    d: "M64 122v-1h1v1z",
    fill: "#b8b8b3"
  })), _path6318 || (_path6318 = /*#__PURE__*/React.createElement("path", {
    d: "M65 121h1v1h-1z",
    fill: "#b8b8b5"
  })), _path6319 || (_path6319 = /*#__PURE__*/React.createElement("path", {
    d: "M67 122h-1v-1h1z",
    fill: "#b7b8b8"
  })), _path6320 || (_path6320 = /*#__PURE__*/React.createElement("path", {
    d: "M68 121v1h-1v-1z",
    fill: "#b8b8b9"
  })), _path6321 || (_path6321 = /*#__PURE__*/React.createElement("path", {
    d: "M69 122h-1v-1h1z",
    fill: "#b7b8ba"
  })), _path6322 || (_path6322 = /*#__PURE__*/React.createElement("path", {
    d: "M70 121v1h-1v-1z",
    fill: "#b7b7b9"
  })), _path6323 || (_path6323 = /*#__PURE__*/React.createElement("path", {
    d: "M71 122h-1v-1h1z",
    fill: "#b6b7b7"
  })), _path6324 || (_path6324 = /*#__PURE__*/React.createElement("path", {
    d: "M72 122h-1v-1h1z",
    fill: "#b6b6b5"
  })), _path6325 || (_path6325 = /*#__PURE__*/React.createElement("path", {
    d: "M72 122v-1h1v1z",
    fill: "#b4b6b4"
  })), _path6326 || (_path6326 = /*#__PURE__*/React.createElement("path", {
    d: "M74 121v1h-1v-1z",
    fill: "#b3b5b0"
  })), _path6327 || (_path6327 = /*#__PURE__*/React.createElement("path", {
    d: "M75 122h-1v-1h1z",
    fill: "#b2b5ae"
  })), _path6328 || (_path6328 = /*#__PURE__*/React.createElement("path", {
    d: "M75 122v-1h1v1z",
    fill: "#b3b4ae"
  })), _path6329 || (_path6329 = /*#__PURE__*/React.createElement("path", {
    d: "M76 122v-1h1v1z",
    fill: "#b3b3af"
  })), _path6330 || (_path6330 = /*#__PURE__*/React.createElement("path", {
    d: "M77 121h1v1h-1z",
    fill: "#b2b2af"
  })), _path6331 || (_path6331 = /*#__PURE__*/React.createElement("path", {
    d: "M79 121v1h-1v-1z",
    fill: "#afb2ae"
  })), _path6332 || (_path6332 = /*#__PURE__*/React.createElement("path", {
    d: "M79 121h1v1h-1z",
    fill: "#aeb2ad"
  })), _path6333 || (_path6333 = /*#__PURE__*/React.createElement("path", {
    d: "M80 121h1v1h-1z",
    fill: "#afb0ae"
  })), _path6334 || (_path6334 = /*#__PURE__*/React.createElement("path", {
    d: "M81 122v-1h1v1z",
    fill: "#b1b0ae"
  })), _path6335 || (_path6335 = /*#__PURE__*/React.createElement("path", {
    d: "M83 122h-1v-1h1z",
    fill: "#aeafaf"
  })), _path6336 || (_path6336 = /*#__PURE__*/React.createElement("path", {
    d: "M84 121v1h-1v-1z",
    fill: "#acadaf"
  })), _path6337 || (_path6337 = /*#__PURE__*/React.createElement("path", {
    d: "M85 122h-1v-1h1z",
    fill: "#adaeaa"
  })), _path6338 || (_path6338 = /*#__PURE__*/React.createElement("path", {
    d: "M85 121h1v1h-1z",
    fill: "#afaead"
  })), _path6339 || (_path6339 = /*#__PURE__*/React.createElement("path", {
    d: "M86 122v-1h1v1z",
    fill: "#b1b0af"
  })), _path6340 || (_path6340 = /*#__PURE__*/React.createElement("path", {
    d: "M89 122h-1v-1h1z",
    fill: "#b7b6b4"
  })), _path6341 || (_path6341 = /*#__PURE__*/React.createElement("path", {
    d: "M90 122h-1v-1h1z",
    fill: "#bfbebc",
    fillOpacity: 0.992
  })), _path6342 || (_path6342 = /*#__PURE__*/React.createElement("path", {
    d: "M91 121v1h-1v-1z",
    fill: "#cdcdca",
    fillOpacity: 0.361
  })), _path6343 || (_path6343 = /*#__PURE__*/React.createElement("path", {
    d: "M39 122v1h-1v-1z",
    fill: "#b9b9b4",
    fillOpacity: 0.588
  })), _path6344 || (_path6344 = /*#__PURE__*/React.createElement("path", {
    d: "M39 122h1v1h-1z",
    fill: "#bab9b5"
  })), _path6345 || (_path6345 = /*#__PURE__*/React.createElement("path", {
    d: "M42 123h-1v-1h1z",
    fill: "#b0afac"
  })), _path6346 || (_path6346 = /*#__PURE__*/React.createElement("path", {
    d: "M42 122h1v1h-1z",
    fill: "#adaca9"
  })), _path6347 || (_path6347 = /*#__PURE__*/React.createElement("path", {
    d: "M44 123v-1h1v1z",
    fill: "#a8a9a4"
  })), _path6348 || (_path6348 = /*#__PURE__*/React.createElement("path", {
    d: "M45 122h1v1h-1z",
    fill: "#a4a6a4"
  })), _path6349 || (_path6349 = /*#__PURE__*/React.createElement("path", {
    d: "M47 123h-1v-1h1z",
    fill: "#a2a4a2"
  })), _path6350 || (_path6350 = /*#__PURE__*/React.createElement("path", {
    d: "M48 123h-1v-1h1z",
    fill: "#a0a39e"
  })), _path6351 || (_path6351 = /*#__PURE__*/React.createElement("path", {
    d: "M48 123v-1h1v1z",
    fill: "#9da09a"
  })), _path6352 || (_path6352 = /*#__PURE__*/React.createElement("path", {
    d: "M50 122v1h-1v-1z",
    fill: "#9c9d9a"
  })), _path6353 || (_path6353 = /*#__PURE__*/React.createElement("path", {
    d: "M51 122v1h-1v-1z",
    fill: "#9c9c97"
  })), _path6354 || (_path6354 = /*#__PURE__*/React.createElement("path", {
    d: "M51 123v-1h1v1z",
    fill: "#9c9e96"
  })), _path6355 || (_path6355 = /*#__PURE__*/React.createElement("path", {
    d: "M53 123h-1v-1h1z",
    fill: "#9c9e98"
  })), _path6356 || (_path6356 = /*#__PURE__*/React.createElement("path", {
    d: "M54 123h-1v-1h1z",
    fill: "#9e9f9b"
  })), _path6357 || (_path6357 = /*#__PURE__*/React.createElement("path", {
    d: "M55 122v1h-1v-1z",
    fill: "#9ea09c"
  })), _path6358 || (_path6358 = /*#__PURE__*/React.createElement("path", {
    d: "M55 122h1v1h-1z",
    fill: "#9fa19d"
  })), _path6359 || (_path6359 = /*#__PURE__*/React.createElement("path", {
    d: "M64 122h1v1h-1z",
    fill: "#a1a19d"
  })), _path6360 || (_path6360 = /*#__PURE__*/React.createElement("path", {
    d: "M66 123v-1h1v1z",
    fill: "#a0a19d"
  })), _path6361 || (_path6361 = /*#__PURE__*/React.createElement("path", {
    d: "M67 122h1v1h-1z",
    fill: "#a2a29f"
  })), _path6362 || (_path6362 = /*#__PURE__*/React.createElement("path", {
    d: "M71 123v-1h1v1z",
    fill: "#a2a2a0"
  })), _path6363 || (_path6363 = /*#__PURE__*/React.createElement("path", {
    d: "M73 122v1h-1v-1z",
    fill: "#a3a29e"
  })), _path6364 || (_path6364 = /*#__PURE__*/React.createElement("path", {
    d: "M75 123h-1v-1h1z",
    fill: "#a1a49e"
  })), _path6365 || (_path6365 = /*#__PURE__*/React.createElement("path", {
    d: "M75 122h1v1h-1z",
    fill: "#a2a59f"
  })), _path6366 || (_path6366 = /*#__PURE__*/React.createElement("path", {
    d: "M77 123v-1h1v1z",
    fill: "#a5a5a2"
  })), _path6367 || (_path6367 = /*#__PURE__*/React.createElement("path", {
    d: "M78 123v-1h1v1z",
    fill: "#a7a5a5"
  })), _path6368 || (_path6368 = /*#__PURE__*/React.createElement("path", {
    d: "M80 123h-1v-1h1z",
    fill: "#a5a6a5"
  })), _path6369 || (_path6369 = /*#__PURE__*/React.createElement("path", {
    d: "M80 123v-1h1v1z",
    fill: "#a5a7a5"
  })), _path6370 || (_path6370 = /*#__PURE__*/React.createElement("path", {
    d: "M83 122v1h-1v-1z",
    fill: "#a8a9a6"
  })), _path6371 || (_path6371 = /*#__PURE__*/React.createElement("path", {
    d: "M83 123v-1h1v1z",
    fill: "#a9a9a7"
  })), _path6372 || (_path6372 = /*#__PURE__*/React.createElement("path", {
    d: "M86 122v1h-1v-1z",
    fill: "#aeaeab"
  })), _path6373 || (_path6373 = /*#__PURE__*/React.createElement("path", {
    d: "M86 122h1v1h-1z",
    fill: "#b2b0af"
  })), _path6374 || (_path6374 = /*#__PURE__*/React.createElement("path", {
    d: "M87 122h1v1h-1z",
    fill: "#b3b1b0"
  })), _path6375 || (_path6375 = /*#__PURE__*/React.createElement("path", {
    d: "M88 122h1v1h-1z",
    fill: "#bfbebe"
  })), _path6376 || (_path6376 = /*#__PURE__*/React.createElement("path", {
    d: "M90 122v1h-1v-1z",
    fill: "#bebcbb",
    fillOpacity: 0.678
  })), _path6377 || (_path6377 = /*#__PURE__*/React.createElement("path", {
    d: "M90 123v-1h1v1z",
    fill: "#aaa",
    fillOpacity: 0.012
  })), _path6378 || (_path6378 = /*#__PURE__*/React.createElement("path", {
    d: "M38 123h1v1h-1z",
    fill: "#b9b9b9",
    fillOpacity: 0.043
  })), _path6379 || (_path6379 = /*#__PURE__*/React.createElement("path", {
    d: "M39 123h1v1h-1z",
    fill: "#afaeac",
    fillOpacity: 0.62
  })), _path6380 || (_path6380 = /*#__PURE__*/React.createElement("path", {
    d: "M41 123v1h-1v-1z",
    fill: "#afaeac",
    fillOpacity: 0.957
  })), _path6381 || (_path6381 = /*#__PURE__*/React.createElement("path", {
    d: "M43 123v1h-1v-1z",
    fill: "#b4b4b0"
  })), _path6382 || (_path6382 = /*#__PURE__*/React.createElement("path", {
    d: "M44 123v1h-1v-1z",
    fill: "#b1b2ad"
  })), _path6383 || (_path6383 = /*#__PURE__*/React.createElement("path", {
    d: "M44 124v-1h1v1z",
    fill: "#b0b0ab"
  })), _path6384 || (_path6384 = /*#__PURE__*/React.createElement("path", {
    d: "M46 123v1h-1v-1z",
    fill: "#afb0ab"
  })), _path6385 || (_path6385 = /*#__PURE__*/React.createElement("path", {
    d: "M46 123h1v1h-1z",
    fill: "#afafaa"
  })), _path6386 || (_path6386 = /*#__PURE__*/React.createElement("path", {
    d: "M48 124h-1v-1h1z",
    fill: "#aeaea8"
  })), _path6387 || (_path6387 = /*#__PURE__*/React.createElement("path", {
    d: "M48 124v-1h1v1z",
    fill: "#aaaaa4"
  })), _path6388 || (_path6388 = /*#__PURE__*/React.createElement("path", {
    d: "M50 124h-1v-1h1z",
    fill: "#a6a59e"
  })), _path6389 || (_path6389 = /*#__PURE__*/React.createElement("path", {
    d: "M51 124h-1v-1h1z",
    fill: "#a6a49d"
  })), _path6390 || (_path6390 = /*#__PURE__*/React.createElement("path", {
    d: "M53 124v-1h1v1z",
    fill: "#a4a49f"
  })), _path6391 || (_path6391 = /*#__PURE__*/React.createElement("path", {
    d: "M56 124v-1h1v1z",
    fill: "#a3a39f"
  })), _path6392 || (_path6392 = /*#__PURE__*/React.createElement("path", {
    d: "M62 124h-1v-1h1z",
    fill: "#a1a29c"
  })), _path6393 || (_path6393 = /*#__PURE__*/React.createElement("path", {
    d: "M65 124h-1v-1h1z",
    fill: "#9fa09a"
  })), _path6394 || (_path6394 = /*#__PURE__*/React.createElement("path", {
    d: "M66 124h-1v-1h1z",
    fill: "#a0a09b"
  })), _path6395 || (_path6395 = /*#__PURE__*/React.createElement("path", {
    d: "M71 124h-1v-1h1z",
    fill: "#a3a49f"
  })), _path6396 || (_path6396 = /*#__PURE__*/React.createElement("path", {
    d: "M72 124h-1v-1h1z",
    fill: "#a4a5a0"
  })), _path6397 || (_path6397 = /*#__PURE__*/React.createElement("path", {
    d: "M74 123h1v1h-1z",
    fill: "#a6a7a2"
  })), _path6398 || (_path6398 = /*#__PURE__*/React.createElement("path", {
    d: "M75 124v-1h1v1z",
    fill: "#a8a7a3"
  })), _path6399 || (_path6399 = /*#__PURE__*/React.createElement("path", {
    d: "M77 123v1h-1v-1z",
    fill: "#aaa9a5"
  })), _path6400 || (_path6400 = /*#__PURE__*/React.createElement("path", {
    d: "M77 123h1v1h-1z",
    fill: "#acaba7"
  })), _path6401 || (_path6401 = /*#__PURE__*/React.createElement("path", {
    d: "M79 124h-1v-1h1z",
    fill: "#acaca9"
  })), _path6402 || (_path6402 = /*#__PURE__*/React.createElement("path", {
    d: "M79 123h1v1h-1z",
    fill: "#adadaa"
  })), _path6403 || (_path6403 = /*#__PURE__*/React.createElement("path", {
    d: "M81 124h-1v-1h1z",
    fill: "#aeafab"
  })), _path6404 || (_path6404 = /*#__PURE__*/React.createElement("path", {
    d: "M87 124h-1v-1h1z",
    fill: "#b5b5b3"
  })), _path6405 || (_path6405 = /*#__PURE__*/React.createElement("path", {
    d: "M87 124v-1h1v1z",
    fill: "#b8b8b7"
  })), _path6406 || (_path6406 = /*#__PURE__*/React.createElement("path", {
    d: "M89 123v1h-1v-1z",
    fill: "#b3b3b3",
    fillOpacity: 0.89
  })), _path6407 || (_path6407 = /*#__PURE__*/React.createElement("path", {
    d: "M89 124v-1h1v1z",
    fill: "#babac0",
    fillOpacity: 0.145
  })), _path6408 || (_path6408 = /*#__PURE__*/React.createElement("path", {
    d: "M40 125v-1h1v1z",
    fill: "#a6a6a6",
    fillOpacity: 0.169
  })), _path6409 || (_path6409 = /*#__PURE__*/React.createElement("path", {
    d: "M41 124h1v1h-1z",
    fill: "#a0a09d",
    fillOpacity: 0.4
  })), _path6410 || (_path6410 = /*#__PURE__*/React.createElement("path", {
    d: "M42 124h1v1h-1z",
    fill: "#9d9f9c",
    fillOpacity: 0.647
  })), _path6411 || (_path6411 = /*#__PURE__*/React.createElement("path", {
    d: "M44 125h-1v-1h1z",
    fill: "#9ca09f",
    fillOpacity: 0.835
  })), _path6412 || (_path6412 = /*#__PURE__*/React.createElement("path", {
    d: "M44 124h1v1h-1z",
    fill: "#9da1a1",
    fillOpacity: 0.953
  })), _path6413 || (_path6413 = /*#__PURE__*/React.createElement("path", {
    d: "M45 125v-1h1v1z",
    fill: "#a3a5a4"
  })), _path6414 || (_path6414 = /*#__PURE__*/React.createElement("path", {
    d: "M46 124h1v1h-1z",
    fill: "#a9aba9"
  })), _path6415 || (_path6415 = /*#__PURE__*/React.createElement("path", {
    d: "M47 125v-1h1v1z",
    fill: "#acafad"
  })), _path6416 || (_path6416 = /*#__PURE__*/React.createElement("path", {
    d: "M49 125h-1v-1h1z",
    fill: "#abadab"
  })), _path6417 || (_path6417 = /*#__PURE__*/React.createElement("path", {
    d: "M51 125h-1v-1h1z",
    fill: "#a9a8a5"
  })), _path6418 || (_path6418 = /*#__PURE__*/React.createElement("path", {
    d: "M52 125h-1v-1h1z",
    fill: "#a8a8a4"
  })), _path6419 || (_path6419 = /*#__PURE__*/React.createElement("path", {
    d: "M52 125v-1h1v1z",
    fill: "#aaa9a6"
  })), _path6420 || (_path6420 = /*#__PURE__*/React.createElement("path", {
    d: "M54 124h1v1h-1z",
    fill: "#a9aba6"
  })), _path6421 || (_path6421 = /*#__PURE__*/React.createElement("path", {
    d: "M56 125v-1h1v1z",
    fill: "#aaaba7"
  })), _path6422 || (_path6422 = /*#__PURE__*/React.createElement("path", {
    d: "M59 124h1v1h-1z",
    fill: "#abaca8"
  })), _path6423 || (_path6423 = /*#__PURE__*/React.createElement("path", {
    d: "M64 124v1h-1v-1z",
    fill: "#a9aaa5"
  })), _path6424 || (_path6424 = /*#__PURE__*/React.createElement("path", {
    d: "M66 124v1h-1v-1z",
    fill: "#abaca6"
  })), _path6425 || (_path6425 = /*#__PURE__*/React.createElement("path", {
    d: "M68 125h-1v-1h1z",
    fill: "#acada5"
  })), _path6426 || (_path6426 = /*#__PURE__*/React.createElement("path", {
    d: "M71 125h-1v-1h1z",
    fill: "#adada7"
  })), _path6427 || (_path6427 = /*#__PURE__*/React.createElement("path", {
    d: "M73 124h1v1h-1z",
    fill: "#aeafa9"
  })), _path6428 || (_path6428 = /*#__PURE__*/React.createElement("path", {
    d: "M74 124h1v1h-1z",
    fill: "#aeaeaa"
  })), _path6429 || (_path6429 = /*#__PURE__*/React.createElement("path", {
    d: "M75 124h1v1h-1z",
    fill: "#b0aeaa"
  })), _path6430 || (_path6430 = /*#__PURE__*/React.createElement("path", {
    d: "M76 125v-1h1v1z",
    fill: "#b1afab"
  })), _path6431 || (_path6431 = /*#__PURE__*/React.createElement("path", {
    d: "M78 125h-1v-1h1z",
    fill: "#b2afac"
  })), _path6432 || (_path6432 = /*#__PURE__*/React.createElement("path", {
    d: "M78 125v-1h1v1z",
    fill: "#b0b1ac"
  })), _path6433 || (_path6433 = /*#__PURE__*/React.createElement("path", {
    d: "M79 124h1v1h-1z",
    fill: "#b1b2ae"
  })), _path6434 || (_path6434 = /*#__PURE__*/React.createElement("path", {
    d: "M81 124v1h-1v-1z",
    fill: "#b2b2b1"
  })), _path6435 || (_path6435 = /*#__PURE__*/React.createElement("path", {
    d: "M82 124v1h-1v-1z",
    fill: "#b1b1b3"
  })), _path6436 || (_path6436 = /*#__PURE__*/React.createElement("path", {
    d: "M83 125h-1v-1h1z",
    fill: "#b0b0b2"
  })), _path6437 || (_path6437 = /*#__PURE__*/React.createElement("path", {
    d: "M83 124h1v1h-1z",
    fill: "#aeaeb0"
  })), _path6438 || (_path6438 = /*#__PURE__*/React.createElement("path", {
    d: "M85 124v1h-1v-1z",
    fill: "#a9aaac"
  })), _path6439 || (_path6439 = /*#__PURE__*/React.createElement("path", {
    d: "M85 125v-1h1v1z",
    fill: "#9fa0a1",
    fillOpacity: 0.988
  })), _path6440 || (_path6440 = /*#__PURE__*/React.createElement("path", {
    d: "M86 124h1v1h-1z",
    fill: "#999b9d",
    fillOpacity: 0.886
  })), _path6441 || (_path6441 = /*#__PURE__*/React.createElement("path", {
    d: "M88 125h-1v-1h1z",
    fill: "#959898",
    fillOpacity: 0.663
  })), _path6442 || (_path6442 = /*#__PURE__*/React.createElement("path", {
    d: "M88 124h1v1h-1z",
    fill: "#97979b",
    fillOpacity: 0.212
  })), _path6443 || (_path6443 = /*#__PURE__*/React.createElement("path", {
    d: "M43 125h1v1h-1z",
    fill: "#66667f",
    fillOpacity: 0.039
  })), _path6444 || (_path6444 = /*#__PURE__*/React.createElement("path", {
    d: "M44 126v-1h1v1z",
    fill: "#7f8585",
    fillOpacity: 0.165
  })), _path6445 || (_path6445 = /*#__PURE__*/React.createElement("path", {
    d: "M46 125v1h-1v-1z",
    fill: "#7f8588",
    fillOpacity: 0.322
  })), _path6446 || (_path6446 = /*#__PURE__*/React.createElement("path", {
    d: "M46 126v-1h1v1z",
    fill: "#7f8387",
    fillOpacity: 0.478
  })), _path6447 || (_path6447 = /*#__PURE__*/React.createElement("path", {
    d: "M47 125h1v1h-1z",
    fill: "#82858a",
    fillOpacity: 0.62
  })), _path6448 || (_path6448 = /*#__PURE__*/React.createElement("path", {
    d: "M48 125h1v1h-1z",
    fill: "#82838a",
    fillOpacity: 0.737
  })), _path6449 || (_path6449 = /*#__PURE__*/React.createElement("path", {
    d: "M49 126v-1h1v1z",
    fill: "#82878b",
    fillOpacity: 0.82
  })), _path6450 || (_path6450 = /*#__PURE__*/React.createElement("path", {
    d: "M50 125h1v1h-1z",
    fill: "#868b8e",
    fillOpacity: 0.882
  })), _path6451 || (_path6451 = /*#__PURE__*/React.createElement("path", {
    d: "M52 125v1h-1v-1z",
    fill: "#8c9093",
    fillOpacity: 0.914
  })), _path6452 || (_path6452 = /*#__PURE__*/React.createElement("path", {
    d: "M53 125v1h-1v-1z",
    fill: "#8f9396",
    fillOpacity: 0.941
  })), _path6453 || (_path6453 = /*#__PURE__*/React.createElement("path", {
    d: "M54 125v1h-1v-1z",
    fill: "#909597",
    fillOpacity: 0.961
  })), _path6454 || (_path6454 = /*#__PURE__*/React.createElement("path", {
    d: "M54 126v-1h1v1z",
    fill: "#94999a",
    fillOpacity: 0.973
  })), _path6455 || (_path6455 = /*#__PURE__*/React.createElement("path", {
    d: "M55 126v-1h1v1z",
    fill: "#979b9d",
    fillOpacity: 0.976
  })), _path6456 || (_path6456 = /*#__PURE__*/React.createElement("path", {
    d: "M57 126h-1v-1h1z",
    fill: "#999e9f",
    fillOpacity: 0.984
  })), _path6457 || (_path6457 = /*#__PURE__*/React.createElement("path", {
    d: "M57 125h1v1h-1z",
    fill: "#9b9e9e",
    fillOpacity: 0.996
  })), _path6458 || (_path6458 = /*#__PURE__*/React.createElement("path", {
    d: "M58 125h1v1h-1z",
    fill: "#9d9f9e"
  })), _path6459 || (_path6459 = /*#__PURE__*/React.createElement("path", {
    d: "M59 126v-1h1v1z",
    fill: "#9ea09f"
  })), _path6460 || (_path6460 = /*#__PURE__*/React.createElement("path", {
    d: "M60 125h1v1h-1z",
    fill: "#a0a1a0"
  })), _path6461 || (_path6461 = /*#__PURE__*/React.createElement("path", {
    d: "M63 126v-1h1v1z",
    fill: "#a2a3a2"
  })), _path6462 || (_path6462 = /*#__PURE__*/React.createElement("path", {
    d: "M65 126h-1v-1h1z",
    fill: "#a2a3a3"
  })), _path6463 || (_path6463 = /*#__PURE__*/React.createElement("path", {
    d: "M66 126h-1v-1h1z",
    fill: "#a4a5a3"
  })), _path6464 || (_path6464 = /*#__PURE__*/React.createElement("path", {
    d: "M66 126v-1h1v1z",
    fill: "#a4a5a1"
  })), _path6465 || (_path6465 = /*#__PURE__*/React.createElement("path", {
    d: "M72 125h1v1h-1z",
    fill: "#a2a3a0"
  })), _path6466 || (_path6466 = /*#__PURE__*/React.createElement("path", {
    d: "M73 126v-1h1v1z",
    fill: "#a0a39f",
    fillOpacity: 0.992
  })), _path6467 || (_path6467 = /*#__PURE__*/React.createElement("path", {
    d: "M75 126h-1v-1h1z",
    fill: "#9ea39e",
    fillOpacity: 0.984
  })), _path6468 || (_path6468 = /*#__PURE__*/React.createElement("path", {
    d: "M75 125h1v1h-1z",
    fill: "#9ea19d",
    fillOpacity: 0.973
  })), _path6469 || (_path6469 = /*#__PURE__*/React.createElement("path", {
    d: "M76 125h1v1h-1z",
    fill: "#9ea09c",
    fillOpacity: 0.961
  })), _path6470 || (_path6470 = /*#__PURE__*/React.createElement("path", {
    d: "M78 126h-1v-1h1z",
    fill: "#9e9f9c",
    fillOpacity: 0.941
  })), _path6471 || (_path6471 = /*#__PURE__*/React.createElement("path", {
    d: "M79 126h-1v-1h1z",
    fill: "#9d9d9f",
    fillOpacity: 0.914
  })), _path6472 || (_path6472 = /*#__PURE__*/React.createElement("path", {
    d: "M80 125v1h-1v-1z",
    fill: "#9a9b9e",
    fillOpacity: 0.882
  })), _path6473 || (_path6473 = /*#__PURE__*/React.createElement("path", {
    d: "M81 126h-1v-1h1z",
    fill: "#95959a",
    fillOpacity: 0.827
  })), _path6474 || (_path6474 = /*#__PURE__*/React.createElement("path", {
    d: "M82 125v1h-1v-1z",
    fill: "#919197",
    fillOpacity: 0.765
  })), _path6475 || (_path6475 = /*#__PURE__*/React.createElement("path", {
    d: "M83 125v1h-1v-1z",
    fill: "#8a8a92",
    fillOpacity: 0.663
  })), _path6476 || (_path6476 = /*#__PURE__*/React.createElement("path", {
    d: "M84 126h-1v-1h1z",
    fill: "#84858d",
    fillOpacity: 0.545
  })), _path6477 || (_path6477 = /*#__PURE__*/React.createElement("path", {
    d: "M85 125v1h-1v-1z",
    fill: "#7f7f87",
    fillOpacity: 0.4
  })), _path6478 || (_path6478 = /*#__PURE__*/React.createElement("path", {
    d: "M85 126v-1h1v1z",
    fill: "#707075",
    fillOpacity: 0.239
  })), _path6479 || (_path6479 = /*#__PURE__*/React.createElement("path", {
    d: "M87 126h-1v-1h1z",
    fill: "#485555",
    fillOpacity: 0.082
  })), _path6480 || (_path6480 = /*#__PURE__*/React.createElement("path", {
    d: "M50 127h-1v-1h1z",
    fillOpacity: 0.031
  })), _path6481 || (_path6481 = /*#__PURE__*/React.createElement("path", {
    d: "M51 127h-1v-1h1z",
    fill: "#384646",
    fillOpacity: 0.071
  })), _path6482 || (_path6482 = /*#__PURE__*/React.createElement("path", {
    d: "M52 126v1h-1v-1z",
    fill: "#51515b",
    fillOpacity: 0.098
  })), _path6483 || (_path6483 = /*#__PURE__*/React.createElement("path", {
    d: "M53 126v1h-1v-1z",
    fill: "#5c5c64",
    fillOpacity: 0.129
  })), _path6484 || (_path6484 = /*#__PURE__*/React.createElement("path", {
    d: "M53 126h1v1h-1z",
    fill: "#68686f",
    fillOpacity: 0.153
  })), _path6485 || (_path6485 = /*#__PURE__*/React.createElement("path", {
    d: "M55 126v1h-1v-1z",
    fill: "#6e7373",
    fillOpacity: 0.173
  })), _path6486 || (_path6486 = /*#__PURE__*/React.createElement("path", {
    d: "M55 126h1v1h-1z",
    fill: "#77777c",
    fillOpacity: 0.184
  })), _path6487 || (_path6487 = /*#__PURE__*/React.createElement("path", {
    d: "M56 126h1v1h-1z",
    fill: "#7d8287",
    fillOpacity: 0.2
  })), _path6488 || (_path6488 = /*#__PURE__*/React.createElement("path", {
    d: "M57 127v-1h1v1z",
    fill: "#818186",
    fillOpacity: 0.224
  })), _path6489 || (_path6489 = /*#__PURE__*/React.createElement("path", {
    d: "M58 126h1v1h-1z",
    fill: "#818185",
    fillOpacity: 0.239
  })), _path6490 || (_path6490 = /*#__PURE__*/React.createElement("path", {
    d: "M59 126h1v1h-1z",
    fill: "#858589",
    fillOpacity: 0.255
  })), _path6491 || (_path6491 = /*#__PURE__*/React.createElement("path", {
    d: "M61 126v1h-1v-1z",
    fill: "#868a8a",
    fillOpacity: 0.275
  })), _path6492 || (_path6492 = /*#__PURE__*/React.createElement("path", {
    d: "M61 126h1v1h-1z",
    fill: "#89898d",
    fillOpacity: 0.29
  })), _path6493 || (_path6493 = /*#__PURE__*/React.createElement("path", {
    d: "M62 127v-1h1v1z",
    fill: "#87878b",
    fillOpacity: 0.302
  })), _path6494 || (_path6494 = /*#__PURE__*/React.createElement("path", {
    d: "M64 126v1h-1v-1z",
    fill: "#89898c",
    fillOpacity: 0.306
  })), _path6495 || (_path6495 = /*#__PURE__*/React.createElement("path", {
    d: "M65 126v1h-1v-1z",
    fill: "#87878a",
    fillOpacity: 0.318
  })), _path6496 || (_path6496 = /*#__PURE__*/React.createElement("path", {
    d: "M65 126h1v1h-1z",
    fill: "#85888b",
    fillOpacity: 0.322
  })), _path6497 || (_path6497 = /*#__PURE__*/React.createElement("path", {
    d: "M68 126h1v1h-1z",
    fill: "#878a8a",
    fillOpacity: 0.318
  })), _path6498 || (_path6498 = /*#__PURE__*/React.createElement("path", {
    d: "M69 127v-1h1v1z",
    fill: "#898c8c",
    fillOpacity: 0.306
  })), _path6499 || (_path6499 = /*#__PURE__*/React.createElement("path", {
    d: "M71 127h-1v-1h1z",
    fill: "#8b8b8b",
    fillOpacity: 0.286
  })), _path6500 || (_path6500 = /*#__PURE__*/React.createElement("path", {
    d: "M72 126v1h-1v-1z",
    fill: "#8b8e8e",
    fillOpacity: 0.259
  })), _path6501 || (_path6501 = /*#__PURE__*/React.createElement("path", {
    d: "M72 127v-1h1v1z",
    fill: "#8c9090",
    fillOpacity: 0.235
  })), _path6502 || (_path6502 = /*#__PURE__*/React.createElement("path", {
    d: "M74 127h-1v-1h1z",
    fill: "#8d8d8d",
    fillOpacity: 0.22
  })), _path6503 || (_path6503 = /*#__PURE__*/React.createElement("path", {
    d: "M75 127h-1v-1h1z",
    fill: "#8c918c",
    fillOpacity: 0.2
  })), _path6504 || (_path6504 = /*#__PURE__*/React.createElement("path", {
    d: "M75 127v-1h1v1z",
    fill: "#858a8a",
    fillOpacity: 0.18
  })), _path6505 || (_path6505 = /*#__PURE__*/React.createElement("path", {
    d: "M76 127v-1h1v1z",
    fill: "#858585",
    fillOpacity: 0.157
  })), _path6506 || (_path6506 = /*#__PURE__*/React.createElement("path", {
    d: "M78 127h-1v-1h1z",
    fill: "#7f7f7f",
    fillOpacity: 0.125
  })), _path6507 || (_path6507 = /*#__PURE__*/React.createElement("path", {
    d: "M78 126h1v1h-1z",
    fill: "#7a7a7a",
    fillOpacity: 0.098
  })), _path6508 || (_path6508 = /*#__PURE__*/React.createElement("path", {
    d: "M79 127v-1h1v1z",
    fill: "#717171",
    fillOpacity: 0.071
  })), _path6509 || (_path6509 = /*#__PURE__*/React.createElement("path", {
    d: "M80 126h1v1h-1z",
    fill: "#383855",
    fillOpacity: 0.035
  })), _path6510 || (_path6510 = /*#__PURE__*/React.createElement("path", {
    d: "M82 126v1h-1v-1z",
    fillOpacity: 0.008
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinksCan);
export default __webpack_public_path__ + "static/media/drinks-can.a96e44a8a86c0db25d7c34ccb1658d6f.svg";
export { ForwardRef as ReactComponent };